// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  UpdateUserArchiveStatusData,
  UpdateUserArchiveStatusResponse,
  BulkUpdateUserStatusData,
  BulkUpdateUserStatusResponse,
  UpdateUserData,
  UpdateUserResponse,
  AddUserData,
  AddUserResponse,
  UpdateUserStatusData,
  UpdateUserStatusResponse,
  SyncDeviceTokenData,
  SyncDeviceTokenResponse,
  RevokeDeviceTokenData,
  RevokeDeviceTokenResponse,
  ResetPasswordData,
  ResetPasswordResponse,
  SwitchLastLoggedInLocationData,
  SwitchLastLoggedInLocationResponse,
  GetProfileResponse,
  UpdateProfileDetailsOfUserData,
  UpdateProfileDetailsOfUserResponse,
  CheckUsernameData,
  CheckUsernameResponse,
  HandleStripeWebhookResponse,
  RegisterUsersOnKeycloakData,
  RegisterUsersOnKeycloakResponse,
  SendInviteData,
  SendInviteResponse,
  RegisterUserWithUuidData,
  RegisterUserWithUuidResponse,
  GetAllUsersData,
  GetAllUsersResponse,
  GetAllProviderAndStaffUserData,
  GetAllProviderAndStaffUserResponse,
  GetClinicalStaffData,
  GetClinicalStaffResponse,
  GetUsersByRoleTypeData,
  GetUsersByRoleTypeResponse,
  GetUserData,
  GetUserResponse,
  GetUserFromIamidData,
  GetUserFromIamidResponse,
  CheckResponse,
  CheckUserRegistrationData,
  CheckUserRegistrationResponse,
  GetAssignedLocationsData,
  GetAssignedLocationsResponse,
  GetUsersData,
  GetUsersResponse,
  ProcessUploadData,
  ProcessUploadResponse,
  UploadFileData,
  UploadFileResponse,
  SetReviewedData,
  SetReviewedResponse,
  UpdateMuteStatusData,
  UpdateMuteStatusResponse,
  GetUploadDetailsByUploadUuidData,
  GetUploadDetailsByUploadUuidResponse,
  GetRowFromCsvData,
  GetRowFromCsvResponse,
  ExportRowsData,
  ExportRowsResponse,
  DownloadFileData,
  DownloadFileResponse,
  GetAllUploadsData,
  GetAllUploadsResponse,
  GetAllUploadDetailsByUploadUuidData,
  GetAllUploadDetailsByUploadUuidResponse,
  GetSubscriptionData,
  GetSubscriptionResponse,
  UpdateSubscriptionData,
  UpdateSubscriptionResponse,
  CancelSubscriptionData,
  CancelSubscriptionResponse,
  ChangePlanData,
  ChangePlanResponse,
  ChangePlanWithProrationData,
  ChangePlanWithProrationResponse,
  UpdatePromotionalCouponData,
  UpdatePromotionalCouponResponse,
  CreatePromotionalCouponData,
  CreatePromotionalCouponResponse,
  HandleStripeWebhook1Response,
  CreateSubscriptionData,
  CreateSubscriptionResponse,
  CreateSubscriptionWithPaymentData,
  CreateSubscriptionWithPaymentResponse,
  CompleteSubscriptionData,
  CompleteSubscriptionResponse,
  CreateSetupIntentData,
  CreateSetupIntentResponse,
  CreateSetupIntentWithCustomerData,
  CreateSetupIntentWithCustomerResponse,
  SetDefaultPaymentMethodData,
  SetDefaultPaymentMethodResponse,
  SaveCardToCustomerWithChargingData,
  SaveCardToCustomerWithChargingResponse,
  SaveCardToCustomerData,
  SaveCardToCustomerResponse,
  RefundAmountData,
  RefundAmountResponse,
  CreateProductData,
  CreateProductResponse,
  CreatePriceForProductData,
  CreatePriceForProductResponse,
  CreateProductAndPriceData,
  CreateProductAndPriceResponse,
  CreateFlexiblePaymentData,
  CreateFlexiblePaymentResponse,
  CreatePaymentIntentWithProductPriceData,
  CreatePaymentIntentWithProductPriceResponse,
  CreatePaymentIntentData,
  CreatePaymentIntentResponse,
  CreateCustomerData,
  CreateCustomerResponse,
  CreateCoupon1Data,
  CreateCoupon1Response,
  AddSaveCardToCustomerData,
  AddSaveCardToCustomerResponse,
  GetPhpUserResponse,
  GetStripeConfigResponse,
  CheckServicesOfUserData,
  CheckServicesOfUserResponse,
  UpdateScriptSurePatientData,
  UpdateScriptSurePatientResponse,
  CreateScriptSurePatientData,
  CreateScriptSurePatientResponse,
  DeleteScriptSurePatientData,
  DeleteScriptSurePatientResponse,
  UpdateAllergyData,
  UpdateAllergyResponse,
  ArchiveAllergyData,
  ArchiveAllergyResponse,
  VendorLoginData,
  VendorLoginResponse,
  RegisterProviderToScriptSureData,
  RegisterProviderToScriptSureResponse,
  RegisterNurseStaffToScriptSureData,
  RegisterNurseStaffToScriptSureResponse,
  RegisterLocationToScriptSureData,
  RegisterLocationToScriptSureResponse,
  SaveMedicationPrescriptionData,
  SaveMedicationPrescriptionResponse,
  GetPatientMedicationsData,
  GetPatientMedicationsResponse,
  GetPatientPharmacyData,
  GetPatientPharmacyResponse,
  SaveAllergyData,
  SaveAllergyResponse,
  SaveNoKnownAllergyData,
  SaveNoKnownAllergyResponse,
  GetPatientAllergiesData,
  GetPatientAllergiesResponse,
  GetPrescriptionIframeData,
  GetPrescriptionIframeResponse,
  GetMessageCountData,
  GetMessageCountResponse,
  GetMedCartIframeData,
  GetMedCartIframeResponse,
  SearchDrugsData,
  SearchDrugsResponse,
  GetDrugDosesData,
  GetDrugDosesResponse,
  GetDrugHistoryIframeData,
  GetDrugHistoryIframeResponse,
  GetCpoeIframeResponse,
  SearchAllergiesData,
  SearchAllergiesResponse,
  GetAllergyIframeData,
  GetAllergyIframeResponse,
  DeletePreferredPharmacyData,
  DeletePreferredPharmacyResponse,
  UpdateSavedCardByUuidData,
  UpdateSavedCardByUuidResponse,
  DeleteSavedCardByUuidData,
  DeleteSavedCardByUuidResponse,
  SetAutopaySavedCardByUuidData,
  SetAutopaySavedCardByUuidResponse,
  SetDefaultSavedCardByUuidData,
  SetDefaultSavedCardByUuidResponse,
  GetAllSavedCardsData,
  GetAllSavedCardsResponse,
  GetAllSavedCards1Data,
  GetAllSavedCards1Response,
  SetAutopaySavedBankByUuidData,
  SetAutopaySavedBankByUuidResponse,
  SetDefaultSavedBankByUuidData,
  SetDefaultSavedBankByUuidResponse,
  CreateSetupIntent1Data,
  CreateSetupIntent1Response,
  ConfirmBankAccountData,
  ConfirmBankAccountResponse,
  UpdateAutopaySavedBankData,
  UpdateAutopaySavedBankResponse,
  GetAllSavedBanksData,
  GetAllSavedBanksResponse,
  DeleteSavedBankByUuidData,
  DeleteSavedBankByUuidResponse,
  CreateSetupIntent11Data,
  CreateSetupIntent11Response,
  ConfirmBankAccount1Data,
  ConfirmBankAccount1Response,
  GetAllSavedBanks1Data,
  GetAllSavedBanks1Response,
  GetSalesTaxProfileByUuidData,
  GetSalesTaxProfileByUuidResponse,
  UpdateSalesTaxProfileByUuidData,
  UpdateSalesTaxProfileByUuidResponse,
  DeleteSalesTaxProfileByUuidData,
  DeleteSalesTaxProfileByUuidResponse,
  SaveSalesTaxProfileData,
  SaveSalesTaxProfileResponse,
  GetAllSalesTaxProfilesData,
  GetAllSalesTaxProfilesResponse,
  GetSalesTaxJurisdictionByUuidData,
  GetSalesTaxJurisdictionByUuidResponse,
  UpdateSalesTaxJurisdictionByUuidData,
  UpdateSalesTaxJurisdictionByUuidResponse,
  DeleteSalesTaxJurisdictionByUuidData,
  DeleteSalesTaxJurisdictionByUuidResponse,
  SaveSalesTaxJurisdictionData,
  SaveSalesTaxJurisdictionResponse,
  GetAllSalesTaxJurisdictionsData,
  GetAllSalesTaxJurisdictionsResponse,
  UpdatePermissionsOfRoleData,
  UpdatePermissionsOfRoleResponse,
  CreateRoleData,
  CreateRoleResponse,
  UpdateRoleNameData,
  UpdateRoleNameResponse,
  GetRoleTypesResponse,
  GetRolesByRoleTypeData,
  GetRolesByRoleTypeResponse,
  GetFeaturesByRoleAndRoleTypeData,
  GetFeaturesByRoleAndRoleTypeResponse,
  GetRoleTypeByUuidData,
  GetRoleTypeByUuidResponse,
  UpdateRoleTypeData,
  UpdateRoleTypeResponse,
  DeleteRoleTypeData,
  DeleteRoleTypeResponse,
  GetAllRoleTypesResponse,
  CreateRoleTypeData,
  CreateRoleTypeResponse,
  GetRoleTypeFeatureByUuidData,
  GetRoleTypeFeatureByUuidResponse,
  UpdateRoleTypeFeatureData,
  UpdateRoleTypeFeatureResponse,
  DeleteRoleTypeFeatureData,
  DeleteRoleTypeFeatureResponse,
  GetAllRoleTypeFeaturesResponse,
  CreateRoleTypeFeatureData,
  CreateRoleTypeFeatureResponse,
  GetRoleTypeFeaturesByRoleTypeData,
  GetRoleTypeFeaturesByRoleTypeResponse,
  GetRoleTypeFeatureByRoleTypeAndFeatureData,
  GetRoleTypeFeatureByRoleTypeAndFeatureResponse,
  GetRoleTypeFeaturesByFeatureData,
  GetRoleTypeFeaturesByFeatureResponse,
  UpdateProviderData,
  UpdateProviderResponse,
  AddProviderData,
  AddProviderResponse,
  AssignedNewProviderData,
  AssignedNewProviderResponse,
  UpdatePatientEntrollmentByProviderUuidData,
  UpdatePatientEntrollmentByProviderUuidResponse,
  UpdateProviderStatusData,
  UpdateProviderStatusResponse,
  GetProviderByUuidData,
  GetProviderByUuidResponse,
  DeleteProviderByUuidData,
  DeleteProviderByUuidResponse,
  IsProviderWithUrgentMessageAlertsData,
  IsProviderWithUrgentMessageAlertsResponse,
  GetCoveringProvidersForUrgentAlertsData,
  GetCoveringProvidersForUrgentAlertsResponse,
  GetProviderProfileData,
  GetProviderProfileResponse,
  GetAllProvidersData,
  GetAllProvidersResponse,
  GetAllProvidersByIsAffiliateData,
  GetAllProvidersByIsAffiliateResponse,
  ExportAffiliateProvidersCsvData,
  ExportAffiliateProvidersCsvResponse,
  UpdatePlanData,
  UpdatePlanResponse,
  UpdatePlanDetailsData,
  UpdatePlanDetailsResponse,
  CreatePlanData,
  CreatePlanResponse,
  GetPlanAmountData,
  GetPlanAmountResponse,
  GetPlanByUuidData,
  GetPlanByUuidResponse,
  DeletePlanByUuidData,
  DeletePlanByUuidResponse,
  GetPlanDetailsByUuidData,
  GetPlanDetailsByUuidResponse,
  GetPlanStatusData,
  GetPlanStatusResponse,
  CheckMyPlanData,
  CheckMyPlanResponse,
  GetAllPlanData,
  GetAllPlanResponse,
  UpdatePaymentTransactionData,
  UpdatePaymentTransactionResponse,
  CreatePaymentTransactionData,
  CreatePaymentTransactionResponse,
  GetPaymentTransactionByUuidData,
  GetPaymentTransactionByUuidResponse,
  DeletePaymentTransactionData,
  DeletePaymentTransactionResponse,
  GetAllPaymentTransactionsData,
  GetAllPaymentTransactionsResponse,
  UpdatePatientData,
  UpdatePatientResponse,
  AddPatientData,
  AddPatientResponse,
  UnEnrollPatientData,
  UnEnrollPatientResponse,
  PatientCreateUpdateData,
  PatientCreateUpdateResponse,
  EndMembershipForPatientAndDependentsData,
  EndMembershipForPatientAndDependentsResponse,
  EditDependentMembershipDetailsData,
  EditDependentMembershipDetailsResponse,
  CreateUpdatePatientData,
  CreateUpdatePatientResponse,
  MarkPatientViewedData,
  MarkPatientViewedResponse,
  SyncPatientWithScriptSureData,
  SyncPatientWithScriptSureResponse,
  SendNotificationMailForBasicPaymentDetailsData,
  SendNotificationMailForBasicPaymentDetailsResponse,
  GeneratePatientChartPdfData,
  GeneratePatientChartPdfResponse,
  UpdateEngagedPatientEmployerMembershipInvoiceData,
  UpdateEngagedPatientEmployerMembershipInvoiceResponse,
  CheckPatientCredentialsData,
  CheckPatientCredentialsResponse,
  CancelPlanChangeData,
  CancelPlanChangeResponse,
  EvictPatientCachesResponse,
  UpdateEngagedPatientBrokerFirmMembershipInvoiceData,
  UpdateEngagedPatientBrokerFirmMembershipInvoiceResponse,
  UpdateEngagedPatientAffiliateFirmMembershipInvoiceData,
  UpdateEngagedPatientAffiliateFirmMembershipInvoiceResponse,
  AddPatientToStripeData,
  AddPatientToStripeResponse,
  AddMembershipData,
  AddMembershipResponse,
  GetPatientByUuidData,
  GetPatientByUuidResponse,
  SetPatientPortalAccessData,
  SetPatientPortalAccessResponse,
  UpdatePatientStatusData,
  UpdatePatientStatusResponse,
  MakePrimaryData,
  MakePrimaryResponse,
  SetPatientPrimaryProviderData,
  SetPatientPrimaryProviderResponse,
  SetSendSmsData,
  SetSendSmsResponse,
  RemovePreEngageData,
  RemovePreEngageResponse,
  SetReEnrollmentData,
  SetReEnrollmentResponse,
  AddExistingPatientAsDependentData,
  AddExistingPatientAsDependentResponse,
  ChangeBillingDateData,
  ChangeBillingDateResponse,
  GetPatientLocationWithSalesTaxData,
  GetPatientLocationWithSalesTaxResponse,
  GetLabPayerDefaultsData,
  GetLabPayerDefaultsResponse,
  GetRecentlyViewedPatientsData,
  GetRecentlyViewedPatientsResponse,
  GetProfile1Response,
  GetPatientPlanDetailsData,
  GetPatientPlanDetailsResponse,
  GetPatientOverviewData,
  GetPatientOverviewResponse,
  GetPatientMemberShipData,
  GetPatientMemberShipResponse,
  GetPatientEmployeeMembershipDetailsData,
  GetPatientEmployeeMembershipDetailsResponse,
  GetPatientDropDownData,
  GetPatientDropDownResponse,
  GetPatientWithDependentsData,
  GetPatientWithDependentsResponse,
  ExportPatientsByAffiliateGroupData,
  ExportPatientsByAffiliateGroupResponse,
  GetDependentsData,
  GetDependentsResponse,
  GetAllPatientData,
  GetAllPatientResponse,
  DeletePatientByUuidData,
  DeletePatientByUuidResponse,
  UpdateData,
  UpdateResponse,
  CreateData,
  CreateResponse,
  GetByUuid1Data,
  GetByUuid1Response,
  GetAllResponse,
  Delete1Data,
  Delete1Response,
  Update1Data,
  Update1Response,
  Create1Data,
  Create1Response,
  GetByUuid2Data,
  GetByUuid2Response,
  GetAllByGranteeData,
  GetAllByGranteeResponse,
  GetAllByOwnerAndGranteeData,
  GetAllByOwnerAndGranteeResponse,
  Delete2Data,
  Delete2Response,
  GetByUuidData,
  GetByUuidResponse,
  Update2Data,
  Update2Response,
  DeleteData,
  DeleteResponse,
  Create2Data,
  Create2Response,
  GetAllByPatientUuidData,
  GetAllByPatientUuidResponse,
  UpdateNurseStaffProviderData,
  UpdateNurseStaffProviderResponse,
  AddNurseStaffProviderData,
  AddNurseStaffProviderResponse,
  UpdateNurseStaffProviderStatusData,
  UpdateNurseStaffProviderStatusResponse,
  GetNurseStaffProviderByUuidData,
  GetNurseStaffProviderByUuidResponse,
  DeleteNurseStaffProviderData,
  DeleteNurseStaffProviderResponse,
  GetAllNurseStaffProvidersData,
  GetAllNurseStaffProvidersResponse,
  UpdateLeadData,
  UpdateLeadResponse,
  CreateLeadData,
  CreateLeadResponse,
  CreateUpdateLeadData,
  CreateUpdateLeadResponse,
  CreateSubscriptionAfterPaymentData,
  CreateSubscriptionAfterPaymentResponse,
  GetLeadByUuidData,
  GetLeadByUuidResponse,
  DeleteLeadByUuidData,
  DeleteLeadByUuidResponse,
  ValidateCouponCodeData,
  ValidateCouponCodeResponse,
  GetLeadFullInfoData,
  GetLeadFullInfoResponse,
  GetAllLeadData,
  GetAllLeadResponse,
  GetInvoiceSettingByUuidData,
  GetInvoiceSettingByUuidResponse,
  UpdateInvoiceSettingData,
  UpdateInvoiceSettingResponse,
  DeleteInvoiceSettingByUuidData,
  DeleteInvoiceSettingByUuidResponse,
  ToggleEmailNotificationData,
  ToggleEmailNotificationResponse,
  CreateInvoiceSettingData,
  CreateInvoiceSettingResponse,
  GetAllInvoiceSettingsData,
  GetAllInvoiceSettingsResponse,
  GetFeatureByUuidData,
  GetFeatureByUuidResponse,
  UpdateFeatureData,
  UpdateFeatureResponse,
  DeleteFeatureData,
  DeleteFeatureResponse,
  GetAllFeaturesResponse,
  CreateFeatureData,
  CreateFeatureResponse,
  UpdateFaxDocumentData,
  UpdateFaxDocumentResponse,
  UpdateFaxStatusData,
  UpdateFaxStatusResponse,
  SendFaxData,
  SendFaxResponse,
  SendWorkNoteByFaxData,
  SendWorkNoteByFaxResponse,
  SendWorkNoteByEmailData,
  SendWorkNoteByEmailResponse,
  SendSoapNoteByFaxData,
  SendSoapNoteByFaxResponse,
  SendSoapNoteByEmailData,
  SendSoapNoteByEmailResponse,
  SendReferralByFaxData,
  SendReferralByFaxResponse,
  SendReferralByEmailData,
  SendReferralByEmailResponse,
  SendPocByFaxData,
  SendPocByFaxResponse,
  SendPocByEmailData,
  SendPocByEmailResponse,
  SendPatientInformationByFaxData,
  SendPatientInformationByFaxResponse,
  SendPatientInformationByEmailData,
  SendPatientInformationByEmailResponse,
  SendLabResultBySmsData,
  SendLabResultBySmsResponse,
  GetFaxDetailServiceData,
  GetFaxDetailServiceResponse,
  SendImagingByFaxData,
  SendImagingByFaxResponse,
  SendImagingByEmailData,
  SendImagingByEmailResponse,
  SendHandpNoteByFaxData,
  SendHandpNoteByFaxResponse,
  SendHandpNoteByEmailData,
  SendHandpNoteByEmailResponse,
  SendDocumentByFaxData,
  SendDocumentByFaxResponse,
  SendDocumentByEmailData,
  SendDocumentByEmailResponse,
  SendFaxToRefferalData,
  SendFaxToRefferalResponse,
  SendQuestionnaireFaxData,
  SendQuestionnaireFaxResponse,
  SendFaxToLabOrderData,
  SendFaxToLabOrderResponse,
  SendFaxToImagingData,
  SendFaxToImagingResponse,
  SendFaxToLabOrder1Data,
  SendFaxToLabOrder1Response,
  CancelEfaxFaxData,
  CancelEfaxFaxResponse,
  AttachDocumentData,
  AttachDocumentResponse,
  FetchSentFaxesByLocationData,
  FetchSentFaxesByLocationResponse,
  RetrieveFaxData,
  RetrieveFaxResponse,
  GetImagingResultPdfData,
  GetImagingResultPdfResponse,
  GetLabOrderPdfData,
  GetLabOrderPdfResponse,
  FetchOutboxFaxesData,
  FetchOutboxFaxesResponse,
  FetchInboxFaxesData,
  FetchInboxFaxesResponse,
  FetchInboxWithSubUsersResponse,
  FetchSentFaxesFromEfaxData,
  FetchSentFaxesFromEfaxResponse,
  FetchReceivedFaxesFromEfaxData,
  FetchReceivedFaxesFromEfaxResponse,
  FetchEfaxFaxPagesData,
  FetchEfaxFaxPagesResponse,
  FetchEfaxOutboundFaxMetadataData,
  FetchEfaxOutboundFaxMetadataResponse,
  FetchEfaxFaxMetadataData,
  FetchEfaxFaxMetadataResponse,
  DeleteEfaxFaxData,
  DeleteEfaxFaxResponse,
  DeleteFaxData,
  DeleteFaxResponse,
  GetLayoutResponse,
  SaveLayoutData,
  SaveLayoutResponse,
  ResetLayoutResponse,
  UpdateEmployerData,
  UpdateEmployerResponse,
  DeleteEmployerData,
  DeleteEmployerResponse,
  GetPricingDetailsData,
  GetPricingDetailsResponse,
  SavePricingDetailsData,
  SavePricingDetailsResponse,
  GetOnlineSignUpData,
  GetOnlineSignUpResponse,
  SaveOnlineSignUpData,
  SaveOnlineSignUpResponse,
  GetAccountDetailsData,
  GetAccountDetailsResponse,
  SaveAccountDetailsData,
  SaveAccountDetailsResponse,
  AddEmployerData,
  AddEmployerResponse,
  GetInvoiceSettingData,
  GetInvoiceSettingResponse,
  UpdateInvoiceSetting1Data,
  UpdateInvoiceSetting1Response,
  UpdateEmployerStatusData,
  UpdateEmployerStatusResponse,
  GetAllEmployerTotalCountData,
  GetAllEmployerTotalCountResponse,
  GetEmployerMemberShipData,
  GetEmployerMemberShipResponse,
  GetMembershipDetailsData,
  GetMembershipDetailsResponse,
  GetEmployerByUuidData,
  GetEmployerByUuidResponse,
  GetEmployerCustomLogoByUuidData,
  GetEmployerCustomLogoByUuidResponse,
  GetEmployerCoveragePlansData,
  GetEmployerCoveragePlansResponse,
  GetBasicDetailsByPatientUuidData,
  GetBasicDetailsByPatientUuidResponse,
  GetAllEmployersData,
  GetAllEmployersResponse,
  ArchiveEmployerPlanData,
  ArchiveEmployerPlanResponse,
  UpdateEmployerPageData,
  UpdateEmployerPageResponse,
  CreateEmployerPageData,
  CreateEmployerPageResponse,
  GetEmployerPageByUuidData,
  GetEmployerPageByUuidResponse,
  DeleteEmployerPageByUuidData,
  DeleteEmployerPageByUuidResponse,
  IsLinkActiveData,
  IsLinkActiveResponse,
  GetAllEmployerPagesData,
  GetAllEmployerPagesResponse,
  UpdateEmployerDivisionData,
  UpdateEmployerDivisionResponse,
  CreateEmployerDivisionData,
  CreateEmployerDivisionResponse,
  GetEmployerDivisionByUuidData,
  GetEmployerDivisionByUuidResponse,
  DeleteEmployerDivisionByUuidData,
  DeleteEmployerDivisionByUuidResponse,
  GetAllEmployerDivisionsData,
  GetAllEmployerDivisionsResponse,
  UpdateEmployerAdministratorData,
  UpdateEmployerAdministratorResponse,
  CreateEmployerAdministratorData,
  CreateEmployerAdministratorResponse,
  GetEmployerAdministratorByUuidData,
  GetEmployerAdministratorByUuidResponse,
  DeleteEmployerAdministratorByUuidData,
  DeleteEmployerAdministratorByUuidResponse,
  GetAllEmployerAdministratorsData,
  GetAllEmployerAdministratorsResponse,
  GetCreditByUuidData,
  GetCreditByUuidResponse,
  UpdateCreditData,
  UpdateCreditResponse,
  DeleteCreditData,
  DeleteCreditResponse,
  AddCreditData,
  AddCreditResponse,
  GetTotalCreditByUuidData,
  GetTotalCreditByUuidResponse,
  GetAllCreditsData,
  GetAllCreditsResponse,
  UpdateCoverageRuleData,
  UpdateCoverageRuleResponse,
  CreateCoverageRuleData,
  CreateCoverageRuleResponse,
  GetCoverageRuleByUuidData,
  GetCoverageRuleByUuidResponse,
  DeleteCoverageRuleByUuidData,
  DeleteCoverageRuleByUuidResponse,
  GetAllCoverageRuleData,
  GetAllCoverageRuleResponse,
  UpdateCoveragePlanData,
  UpdateCoveragePlanResponse,
  CreateCoveragePlanData,
  CreateCoveragePlanResponse,
  GetCoveragePlanByUuidData,
  GetCoveragePlanByUuidResponse,
  DeleteCoveragePlanByUuidData,
  DeleteCoveragePlanByUuidResponse,
  GetAllCoveragePlanData,
  GetAllCoveragePlanResponse,
  DeleteCoveragePlanEmployerByUuidData,
  DeleteCoveragePlanEmployerByUuidResponse,
  UpdateCouponData,
  UpdateCouponResponse,
  CreateCouponData,
  CreateCouponResponse,
  GetCouponByUuidData,
  GetCouponByUuidResponse,
  DeleteCouponByUuidData,
  DeleteCouponByUuidResponse,
  GetAllCouponsData,
  GetAllCouponsResponse,
  GetChargeItemByUuidData,
  GetChargeItemByUuidResponse,
  UpdateChargeItemByUuidData,
  UpdateChargeItemByUuidResponse,
  DeleteChargeItemByUuidData,
  DeleteChargeItemByUuidResponse,
  UploadCsvData,
  UploadCsvResponse,
  UpdatePricesFromCsvData,
  UpdatePricesFromCsvResponse,
  SaveChargeItemData,
  SaveChargeItemResponse,
  GetChargeItemTaxMappingData,
  GetChargeItemTaxMappingResponse,
  DownloadPriceUpdateCsvTemplateResponse,
  ExportCsvData,
  ExportCsvResponse,
  DownloadCsvTemplate1Response,
  GetChargeItemsByChargeCategoryUuidData,
  GetChargeItemsByChargeCategoryUuidResponse,
  SearchAndFilterChargeItemsData,
  SearchAndFilterChargeItemsResponse,
  DeleteChargeItemsByUuidsData,
  DeleteChargeItemsByUuidsResponse,
  GetChargeCategoryByUuidData,
  GetChargeCategoryByUuidResponse,
  UpdateChargeCategoryByUuidData,
  UpdateChargeCategoryByUuidResponse,
  DeleteChargeCategoryByUuidData,
  DeleteChargeCategoryByUuidResponse,
  SaveChargeCategoryData,
  SaveChargeCategoryResponse,
  GetChargeCategoryByCoveragePlanUuidData,
  GetChargeCategoryByCoveragePlanUuidResponse,
  GetAllChargeCategoriesData,
  GetAllChargeCategoriesResponse,
  GetCancellationByUuidData,
  GetCancellationByUuidResponse,
  UpdateCancellationData,
  UpdateCancellationResponse,
  DeleteCancellationByUuidData,
  DeleteCancellationByUuidResponse,
  ArchiveAndUnarchiveCancellationByUuidData,
  ArchiveAndUnarchiveCancellationByUuidResponse,
  SaveCancellationData,
  SaveCancellationResponse,
  GetAllCancellationsData,
  GetAllCancellationsResponse,
  UpdateBrokerData,
  UpdateBrokerResponse,
  CreateBrokerData,
  CreateBrokerResponse,
  UpdateBrokerStatusData,
  UpdateBrokerStatusResponse,
  GetBrokerByUuidData,
  GetBrokerByUuidResponse,
  DeleteBrokerByUuidData,
  DeleteBrokerByUuidResponse,
  GetAllBrokersData,
  GetAllBrokersResponse,
  Update3Data,
  Update3Response,
  Create3Data,
  Create3Response,
  GetByUuid3Data,
  GetByUuid3Response,
  GetAllBreakGlassData,
  GetAllBreakGlassResponse,
  Delete3Data,
  Delete3Response,
  UpdateAncillaryServiceChargesData,
  UpdateAncillaryServiceChargesResponse,
  GetMiscellaneousServiceChargeByUuidData,
  GetMiscellaneousServiceChargeByUuidResponse,
  UpdateMiscellaneousServiceChargeByUuidData,
  UpdateMiscellaneousServiceChargeByUuidResponse,
  DeleteMiscellaneousServiceChargeByUuidData,
  DeleteMiscellaneousServiceChargeByUuidResponse,
  UpdatePlanRenewalDatesForActiveRetailPatientsResponse,
  SyncEmployerInvoiceData,
  SyncEmployerInvoiceResponse,
  ScheduledPaymentProcessingResponse,
  ScheduledPaymentData,
  ScheduledPaymentResponse,
  UpdateExistingRetailPatientMembershipInvoiceData,
  UpdateExistingRetailPatientMembershipInvoiceResponse,
  RefundAmount1Data,
  RefundAmount1Response,
  ReactiveEmployerMembershipData,
  ReactiveEmployerMembershipResponse,
  ProcessOverdueInvoicesAndGeneratePdfsResponse,
  SaveMiscellaneousServiceChargeData,
  SaveMiscellaneousServiceChargeResponse,
  MakePaymentData,
  MakePaymentResponse,
  LinkChargeItemsToPatientData,
  LinkChargeItemsToPatientResponse,
  MarkLabOrderAsDrawnData,
  MarkLabOrderAsDrawnResponse,
  InvoiceLabOrderNowData,
  InvoiceLabOrderNowResponse,
  SendLabInvoicePaymentRemindersResponse,
  LabInvoiceAutopayProcessingResponse,
  CreateRetailMembershipInvoiceData,
  CreateRetailMembershipInvoiceResponse,
  RetailPatientAutopayProcessingResponse,
  GenerateMonthlyEmployerInvoicesResponse,
  GenerateMonthlyBrokerFirmInvoicesResponse,
  GenerateMonthlyAffiliateFirmInvoicesResponse,
  GenerateLabOrderInvoicesResponse,
  GenerateInvoiceOfAncillaryForUserData,
  GenerateInvoiceOfAncillaryForUserResponse,
  GenerateInvoiceEmployerMembershipData,
  GenerateInvoiceEmployerMembershipResponse,
  EmployerInvoiceSettingResponse,
  DeactivateRetailPatientsWithUnpaidInvoicesResponse,
  ProcessEmployerDeactivationResponse,
  CreateChargeItemAndInvoiceData,
  CreateChargeItemAndInvoiceResponse,
  SaveAncillaryServiceChargesData,
  SaveAncillaryServiceChargesResponse,
  ConvertPatientMembershipResponse,
  CheckChargeCoverageData,
  CheckChargeCoverageResponse,
  ChangeInvoiceStatusData,
  ChangeInvoiceStatusResponse,
  UpdateExistingAffiliateFirmMembershipInvoiceData,
  UpdateExistingAffiliateFirmMembershipInvoiceResponse,
  UpdateExistingBrokerFirmMembershipInvoiceData,
  UpdateExistingBrokerFirmMembershipInvoiceResponse,
  ActivatePendingEmployeePatientsResponse,
  GetAncillaryServiceChargesUuidData,
  GetAncillaryServiceChargesUuidResponse,
  TransactionDetailsData,
  TransactionDetailsResponse,
  InvoiceTransactionDetailsData,
  InvoiceTransactionDetailsResponse,
  GetInvoiceStatementData,
  GetInvoiceStatementResponse,
  GetAllScheduledPaymentData,
  GetAllScheduledPaymentResponse,
  PaymentHistoryData,
  PaymentHistoryResponse,
  GetAllMiscellaneousServiceChargesData,
  GetAllMiscellaneousServiceChargesResponse,
  GenerateRetailPatientInvoicesResponse,
  GetInvoiceStatusData,
  GetInvoiceStatusResponse,
  InvoiceDetailsData,
  InvoiceDetailsResponse,
  EmployerEmployeesDetailsData,
  EmployerEmployeesDetailsResponse,
  GetChargeItemNamesByInvoiceData,
  GetChargeItemNamesByInvoiceResponse,
  AmountDetailsData,
  AmountDetailsResponse,
  GetAllAncillaryServiceChargesData,
  GetAllAncillaryServiceChargesResponse,
  AffiliateFirmEmployeesDetailsData,
  AffiliateFirmEmployeesDetailsResponse,
  EmployerDetailsMonthWiseData,
  EmployerDetailsMonthWiseResponse,
  GetAllAffiliateBrokerServiceChargesData,
  GetAllAffiliateBrokerServiceChargesResponse,
  AffiliateProviderEmployeeDetailsData,
  AffiliateProviderEmployeeDetailsResponse,
  DeleteAncillaryServiceChargesByUuidData,
  DeleteAncillaryServiceChargesByUuidResponse,
  UpdateAgentFirmData,
  UpdateAgentFirmResponse,
  CreateAgentFirmData,
  CreateAgentFirmResponse,
  GetAgentFirmByUuidData,
  GetAgentFirmByUuidResponse,
  DeleteAgentFirmByUuidData,
  DeleteAgentFirmByUuidResponse,
  GetEmployersUnderAgentFirmData,
  GetEmployersUnderAgentFirmResponse,
  GetAllAgentFirmsData,
  GetAllAgentFirmsResponse,
  UpdateAgentDealData,
  UpdateAgentDealResponse,
  CreateAgentDealData,
  CreateAgentDealResponse,
  EndAgentDealData,
  EndAgentDealResponse,
  EndAllDealsByAgentFirmData,
  EndAllDealsByAgentFirmResponse,
  GetAgentDealByUuidData,
  GetAgentDealByUuidResponse,
  DeleteAgentDealByUuidData,
  DeleteAgentDealByUuidResponse,
  GetEmployersUnderBrokerData,
  GetEmployersUnderBrokerResponse,
  GetAgentDealsByAgentFirmUuidData,
  GetAgentDealsByAgentFirmUuidResponse,
  GetAllAgentDealsData,
  GetAllAgentDealsResponse,
  GetAffiliateGropByUuidData,
  GetAffiliateGropByUuidResponse,
  UpdateAffiliateData,
  UpdateAffiliateResponse,
  DeleteAffiliateData,
  DeleteAffiliateResponse,
  UpdateAffiliateUserData,
  UpdateAffiliateUserResponse,
  MarkAffiliateUserAsPrimaryData,
  MarkAffiliateUserAsPrimaryResponse,
  AddAffiliateData,
  AddAffiliateResponse,
  GetAffiliateUsersByAffiliateGroupUuidData,
  GetAffiliateUsersByAffiliateGroupUuidResponse,
  AddAffiliateUserData,
  AddAffiliateUserResponse,
  DownloadAffiliateDataExcelData,
  DownloadAffiliateDataExcelResponse,
  GetAffiliateUserByUuidData,
  GetAffiliateUserByUuidResponse,
  ExportCsvForAffiliateData,
  ExportCsvForAffiliateResponse,
  GetAllAffiliatesData,
  GetAllAffiliatesResponse,
  GetAdminUserByUuidData,
  GetAdminUserByUuidResponse,
  UpdateAdminUserByUuidData,
  UpdateAdminUserByUuidResponse,
  DeleteAdminUserByUuidData,
  DeleteAdminUserByUuidResponse,
  ActiveAdminUserByUuidData,
  ActiveAdminUserByUuidResponse,
  ResetUserMfaData,
  ResetUserMfaResponse,
  GenerateGuestTokenData,
  GenerateGuestTokenResponse,
  ResendLinkData,
  ResendLinkResponse,
  SaveAdminUserData,
  SaveAdminUserResponse,
  GetSupersetDashBoardIdData,
  GetSupersetDashBoardIdResponse,
  GetUserDetailsData,
  GetUserDetailsResponse,
  GetProfile2Response,
  GetAllAdminUsersData,
  GetAllAdminUsersResponse,
  SendRequestsData,
  SendRequestsResponse,
  DenyData,
  DenyResponse,
  ApproveData,
  ApproveResponse,
  GetIncomingRequestsData,
  GetIncomingRequestsResponse,
  GetApprovedProvidersData,
  GetApprovedProvidersResponse,
  ShareCardData,
  ShareCardResponse,
  GetSharedCardsByUserData,
  GetSharedCardsByUserResponse,
  GetSharedCardCustomersData,
  GetSharedCardCustomersResponse,
  DeleteShareCardData,
  DeleteShareCardResponse,
  ShareCard1Data,
  ShareCard1Response,
  AddMetadataData,
  AddMetadataResponse,
  GetSharedCardsByUser1Data,
  GetSharedCardsByUser1Response,
  ShareBankData,
  ShareBankResponse,
  GetSharedBanksByUserData,
  GetSharedBanksByUserResponse,
  GetSharedBankCustomersData,
  GetSharedBankCustomersResponse,
  DeleteSharedBankAccountData,
  DeleteSharedBankAccountResponse,
  GetCoveragesData,
  GetCoveragesResponse,
  CreateRequestData,
  CreateRequestResponse,
  ResyncScriptSureData,
  ResyncScriptSureResponse,
  RevokeData,
  RevokeResponse,
  Deny1Data,
  Deny1Response,
  Approve1Data,
  Approve1Response,
  GetUrgentMessageAlertResponse,
  UpdateUrgentMessageAlertData,
  UpdateUrgentMessageAlertResponse,
  ExpireEndedCoveragesResponse,
  GetCoverageByUuidData,
  GetCoverageByUuidResponse,
  GetActiveCoverageResponse,
  UploadSoapNotePdfData,
  UploadSoapNotePdfResponse,
  UploadSingleLabOrderPdfData,
  UploadSingleLabOrderPdfResponse,
  UploadPocPdfData,
  UploadPocPdfResponse,
  UploadPatientInformationPdfData,
  UploadPatientInformationPdfResponse,
  UploadLabResultPdfData,
  UploadLabResultPdfResponse,
  UploadImagingResultPdfData,
  UploadImagingResultPdfResponse,
  UploadHandpNotePdfData,
  UploadHandpNotePdfResponse,
  SignExistingPdfData,
  SignExistingPdfResponse,
  GeneratePdfData,
  GeneratePdfResponse,
  GenerateWorkNotePdfData,
  GenerateWorkNotePdfResponse,
  GenerateExportStatementPdfData,
  GenerateExportStatementPdfResponse,
  GenerateSpecimenLabelData,
  GenerateSpecimenLabelResponse,
  GenerateSoapNotePdfData,
  GenerateSoapNotePdfResponse,
  GenerateSingleLabOrderPdfData,
  GenerateSingleLabOrderPdfResponse,
  GenerateReturnLetterPdfData,
  GenerateReturnLetterPdfResponse,
  GenerateReferralPdfData,
  GenerateReferralPdfResponse,
  GenerateProviderAppointmentsPdfData,
  GenerateProviderAppointmentsPdfResponse,
  GeneratePocPdfData,
  GeneratePocPdfResponse,
  GeneratePatientInformationPdfData,
  GeneratePatientInformationPdfResponse,
  GenerateMedicationsPdfData,
  GenerateMedicationsPdfResponse,
  GenerateLabResultPdfData,
  GenerateLabResultPdfResponse,
  GenerateLabResultPdfByUuidData,
  GenerateLabResultPdfByUuidResponse,
  GenerateLabOrdersPdfData,
  GenerateLabOrdersPdfResponse,
  GenerateInventoryOrderPdfData,
  GenerateInventoryOrderPdfResponse,
  GenerateInventoryDetailPdfData,
  GenerateInventoryDetailPdfResponse,
  GenerateImmunizationsPdfData,
  GenerateImmunizationsPdfResponse,
  GenerateImagingResultPdfData,
  GenerateImagingResultPdfResponse,
  GenerateHandpNotePdfData,
  GenerateHandpNotePdfResponse,
  GenerateFacesheetPdfData,
  GenerateFacesheetPdfResponse,
  GenerateDiagnosisPdfData,
  GenerateDiagnosisPdfResponse,
  GenerateAuditLogPdfData,
  GenerateAuditLogPdfResponse,
  GetLabPdfByPatientData,
  GetLabPdfByPatientResponse,
  MakePayoutData,
  MakePayoutResponse,
  AddPayoutBankAccountData,
  AddPayoutBankAccountResponse,
  VerifyPayoutBankAccountData,
  VerifyPayoutBankAccountResponse,
  GetPayoutBankAccountsData,
  GetPayoutBankAccountsResponse,
  AddToInventoryData,
  AddToInventoryResponse,
  PollShipmentsResponse,
  PlaceOrderOnNorthWindData,
  PlaceOrderOnNorthWindResponse,
  TransferInventoryData,
  TransferInventoryResponse,
  AddInventoryQuantityData,
  AddInventoryQuantityResponse,
  UpdateInventoryData,
  UpdateInventoryResponse,
  UpdateFormularyData,
  UpdateFormularyResponse,
  UpdateAutoShipData,
  UpdateAutoShipResponse,
  GetAllInventoryData,
  GetAllInventoryResponse,
  LocationBasedFormularyData,
  LocationBasedFormularyResponse,
  ExportLocationBasedInventoryCsvResponse,
  ExportInventoryCsvData,
  ExportInventoryCsvResponse,
  GetAllShipmentMedicationByInvoiceNumberData,
  GetAllShipmentMedicationByInvoiceNumberResponse,
  GetAllShipmentData,
  GetAllShipmentResponse,
  GetAllOrderData,
  GetAllOrderResponse,
  UploadPatientAddressesCsvData,
  UploadPatientAddressesCsvResponse,
  GenerateShareLinkData,
  GenerateShareLinkResponse,
  DeleteShareLinkData,
  DeleteShareLinkResponse,
  UpdateShareLinkData,
  UpdateShareLinkResponse,
  GetAllShareLinksData,
  GetAllShareLinksResponse,
  DownloadPatientZipcodeCsvTemplateResponse,
  GetMapDataData,
  GetMapDataResponse,
  RegenerateInvoiceWithCurrentRenewalDateData,
  RegenerateInvoiceWithCurrentRenewalDateResponse,
  RegenerateEmployerMembershipInvoiceData,
  RegenerateEmployerMembershipInvoiceResponse,
  UploadEmployeeUploadTemplateData,
  UploadEmployeeUploadTemplateResponse,
  GetEmployeeUploadTemplateResponse,
  DownloadExcelTemplateResponse,
  DownloadCsvTemplateResponse,
  GetCsvTemplateAsFileResponse,
  PlaceOrderData,
  PlaceOrderResponse,
  AddToCartData,
  AddToCartResponse,
  UpdateQuantityData,
  UpdateQuantityResponse,
  GetAllCartsData,
  GetAllCartsResponse,
  DeleteCartByUuidData,
  DeleteCartByUuidResponse,
  RefreshData,
  RefreshResponse,
  ConfirmEnrollmentData,
  ConfirmEnrollmentResponse,
  LogoutData,
  LogoutResponse,
  LoginData,
  LoginResponse,
  VerifyOtpData,
  VerifyOtpResponse,
  ForgotPasswordData,
  ForgotPasswordResponse,
  JitsiTokenData,
  JitsiTokenResponse,
  GetAllSpecialitiesData,
  GetAllSpecialitiesResponse,
  GetAllPhysicianAccountTypesData,
  GetAllPhysicianAccountTypesResponse,
  GetEmailHistoryByUserData,
  GetEmailHistoryByUserResponse,
  GetEmployerManagementStatsData,
  GetEmployerManagementStatsResponse,
  GetAffiliateStatsResponse,
  GetAffiliatePortalStatsData,
  GetAffiliatePortalStatsResponse,
  MarkReviewResultData,
  MarkReviewResultResponse,
  GetPendingItemsData,
  GetPendingItemsResponse,
  GetPendingFormsCountData,
  GetPendingFormsCountResponse,
  GetPatientReportsData,
  GetPatientReportsResponse,
  GetPatientPortalCountsData,
  GetPatientPortalCountsResponse,
  GetMessegeInfoData,
  GetMessegeInfoResponse,
  GetLabAndImagingResultsData,
  GetLabAndImagingResultsResponse,
  GetWorkNoteByUuidData,
  GetWorkNoteByUuidResponse,
  UpdateWorkNoteData,
  UpdateWorkNoteResponse,
  DeleteWorkNoteByUuidData,
  DeleteWorkNoteByUuidResponse,
  AddWorkNoteData,
  AddWorkNoteResponse,
  GetAllWorkNotesData,
  GetAllWorkNotesResponse,
  GetVitalByUuidData,
  GetVitalByUuidResponse,
  UpdateVitalData,
  UpdateVitalResponse,
  DeleteVitalData,
  DeleteVitalResponse,
  AddVitalData,
  AddVitalResponse,
  RecalculateGrowthPercentilesResponse,
  GetAllVitalsData,
  GetAllVitalsResponse,
  GetVaccineByUuidData,
  GetVaccineByUuidResponse,
  UpdateVaccineData,
  UpdateVaccineResponse,
  DeleteVaccineByUuidData,
  DeleteVaccineByUuidResponse,
  CreateVaccineData,
  CreateVaccineResponse,
  GetAllVaccinesData,
  GetAllVaccinesResponse,
  GetTaskByUuidData,
  GetTaskByUuidResponse,
  UpdateTaskData,
  UpdateTaskResponse,
  DeleteTaskData,
  DeleteTaskResponse,
  AddTaskData,
  AddTaskResponse,
  ResolveTasksForThreadData,
  ResolveTasksForThreadResponse,
  ProcessTaskRemindersResponse,
  HasUnresolvedTaskForThreadData,
  HasUnresolvedTaskForThreadResponse,
  GetAllTasksData,
  GetAllTasksResponse,
  UpdateStatusConfigurationData,
  UpdateStatusConfigurationResponse,
  CreateStatusConfigurationData,
  CreateStatusConfigurationResponse,
  GetStatusConfigurationByUuidData,
  GetStatusConfigurationByUuidResponse,
  DeleteStatusConfigurationByUuidData,
  DeleteStatusConfigurationByUuidResponse,
  GetAllStatusConfigurationsData,
  GetAllStatusConfigurationsResponse,
  GetSocialHistoryByUuidData,
  GetSocialHistoryByUuidResponse,
  UpdateSocialHistoryData,
  UpdateSocialHistoryResponse,
  DeleteSocialHistoryByUuidData,
  DeleteSocialHistoryByUuidResponse,
  GetAllSocialHistoryData,
  GetAllSocialHistoryResponse,
  UpdateSoapNoteData,
  UpdateSoapNoteResponse,
  AddSoapNoteData,
  AddSoapNoteResponse,
  UpdatePreEngagedStatusData,
  UpdatePreEngagedStatusResponse,
  GetSoapNoteByUuidData,
  GetSoapNoteByUuidResponse,
  DeleteSoapNoteData,
  DeleteSoapNoteResponse,
  GetAllWorkNotes1Data,
  GetAllWorkNotes1Response,
  GetSoapNotesByPatientUuidData,
  GetSoapNotesByPatientUuidResponse,
  GetAllInstructionsData,
  GetAllInstructionsResponse,
  GetSoapNoteByAppointmentUuidData,
  GetSoapNoteByAppointmentUuidResponse,
  GetSoapNoteAndHandPnoteByAppointmentUuidData,
  GetSoapNoteAndHandPnoteByAppointmentUuidResponse,
  GetVisitNotesByPatientUuidData,
  GetVisitNotesByPatientUuidResponse,
  GetAllEncounterDetailsData,
  GetAllEncounterDetailsResponse,
  GetAllCarePlanNotesData,
  GetAllCarePlanNotesResponse,
  GetAllSoapNotesData,
  GetAllSoapNotesResponse,
  GetSoapNoteTemplateByUuidData,
  GetSoapNoteTemplateByUuidResponse,
  UpdateSoapNoteTemplateData,
  UpdateSoapNoteTemplateResponse,
  DeleteSoapNoteTemplateByUuidData,
  DeleteSoapNoteTemplateByUuidResponse,
  AddSoapNoteTemplateData,
  AddSoapNoteTemplateResponse,
  UpdateSoapNoteTemplateBookmarkData,
  UpdateSoapNoteTemplateBookmarkResponse,
  GetAllSoapNoteTemplatesData,
  GetAllSoapNoteTemplatesResponse,
  GetScreenHistoryByUuidData,
  GetScreenHistoryByUuidResponse,
  UpdateScreenHistoryData,
  UpdateScreenHistoryResponse,
  DeleteScreenHistoryByUuidData,
  DeleteScreenHistoryByUuidResponse,
  Create11Data,
  Create11Response,
  GetAllScreenHistoryData,
  GetAllScreenHistoryResponse,
  GetReviewOfSystemTemplateByUuidData,
  GetReviewOfSystemTemplateByUuidResponse,
  UpdateReviewOfSystemTemplateData,
  UpdateReviewOfSystemTemplateResponse,
  DeleteReviewOfSystemTemplateData,
  DeleteReviewOfSystemTemplateResponse,
  AddReviewOfSystemTemplateData,
  AddReviewOfSystemTemplateResponse,
  UpdateRosBookmarkData,
  UpdateRosBookmarkResponse,
  GetAllReviewOfSystemTemplatesData,
  GetAllReviewOfSystemTemplatesResponse,
  GetReviewOfSystemByUuidData,
  GetReviewOfSystemByUuidResponse,
  UpdateReviewOfSystemData,
  UpdateReviewOfSystemResponse,
  DeleteReviewOfSystemData,
  DeleteReviewOfSystemResponse,
  AddReviewOfSystemData,
  AddReviewOfSystemResponse,
  GetAllReviewOfSystemsData,
  GetAllReviewOfSystemsResponse,
  UpdateReferralByUuidData,
  UpdateReferralByUuidResponse,
  SaveReferralData,
  SaveReferralResponse,
  GetReferralByUuidData,
  GetReferralByUuidResponse,
  DeleteReferralByUuidData,
  DeleteReferralByUuidResponse,
  GetAllReferralsByProvidersData,
  GetAllReferralsByProvidersResponse,
  GetAllReferralsForGlobalData,
  GetAllReferralsForGlobalResponse,
  GetAllChartItemResponse,
  GetAllReferralsData,
  GetAllReferralsResponse,
  UpdateProviderDirectoryData,
  UpdateProviderDirectoryResponse,
  UploadCsv1Data,
  UploadCsv1Response,
  GetNppesImportHistoryData,
  GetNppesImportHistoryResponse,
  TriggerNppesImportResponse,
  TriggerNppesFileImportData,
  TriggerNppesFileImportResponse,
  SaveProviderDirectoryData,
  SaveProviderDirectoryResponse,
  GetProviderDirectoryUuidData,
  GetProviderDirectoryUuidResponse,
  DeleteProviderDirectoryByUuidData,
  DeleteProviderDirectoryByUuidResponse,
  GetAllReferralTypesData,
  GetAllReferralTypesResponse,
  ProviderDirectoryExportCsvData,
  ProviderDirectoryExportCsvResponse,
  GetAllProviderDirectoryData,
  GetAllProviderDirectoryResponse,
  UpdatePointOfCareLabData,
  UpdatePointOfCareLabResponse,
  CreatePointOfCareLabData,
  CreatePointOfCareLabResponse,
  GetPointOfCareLabByUuidData,
  GetPointOfCareLabByUuidResponse,
  DeletePointOfCareLabByUuidData,
  DeletePointOfCareLabByUuidResponse,
  GetAllPointOfCareLabData,
  GetAllPointOfCareLabResponse,
  GetPocLabTestByIdData,
  GetPocLabTestByIdResponse,
  UpdatePocLabTestData,
  UpdatePocLabTestResponse,
  DeletePocLabTestData,
  DeletePocLabTestResponse,
  AddPocLabTestData,
  AddPocLabTestResponse,
  GetAllPocLabTestsData,
  GetAllPocLabTestsResponse,
  DeletePocTestFieldsData,
  DeletePocTestFieldsResponse,
  GetPocLabResultByIdData,
  GetPocLabResultByIdResponse,
  UpdatePocLabResultData,
  UpdatePocLabResultResponse,
  DeletePocLabResultData,
  DeletePocLabResultResponse,
  AddPocLabResultData,
  AddPocLabResultResponse,
  GetAllPocLabResultsData,
  GetAllPocLabResultsResponse,
  GetPhysicalExamTemplateByUuidData,
  GetPhysicalExamTemplateByUuidResponse,
  UpdatePhysicalExamTemplateData,
  UpdatePhysicalExamTemplateResponse,
  DeletePhysicalExamTemplateByUuidData,
  DeletePhysicalExamTemplateByUuidResponse,
  AddPhysicalExamTemplateData,
  AddPhysicalExamTemplateResponse,
  UpdatePhysicalExamTemplateBookmarkData,
  UpdatePhysicalExamTemplateBookmarkResponse,
  GetAllPhysicalExamTemplatesData,
  GetAllPhysicalExamTemplatesResponse,
  GetPhysicalExamByUuidData,
  GetPhysicalExamByUuidResponse,
  UpdatePhysicalExamData,
  UpdatePhysicalExamResponse,
  DeletePhysicalExamByUuidData,
  DeletePhysicalExamByUuidResponse,
  AddPhysicalExamData,
  AddPhysicalExamResponse,
  GetAllPhysicalExamsData,
  GetAllPhysicalExamsResponse,
  GetPharmacyByUuidData,
  GetPharmacyByUuidResponse,
  UpdatePharmacyData,
  UpdatePharmacyResponse,
  DeletePharmacyData,
  DeletePharmacyResponse,
  AddPharmacyData,
  AddPharmacyResponse,
  GetAllPharmaciesData,
  GetAllPharmaciesResponse,
  GetPatientVaccinationByUuidData,
  GetPatientVaccinationByUuidResponse,
  UpdatePatientVaccinationData,
  UpdatePatientVaccinationResponse,
  DeletePatientVaccinationData,
  DeletePatientVaccinationResponse,
  CreatePatientVaccinationData,
  CreatePatientVaccinationResponse,
  GetAllVaccinationsForPdfData,
  GetAllVaccinationsForPdfResponse,
  ExportPatientVaccinationsData,
  ExportPatientVaccinationsResponse,
  GetAllPatientVaccinationData,
  GetAllPatientVaccinationResponse,
  GetAllPatientVaccinationForVaccineTableData,
  GetAllPatientVaccinationForVaccineTableResponse,
  GetPatientFlagByUuidData,
  GetPatientFlagByUuidResponse,
  UpdatePatientFlagData,
  UpdatePatientFlagResponse,
  DeletePatientFlagData,
  DeletePatientFlagResponse,
  AddPatientFlagData,
  AddPatientFlagResponse,
  GetAllPatientFlagsData,
  GetAllPatientFlagsResponse,
  GetPastSurgicalHistoryByUuidData,
  GetPastSurgicalHistoryByUuidResponse,
  UpdatePastSurgicalHistoryData,
  UpdatePastSurgicalHistoryResponse,
  DeletePastSurgicalHistoryByUuidData,
  DeletePastSurgicalHistoryByUuidResponse,
  AddPastSurgicalHistoryData,
  AddPastSurgicalHistoryResponse,
  GetAllPastSurgicalHistoryData,
  GetAllPastSurgicalHistoryResponse,
  GetPastMedicalHistoryByUuidData,
  GetPastMedicalHistoryByUuidResponse,
  UpdatePastMedicalHistoryData,
  UpdatePastMedicalHistoryResponse,
  DeletePastMedicalHistoryByUuidData,
  DeletePastMedicalHistoryByUuidResponse,
  AddPastMedicalHistoryData,
  AddPastMedicalHistoryResponse,
  GetAllPastMedicalHistoryData,
  GetAllPastMedicalHistoryResponse,
  UpdateNoteByUuidData,
  UpdateNoteByUuidResponse,
  SaveThreadToChartData,
  SaveThreadToChartResponse,
  SaveNoteData,
  SaveNoteResponse,
  UpdateNoteFlagData,
  UpdateNoteFlagResponse,
  GetNoteByUuidData,
  GetNoteByUuidResponse,
  DeleteNoteByUuidData,
  DeleteNoteByUuidResponse,
  GetNoteByThreadUuidData,
  GetNoteByThreadUuidResponse,
  GetAllNotesData,
  GetAllNotesResponse,
  GetAllFlagNotesData,
  GetAllFlagNotesResponse,
  GetMedicationByUuidData,
  GetMedicationByUuidResponse,
  UpdateMedicationByUuidData,
  UpdateMedicationByUuidResponse,
  DeleteMedicationByUuidData,
  DeleteMedicationByUuidResponse,
  UploadMedicationsData,
  UploadMedicationsResponse,
  SaveMedicationData,
  SaveMedicationResponse,
  GetAllMedicationsForPdfData,
  GetAllMedicationsForPdfResponse,
  DownloadCsvTemplate11Response,
  GetAllMedicationsData,
  GetAllMedicationsResponse,
  GetMacroByUuidData,
  GetMacroByUuidResponse,
  UpdateMacroData,
  UpdateMacroResponse,
  DeleteMacroData,
  DeleteMacroResponse,
  AddMacroData,
  AddMacroResponse,
  UpdateMacroBookmarkData,
  UpdateMacroBookmarkResponse,
  GetMacroByTextData,
  GetMacroByTextResponse,
  GetAllMacroData,
  GetAllMacroResponse,
  UpdateLocationData,
  UpdateLocationResponse,
  AddLocationData,
  AddLocationResponse,
  GetLocationByUuidData,
  GetLocationByUuidResponse,
  DeleteLocationByUuidData,
  DeleteLocationByUuidResponse,
  ExportLocationsToCsvData,
  ExportLocationsToCsvResponse,
  GetAllLocationListResponse,
  GetAllLocationData,
  GetAllLocationResponse,
  UpdateSingleToggleData,
  UpdateSingleToggleResponse,
  GetAllSettingsByLocationData,
  GetAllSettingsByLocationResponse,
  UpdateLocationGroupData,
  UpdateLocationGroupResponse,
  AddLocationGroupData,
  AddLocationGroupResponse,
  GetLocationGroupByUuidData,
  GetLocationGroupByUuidResponse,
  DeleteLocationGroupByUuidData,
  DeleteLocationGroupByUuidResponse,
  GetAllLocationGroupData,
  GetAllLocationGroupResponse,
  GetLocationAvailabilityByUuidData,
  GetLocationAvailabilityByUuidResponse,
  UpdateLocationAvailabilityData,
  UpdateLocationAvailabilityResponse,
  DeleteLocationAvailabilityByUuidData,
  DeleteLocationAvailabilityByUuidResponse,
  Create21Data,
  Create21Response,
  GetAllLocationAvailabilityData,
  GetAllLocationAvailabilityResponse,
  SetDefaultPharmacyData,
  SetDefaultPharmacyResponse,
  LinkPharmacyData,
  LinkPharmacyResponse,
  GetAllPharmaciesForPatientData,
  GetAllPharmaciesForPatientResponse,
  DeletePharmacyForPatientByUuidData,
  DeletePharmacyForPatientByUuidResponse,
  UpdateLabTestData,
  UpdateLabTestResponse,
  CreateLabTestData,
  CreateLabTestResponse,
  GetLabTestByUuidData,
  GetLabTestByUuidResponse,
  DeleteLabTestByUuidData,
  DeleteLabTestByUuidResponse,
  GetAllLabTestData,
  GetAllLabTestResponse,
  ApproveLabResultData,
  ApproveLabResultResponse,
  ProccesResultResponse,
  GetAllLabResultsByOrderUuidData,
  GetAllLabResultsByOrderUuidResponse,
  AddLabResultByOrderUuidData,
  AddLabResultByOrderUuidResponse,
  AddLabResultData,
  AddLabResultResponse,
  GetAllLabResultsByPatientUuidData,
  GetAllLabResultsByPatientUuidResponse,
  GetAllLabResultsData,
  GetAllLabResultsResponse,
  ArchiveLabResultData,
  ArchiveLabResultResponse,
  UpdateLabOrderData,
  UpdateLabOrderResponse,
  CreateLabOrderData,
  CreateLabOrderResponse,
  CalculatePriceData,
  CalculatePriceResponse,
  GetLabOrderByUuidData,
  GetLabOrderByUuidResponse,
  DeleteLabOrderByUuidData,
  DeleteLabOrderByUuidResponse,
  MarkAsCompleteData,
  MarkAsCompleteResponse,
  ArchiveLabOrderByUuidData,
  ArchiveLabOrderByUuidResponse,
  GetSpecimenLabelData,
  GetSpecimenLabelResponse,
  GetLabOrderHistoryData,
  GetLabOrderHistoryResponse,
  GetTestCodesWithOrderSetsData,
  GetTestCodesWithOrderSetsResponse,
  GetAllLabOrdersForPdf1Data,
  GetAllLabOrdersForPdf1Response,
  GetAllDraftLabAndImagingOrdersData,
  GetAllDraftLabAndImagingOrdersResponse,
  GetAllLabOrderData,
  GetAllLabOrderResponse,
  UpdateLabOrderSetData,
  UpdateLabOrderSetResponse,
  CreateLabOrderSetData,
  CreateLabOrderSetResponse,
  GetLabOrderSetByUuidData,
  GetLabOrderSetByUuidResponse,
  DeleteLabOrderSetByUuidData,
  DeleteLabOrderSetByUuidResponse,
  GetAllLabOrderSetData,
  GetAllLabOrderSetResponse,
  GetGlobalLabOrderSetData,
  GetGlobalLabOrderSetResponse,
  GetInvoiceByUuidData,
  GetInvoiceByUuidResponse,
  UpdateInvoiceByUuidData,
  UpdateInvoiceByUuidResponse,
  DeleteInvoiceByUuidData,
  DeleteInvoiceByUuidResponse,
  SaveInvoiceStatementData,
  SaveInvoiceStatementResponse,
  SaveInvoiceData,
  SaveInvoiceResponse,
  GetInvoiceStatement1Data,
  GetInvoiceStatement1Response,
  ExportInvoicesToCsvData,
  ExportInvoicesToCsvResponse,
  GetAllInvoicesData,
  GetAllInvoicesResponse,
  UpdateInsuranceData,
  UpdateInsuranceResponse,
  CreateInsuranceData,
  CreateInsuranceResponse,
  GetAllPatientInsuranceWithDependentsData,
  GetAllPatientInsuranceWithDependentsResponse,
  GetInsuranceByUuidData,
  GetInsuranceByUuidResponse,
  DeleteInsuranceByUuidData,
  DeleteInsuranceByUuidResponse,
  GetAllPatientInsuranceData,
  GetAllPatientInsuranceResponse,
  GetImagingResultByUuidData,
  GetImagingResultByUuidResponse,
  UpdateImagingResultData,
  UpdateImagingResultResponse,
  DeleteImagingResultByUuidData,
  DeleteImagingResultByUuidResponse,
  SaveImagingResultData,
  SaveImagingResultResponse,
  ExportCsv1Data,
  ExportCsv1Response,
  GetAllImagingResultsData,
  GetAllImagingResultsResponse,
  GetImagingOrderByUuidData,
  GetImagingOrderByUuidResponse,
  UpdateImagingOrderData,
  UpdateImagingOrderResponse,
  DeleteImagingOrderByUuidData,
  DeleteImagingOrderByUuidResponse,
  SaveImagingOrderData,
  SaveImagingOrderResponse,
  GetAllImagingOrderData,
  GetAllImagingOrderResponse,
  GetIcdCodeByUuidData,
  GetIcdCodeByUuidResponse,
  UpdateIcdCodeData,
  UpdateIcdCodeResponse,
  DeleteIcdCodeByUuidData,
  DeleteIcdCodeByUuidResponse,
  CreateIcdCodeData,
  CreateIcdCodeResponse,
  SearchExternalIcdCodesData,
  SearchExternalIcdCodesResponse,
  GetAllIcdCodesData,
  GetAllIcdCodesResponse,
  GetHandPnoteByUuidData,
  GetHandPnoteByUuidResponse,
  UpdateHandPnoteData,
  UpdateHandPnoteResponse,
  DeleteHandPnoteData,
  DeleteHandPnoteResponse,
  AddHandPnoteData,
  AddHandPnoteResponse,
  GetUnsignedNotesByUserData,
  GetUnsignedNotesByUserResponse,
  GetHandPnotesByPatientUuidData,
  GetHandPnotesByPatientUuidResponse,
  GetHandPnoteByAppointmentUuidData,
  GetHandPnoteByAppointmentUuidResponse,
  GetAllEncountersWithoutDateFilterData,
  GetAllEncountersWithoutDateFilterResponse,
  GetAllHandPnotesData,
  GetAllHandPnotesResponse,
  GetAllEncounterData,
  GetAllEncounterResponse,
  GetHabitsByUuidData,
  GetHabitsByUuidResponse,
  UpdateHabitsData,
  UpdateHabitsResponse,
  DeleteHabitsByUuidData,
  DeleteHabitsByUuidResponse,
  Create31Data,
  Create31Response,
  GetAllHabitsData,
  GetAllHabitsResponse,
  GetGlobalHolidayByUuidData,
  GetGlobalHolidayByUuidResponse,
  UpdateGlobalHolidayData,
  UpdateGlobalHolidayResponse,
  DeleteGlobalHolidayByUuidData,
  DeleteGlobalHolidayByUuidResponse,
  AddGlobalHolidayData,
  AddGlobalHolidayResponse,
  ToggleGlobalHolidayData,
  ToggleGlobalHolidayResponse,
  GetHolidaysForLocationData,
  GetHolidaysForLocationResponse,
  GetAllGlobalHolidaysData,
  GetAllGlobalHolidaysResponse,
  GetFormTemplateByUuidData,
  GetFormTemplateByUuidResponse,
  UpdateFormTemplateData,
  UpdateFormTemplateResponse,
  DeleteFormTemplateData,
  DeleteFormTemplateResponse,
  SetFormAsDefaultData,
  SetFormAsDefaultResponse,
  UpdateFormTemplateWithPdfData,
  UpdateFormTemplateWithPdfResponse,
  GetAllFormTemplatesData,
  GetAllFormTemplatesResponse,
  CreateFormTemplateData,
  CreateFormTemplateResponse,
  DuplicateFormTemplateData,
  DuplicateFormTemplateResponse,
  CreateFormTemplateWithPdfData,
  CreateFormTemplateWithPdfResponse,
  GetFormJsonData,
  GetFormJsonResponse,
  CheckIfFormDefaultExistsData,
  CheckIfFormDefaultExistsResponse,
  GetFormTemplateContentByTypeData,
  GetFormTemplateContentByTypeResponse,
  GetFdbMedicationByUuidData,
  GetFdbMedicationByUuidResponse,
  UpdateFdbMedicationData,
  UpdateFdbMedicationResponse,
  DeleteFdbMedicationByUuidData,
  DeleteFdbMedicationByUuidResponse,
  Create4Data,
  Create4Response,
  GetAllFdbMedicationsData,
  GetAllFdbMedicationsResponse,
  GetFamilyHistoryByUuidData,
  GetFamilyHistoryByUuidResponse,
  UpdateFamilyHistoryData,
  UpdateFamilyHistoryResponse,
  DeleteFamilyHistoryByUuidData,
  DeleteFamilyHistoryByUuidResponse,
  AddFamilyHistoryData,
  AddFamilyHistoryResponse,
  GetAllFamilyHistoryData,
  GetAllFamilyHistoryResponse,
  GetEducationalMaterialByUuidData,
  GetEducationalMaterialByUuidResponse,
  UpdateEducationalMaterialData,
  UpdateEducationalMaterialResponse,
  DeleteEducationalMaterialData,
  DeleteEducationalMaterialResponse,
  CreateEducationalMaterialData,
  CreateEducationalMaterialResponse,
  SetPatientsForMaterialData,
  SetPatientsForMaterialResponse,
  UpdatePatientMaterialBookmarkData,
  UpdatePatientMaterialBookmarkResponse,
  UpdateBookmarkData,
  UpdateBookmarkResponse,
  GetAllEducationalMaterialsData,
  GetAllEducationalMaterialsResponse,
  UpdateDrugIntoleranceData,
  UpdateDrugIntoleranceResponse,
  AddDrugIntoleranceData,
  AddDrugIntoleranceResponse,
  GetDrugIntoleranceByUuidData,
  GetDrugIntoleranceByUuidResponse,
  DeleteDrugIntoleranceByUuidData,
  DeleteDrugIntoleranceByUuidResponse,
  GetAllDrugIntolerancesForPdfData,
  GetAllDrugIntolerancesForPdfResponse,
  GetAllDrugIntolerancesData,
  GetAllDrugIntolerancesResponse,
  UpdateDocumentTypeData,
  UpdateDocumentTypeResponse,
  SaveDocumentTypeData,
  SaveDocumentTypeResponse,
  GetDocumentTypeByUuidData,
  GetDocumentTypeByUuidResponse,
  DeleteDocumentTypeByUuidData,
  DeleteDocumentTypeByUuidResponse,
  GetAllDocumentTypesData,
  GetAllDocumentTypesResponse,
  GetDiagnosisByUuidData,
  GetDiagnosisByUuidResponse,
  UpdateDiagnosisData,
  UpdateDiagnosisResponse,
  DeleteDiagnosisData,
  DeleteDiagnosisResponse,
  AddDiagnosisData,
  AddDiagnosisResponse,
  ResolvedDiagnosisData,
  ResolvedDiagnosisResponse,
  GetAllDiagnosisForPdfData,
  GetAllDiagnosisForPdfResponse,
  GetAllDiagnosesData,
  GetAllDiagnosesResponse,
  UpdateIcdCode1Data,
  UpdateIcdCode1Response,
  AddCptCodeData,
  AddCptCodeResponse,
  GetIcdCodeByUuid1Data,
  GetIcdCodeByUuid1Response,
  DeleteIcdCodeByUuid1Data,
  DeleteIcdCodeByUuid1Response,
  GetAllIcdCodes1Data,
  GetAllIcdCodes1Response,
  GetMessageByUuidData,
  GetMessageByUuidResponse,
  UpdateMessageData,
  UpdateMessageResponse,
  DeleteMessageData,
  DeleteMessageResponse,
  AddMessageData,
  AddMessageResponse,
  GetAssignableUsersForTaskData,
  GetAssignableUsersForTaskResponse,
  GetAllMessagesData,
  GetAllMessagesResponse,
  GetCarePlanByUuidData,
  GetCarePlanByUuidResponse,
  UpdateCarePlanByUuidData,
  UpdateCarePlanByUuidResponse,
  DeleteCarePlanData,
  DeleteCarePlanResponse,
  SaveCarePlanData,
  SaveCarePlanResponse,
  GetCarePlansData,
  GetCarePlansResponse,
  GetAllCarePlansData,
  GetAllCarePlansResponse,
  UpdateAvailabilityData,
  UpdateAvailabilityResponse,
  AddAvailabilityData,
  AddAvailabilityResponse,
  CreateAvailabilityForDateData,
  CreateAvailabilityForDateResponse,
  GetBlockDaysForProvidersData,
  GetBlockDaysForProvidersResponse,
  CreateBlockSlotData,
  CreateBlockSlotResponse,
  GetAvailabilityByProviderUuidData,
  GetAvailabilityByProviderUuidResponse,
  GetAvailabilitySlotsData,
  GetAvailabilitySlotsResponse,
  GetAvailabilitySlotForCalendarData,
  GetAvailabilitySlotForCalendarResponse,
  GetAllAvailabilityData,
  GetAllAvailabilityResponse,
  DeleteAvailabilityByUuidData,
  DeleteAvailabilityByUuidResponse,
  UpdateAppointmentData,
  UpdateAppointmentResponse,
  CreateAppointmentData,
  CreateAppointmentResponse,
  CancelAppointmentByUuidData,
  CancelAppointmentByUuidResponse,
  SubmitVideoConsentData,
  SubmitVideoConsentResponse,
  ConfirmAppointmentFromSmsData,
  ConfirmAppointmentFromSmsResponse,
  GenerateCalendarSyncUrlResponse,
  UpdateAppointmentStatusData,
  UpdateAppointmentStatusResponse,
  GetAppointmentByUuidData,
  GetAppointmentByUuidResponse,
  GetAppointmentVisitDetailsData,
  GetAppointmentVisitDetailsResponse,
  GetVideoConsentFormResponse,
  GetAppointmentForDashBoardData,
  GetAppointmentForDashBoardResponse,
  GetProviderCalendarIcsData,
  GetProviderCalendarIcsResponse,
  GetAllAppointmentsData,
  GetAllAppointmentsResponse,
  DeleteAppointmentByUuidData,
  DeleteAppointmentByUuidResponse,
  UpdateAppointmentTypeData,
  UpdateAppointmentTypeResponse,
  CreateAppointmentTypeData,
  CreateAppointmentTypeResponse,
  GetAppointmentTypeByUuidData,
  GetAppointmentTypeByUuidResponse,
  DeleteAppointmentTypeByUuidData,
  DeleteAppointmentTypeByUuidResponse,
  GetAllAppointmentTypeData,
  GetAllAppointmentTypeResponse,
  GetAnnotableImageData,
  GetAnnotableImageResponse,
  UpdateAnnotableImageData,
  UpdateAnnotableImageResponse,
  DeleteAnnotableImageData,
  DeleteAnnotableImageResponse,
  AddAnnotableImageData,
  AddAnnotableImageResponse,
  GetAllAnnotableImagesData,
  GetAllAnnotableImagesResponse,
  GetAnnotableImageTemplateByUuidData,
  GetAnnotableImageTemplateByUuidResponse,
  UpdateAnnotableImageTemplateData,
  UpdateAnnotableImageTemplateResponse,
  DeleteAnnotableImageTemplateData,
  DeleteAnnotableImageTemplateResponse,
  AddAnnotableImageTemplateData,
  AddAnnotableImageTemplateResponse,
  UpdateAnnotableImageTemplateBookmarkData,
  UpdateAnnotableImageTemplateBookmarkResponse,
  GetAllAnnotableImageTemplateData,
  GetAllAnnotableImageTemplateResponse,
  GetAnnotableImagePinByUuidData,
  GetAnnotableImagePinByUuidResponse,
  UpdateAnnotableImagePinData,
  UpdateAnnotableImagePinResponse,
  DeleteAnnotableImagePinData,
  DeleteAnnotableImagePinResponse,
  AddAnnotableImagePinData,
  AddAnnotableImagePinResponse,
  GetAllAnnotableImagePinsData,
  GetAllAnnotableImagePinsResponse,
  GetAllergyByUuidData,
  GetAllergyByUuidResponse,
  UpdateAllergy1Data,
  UpdateAllergy1Response,
  DeleteAllergyByUuIdData,
  DeleteAllergyByUuIdResponse,
  AddAllergyData,
  AddAllergyResponse,
  GetAllAllergiesForPdfData,
  GetAllAllergiesForPdfResponse,
  GetAllAllergiesData,
  GetAllAllergiesResponse,
  SubmitQuestionnaireMultipartData,
  SubmitQuestionnaireMultipartResponse,
  SendQuestionnaireReminderData,
  SendQuestionnaireReminderResponse,
  SendQuestionnaireFax1Data,
  SendQuestionnaireFax1Response,
  UploadPdfData,
  UploadPdfResponse,
  MarkAsReviewedData,
  MarkAsReviewedResponse,
  GetQuestionnairePdfUrlsData,
  GetQuestionnairePdfUrlsResponse,
  GetQuestionnaireTableMappingsData,
  GetQuestionnaireTableMappingsResponse,
  GetQuestionnaireContentForPatientData,
  GetQuestionnaireContentForPatientResponse,
  GetQuestionnairesForPatientPortalData,
  GetQuestionnairesForPatientPortalResponse,
  DeleteQuestionnaireData,
  DeleteQuestionnaireResponse,
  ReceiveQuestResultData,
  ReceiveQuestResultResponse,
  GetOrderDocumentData,
  GetOrderDocumentResponse,
  GetAllCptCodesData,
  GetAllCptCodesResponse,
  GetAoeQuestionsData,
  GetAoeQuestionsResponse,
  GetAllCodesData,
  GetAllCodesResponse,
  UpdateCompadiumResponse,
  SendOrderData,
  SendOrderResponse,
  SubmitToQuestData,
  SubmitToQuestResponse,
  TestOrderQuestData,
  TestOrderQuestResponse,
  GetResultsData,
  GetResultsResponse,
  SendFormToPatientData,
  SendFormToPatientResponse,
  SendMultipleFormsToPatientData,
  SendMultipleFormsToPatientResponse,
  SendFormToBulkPatientsData,
  SendFormToBulkPatientsResponse,
  UploadDocumentData,
  UploadDocumentResponse,
  SaveDocumentData,
  SaveDocumentResponse,
  UnshareDocumentWithPatientData,
  UnshareDocumentWithPatientResponse,
  ShareDocumentWithPatientData,
  ShareDocumentWithPatientResponse,
  UpdateReviewRequiredData,
  UpdateReviewRequiredResponse,
  ExpireDocumentData,
  ExpireDocumentResponse,
  GetDocumentByUuidData,
  GetDocumentByUuidResponse,
  DeleteDocumentByUuidData,
  DeleteDocumentByUuidResponse,
  GetAllDocuments1Data,
  GetAllDocuments1Response,
  SaveContactDirectoryData,
  SaveContactDirectoryResponse,
  GetContactDirectoryUuidData,
  GetContactDirectoryUuidResponse,
  DeleteContactDirectoryByUuidData,
  DeleteContactDirectoryByUuidResponse,
  GetAllContactDirectoryData,
  GetAllContactDirectoryResponse,
  UploadImageAsMultipartData,
  UploadImageAsMultipartResponse,
  UploadImageAsBase64Data,
  UploadImageAsBase64Response,
  UploadDocumentAsMultipartData,
  UploadDocumentAsMultipartResponse,
  UploadDocumentAsBase64Data,
  UploadDocumentAsBase64Response,
  GetFileData,
  GetFileResponse,
  GetFile1Data,
  GetFile1Response,
  GetDownloadUrlData,
  GetDownloadUrlResponse,
  GetDownloadUrl1Data,
  GetDownloadUrl1Response,
  SubmitAgreementMultipartData,
  SubmitAgreementMultipartResponse,
  CreateAffiliateAgreementData,
  CreateAffiliateAgreementResponse,
  CreateMultipleAffiliateAgreementsData,
  CreateMultipleAffiliateAgreementsResponse,
  GetAgreementByUuidData,
  GetAgreementByUuidResponse,
  DeleteAgreementData,
  DeleteAgreementResponse,
  GetAgreementPdfUrlsData,
  GetAgreementPdfUrlsResponse,
  GetAgreementContentForAffiliateGroupData,
  GetAgreementContentForAffiliateGroupResponse,
  GetAgreementsForPortalData,
  GetAgreementsForPortalResponse,
  GetAllAgreementsForFirmsData,
  GetAllAgreementsForFirmsResponse,
  GetPendingAgreementForLoginData,
  GetPendingAgreementForLoginResponse,
  GetAllTribleTestCodesData,
  GetAllTribleTestCodesResponse,
  GetByPatientUuidData,
  GetByPatientUuidResponse,
  GetAllLabOrdersForPdfData,
  GetAllLabOrdersForPdfResponse,
  GetAll1Data,
  GetAll1Response,
  GetAllTaskCategoriesData,
  GetAllTaskCategoriesResponse,
  GetProcedureCodesData,
  GetProcedureCodesResponse,
  GetAllPlaceholdersResponse,
  GetAllDocumentsData,
  GetAllDocumentsResponse,
  GetGrowthChartData,
  GetGrowthChartResponse,
  GetAvailableFieldsResponse,
  GetAuditHistoryByUuidData,
  GetAuditHistoryByUuidResponse,
  GetUserAuditLogsData,
  GetUserAuditLogsResponse,
  GetTicketAuditLogsData,
  GetTicketAuditLogsResponse,
  GetTaskAuditLogsData,
  GetTaskAuditLogsResponse,
  GetSoapNoteAuditLogsData,
  GetSoapNoteAuditLogsResponse,
  GetPatientModuleAccessAuditLogsData,
  GetPatientModuleAccessAuditLogsResponse,
  GetInventoryAuditLogsData,
  GetInventoryAuditLogsResponse,
  GetHandPnoteAuditLogsData,
  GetHandPnoteAuditLogsResponse,
  ExportTaskAuditLogsCsvData,
  ExportTaskAuditLogsCsvResponse,
  ExportAuditLogsPdfData,
  ExportAuditLogsPdfResponse,
  ExportInventoryAuditLogsPdfData,
  ExportInventoryAuditLogsPdfResponse,
  ExportInventoryAuditLogsCsvData,
  ExportInventoryAuditLogsCsvResponse,
  ExportEmployerAuditLogsCsvData,
  ExportEmployerAuditLogsCsvResponse,
  ExportEmployeeAuditLogsCsvData,
  ExportEmployeeAuditLogsCsvResponse,
  ExportAuditLogsCsvData,
  ExportAuditLogsCsvResponse,
  ExportAuditLogsCsv1Data,
  ExportAuditLogsCsv1Response,
  ExportAdminAuditLogsCsvData,
  ExportAdminAuditLogsCsvResponse,
  GetTicketRelatedAuditLogsData,
  GetTicketRelatedAuditLogsResponse,
  GetEmployerAuditLogsData,
  GetEmployerAuditLogsResponse,
  GetEmployerAdministratorAuditLogsData,
  GetEmployerAdministratorAuditLogsResponse,
  GetEmployeeAuditLogsData,
  GetEmployeeAuditLogsResponse,
  GetBreakGlassAuditLogsData,
  GetBreakGlassAuditLogsResponse,
  GetAllAuditEntitiesResponse,
  GetAllTicketAuditLogsData,
  GetAllTicketAuditLogsResponse,
  GetAllAuditHistoryData,
  GetAllAuditHistoryResponse,
  GetAdminAuditLogsData,
  GetAdminAuditLogsResponse,
  MarkAsReadData,
  MarkAsReadResponse,
  GetAllNotificationsData,
  GetAllNotificationsResponse,
  CreateNotificationData,
  CreateNotificationResponse,
  GetNotificationData,
  GetNotificationResponse,
  DeleteNotificationData,
  DeleteNotificationResponse,
  GetNotificationCountByUserUuidData,
  GetNotificationCountByUserUuidResponse,
  UpdateNotificationPreferenceData,
  UpdateNotificationPreferenceResponse,
  AddNotificationPreferenceData,
  AddNotificationPreferenceResponse,
  GetAllNotificationPreferenceResponse,
  UpdateSingleToggle1Data,
  UpdateSingleToggle1Response,
  UploadEmailStructureAndTemplateToS32Data,
  UploadEmailStructureAndTemplateToS32Response,
  UpdateStatusData,
  UpdateStatusResponse,
  GetEmployerManagementNotificationSettingyUuidData,
  GetEmployerManagementNotificationSettingyUuidResponse,
  GetAllSettingsByEmployerData,
  GetAllSettingsByEmployerResponse,
  GetAllEmployerManagementNotificationSettingsData,
  GetAllEmployerManagementNotificationSettingsResponse,
  SendFcmNotificationData,
  SendFcmNotificationResponse,
  SendFcmBulkNotificationData,
  SendFcmBulkNotificationResponse,
  GetNotificationSettingyUuidData,
  GetNotificationSettingyUuidResponse,
  UpdateCustomNotificationData,
  UpdateCustomNotificationResponse,
  SendEmailForSetPasswordData,
  SendEmailForSetPasswordResponse,
  UploadEmailTemplateToS3Data,
  UploadEmailTemplateToS3Response,
  UploadEmailStructureAndTemplateToS3Data,
  UploadEmailStructureAndTemplateToS3Response,
  SendEmailForData,
  SendEmailForResponse,
  SendEmailForAddPaymentToPatientData,
  SendEmailForAddPaymentToPatientResponse,
  SendAddressChangeMailToPhpData,
  SendAddressChangeMailToPhpResponse,
  SendEmailForProviderSignupData,
  SendEmailForProviderSignupResponse,
  SendAppointmentJoinNotificationToPatientData,
  SendAppointmentJoinNotificationToPatientResponse,
  SendLabResultToPatientData,
  SendLabResultToPatientResponse,
  SendRetailEnrollmentNotificationResponse,
  SendRefundEmailData,
  SendRefundEmailResponse,
  SendEmailForPatientBirthdayResponse,
  SendUpcomingInvoiceNotificationData,
  SendUpcomingInvoiceNotificationResponse,
  SendPatientNotificationEmailData,
  SendPatientNotificationEmailResponse,
  SendPatientEnrollmentRequestNotificationData,
  SendPatientEnrollmentRequestNotificationResponse,
  SendMultipleFormsEmailData,
  SendMultipleFormsEmailResponse,
  SendMembershipPaidEmailData,
  SendMembershipPaidEmailResponse,
  SendMembershipCreatedEmailData,
  SendMembershipCreatedEmailResponse,
  SendLabResultReadyNotificationData,
  SendLabResultReadyNotificationResponse,
  SendEmailForInvoiceNotificationAutopayDisabledResponse,
  SendEmailForInvoiceNotificationAutopayResponse,
  SendEmailForInvoiceData,
  SendEmailForInvoiceResponse,
  SendEmailsForInvoiceNotificationResponse,
  SendFailedPaymentSummaryToAdminResponse,
  SendUpcomingInvoiceNotificationToEmployerData,
  SendUpcomingInvoiceNotificationToEmployerResponse,
  SendPatientPaidNotificationToEmployerData,
  SendPatientPaidNotificationToEmployerResponse,
  SendInvoiceIssuedNotificationToEmployerData,
  SendInvoiceIssuedNotificationToEmployerResponse,
  SendCreatedInvoiceNotificationToEmployerData,
  SendCreatedInvoiceNotificationToEmployerResponse,
  SendAutopayProcessedNotificationToEmployerData,
  SendAutopayProcessedNotificationToEmployerResponse,
  SendEmployerInvoiceCreationReminderNotificationResponse,
  SendEmailForChargePaidData,
  SendEmailForChargePaidResponse,
  SendEmailForCardExpiringSoonResponse,
  SendCardSharedEmailData,
  SendCardSharedEmailResponse,
  SendEmailForRemovalOfCardData,
  SendEmailForRemovalOfCardResponse,
  SendCardReceivedEmailData,
  SendCardReceivedEmailResponse,
  SendCallInvitationNotificationData,
  SendCallInvitationNotificationResponse,
  SendSignBrokerData,
  SendSignBrokerResponse,
  SendEmailForRemovalOfBankData,
  SendEmailForRemovalOfBankResponse,
  SendAppointmentEmailData,
  SendAppointmentEmailResponse,
  SendAgentFirmAgreementCreatedEmailData,
  SendAgentFirmAgreementCreatedEmailResponse,
  SendAffiliateAgreementCreatedEmailData,
  SendAffiliateAgreementCreatedEmailResponse,
  GetFile11Data,
  GetFile11Response,
  GetAllNotificationSettingsData,
  GetAllNotificationSettingsResponse,
  HandleSnsNotificationData,
  HandleSnsNotificationResponse,
  UploadEmailStructureAndTemplateToS31Data,
  UploadEmailStructureAndTemplateToS31Response,
  EmployerNotificationSettingUuidData,
  EmployerNotificationSettingUuidResponse,
  GetAllEmployerNotificationSettingsData,
  GetAllEmployerNotificationSettingsResponse,
  SendReferralEmailData,
  SendReferralEmailResponse,
  SendReferralEmailWithLinkData,
  SendReferralEmailWithLinkResponse,
  SendProviderReassignmentEmailsData,
  SendProviderReassignmentEmailsResponse,
  SendFormTemplateData,
  SendFormTemplateResponse,
  SendBulkEmailData,
  SendBulkEmailResponse,
  SendInvitationEmailData,
  SendInvitationEmailResponse,
  GetSubscription1Data,
  GetSubscription1Response,
  UpdateSubscription1Data,
  UpdateSubscription1Response,
  CancelSubscription1Data,
  CancelSubscription1Response,
  ChangePlan1Data,
  ChangePlan1Response,
  ChangePlanWithProration1Data,
  ChangePlanWithProration1Response,
  UpdatePromotionalCoupon1Data,
  UpdatePromotionalCoupon1Response,
  CreatePromotionalCoupon1Data,
  CreatePromotionalCoupon1Response,
  CreateSubscription1Data,
  CreateSubscription1Response,
  CreateSubscriptionWithPayment1Data,
  CreateSubscriptionWithPayment1Response,
  CreateSetupIntentWithCustomer1Data,
  CreateSetupIntentWithCustomer1Response,
  SetDefaultPaymentMethod1Data,
  SetDefaultPaymentMethod1Response,
  SaveCardToCustomerWithCharging1Data,
  SaveCardToCustomerWithCharging1Response,
  SaveCardToCustomer1Data,
  SaveCardToCustomer1Response,
  CreateProduct1Data,
  CreateProduct1Response,
  CreatePriceForProduct1Data,
  CreatePriceForProduct1Response,
  CreateProductAndPrice1Data,
  CreateProductAndPrice1Response,
  CreatePaymentIntent1Data,
  CreatePaymentIntent1Response,
  CreateCustomer1Data,
  CreateCustomer1Response,
  GetStripeConfig1Response,
  UpdateTicketData,
  UpdateTicketResponse,
  DeleteTicketData,
  DeleteTicketResponse,
  UpdateTicketPriorityData,
  UpdateTicketPriorityResponse,
  UpdateTicketStatusData,
  UpdateTicketStatusResponse,
  CreateTicketData,
  CreateTicketResponse,
  GetTicketByUuidData,
  GetTicketByUuidResponse,
  GetTicketsByEmployerUuidData,
  GetTicketsByEmployerUuidResponse,
  GetTotalTicketsCountByUuidData,
  GetTotalTicketsCountByUuidResponse,
  GetTicketCountsByStatusByUuidData,
  GetTicketCountsByStatusByUuidResponse,
  GetEmployerInfoData,
  GetEmployerInfoResponse,
  GetEmployerStatsData,
  GetEmployerStatsResponse,
  GetCreatorTicketStatsData,
  GetCreatorTicketStatsResponse,
  GetTicketCountsData,
  GetTicketCountsResponse,
  GetAllTicketsWithFiltersData,
  GetAllTicketsWithFiltersResponse,
  GetAdminTicketStatusData,
  GetAdminTicketStatusResponse,
  GetTicketTaskByUuidData,
  GetTicketTaskByUuidResponse,
  UpdateTicketTaskData,
  UpdateTicketTaskResponse,
  DeleteTicketTaskData,
  DeleteTicketTaskResponse,
  UpdateTicketTaskStatusData,
  UpdateTicketTaskStatusResponse,
  UpdateTicketTaskPriorityData,
  UpdateTicketTaskPriorityResponse,
  UpdateTicketTaskAssigneeData,
  UpdateTicketTaskAssigneeResponse,
  CreateTicketTaskData,
  CreateTicketTaskResponse,
  GetAllTasksByEmployerData,
  GetAllTasksByEmployerResponse,
  GetAllTasksByTicketUuidData,
  GetAllTasksByTicketUuidResponse,
  GetTicketNotesByUuidData,
  GetTicketNotesByUuidResponse,
  UpdateTicketNotesData,
  UpdateTicketNotesResponse,
  DeleteTicketNotesData,
  DeleteTicketNotesResponse,
  CreateTicketNotesData,
  CreateTicketNotesResponse,
  GetAllNotesByEmployerData,
  GetAllNotesByEmployerResponse,
  GetAllTicketNotesData,
  GetAllTicketNotesResponse,
  GetAttachmentByUuidData,
  GetAttachmentByUuidResponse,
  UpdateAttachmentData,
  UpdateAttachmentResponse,
  DeleteAttachmentData,
  DeleteAttachmentResponse,
  AddAttachmentData,
  AddAttachmentResponse,
  GetAllAttachmentsByEmployerData,
  GetAllAttachmentsByEmployerResponse,
  GetAllAttachmentsByTicketUuidData,
  GetAllAttachmentsByTicketUuidResponse,
  GetTemplateData,
  GetTemplateResponse,
  UpdateTemplateData,
  UpdateTemplateResponse,
  DeleteTemplateData,
  DeleteTemplateResponse,
  AddTemplateData,
  AddTemplateResponse,
  GetAllTemplatesData,
  GetAllTemplatesResponse,
  GetAllTemplates1Data,
  GetAllTemplates1Response,
  GetTaskByUuid1Data,
  GetTaskByUuid1Response,
  UpdateCrmTaskData,
  UpdateCrmTaskResponse,
  DeleteCrmTaskData,
  DeleteCrmTaskResponse,
  UpdateTaskPriorityData,
  UpdateTaskPriorityResponse,
  CreateTaskData,
  CreateTaskResponse,
  GetAllTasksByContactUuidData,
  GetAllTasksByContactUuidResponse,
  GetAllTasks1Data,
  GetAllTasks1Response,
  GetTaskLogByUuidData,
  GetTaskLogByUuidResponse,
  UpdateTaskLogData,
  UpdateTaskLogResponse,
  DeleteTaskLogData,
  DeleteTaskLogResponse,
  CreateTaskLogData,
  CreateTaskLogResponse,
  GetAllTaskLogsData,
  GetAllTaskLogsResponse,
  UpdateNewsletterData,
  UpdateNewsletterResponse,
  DeleteNewsletterData,
  DeleteNewsletterResponse,
  CreateNewsletterData,
  CreateNewsletterResponse,
  GetNewsletterByUuidResponse,
  GetAllNewsletterData,
  GetAllNewsletterResponse,
  GetCampaignByUuidData,
  GetCampaignByUuidResponse,
  UpdateCampaignData,
  UpdateCampaignResponse,
  DeleteCampaignResponse,
  CreateCampaignData,
  CreateCampaignResponse,
  GetAllCampaignData,
  GetAllCampaignResponse,
  GetCallLogByUuidData,
  GetCallLogByUuidResponse,
  UpdateCallLogData,
  UpdateCallLogResponse,
  DeleteCallLogData,
  DeleteCallLogResponse,
  CreateCallLogData,
  CreateCallLogResponse,
  GetAllCallLogsData,
  GetAllCallLogsResponse,
  MergeTicketData,
  MergeTicketResponse,
  GetMergedTicketData,
  GetMergedTicketResponse,
  GetAllMergedTicketsData,
  GetAllMergedTicketsResponse,
  LinkTicketData,
  LinkTicketResponse,
  GetLinkedTicketByUuidData,
  GetLinkedTicketByUuidResponse,
  GetAllLinkedTicketsData,
  GetAllLinkedTicketsResponse,
  UnlinkTicketData,
  UnlinkTicketResponse,
  CreateConversationData,
  CreateConversationResponse,
  GetConversationByUuidData,
  GetConversationByUuidResponse,
  GetAllConversationsByTicketUuidData,
  GetAllConversationsByTicketUuidResponse,
  MarkMessageUrgentData,
  MarkMessageUrgentResponse,
  MarkMessageReadByUserData,
  MarkMessageReadByUserResponse,
  CancelScheduledMessageData,
  CancelScheduledMessageResponse,
  MarkAllMessagesReadInThreadData,
  MarkAllMessagesReadInThreadResponse,
  MarkAllMessagesReadInThreadForUserData,
  MarkAllMessagesReadInThreadForUserResponse,
  RescheduleMessageData,
  RescheduleMessageResponse,
  EditScheduledMessageData,
  EditScheduledMessageResponse,
  RemoveMessageUrgentData,
  RemoveMessageUrgentResponse,
  SendMessageData,
  SendMessageResponse,
  SendScheduledMessageNowData,
  SendScheduledMessageNowResponse,
  RemoveAttacmentData,
  RemoveAttacmentResponse,
  GetUnreadMessageCountByUserUuidData,
  GetUnreadMessageCountByUserUuidResponse,
  GetMessageSummariesByUserUuidData,
  GetMessageSummariesByUserUuidResponse,
  GetUrgentUnreadMessagesForUserData,
  GetUrgentUnreadMessagesForUserResponse,
  GetUrgentUnreadMessageCountForUserData,
  GetUrgentUnreadMessageCountForUserResponse,
  GetUnreadMessagesForUserData,
  GetUnreadMessagesForUserResponse,
  GetUnreadMessageCountForUserResponse,
  ListMessagesData,
  ListMessagesResponse,
  GetScheduledMessagesData,
  GetScheduledMessagesResponse,
  CountUnreadData,
  CountUnreadResponse,
  CountUnreadForUserData,
  CountUnreadForUserResponse,
  SearchMessagesData,
  SearchMessagesResponse,
  GetPatientDependentsMessageSummaryData,
  GetPatientDependentsMessageSummaryResponse,
  DeleteMessageByUuidData,
  DeleteMessageByUuidResponse,
  DeleteScheduledMessageData,
  DeleteScheduledMessageResponse,
  EndCallData,
  EndCallResponse,
  DeclineCallData,
  DeclineCallResponse,
  CancelCallData,
  CancelCallResponse,
  AcceptCallData,
  AcceptCallResponse,
  StartCallData,
  StartCallResponse,
  GetCallData,
  GetCallResponse,
  OutboundDialData,
  OutboundDialResponse,
  InboundCallData,
  InboundCallResponse,
  DialActionData,
  DialActionResponse,
  AppDialData,
  AppDialResponse,
  RecordingsData,
  RecordingsResponse,
  EventsData,
  EventsResponse,
  IssueTokenData,
  IssueTokenResponse,
  UnregisterResponse,
  CallLogData,
  CallLogResponse,
  PlaceCallData,
  PlaceCallResponse,
  HangUpResponse,
  StatusResponse,
  GetCall1Data,
  GetCall1Response,
  ReadTranscriptData,
  ReadTranscriptResponse,
  PlayRecordingData,
  PlayRecordingResponse,
  InboundSmsData,
  InboundSmsResponse,
  SendSmsData,
  SendSmsResponse,
  SendGenericSmsData,
  SendGenericSmsResponse,
  GenerateAccessTokenResponse,
  GetServiceStatusResponse,
  CheckHealthResponse,
  CreateThreadData,
  CreateThreadResponse,
  ResumeThreadData,
  ResumeThreadResponse,
  BroadcastThreadListUpdateData,
  BroadcastThreadListUpdateResponse,
  BroadcastThreadSummariesData,
  BroadcastThreadSummariesResponse,
  RouteThreadData,
  RouteThreadResponse,
  CreateOpenThreadData,
  CreateOpenThreadResponse,
  MarkThreadUrgentData,
  MarkThreadUrgentResponse,
  UpdateThreadStatusData,
  UpdateThreadStatusResponse,
  UpdateOpenThreadData,
  UpdateOpenThreadResponse,
  GetThreadByIdData,
  GetThreadByIdResponse,
  GetOpenThreadUsersData,
  GetOpenThreadUsersResponse,
  SearchThreadsData,
  SearchThreadsResponse,
  GetThreadsByPatientData,
  GetThreadsByPatientResponse,
  GetThreadsListData,
  GetThreadsListResponse,
  GetMyThreadsData,
  GetMyThreadsResponse,
  GetThreadCategoriesResponse,
  BroadcastData,
  BroadcastResponse,
  BookmarkThreadData,
  BookmarkThreadResponse,
  UnbookmarkThreadData,
  UnbookmarkThreadResponse,
  BookmarkMessageData,
  BookmarkMessageResponse,
  UnbookmarkMessageData,
  UnbookmarkMessageResponse,
  GetBookmarkedThreadsData,
  GetBookmarkedThreadsResponse,
  GetBookmarkedMessagesData,
  GetBookmarkedMessagesResponse,
  GetMessagePositionInThreadData,
  GetMessagePositionInThreadResponse,
  GetBookmarkedMessagesByThreadData,
  GetBookmarkedMessagesByThreadResponse,
  UnbookmarkMessagesByThreadData,
  UnbookmarkMessagesByThreadResponse,
} from "./types.gen";

export class UserControllerService {
  /**
   * Archive/Unarchive User
   * Change User archive status to either archived or unarchived.
   * @param data The data for the request.
   * @param data.userId
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static updateUserArchiveStatus(
    data: UpdateUserArchiveStatusData,
  ): CancelablePromise<UpdateUserArchiveStatusResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/{userId}/archive-status/{status}",
      path: {
        userId: data.userId,
        status: data.status,
      },
    });
  }

  /**
   * Bulk Update User Status
   * Update status of multiple users in Keycloak
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static bulkUpdateUserStatus(
    data: BulkUpdateUserStatusData,
  ): CancelablePromise<BulkUpdateUserStatusResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/users/bulk-status",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Update Staff Users
   * Edit Staff User with editable fields as firstName, lastName, phone, roleType, role.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateUser(
    data: UpdateUserData,
  ): CancelablePromise<UpdateUserResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/user",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Add Staff User
   * Add a new Staff User into the system
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addUser(data: AddUserData): CancelablePromise<AddUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/user",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Enable/Disable User
   * Change user status to either active or inactive to restrict user from login
   * @param data The data for the request.
   * @param data.userId
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static updateUserStatus(
    data: UpdateUserStatusData,
  ): CancelablePromise<UpdateUserStatusResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/user/{userId}/status/{status}",
      path: {
        userId: data.userId,
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.deviceToken
   * @param data.deviceType
   * @returns Response OK
   * @throws ApiError
   */
  public static syncDeviceToken(
    data: SyncDeviceTokenData,
  ): CancelablePromise<SyncDeviceTokenResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/sync-device-token",
      query: {
        deviceToken: data.deviceToken,
        deviceType: data.deviceType,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.deviceType
   * @returns Response OK
   * @throws ApiError
   */
  public static revokeDeviceToken(
    data: RevokeDeviceTokenData,
  ): CancelablePromise<RevokeDeviceTokenResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/revoke-device-token",
      query: {
        deviceType: data.deviceType,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.oldPassword
   * @param data.newPassword
   * @returns Response OK
   * @throws ApiError
   */
  public static resetPassword(
    data: ResetPasswordData,
  ): CancelablePromise<ResetPasswordResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/reset-password",
      query: {
        oldPassword: data.oldPassword,
        newPassword: data.newPassword,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static switchLastLoggedInLocation(
    data: SwitchLastLoggedInLocationData,
  ): CancelablePromise<SwitchLastLoggedInLocationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/provider/switch-location/{locationUuid}",
      path: {
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * User Profile
   * Get Logged-in User Profile
   * @returns Response OK
   * @throws ApiError
   */
  public static getProfile(): CancelablePromise<GetProfileResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/profile",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateProfileDetailsOfUser(
    data: UpdateProfileDetailsOfUserData,
  ): CancelablePromise<UpdateProfileDetailsOfUserResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/profile",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.username
   * @returns Response OK
   * @throws ApiError
   */
  public static checkUsername(
    data: CheckUsernameData,
  ): CancelablePromise<CheckUsernameResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/check-username",
      query: {
        username: data.username,
      },
    });
  }

  /**
   * @returns string OK
   * @throws ApiError
   */
  public static handleStripeWebhook(): CancelablePromise<HandleStripeWebhookResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/webhook",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.roleType
   * @returns Response OK
   * @throws ApiError
   */
  public static registerUsersOnKeycloak(
    data: RegisterUsersOnKeycloakData = {},
  ): CancelablePromise<RegisterUsersOnKeycloakResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/users/register",
      query: {
        roleType: data.roleType,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userEmails
   * @param data.appointmentUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendInvite(
    data: SendInviteData,
  ): CancelablePromise<SendInviteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/user/invite/{userUuid}",
      query: {
        userEmails: data.userEmails,
        appointmentUuid: data.appointmentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static registerUserWithUuid(
    data: RegisterUserWithUuidData,
  ): CancelablePromise<RegisterUserWithUuidResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/register-with-uuid",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * List Staff Users
   * List staff users using Filter with Pagination and Sorting with filter options on status, archive and role and search functionality on firstName, lastName and email,
   * @param data The data for the request.
   * @param data.page
   * @param data.size
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.status
   * @param data.archive
   * @param data.role
   * @param data.roleType
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllUsers(
    data: GetAllUsersData = {},
  ): CancelablePromise<GetAllUsersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/users",
      query: {
        page: data.page,
        size: data.size,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        status: data.status,
        archive: data.archive,
        role: data.role,
        roleType: data.roleType,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllProviderAndStaffUser(
    data: GetAllProviderAndStaffUserData = {},
  ): CancelablePromise<GetAllProviderAndStaffUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/users/staff-providers/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.locationUuids
   * @param data.roleTypes
   * @returns Response OK
   * @throws ApiError
   */
  public static getClinicalStaff(
    data: GetClinicalStaffData = {},
  ): CancelablePromise<GetClinicalStaffResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/users/clinical-staff",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        locationUuids: data.locationUuids,
        roleTypes: data.roleTypes,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.roleType
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getUsersByRoleType(
    data: GetUsersByRoleTypeData = {},
  ): CancelablePromise<GetUsersByRoleTypeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/users/by-role-type",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        roleType: data.roleType,
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * Staff User
   * Get Staff User by userUuid
   * @param data The data for the request.
   * @param data.userId
   * @returns Response OK
   * @throws ApiError
   */
  public static getUser(data: GetUserData): CancelablePromise<GetUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/user/{userId}",
      path: {
        userId: data.userId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.iamid
   * @returns Response OK
   * @throws ApiError
   */
  public static getUserFromIamid(
    data: GetUserFromIamidData,
  ): CancelablePromise<GetUserFromIamidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/user/uuid/{iamid}",
      path: {
        iamid: data.iamid,
      },
    });
  }

  /**
   * @returns string OK
   * @throws ApiError
   */
  public static check(): CancelablePromise<CheckResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/check",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.registrationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static checkUserRegistration(
    data: CheckUserRegistrationData,
  ): CancelablePromise<CheckUserRegistrationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/check-registration",
      query: {
        registrationUuid: data.registrationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.isAffiliate
   * @returns Response OK
   * @throws ApiError
   */
  public static getAssignedLocations(
    data: GetAssignedLocationsData = {},
  ): CancelablePromise<GetAssignedLocationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/assigned-locations",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        isAffiliate: data.isAffiliate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.flag
   * @param data.affiliate
   * @returns Response OK
   * @throws ApiError
   */
  public static getUsers(
    data: GetUsersData = {},
  ): CancelablePromise<GetUsersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/all-users",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        flag: data.flag,
        affiliate: data.affiliate,
      },
    });
  }
}

export class EmployeeUploadControllerService {
  /**
   * @param data The data for the request.
   * @param data.uploadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static processUpload(
    data: ProcessUploadData,
  ): CancelablePromise<ProcessUploadResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/upload/process-upload/{uploadUuid}",
      path: {
        uploadUuid: data.uploadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadFile(
    data: UploadFileData,
  ): CancelablePromise<UploadFileResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/upload",
      query: {
        employerUuid: data.employerUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.status
   * @param data.uploadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static setReviewed(
    data: SetReviewedData,
  ): CancelablePromise<SetReviewedResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/upload/status",
      query: {
        status: data.status,
        uploadUuid: data.uploadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.status
   * @param data.uploadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateMuteStatus(
    data: UpdateMuteStatusData,
  ): CancelablePromise<UpdateMuteStatusResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/upload/status/update-mute",
      query: {
        status: data.status,
        uploadUuid: data.uploadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uploadUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.status
   * @param data.searchString
   * @param data.mute
   * @returns Response OK
   * @throws ApiError
   */
  public static getUploadDetailsByUploadUuid(
    data: GetUploadDetailsByUploadUuidData,
  ): CancelablePromise<GetUploadDetailsByUploadUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/upload/{uploadUuid}",
      path: {
        uploadUuid: data.uploadUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        status: data.status,
        searchString: data.searchString,
        mute: data.mute,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uploadUuid
   * @param data.rowNumber
   * @returns Response OK
   * @throws ApiError
   */
  public static getRowFromCsv(
    data: GetRowFromCsvData,
  ): CancelablePromise<GetRowFromCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/upload/get-csvrow",
      query: {
        uploadUuid: data.uploadUuid,
        rowNumber: data.rowNumber,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uploadUuid
   * @param data.status
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportRows(
    data: ExportRowsData,
  ): CancelablePromise<ExportRowsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/upload/export",
      query: {
        uploadUuid: data.uploadUuid,
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uploadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static downloadFile(
    data: DownloadFileData,
  ): CancelablePromise<DownloadFileResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/upload/download/{uploadUuid}",
      path: {
        uploadUuid: data.uploadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.fileName
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllUploads(
    data: GetAllUploadsData,
  ): CancelablePromise<GetAllUploadsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/upload/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        fileName: data.fileName,
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uploadUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllUploadDetailsByUploadUuid(
    data: GetAllUploadDetailsByUploadUuidData,
  ): CancelablePromise<GetAllUploadDetailsByUploadUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/upload/all/{uploadUuid}",
      path: {
        uploadUuid: data.uploadUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        status: data.status,
      },
    });
  }
}

export class StripeControllerService {
  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @returns Response OK
   * @throws ApiError
   */
  public static getSubscription(
    data: GetSubscriptionData,
  ): CancelablePromise<GetSubscriptionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/strip/subscription/{subscriptionId}",
      path: {
        subscriptionId: data.subscriptionId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @param data.priceId
   * @param data.promotionCode
   * @returns Response OK
   * @throws ApiError
   */
  public static updateSubscription(
    data: UpdateSubscriptionData,
  ): CancelablePromise<UpdateSubscriptionResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/strip/subscription/{subscriptionId}",
      path: {
        subscriptionId: data.subscriptionId,
      },
      query: {
        priceId: data.priceId,
        promotionCode: data.promotionCode,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @returns Response OK
   * @throws ApiError
   */
  public static cancelSubscription(
    data: CancelSubscriptionData,
  ): CancelablePromise<CancelSubscriptionResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/strip/subscription/{subscriptionId}",
      path: {
        subscriptionId: data.subscriptionId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @param data.newPriceId
   * @returns Response OK
   * @throws ApiError
   */
  public static changePlan(
    data: ChangePlanData,
  ): CancelablePromise<ChangePlanResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/strip/subscription/{subscriptionId}/change-plan",
      path: {
        subscriptionId: data.subscriptionId,
      },
      query: {
        newPriceId: data.newPriceId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @param data.newPriceId
   * @param data.prorate
   * @returns Response OK
   * @throws ApiError
   */
  public static changePlanWithProration(
    data: ChangePlanWithProrationData,
  ): CancelablePromise<ChangePlanWithProrationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/strip/subscription/{subscriptionId}/change-plan-advanced",
      path: {
        subscriptionId: data.subscriptionId,
      },
      query: {
        newPriceId: data.newPriceId,
        prorate: data.prorate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.promotionalCodeId
   * @param data.active
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePromotionalCoupon(
    data: UpdatePromotionalCouponData,
  ): CancelablePromise<UpdatePromotionalCouponResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/strip/promotional-code",
      query: {
        promotionalCodeId: data.promotionalCodeId,
        active: data.active,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createPromotionalCoupon(
    data: CreatePromotionalCouponData,
  ): CancelablePromise<CreatePromotionalCouponResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/promotional-code",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns string OK
   * @throws ApiError
   */
  public static handleStripeWebhook1(): CancelablePromise<HandleStripeWebhook1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/webhook",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createSubscription(
    data: CreateSubscriptionData,
  ): CancelablePromise<CreateSubscriptionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/subscription",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createSubscriptionWithPayment(
    data: CreateSubscriptionWithPaymentData,
  ): CancelablePromise<CreateSubscriptionWithPaymentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/subscription/with-payment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static completeSubscription(
    data: CompleteSubscriptionData,
  ): CancelablePromise<CompleteSubscriptionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/subscription/complete",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.customerId
   * @returns Response OK
   * @throws ApiError
   */
  public static createSetupIntent(
    data: CreateSetupIntentData,
  ): CancelablePromise<CreateSetupIntentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/setup_intent",
      query: {
        customerId: data.customerId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createSetupIntentWithCustomer(
    data: CreateSetupIntentWithCustomerData,
  ): CancelablePromise<CreateSetupIntentWithCustomerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/setup_intent/with-customer",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.customerId
   * @param data.paymentMethodId
   * @returns Response OK
   * @throws ApiError
   */
  public static setDefaultPaymentMethod(
    data: SetDefaultPaymentMethodData,
  ): CancelablePromise<SetDefaultPaymentMethodResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/set-default-payment-method",
      query: {
        customerId: data.customerId,
        paymentMethodId: data.paymentMethodId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveCardToCustomerWithCharging(
    data: SaveCardToCustomerWithChargingData,
  ): CancelablePromise<SaveCardToCustomerWithChargingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/save_card_charging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveCardToCustomer(
    data: SaveCardToCustomerData,
  ): CancelablePromise<SaveCardToCustomerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/save_card",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static refundAmount(
    data: RefundAmountData,
  ): CancelablePromise<RefundAmountResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/refund_amount",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createProduct(
    data: CreateProductData,
  ): CancelablePromise<CreateProductResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/product",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.productId
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createPriceForProduct(
    data: CreatePriceForProductData,
  ): CancelablePromise<CreatePriceForProductResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/product/{productId}/price",
      path: {
        productId: data.productId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createProductAndPrice(
    data: CreateProductAndPriceData,
  ): CancelablePromise<CreateProductAndPriceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/product-price",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createFlexiblePayment(
    data: CreateFlexiblePaymentData,
  ): CancelablePromise<CreateFlexiblePaymentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/payment/flexible",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createPaymentIntentWithProductPrice(
    data: CreatePaymentIntentWithProductPriceData,
  ): CancelablePromise<CreatePaymentIntentWithProductPriceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/create_product_payment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createPaymentIntent(
    data: CreatePaymentIntentData,
  ): CancelablePromise<CreatePaymentIntentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/create_customer_payment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createCustomer(
    data: CreateCustomerData,
  ): CancelablePromise<CreateCustomerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/create_customer",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createCoupon1(
    data: CreateCoupon1Data,
  ): CancelablePromise<CreateCoupon1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/coupon",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addSaveCardToCustomer(
    data: AddSaveCardToCustomerData,
  ): CancelablePromise<AddSaveCardToCustomerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/strip/add_save_card",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getPhpUser(): CancelablePromise<GetPhpUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/strip/get_php_user",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getStripeConfig(): CancelablePromise<GetStripeConfigResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/strip/config",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.userTypes
   * @returns Response OK
   * @throws ApiError
   */
  public static checkServicesOfUser(
    data: CheckServicesOfUserData,
  ): CancelablePromise<CheckServicesOfUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/strip/check_services/user/{uuid}/userTypes/{userTypes}",
      path: {
        uuid: data.uuid,
        userTypes: data.userTypes,
      },
    });
  }
}

export class ScriptSureControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.sessionToken
   * @returns Response OK
   * @throws ApiError
   */
  public static updateScriptSurePatient(
    data: UpdateScriptSurePatientData,
  ): CancelablePromise<UpdateScriptSurePatientResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/script-sure",
      query: {
        sessionToken: data.sessionToken,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.sessionToken
   * @returns Response OK
   * @throws ApiError
   */
  public static createScriptSurePatient(
    data: CreateScriptSurePatientData,
  ): CancelablePromise<CreateScriptSurePatientResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure",
      query: {
        sessionToken: data.sessionToken,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteScriptSurePatient(
    data: DeleteScriptSurePatientData,
  ): CancelablePromise<DeleteScriptSurePatientResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/script-sure",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAllergy(
    data: UpdateAllergyData,
  ): CancelablePromise<UpdateAllergyResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/script-sure/allergy/update",
      query: {
        patientUuid: data.patientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static archiveAllergy(
    data: ArchiveAllergyData,
  ): CancelablePromise<ArchiveAllergyResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/script-sure/allergy/archive",
      query: {
        patientUuid: data.patientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.apiKeyHash
   * @param data.email
   * @returns Response OK
   * @throws ApiError
   */
  public static vendorLogin(
    data: VendorLoginData,
  ): CancelablePromise<VendorLoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure/vendor-login",
      query: {
        apiKeyHash: data.apiKeyHash,
        email: data.email,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static registerProviderToScriptSure(
    data: RegisterProviderToScriptSureData,
  ): CancelablePromise<RegisterProviderToScriptSureResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure/register-provider",
      query: {
        providerUuid: data.providerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.nurseStaffUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static registerNurseStaffToScriptSure(
    data: RegisterNurseStaffToScriptSureData,
  ): CancelablePromise<RegisterNurseStaffToScriptSureResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure/register-nurse-staff",
      query: {
        nurseStaffUuid: data.nurseStaffUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static registerLocationToScriptSure(
    data: RegisterLocationToScriptSureData,
  ): CancelablePromise<RegisterLocationToScriptSureResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure/register-location",
      query: {
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveMedicationPrescription(
    data: SaveMedicationPrescriptionData,
  ): CancelablePromise<SaveMedicationPrescriptionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure/prescription/save",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.xScriptSureForwarded
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientMedications(
    data: GetPatientMedicationsData,
  ): CancelablePromise<GetPatientMedicationsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure/prescription-webhook",
      headers: {
        "X-ScriptSure-Forwarded": data.xScriptSureForwarded,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.xScriptSureForwarded
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientPharmacy(
    data: GetPatientPharmacyData,
  ): CancelablePromise<GetPatientPharmacyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure/pharmacy-webhook",
      headers: {
        "X-ScriptSure-Forwarded": data.xScriptSureForwarded,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveAllergy(
    data: SaveAllergyData,
  ): CancelablePromise<SaveAllergyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure/allergy/save",
      query: {
        patientUuid: data.patientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveNoKnownAllergy(
    data: SaveNoKnownAllergyData,
  ): CancelablePromise<SaveNoKnownAllergyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure/allergy/no-known-allergy",
      query: {
        patientUuid: data.patientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.xScriptSureForwarded
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientAllergies(
    data: GetPatientAllergiesData,
  ): CancelablePromise<GetPatientAllergiesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/script-sure/allergy-webhook",
      headers: {
        "X-ScriptSure-Forwarded": data.xScriptSureForwarded,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPrescriptionIframe(
    data: GetPrescriptionIframeData = {},
  ): CancelablePromise<GetPrescriptionIframeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/script-sure/prescription-iframe",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.doctorId
   * @returns Response OK
   * @throws ApiError
   */
  public static getMessageCount(
    data: GetMessageCountData,
  ): CancelablePromise<GetMessageCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/script-sure/message-count",
      query: {
        doctorId: data.doctorId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getMedCartIframe(
    data: GetMedCartIframeData,
  ): CancelablePromise<GetMedCartIframeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/script-sure/medcart-iframe",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.query
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static searchDrugs(
    data: SearchDrugsData,
  ): CancelablePromise<SearchDrugsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/script-sure/drug/search",
      query: {
        query: data.query,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.drugId
   * @returns Response OK
   * @throws ApiError
   */
  public static getDrugDoses(
    data: GetDrugDosesData,
  ): CancelablePromise<GetDrugDosesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/script-sure/drug/doses/{drugId}",
      path: {
        drugId: data.drugId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getDrugHistoryIframe(
    data: GetDrugHistoryIframeData,
  ): CancelablePromise<GetDrugHistoryIframeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/script-sure/drug-history-iframe",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getCpoeIframe(): CancelablePromise<GetCpoeIframeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/script-sure/cpoe-iframe",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.query
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static searchAllergies(
    data: SearchAllergiesData,
  ): CancelablePromise<SearchAllergiesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/script-sure/allergy/search",
      query: {
        query: data.query,
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllergyIframe(
    data: GetAllergyIframeData = {},
  ): CancelablePromise<GetAllergyIframeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/script-sure/allergy-iframe",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePreferredPharmacy(
    data: DeletePreferredPharmacyData,
  ): CancelablePromise<DeletePreferredPharmacyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/script-sure/patient-pharmacy",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class SavedCardControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateSavedCardByUuid(
    data: UpdateSavedCardByUuidData,
  ): CancelablePromise<UpdateSavedCardByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/saved_card/{savedCardUuid}",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.savedCardUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteSavedCardByUuid(
    data: DeleteSavedCardByUuidData,
  ): CancelablePromise<DeleteSavedCardByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/saved_card/{savedCardUuid}",
      path: {
        savedCardUuid: data.savedCardUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.savedCardUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static setAutopaySavedCardByUuid(
    data: SetAutopaySavedCardByUuidData,
  ): CancelablePromise<SetAutopaySavedCardByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/saved_card/set_autopay/{savedCardUuid}",
      path: {
        savedCardUuid: data.savedCardUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.customerId
   * @param data.savedCardUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static setDefaultSavedCardByUuid(
    data: SetDefaultSavedCardByUuidData,
  ): CancelablePromise<SetDefaultSavedCardByUuidResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/saved_card/{customerId}/set_default/{savedCardUuid}",
      path: {
        customerId: data.customerId,
        savedCardUuid: data.savedCardUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.userTypes
   * @param data.active
   * @param data.isDefault
   * @param data.brand
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllSavedCards(
    data: GetAllSavedCardsData = {},
  ): CancelablePromise<GetAllSavedCardsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/saved_card/all",
      query: {
        uuid: data.uuid,
        userTypes: data.userTypes,
        active: data.active,
        isDefault: data.isDefault,
        brand: data.brand,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.active
   * @param data.isDefault
   * @param data.brand
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response1 OK
   * @throws ApiError
   */
  public static getAllSavedCards1(
    data: GetAllSavedCards1Data = {},
  ): CancelablePromise<GetAllSavedCards1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/billing/v1/saved_card/all",
      query: {
        userUuid: data.userUuid,
        active: data.active,
        isDefault: data.isDefault,
        brand: data.brand,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class SavedBankControllerService {
  /**
   * @param data The data for the request.
   * @param data.savedBankAccountUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static setAutopaySavedBankByUuid(
    data: SetAutopaySavedBankByUuidData,
  ): CancelablePromise<SetAutopaySavedBankByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/saved_bank/set_autopay/{savedBankAccountUuid}",
      path: {
        savedBankAccountUuid: data.savedBankAccountUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.customerId
   * @param data.savedBankAccountUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static setDefaultSavedBankByUuid(
    data: SetDefaultSavedBankByUuidData,
  ): CancelablePromise<SetDefaultSavedBankByUuidResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/saved_bank/{customerId}/set_default/{savedBankAccountUuid}",
      path: {
        customerId: data.customerId,
        savedBankAccountUuid: data.savedBankAccountUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.customerId
   * @returns Response OK
   * @throws ApiError
   */
  public static createSetupIntent1(
    data: CreateSetupIntent1Data,
  ): CancelablePromise<CreateSetupIntent1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/saved_bank/create_setup_intent",
      query: {
        customerId: data.customerId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.setupIntentId
   * @param data.uuid
   * @param data.userTypes
   * @param data.label
   * @param data.isDefault
   * @param data.customerId
   * @param data.autopay
   * @returns Response OK
   * @throws ApiError
   */
  public static confirmBankAccount(
    data: ConfirmBankAccountData = {},
  ): CancelablePromise<ConfirmBankAccountResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/saved_bank/confirm_setup",
      query: {
        setupIntentId: data.setupIntentId,
        uuid: data.uuid,
        userTypes: data.userTypes,
        label: data.label,
        isDefault: data.isDefault,
        customerId: data.customerId,
        autopay: data.autopay,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAutopaySavedBank(
    data: UpdateAutopaySavedBankData,
  ): CancelablePromise<UpdateAutopaySavedBankResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/saved_bank/update",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.userTypes
   * @param data.bankName
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllSavedBanks(
    data: GetAllSavedBanksData = {},
  ): CancelablePromise<GetAllSavedBanksResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/saved_bank/all",
      query: {
        uuid: data.uuid,
        userTypes: data.userTypes,
        bankName: data.bankName,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.savedBankAccountUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteSavedBankByUuid(
    data: DeleteSavedBankByUuidData,
  ): CancelablePromise<DeleteSavedBankByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/saved_bank/{savedBankAccountUuid}",
      path: {
        savedBankAccountUuid: data.savedBankAccountUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.customerId
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createSetupIntent11(
    data: CreateSetupIntent11Data,
  ): CancelablePromise<CreateSetupIntent11Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/saved_bank/create_setup_intent",
      query: {
        customerId: data.customerId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.setupIntentId
   * @returns Response1 OK
   * @throws ApiError
   */
  public static confirmBankAccount1(
    data: ConfirmBankAccount1Data,
  ): CancelablePromise<ConfirmBankAccount1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/saved_bank/confirm_setup",
      query: {
        setupIntentId: data.setupIntentId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.bankName
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response1 OK
   * @throws ApiError
   */
  public static getAllSavedBanks1(
    data: GetAllSavedBanks1Data = {},
  ): CancelablePromise<GetAllSavedBanks1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/billing/v1/saved_bank/all",
      query: {
        userUuid: data.userUuid,
        bankName: data.bankName,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class SalesTaxProfileControllerService {
  /**
   * @param data The data for the request.
   * @param data.salesTaxProfileUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getSalesTaxProfileByUuid(
    data: GetSalesTaxProfileByUuidData,
  ): CancelablePromise<GetSalesTaxProfileByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/sales_tax_profile/{salesTaxProfileUuid}",
      path: {
        salesTaxProfileUuid: data.salesTaxProfileUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.salesTaxProfileUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateSalesTaxProfileByUuid(
    data: UpdateSalesTaxProfileByUuidData,
  ): CancelablePromise<UpdateSalesTaxProfileByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/sales_tax_profile/{salesTaxProfileUuid}",
      path: {
        salesTaxProfileUuid: data.salesTaxProfileUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.salesTaxProfileUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteSalesTaxProfileByUuid(
    data: DeleteSalesTaxProfileByUuidData,
  ): CancelablePromise<DeleteSalesTaxProfileByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/sales_tax_profile/{salesTaxProfileUuid}",
      path: {
        salesTaxProfileUuid: data.salesTaxProfileUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveSalesTaxProfile(
    data: SaveSalesTaxProfileData,
  ): CancelablePromise<SaveSalesTaxProfileResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/sales_tax_profile/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllSalesTaxProfiles(
    data: GetAllSalesTaxProfilesData = {},
  ): CancelablePromise<GetAllSalesTaxProfilesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/sales_tax_profile/all",
      query: {
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class SalesTaxJurisdictionControllerService {
  /**
   * @param data The data for the request.
   * @param data.salesTaxJurisdictionUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getSalesTaxJurisdictionByUuid(
    data: GetSalesTaxJurisdictionByUuidData,
  ): CancelablePromise<GetSalesTaxJurisdictionByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/sales_tax_jurisdiction/{salesTaxJurisdictionUuid}",
      path: {
        salesTaxJurisdictionUuid: data.salesTaxJurisdictionUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.salesTaxJurisdictionUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateSalesTaxJurisdictionByUuid(
    data: UpdateSalesTaxJurisdictionByUuidData,
  ): CancelablePromise<UpdateSalesTaxJurisdictionByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/sales_tax_jurisdiction/{salesTaxJurisdictionUuid}",
      path: {
        salesTaxJurisdictionUuid: data.salesTaxJurisdictionUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.salesTaxJurisdictionUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteSalesTaxJurisdictionByUuid(
    data: DeleteSalesTaxJurisdictionByUuidData,
  ): CancelablePromise<DeleteSalesTaxJurisdictionByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/sales_tax_jurisdiction/{salesTaxJurisdictionUuid}",
      path: {
        salesTaxJurisdictionUuid: data.salesTaxJurisdictionUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveSalesTaxJurisdiction(
    data: SaveSalesTaxJurisdictionData,
  ): CancelablePromise<SaveSalesTaxJurisdictionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/sales_tax_jurisdiction/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllSalesTaxJurisdictions(
    data: GetAllSalesTaxJurisdictionsData = {},
  ): CancelablePromise<GetAllSalesTaxJurisdictionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/sales_tax_jurisdiction/all",
      query: {
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class RolesAndPermissionControllerService {
  /**
   * @param data The data for the request.
   * @param data.roleId
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePermissionsOfRole(
    data: UpdatePermissionsOfRoleData,
  ): CancelablePromise<UpdatePermissionsOfRoleResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/roles/{roleId}",
      path: {
        roleId: data.roleId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createRole(
    data: CreateRoleData,
  ): CancelablePromise<CreateRoleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/roles",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.roleUuid
   * @param data.name
   * @returns Response OK
   * @throws ApiError
   */
  public static updateRoleName(
    data: UpdateRoleNameData,
  ): CancelablePromise<UpdateRoleNameResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/roles/{roleUuid}",
      path: {
        roleUuid: data.roleUuid,
      },
      query: {
        name: data.name,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getRoleTypes(): CancelablePromise<GetRoleTypesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/roles/role_types",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.roleType
   * @returns Response OK
   * @throws ApiError
   */
  public static getRolesByRoleType(
    data: GetRolesByRoleTypeData,
  ): CancelablePromise<GetRolesByRoleTypeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/roles/get-roles",
      query: {
        roleType: data.roleType,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.roleId
   * @returns Response OK
   * @throws ApiError
   */
  public static getFeaturesByRoleAndRoleType(
    data: GetFeaturesByRoleAndRoleTypeData,
  ): CancelablePromise<GetFeaturesByRoleAndRoleTypeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/roles/features",
      query: {
        roleId: data.roleId,
      },
    });
  }
}

export class RoleTypeManagementControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getRoleTypeByUuid(
    data: GetRoleTypeByUuidData,
  ): CancelablePromise<GetRoleTypeByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/role-types/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateRoleType(
    data: UpdateRoleTypeData,
  ): CancelablePromise<UpdateRoleTypeResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/role-types/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteRoleType(
    data: DeleteRoleTypeData,
  ): CancelablePromise<DeleteRoleTypeResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/role-types/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllRoleTypes(): CancelablePromise<GetAllRoleTypesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/role-types",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createRoleType(
    data: CreateRoleTypeData,
  ): CancelablePromise<CreateRoleTypeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/role-types",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class RoleTypeFeatureManagementControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getRoleTypeFeatureByUuid(
    data: GetRoleTypeFeatureByUuidData,
  ): CancelablePromise<GetRoleTypeFeatureByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/role-type-features/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateRoleTypeFeature(
    data: UpdateRoleTypeFeatureData,
  ): CancelablePromise<UpdateRoleTypeFeatureResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/role-type-features/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteRoleTypeFeature(
    data: DeleteRoleTypeFeatureData,
  ): CancelablePromise<DeleteRoleTypeFeatureResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/role-type-features/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllRoleTypeFeatures(): CancelablePromise<GetAllRoleTypeFeaturesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/role-type-features",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createRoleTypeFeature(
    data: CreateRoleTypeFeatureData,
  ): CancelablePromise<CreateRoleTypeFeatureResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/role-type-features",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.roleTypeUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getRoleTypeFeaturesByRoleType(
    data: GetRoleTypeFeaturesByRoleTypeData,
  ): CancelablePromise<GetRoleTypeFeaturesByRoleTypeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/role-type-features/by-role-type/{roleTypeUuid}",
      path: {
        roleTypeUuid: data.roleTypeUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.roleTypeUuid
   * @param data.featureUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getRoleTypeFeatureByRoleTypeAndFeature(
    data: GetRoleTypeFeatureByRoleTypeAndFeatureData,
  ): CancelablePromise<GetRoleTypeFeatureByRoleTypeAndFeatureResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/role-type-features/by-role-type-and-feature",
      query: {
        roleTypeUuid: data.roleTypeUuid,
        featureUuid: data.featureUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.featureUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getRoleTypeFeaturesByFeature(
    data: GetRoleTypeFeaturesByFeatureData,
  ): CancelablePromise<GetRoleTypeFeaturesByFeatureResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/role-type-features/by-feature/{featureUuid}",
      path: {
        featureUuid: data.featureUuid,
      },
    });
  }
}

export class ProviderControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateProvider(
    data: UpdateProviderData,
  ): CancelablePromise<UpdateProviderResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/provider",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addProvider(
    data: AddProviderData,
  ): CancelablePromise<AddProviderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/provider",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static assignedNewProvider(
    data: AssignedNewProviderData,
  ): CancelablePromise<AssignedNewProviderResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/provider/reassign",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerUuid
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePatientEntrollmentByProviderUuid(
    data: UpdatePatientEntrollmentByProviderUuidData,
  ): CancelablePromise<UpdatePatientEntrollmentByProviderUuidResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/provider/{providerUuid}/status",
      path: {
        providerUuid: data.providerUuid,
      },
      query: {
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.status
   * @param data.providerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateProviderStatus(
    data: UpdateProviderStatusData,
  ): CancelablePromise<UpdateProviderStatusResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/provider/status",
      query: {
        status: data.status,
        providerUuid: data.providerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getProviderByUuid(
    data: GetProviderByUuidData,
  ): CancelablePromise<GetProviderByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider/{providerUuid}",
      path: {
        providerUuid: data.providerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteProviderByUuid(
    data: DeleteProviderByUuidData,
  ): CancelablePromise<DeleteProviderByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/provider/{providerUuid}",
      path: {
        providerUuid: data.providerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userIamId
   * @returns boolean OK
   * @throws ApiError
   */
  public static isProviderWithUrgentMessageAlerts(
    data: IsProviderWithUrgentMessageAlertsData,
  ): CancelablePromise<IsProviderWithUrgentMessageAlertsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider/urgent-alerts/{userIamId}",
      path: {
        userIamId: data.userIamId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userIamId
   * @returns string OK
   * @throws ApiError
   */
  public static getCoveringProvidersForUrgentAlerts(
    data: GetCoveringProvidersForUrgentAlertsData,
  ): CancelablePromise<GetCoveringProvidersForUrgentAlertsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider/urgent-alerts/{userIamId}/covering-providers",
      path: {
        userIamId: data.userIamId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.xLocationId
   * @returns Response OK
   * @throws ApiError
   */
  public static getProviderProfile(
    data: GetProviderProfileData = {},
  ): CancelablePromise<GetProviderProfileResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider/profile",
      headers: {
        "x-location-id": data.xLocationId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.longitude
   * @param data.latitude
   * @param data.leadUuid
   * @param data.filterBy
   * @param data.filterValue
   * @param data.searchString
   * @param data.zipcode
   * @param data.status
   * @param data.employer
   * @param data.locationUuids
   * @param data.employerPageUuid
   * @param data.specialityNames
   * @param data.stateNames
   * @param data.locationNames
   * @param data.roleUuid
   * @param data.isAffiliate
   * @param data.isPatientEnrollment
   * @param data.couponCode
   * @param data.couponLocationUuid
   * @param data.careTeamUserUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllProviders(
    data: GetAllProvidersData = {},
  ): CancelablePromise<GetAllProvidersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        longitude: data.longitude,
        latitude: data.latitude,
        leadUuid: data.leadUuid,
        filterBy: data.filterBy,
        filterValue: data.filterValue,
        searchString: data.searchString,
        zipcode: data.zipcode,
        status: data.status,
        employer: data.employer,
        locationUuids: data.locationUuids,
        employerPageUuid: data.employerPageUuid,
        specialityNames: data.specialityNames,
        stateNames: data.stateNames,
        locationNames: data.locationNames,
        roleUuid: data.roleUuid,
        isAffiliate: data.isAffiliate,
        isPatientEnrollment: data.isPatientEnrollment,
        couponCode: data.couponCode,
        couponLocationUuid: data.couponLocationUuid,
        careTeamUserUuid: data.careTeamUserUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.longitude
   * @param data.latitude
   * @param data.patientUuid
   * @param data.filterBy
   * @param data.filterValue
   * @param data.searchString
   * @param data.zipcode
   * @param data.status
   * @param data.employer
   * @param data.locationUuid
   * @param data.employerPageUuid
   * @param data.specialityNames
   * @param data.stateNames
   * @param data.locationNames
   * @param data.affiliateGroupUuids
   * @param data.isAffiliate
   * @param data.isPatientEnrollment
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllProvidersByIsAffiliate(
    data: GetAllProvidersByIsAffiliateData = {},
  ): CancelablePromise<GetAllProvidersByIsAffiliateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider/all-isAffiliate",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        longitude: data.longitude,
        latitude: data.latitude,
        patientUuid: data.patientUuid,
        filterBy: data.filterBy,
        filterValue: data.filterValue,
        searchString: data.searchString,
        zipcode: data.zipcode,
        status: data.status,
        employer: data.employer,
        locationUuid: data.locationUuid,
        employerPageUuid: data.employerPageUuid,
        specialityNames: data.specialityNames,
        stateNames: data.stateNames,
        locationNames: data.locationNames,
        affiliateGroupUuids: data.affiliateGroupUuids,
        isAffiliate: data.isAffiliate,
        isPatientEnrollment: data.isPatientEnrollment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.searchString
   * @param data.zipcode
   * @param data.status
   * @param data.employer
   * @param data.locationUuid
   * @param data.specialityNames
   * @param data.stateNames
   * @param data.locationNames
   * @param data.affiliateGroupUuids
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportAffiliateProvidersCsv(
    data: ExportAffiliateProvidersCsvData = {},
  ): CancelablePromise<ExportAffiliateProvidersCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider/affiliate-providers/export-csv",
      query: {
        searchString: data.searchString,
        zipcode: data.zipcode,
        status: data.status,
        employer: data.employer,
        locationUuid: data.locationUuid,
        specialityNames: data.specialityNames,
        stateNames: data.stateNames,
        locationNames: data.locationNames,
        affiliateGroupUuids: data.affiliateGroupUuids,
      },
    });
  }
}

export class PlanControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePlan(
    data: UpdatePlanData,
  ): CancelablePromise<UpdatePlanResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/plan/update",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePlanDetails(
    data: UpdatePlanDetailsData,
  ): CancelablePromise<UpdatePlanDetailsResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/plan/plan-details",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createPlan(
    data: CreatePlanData,
  ): CancelablePromise<CreatePlanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/plan/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.primaryLeadUuid
   * @param data.employer
   * @param data.birthDate
   * @param data.planUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPlanAmount(
    data: GetPlanAmountData = {},
  ): CancelablePromise<GetPlanAmountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/plan",
      query: {
        primaryLeadUuid: data.primaryLeadUuid,
        employer: data.employer,
        birthDate: data.birthDate,
        planUuid: data.planUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.planUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPlanByUuid(
    data: GetPlanByUuidData,
  ): CancelablePromise<GetPlanByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/plan/{planUuid}",
      path: {
        planUuid: data.planUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.planUuid
   * @param data.active
   * @param data.reason
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePlanByUuid(
    data: DeletePlanByUuidData,
  ): CancelablePromise<DeletePlanByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/plan/{planUuid}",
      path: {
        planUuid: data.planUuid,
      },
      query: {
        active: data.active,
        reason: data.reason,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.planUuid
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPlanDetailsByUuid(
    data: GetPlanDetailsByUuidData,
  ): CancelablePromise<GetPlanDetailsByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/plan/{planUuid}/plan-details",
      path: {
        planUuid: data.planUuid,
      },
      query: {
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.planUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPlanStatus(
    data: GetPlanStatusData,
  ): CancelablePromise<GetPlanStatusResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/plan/online-signup/{planUuid}/status",
      path: {
        planUuid: data.planUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.primaryLeadUuid
   * @param data.planUuid
   * @param data.defaultBillingPeriod
   * @param data.relationShip
   * @param data.dependentName
   * @param data.employer
   * @param data.providerUuids
   * @param data.dependentBirthDate
   * @returns Response OK
   * @throws ApiError
   */
  public static checkMyPlan(
    data: CheckMyPlanData = {},
  ): CancelablePromise<CheckMyPlanResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/plan/check-my-plan",
      query: {
        primaryLeadUuid: data.primaryLeadUuid,
        planUuid: data.planUuid,
        defaultBillingPeriod: data.defaultBillingPeriod,
        relationShip: data.relationShip,
        dependentName: data.dependentName,
        employer: data.employer,
        providerUuids: data.providerUuids,
        dependentBirthDate: data.dependentBirthDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.planType
   * @param data.archive
   * @param data.employer
   * @param data.defaultPlan
   * @param data.employerplan
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPlan(
    data: GetAllPlanData = {},
  ): CancelablePromise<GetAllPlanResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/plan/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        planType: data.planType,
        archive: data.archive,
        employer: data.employer,
        defaultPlan: data.defaultPlan,
        employerplan: data.employerplan,
      },
    });
  }
}

export class PaymentTransactionControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePaymentTransaction(
    data: UpdatePaymentTransactionData,
  ): CancelablePromise<UpdatePaymentTransactionResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/payment-transactions",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createPaymentTransaction(
    data: CreatePaymentTransactionData,
  ): CancelablePromise<CreatePaymentTransactionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/payment-transactions",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.paymentTransactionUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPaymentTransactionByUuid(
    data: GetPaymentTransactionByUuidData,
  ): CancelablePromise<GetPaymentTransactionByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/payment-transactions/{paymentTransactionUuid}",
      path: {
        paymentTransactionUuid: data.paymentTransactionUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.paymentTransactionUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePaymentTransaction(
    data: DeletePaymentTransactionData,
  ): CancelablePromise<DeletePaymentTransactionResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/payment-transactions/{paymentTransactionUuid}",
      path: {
        paymentTransactionUuid: data.paymentTransactionUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPaymentTransactions(
    data: GetAllPaymentTransactionsData = {},
  ): CancelablePromise<GetAllPaymentTransactionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/payment-transactions/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class PatientControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePatient(
    data: UpdatePatientData,
  ): CancelablePromise<UpdatePatientResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/patient",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addPatient(
    data: AddPatientData,
  ): CancelablePromise<AddPatientResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static unEnrollPatient(
    data: UnEnrollPatientData,
  ): CancelablePromise<UnEnrollPatientResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/patient/un-enroll/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.primaryPatientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static patientCreateUpdate(
    data: PatientCreateUpdateData,
  ): CancelablePromise<PatientCreateUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/patient/patient-create-update",
      query: {
        primaryPatientUuid: data.primaryPatientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static endMembershipForPatientAndDependents(
    data: EndMembershipForPatientAndDependentsData,
  ): CancelablePromise<EndMembershipForPatientAndDependentsResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/patient/end-membership/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.enrollmentRequestDate
   * @param data.membershipStartDate
   * @returns Response OK
   * @throws ApiError
   */
  public static editDependentMembershipDetails(
    data: EditDependentMembershipDetailsData,
  ): CancelablePromise<EditDependentMembershipDetailsResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/patient/edit-dependents-details/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        enrollmentRequestDate: data.enrollmentRequestDate,
        membershipStartDate: data.membershipStartDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.primaryPatientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static createUpdatePatient(
    data: CreateUpdatePatientData,
  ): CancelablePromise<CreateUpdatePatientResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/patient/create-update",
      query: {
        primaryPatientUuid: data.primaryPatientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.providerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static markPatientViewed(
    data: MarkPatientViewedData,
  ): CancelablePromise<MarkPatientViewedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/{patientUuid}/viewed",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        providerUuid: data.providerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static syncPatientWithScriptSure(
    data: SyncPatientWithScriptSureData,
  ): CancelablePromise<SyncPatientWithScriptSureResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/sync-with-scriptsure",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendNotificationMailForBasicPaymentDetails(
    data: SendNotificationMailForBasicPaymentDetailsData,
  ): CancelablePromise<SendNotificationMailForBasicPaymentDetailsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/send-mail-payment-details/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static generatePatientChartPdf(
    data: GeneratePatientChartPdfData,
  ): CancelablePromise<GeneratePatientChartPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/pdf/patient-chart",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateEngagedPatientEmployerMembershipInvoice(
    data: UpdateEngagedPatientEmployerMembershipInvoiceData,
  ): CancelablePromise<UpdateEngagedPatientEmployerMembershipInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/employer_membership_invoice/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static checkPatientCredentials(
    data: CheckPatientCredentialsData,
  ): CancelablePromise<CheckPatientCredentialsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/check-details",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static cancelPlanChange(
    data: CancelPlanChangeData,
  ): CancelablePromise<CancelPlanChangeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/cancel-plan-change",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static evictPatientCaches(): CancelablePromise<EvictPatientCachesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/cache/evict",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.brokerFirmUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateEngagedPatientBrokerFirmMembershipInvoice(
    data: UpdateEngagedPatientBrokerFirmMembershipInvoiceData,
  ): CancelablePromise<UpdateEngagedPatientBrokerFirmMembershipInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/broker_firm_membership_invoice/{brokerFirmUuid}",
      path: {
        brokerFirmUuid: data.brokerFirmUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateFirmUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateEngagedPatientAffiliateFirmMembershipInvoice(
    data: UpdateEngagedPatientAffiliateFirmMembershipInvoiceData,
  ): CancelablePromise<UpdateEngagedPatientAffiliateFirmMembershipInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/affiliate_firm_membership_invoice/{affiliateFirmUuid}",
      path: {
        affiliateFirmUuid: data.affiliateFirmUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static addPatientToStripe(
    data: AddPatientToStripeData,
  ): CancelablePromise<AddPatientToStripeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/add-patient-stripe/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.retail
   * @param data.requestBody
   * @param data.planUuid
   * @param data.planChange
   * @param data.update
   * @returns Response OK
   * @throws ApiError
   */
  public static addMembership(
    data: AddMembershipData,
  ): CancelablePromise<AddMembershipResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient/add-membership",
      query: {
        planUuid: data.planUuid,
        retail: data.retail,
        planChange: data.planChange,
        update: data.update,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientByUuid(
    data: GetPatientByUuidData,
  ): CancelablePromise<GetPatientByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static setPatientPortalAccess(
    data: SetPatientPortalAccessData,
  ): CancelablePromise<SetPatientPortalAccessResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/patient/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.planEndDate
   * @param data.cancellationUuid
   * @param data.status
   * @param data.isCancelMembership
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePatientStatus(
    data: UpdatePatientStatusData,
  ): CancelablePromise<UpdatePatientStatusResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/patient/{patientUuid}/status",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        planEndDate: data.planEndDate,
        cancellationUuid: data.cancellationUuid,
        status: data.status,
        isCancelMembership: data.isCancelMembership,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.dependentPatientUuid
   * @param data.oldPrimaryRelationShip
   * @returns Response OK
   * @throws ApiError
   */
  public static makePrimary(
    data: MakePrimaryData,
  ): CancelablePromise<MakePrimaryResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/patient/{dependentPatientUuid}/make-primary",
      path: {
        dependentPatientUuid: data.dependentPatientUuid,
      },
      query: {
        oldPrimaryRelationShip: data.oldPrimaryRelationShip,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.providerUuid
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static setPatientPrimaryProvider(
    data: SetPatientPrimaryProviderData,
  ): CancelablePromise<SetPatientPrimaryProviderResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/patient/update-provider/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        providerUuid: data.providerUuid,
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.sendSms
   * @returns Response OK
   * @throws ApiError
   */
  public static setSendSms(
    data: SetSendSmsData,
  ): CancelablePromise<SetSendSmsResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/patient/send-sms/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        sendSms: data.sendSms,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static removePreEngage(
    data: RemovePreEngageData,
  ): CancelablePromise<RemovePreEngageResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/patient/remove-pre-engage/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.reEnrollment
   * @param data.reasonForReEnrollment
   * @returns Response OK
   * @throws ApiError
   */
  public static setReEnrollment(
    data: SetReEnrollmentData,
  ): CancelablePromise<SetReEnrollmentResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/patient/re-enrollment/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        reEnrollment: data.reEnrollment,
        reasonForReEnrollment: data.reasonForReEnrollment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.primaryPatientUuid
   * @param data.relationShip
   * @param data.existingPatientUuid
   * @param data.effectiveDate
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addExistingPatientAsDependent(
    data: AddExistingPatientAsDependentData,
  ): CancelablePromise<AddExistingPatientAsDependentResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/patient/existing",
      query: {
        primaryPatientUuid: data.primaryPatientUuid,
        relationShip: data.relationShip,
        existingPatientUuid: data.existingPatientUuid,
        effectiveDate: data.effectiveDate,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.planStartDate
   * @returns Response OK
   * @throws ApiError
   */
  public static changeBillingDate(
    data: ChangeBillingDateData,
  ): CancelablePromise<ChangeBillingDateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/patient/billing-date/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        planStartDate: data.planStartDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientLocationWithSalesTax(
    data: GetPatientLocationWithSalesTaxData,
  ): CancelablePromise<GetPatientLocationWithSalesTaxResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/{patientUuid}/location-sales-tax",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getLabPayerDefaults(
    data: GetLabPayerDefaultsData,
  ): CancelablePromise<GetLabPayerDefaultsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/{patientUuid}/lab-payer-defaults",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerUuid
   * @param data.locationUuids
   * @param data.limit
   * @returns Response OK
   * @throws ApiError
   */
  public static getRecentlyViewedPatients(
    data: GetRecentlyViewedPatientsData = {},
  ): CancelablePromise<GetRecentlyViewedPatientsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/recently-viewed",
      query: {
        providerUuid: data.providerUuid,
        locationUuids: data.locationUuids,
        limit: data.limit,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getProfile1(): CancelablePromise<GetProfile1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/profile",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientPlanDetails(
    data: GetPatientPlanDetailsData,
  ): CancelablePromise<GetPatientPlanDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/plan-details/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientOverview(
    data: GetPatientOverviewData,
  ): CancelablePromise<GetPatientOverviewResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/overview/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientMemberShip(
    data: GetPatientMemberShipData,
  ): CancelablePromise<GetPatientMemberShipResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/membership/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.paymentTransactionUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientEmployeeMembershipDetails(
    data: GetPatientEmployeeMembershipDetailsData,
  ): CancelablePromise<GetPatientEmployeeMembershipDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/membership-details",
      query: {
        patientUuid: data.patientUuid,
        paymentTransactionUuid: data.paymentTransactionUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.employers
   * @param data.affiliateGroupUuid
   * @param data.providerUuids
   * @param data.locationUuids
   * @param data.patientStatus
   * @param data.employerUuids
   * @param data.excludeExistingDependents
   * @param data.isAffiliate
   * @param data.birthDateStart
   * @param data.birthDateEnd
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientDropDown(
    data: GetPatientDropDownData = {},
  ): CancelablePromise<GetPatientDropDownResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/list-dropdown",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        employers: data.employers,
        affiliateGroupUuid: data.affiliateGroupUuid,
        providerUuids: data.providerUuids,
        locationUuids: data.locationUuids,
        patientStatus: data.patientStatus,
        employerUuids: data.employerUuids,
        excludeExistingDependents: data.excludeExistingDependents,
        isAffiliate: data.isAffiliate,
        birthDateStart: data.birthDateStart,
        birthDateEnd: data.birthDateEnd,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientWithDependents(
    data: GetPatientWithDependentsData,
  ): CancelablePromise<GetPatientWithDependentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/family/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @param data.providerUuid
   * @returns string OK
   * @throws ApiError
   */
  public static exportPatientsByAffiliateGroup(
    data: ExportPatientsByAffiliateGroupData,
  ): CancelablePromise<ExportPatientsByAffiliateGroupResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/export/affiliate-group/{affiliateGroupUuid}",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
      query: {
        providerUuid: data.providerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.primaryPatient
   * @returns Response OK
   * @throws ApiError
   */
  public static getDependents(
    data: GetDependentsData,
  ): CancelablePromise<GetDependentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/dependents",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        primaryPatient: data.primaryPatient,
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.startDate
   * @param data.endDate
   * @param data.employerUuids
   * @param data.providerUuid
   * @param data.employers
   * @param data.paid
   * @param data.billing
   * @param data.patientStatus
   * @param data.affiliateGroupUuid
   * @param data.planUuids
   * @param data.joinedPracticeDate
   * @param data.joinedPracticeEndDate
   * @param data.breakGlassUuid
   * @param data.isProvider
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPatient(
    data: GetAllPatientData = {},
  ): CancelablePromise<GetAllPatientResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        startDate: data.startDate,
        endDate: data.endDate,
        employerUuids: data.employerUuids,
        providerUuid: data.providerUuid,
        employers: data.employers,
        paid: data.paid,
        billing: data.billing,
        patientStatus: data.patientStatus,
        affiliateGroupUuid: data.affiliateGroupUuid,
        planUuids: data.planUuids,
        joinedPracticeDate: data.joinedPracticeDate,
        joinedPracticeEndDate: data.joinedPracticeEndDate,
        breakGlassUuid: data.breakGlassUuid,
        isProvider: data.isProvider,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.remove
   * @param data.employer
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePatientByUuid(
    data: DeletePatientByUuidData,
  ): CancelablePromise<DeletePatientByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/patient/remove/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        remove: data.remove,
        employer: data.employer,
      },
    });
  }
}

export class PatientModuleControllerService {
  /**
   * @param data The data for the request.
   * @param data.patientModuleUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static update(data: UpdateData): CancelablePromise<UpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/patient-module/update/{patientModuleUuid}",
      path: {
        patientModuleUuid: data.patientModuleUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static create(data: CreateData): CancelablePromise<CreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient-module/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientModuleUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getByUuid1(
    data: GetByUuid1Data,
  ): CancelablePromise<GetByUuid1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient-module/{patientModuleUuid}",
      path: {
        patientModuleUuid: data.patientModuleUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getAll(): CancelablePromise<GetAllResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient-module/all",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientModuleUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static delete1(data: Delete1Data): CancelablePromise<Delete1Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/patient-module/delete/{patientModuleUuid}",
      path: {
        patientModuleUuid: data.patientModuleUuid,
      },
    });
  }
}

export class PatientModuleAccessControllerService {
  /**
   * @param data The data for the request.
   * @param data.patientModuleAccessUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static update1(data: Update1Data): CancelablePromise<Update1Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/patient-module-access/update/{patientModuleAccessUuid}",
      path: {
        patientModuleAccessUuid: data.patientModuleAccessUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static create1(data: Create1Data): CancelablePromise<Create1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient-module-access/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientModuleAccessUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getByUuid2(
    data: GetByUuid2Data,
  ): CancelablePromise<GetByUuid2Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient-module-access/{patientModuleAccessUuid}",
      path: {
        patientModuleAccessUuid: data.patientModuleAccessUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.granteePatientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllByGrantee(
    data: GetAllByGranteeData,
  ): CancelablePromise<GetAllByGranteeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient-module-access/grantee/{granteePatientUuid}",
      path: {
        granteePatientUuid: data.granteePatientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ownerPatientUuid
   * @param data.granteePatientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllByOwnerAndGrantee(
    data: GetAllByOwnerAndGranteeData,
  ): CancelablePromise<GetAllByOwnerAndGranteeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient-module-access/all",
      query: {
        ownerPatientUuid: data.ownerPatientUuid,
        granteePatientUuid: data.granteePatientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static delete2(data: Delete2Data): CancelablePromise<Delete2Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/patient-module-access/delete",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class PatientInformationControllerService {
  /**
   * @param data The data for the request.
   * @param data.patientInformationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getByUuid(
    data: GetByUuidData,
  ): CancelablePromise<GetByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient-information/{patientInformationUuid}",
      path: {
        patientInformationUuid: data.patientInformationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientInformationUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static update2(data: Update2Data): CancelablePromise<Update2Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/patient-information/{patientInformationUuid}",
      path: {
        patientInformationUuid: data.patientInformationUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientInformationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static delete(data: DeleteData): CancelablePromise<DeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/patient-information/{patientInformationUuid}",
      path: {
        patientInformationUuid: data.patientInformationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static create2(data: Create2Data): CancelablePromise<Create2Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/patient-information",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllByPatientUuid(
    data: GetAllByPatientUuidData,
  ): CancelablePromise<GetAllByPatientUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/patient-information/patient/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class NurseStaffProviderControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateNurseStaffProvider(
    data: UpdateNurseStaffProviderData,
  ): CancelablePromise<UpdateNurseStaffProviderResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/nurse-staff-provider",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addNurseStaffProvider(
    data: AddNurseStaffProviderData,
  ): CancelablePromise<AddNurseStaffProviderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/nurse-staff-provider",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.status
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateNurseStaffProviderStatus(
    data: UpdateNurseStaffProviderStatusData,
  ): CancelablePromise<UpdateNurseStaffProviderStatusResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/nurse-staff-provider/status",
      query: {
        status: data.status,
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getNurseStaffProviderByUuid(
    data: GetNurseStaffProviderByUuidData,
  ): CancelablePromise<GetNurseStaffProviderByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/nurse-staff-provider/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteNurseStaffProvider(
    data: DeleteNurseStaffProviderData,
  ): CancelablePromise<DeleteNurseStaffProviderResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/nurse-staff-provider/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.status
   * @param data.roleUuids
   * @param data.providerUuid
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllNurseStaffProviders(
    data: GetAllNurseStaffProvidersData = {},
  ): CancelablePromise<GetAllNurseStaffProvidersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/nurse-staff-provider/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        status: data.status,
        roleUuids: data.roleUuids,
        providerUuid: data.providerUuid,
        locationUuid: data.locationUuid,
      },
    });
  }
}

export class LeadControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateLead(
    data: UpdateLeadData,
  ): CancelablePromise<UpdateLeadResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/lead",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createLead(
    data: CreateLeadData,
  ): CancelablePromise<CreateLeadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/lead",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createUpdateLead(
    data: CreateUpdateLeadData,
  ): CancelablePromise<CreateUpdateLeadResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/lead/create-update",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.leadUuid
   * @param data.paymentMethodId
   * @returns Response OK
   * @throws ApiError
   */
  public static createSubscriptionAfterPayment(
    data: CreateSubscriptionAfterPaymentData,
  ): CancelablePromise<CreateSubscriptionAfterPaymentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/lead/{leadUuid}/subscription/create",
      path: {
        leadUuid: data.leadUuid,
      },
      query: {
        paymentMethodId: data.paymentMethodId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.leadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getLeadByUuid(
    data: GetLeadByUuidData,
  ): CancelablePromise<GetLeadByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/lead/{leadUuid}",
      path: {
        leadUuid: data.leadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.leadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteLeadByUuid(
    data: DeleteLeadByUuidData,
  ): CancelablePromise<DeleteLeadByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/lead/{leadUuid}",
      path: {
        leadUuid: data.leadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.couponCode
   * @returns Response OK
   * @throws ApiError
   */
  public static validateCouponCode(
    data: ValidateCouponCodeData,
  ): CancelablePromise<ValidateCouponCodeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/lead/validate_coupon_code/{couponCode}",
      path: {
        couponCode: data.couponCode,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.leadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getLeadFullInfo(
    data: GetLeadFullInfoData,
  ): CancelablePromise<GetLeadFullInfoResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/lead/getContact/{leadUuid}",
      path: {
        leadUuid: data.leadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.isContact
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLead(
    data: GetAllLeadData = {},
  ): CancelablePromise<GetAllLeadResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/lead/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        isContact: data.isContact,
      },
    });
  }
}

export class InvoiceSettingControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getInvoiceSettingByUuid(
    data: GetInvoiceSettingByUuidData,
  ): CancelablePromise<GetInvoiceSettingByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/invoice-setting/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateInvoiceSetting(
    data: UpdateInvoiceSettingData,
  ): CancelablePromise<UpdateInvoiceSettingResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/invoice-setting/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteInvoiceSettingByUuid(
    data: DeleteInvoiceSettingByUuidData,
  ): CancelablePromise<DeleteInvoiceSettingByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/invoice-setting/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.emailNotificationEnabled
   * @returns Response OK
   * @throws ApiError
   */
  public static toggleEmailNotification(
    data: ToggleEmailNotificationData,
  ): CancelablePromise<ToggleEmailNotificationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/invoice-setting/{uuid}/toggle-email-notification",
      path: {
        uuid: data.uuid,
      },
      query: {
        emailNotificationEnabled: data.emailNotificationEnabled,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createInvoiceSetting(
    data: CreateInvoiceSettingData,
  ): CancelablePromise<CreateInvoiceSettingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/invoice-setting",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllInvoiceSettings(
    data: GetAllInvoiceSettingsData = {},
  ): CancelablePromise<GetAllInvoiceSettingsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/invoice-setting/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class FeatureManagementControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getFeatureByUuid(
    data: GetFeatureByUuidData,
  ): CancelablePromise<GetFeatureByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/features/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateFeature(
    data: UpdateFeatureData,
  ): CancelablePromise<UpdateFeatureResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/features/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteFeature(
    data: DeleteFeatureData,
  ): CancelablePromise<DeleteFeatureResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/features/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllFeatures(): CancelablePromise<GetAllFeaturesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/features",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createFeature(
    data: CreateFeatureData,
  ): CancelablePromise<CreateFeatureResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/features",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class FaxControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateFaxDocument(
    data: UpdateFaxDocumentData,
  ): CancelablePromise<UpdateFaxDocumentResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/fax/efax-document",
      query: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateFaxStatus(
    data: UpdateFaxStatusData,
  ): CancelablePromise<UpdateFaxStatusResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/update-fax-status",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFax(data: SendFaxData): CancelablePromise<SendFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fax
   * @param data.workUuid
   * @param data.locationUuid
   * @param data.comment
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendWorkNoteByFax(
    data: SendWorkNoteByFaxData,
  ): CancelablePromise<SendWorkNoteByFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-work-note-fax",
      query: {
        fax: data.fax,
        workUuid: data.workUuid,
        locationUuid: data.locationUuid,
        comment: data.comment,
        srFax: data.srFax,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.email
   * @param data.workNoteUuid
   * @param data.comment
   * @returns Response OK
   * @throws ApiError
   */
  public static sendWorkNoteByEmail(
    data: SendWorkNoteByEmailData,
  ): CancelablePromise<SendWorkNoteByEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-work-note-email",
      query: {
        email: data.email,
        workNoteUuid: data.workNoteUuid,
        comment: data.comment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fax
   * @param data.soapNoteUuid
   * @param data.locationUuid
   * @param data.localDateTime
   * @param data.comment
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendSoapNoteByFax(
    data: SendSoapNoteByFaxData,
  ): CancelablePromise<SendSoapNoteByFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-soap-note-fax",
      query: {
        fax: data.fax,
        soapNoteUuid: data.soapNoteUuid,
        locationUuid: data.locationUuid,
        localDateTime: data.localDateTime,
        comment: data.comment,
        srFax: data.srFax,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.email
   * @param data.soapNoteUuid
   * @param data.localDateTime
   * @param data.comment
   * @returns Response OK
   * @throws ApiError
   */
  public static sendSoapNoteByEmail(
    data: SendSoapNoteByEmailData,
  ): CancelablePromise<SendSoapNoteByEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-soap-note-email",
      query: {
        email: data.email,
        soapNoteUuid: data.soapNoteUuid,
        localDateTime: data.localDateTime,
        comment: data.comment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fax
   * @param data.referralUuid
   * @param data.locationUuid
   * @param data.comment
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendReferralByFax(
    data: SendReferralByFaxData,
  ): CancelablePromise<SendReferralByFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-referral-fax",
      query: {
        fax: data.fax,
        referralUuid: data.referralUuid,
        locationUuid: data.locationUuid,
        comment: data.comment,
        srFax: data.srFax,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.email
   * @param data.referralUuid
   * @param data.comment
   * @returns Response OK
   * @throws ApiError
   */
  public static sendReferralByEmail(
    data: SendReferralByEmailData,
  ): CancelablePromise<SendReferralByEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-referral-email",
      query: {
        email: data.email,
        referralUuid: data.referralUuid,
        comment: data.comment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fax
   * @param data.pocUuid
   * @param data.locationUuid
   * @param data.comment
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendPocByFax(
    data: SendPocByFaxData,
  ): CancelablePromise<SendPocByFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-poc-fax",
      query: {
        fax: data.fax,
        pocUuid: data.pocUuid,
        locationUuid: data.locationUuid,
        comment: data.comment,
        srFax: data.srFax,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.email
   * @param data.pocUuid
   * @param data.comment
   * @returns Response OK
   * @throws ApiError
   */
  public static sendPocByEmail(
    data: SendPocByEmailData,
  ): CancelablePromise<SendPocByEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-poc-email",
      query: {
        email: data.email,
        pocUuid: data.pocUuid,
        comment: data.comment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fax
   * @param data.patientInformationUuid
   * @param data.locationUuid
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendPatientInformationByFax(
    data: SendPatientInformationByFaxData,
  ): CancelablePromise<SendPatientInformationByFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-patient-information-fax",
      query: {
        fax: data.fax,
        patientInformationUuid: data.patientInformationUuid,
        locationUuid: data.locationUuid,
        srFax: data.srFax,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.email
   * @param data.patientInformationUuid
   * @param data.comment
   * @returns Response OK
   * @throws ApiError
   */
  public static sendPatientInformationByEmail(
    data: SendPatientInformationByEmailData,
  ): CancelablePromise<SendPatientInformationByEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-patient-information-email",
      query: {
        email: data.email,
        patientInformationUuid: data.patientInformationUuid,
        comment: data.comment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendLabResultBySms(
    data: SendLabResultBySmsData,
  ): CancelablePromise<SendLabResultBySmsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-labresult-sms",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static getFaxDetailService(
    data: GetFaxDetailServiceData,
  ): CancelablePromise<GetFaxDetailServiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-labresult-email",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fax
   * @param data.imagingUuid
   * @param data.locationUuid
   * @param data.comment
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendImagingByFax(
    data: SendImagingByFaxData,
  ): CancelablePromise<SendImagingByFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-imaging-fax",
      query: {
        fax: data.fax,
        imagingUuid: data.imagingUuid,
        locationUuid: data.locationUuid,
        comment: data.comment,
        srFax: data.srFax,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.email
   * @param data.imagingUuid
   * @param data.comment
   * @returns Response OK
   * @throws ApiError
   */
  public static sendImagingByEmail(
    data: SendImagingByEmailData,
  ): CancelablePromise<SendImagingByEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-imaging-email",
      query: {
        email: data.email,
        imagingUuid: data.imagingUuid,
        comment: data.comment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fax
   * @param data.handpNoteUuid
   * @param data.locationUuid
   * @param data.localDateTime
   * @param data.comment
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendHandpNoteByFax(
    data: SendHandpNoteByFaxData,
  ): CancelablePromise<SendHandpNoteByFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-handp-note-fax",
      query: {
        fax: data.fax,
        handpNoteUuid: data.handpNoteUuid,
        locationUuid: data.locationUuid,
        localDateTime: data.localDateTime,
        comment: data.comment,
        srFax: data.srFax,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.email
   * @param data.handpNoteUuid
   * @param data.localDateTime
   * @param data.comment
   * @returns Response OK
   * @throws ApiError
   */
  public static sendHandpNoteByEmail(
    data: SendHandpNoteByEmailData,
  ): CancelablePromise<SendHandpNoteByEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-handp-note-email",
      query: {
        email: data.email,
        handpNoteUuid: data.handpNoteUuid,
        localDateTime: data.localDateTime,
        comment: data.comment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fax
   * @param data.documentUuid
   * @param data.locationUuid
   * @param data.comment
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendDocumentByFax(
    data: SendDocumentByFaxData,
  ): CancelablePromise<SendDocumentByFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-document-fax",
      query: {
        fax: data.fax,
        documentUuid: data.documentUuid,
        locationUuid: data.locationUuid,
        comment: data.comment,
        srFax: data.srFax,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.email
   * @param data.documentUuid
   * @param data.comment
   * @returns Response OK
   * @throws ApiError
   */
  public static sendDocumentByEmail(
    data: SendDocumentByEmailData,
  ): CancelablePromise<SendDocumentByEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/send-document-email",
      query: {
        email: data.email,
        documentUuid: data.documentUuid,
        comment: data.comment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFaxToRefferal(
    data: SendFaxToRefferalData,
  ): CancelablePromise<SendFaxToRefferalResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/referral",
      query: {
        srFax: data.srFax,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendQuestionnaireFax(
    data: SendQuestionnaireFaxData,
  ): CancelablePromise<SendQuestionnaireFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/questionnaire",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFaxToLabOrder(
    data: SendFaxToLabOrderData,
  ): CancelablePromise<SendFaxToLabOrderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/lab-order",
      query: {
        srFax: data.srFax,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.srFax
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFaxToImaging(
    data: SendFaxToImagingData,
  ): CancelablePromise<SendFaxToImagingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/imaging",
      query: {
        srFax: data.srFax,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFaxToLabOrder1(
    data: SendFaxToLabOrder1Data,
  ): CancelablePromise<SendFaxToLabOrder1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/fax/labresult",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.faxId
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static cancelEfaxFax(
    data: CancelEfaxFaxData,
  ): CancelablePromise<CancelEfaxFaxResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/efax-cancel",
      query: {
        faxId: data.faxId,
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.referenceType
   * @param data.resultUuid
   * @param data.documentUuid
   * @param data.reviewRequired
   * @returns Response OK
   * @throws ApiError
   */
  public static attachDocument(
    data: AttachDocumentData,
  ): CancelablePromise<AttachDocumentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/fax/attach-document",
      query: {
        referenceType: data.referenceType,
        resultUuid: data.resultUuid,
        documentUuid: data.documentUuid,
        reviewRequired: data.reviewRequired,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static fetchSentFaxesByLocation(
    data: FetchSentFaxesByLocationData,
  ): CancelablePromise<FetchSentFaxesByLocationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/sent-faxes",
      query: {
        locationUuid: data.locationUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.direction
   * @returns Response OK
   * @throws ApiError
   */
  public static retrieveFax(
    data: RetrieveFaxData,
  ): CancelablePromise<RetrieveFaxResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/retrieve",
      query: {
        uuid: data.uuid,
        direction: data.direction,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns string OK
   * @throws ApiError
   */
  public static getImagingResultPdf(
    data: GetImagingResultPdfData,
  ): CancelablePromise<GetImagingResultPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/pdf/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns string OK
   * @throws ApiError
   */
  public static getLabOrderPdf(
    data: GetLabOrderPdfData,
  ): CancelablePromise<GetLabOrderPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/pdf-lab-order/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @returns Response OK
   * @throws ApiError
   */
  public static fetchOutboxFaxes(
    data: FetchOutboxFaxesData = {},
  ): CancelablePromise<FetchOutboxFaxesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/fetch-outbox",
      query: {
        page: data.page,
        pageSize: data.pageSize,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static fetchInboxFaxes(
    data: FetchInboxFaxesData,
  ): CancelablePromise<FetchInboxFaxesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/fetch-inbox",
      query: {
        locationUuid: data.locationUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static fetchInboxWithSubUsers(): CancelablePromise<FetchInboxWithSubUsersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/fetch-inbox-test",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @param data.paginationOffset
   * @param data.paginationLimit
   * @returns Response OK
   * @throws ApiError
   */
  public static fetchSentFaxesFromEfax(
    data: FetchSentFaxesFromEfaxData,
  ): CancelablePromise<FetchSentFaxesFromEfaxResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/efax-sent",
      query: {
        locationUuid: data.locationUuid,
        paginationOffset: data.paginationOffset,
        paginationLimit: data.paginationLimit,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @param data.paginationOffset
   * @param data.paginationLimit
   * @returns Response OK
   * @throws ApiError
   */
  public static fetchReceivedFaxesFromEfax(
    data: FetchReceivedFaxesFromEfaxData,
  ): CancelablePromise<FetchReceivedFaxesFromEfaxResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/efax-received",
      query: {
        locationUuid: data.locationUuid,
        paginationOffset: data.paginationOffset,
        paginationLimit: data.paginationLimit,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.faxId
   * @param data.locationUuid
   * @param data.startPage
   * @param data.numPages
   * @returns Response OK
   * @throws ApiError
   */
  public static fetchEfaxFaxPages(
    data: FetchEfaxFaxPagesData,
  ): CancelablePromise<FetchEfaxFaxPagesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/efax-pages",
      query: {
        faxId: data.faxId,
        locationUuid: data.locationUuid,
        startPage: data.startPage,
        numPages: data.numPages,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.faxId
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static fetchEfaxOutboundFaxMetadata(
    data: FetchEfaxOutboundFaxMetadataData,
  ): CancelablePromise<FetchEfaxOutboundFaxMetadataResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/efax-outbound-metadata",
      query: {
        faxId: data.faxId,
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.faxId
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static fetchEfaxFaxMetadata(
    data: FetchEfaxFaxMetadataData,
  ): CancelablePromise<FetchEfaxFaxMetadataResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/fax/efax-metadata",
      query: {
        faxId: data.faxId,
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.faxId
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteEfaxFax(
    data: DeleteEfaxFaxData,
  ): CancelablePromise<DeleteEfaxFaxResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/fax/efax-delete",
      query: {
        faxId: data.faxId,
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteFax(
    data: DeleteFaxData,
  ): CancelablePromise<DeleteFaxResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/fax/delete-fax",
      query: {
        uuid: data.uuid,
      },
    });
  }
}

export class FaceSheetLayoutControllerService {
  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getLayout(): CancelablePromise<GetLayoutResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/face-sheet-layout",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveLayout(
    data: SaveLayoutData,
  ): CancelablePromise<SaveLayoutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/face-sheet-layout",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static resetLayout(): CancelablePromise<ResetLayoutResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/face-sheet-layout/reset",
    });
  }
}

export class EmployerControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateEmployer(
    data: UpdateEmployerData,
  ): CancelablePromise<UpdateEmployerResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/employer/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteEmployer(
    data: DeleteEmployerData,
  ): CancelablePromise<DeleteEmployerResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/employer/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPricingDetails(
    data: GetPricingDetailsData,
  ): CancelablePromise<GetPricingDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/pricing-details",
      query: {
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static savePricingDetails(
    data: SavePricingDetailsData,
  ): CancelablePromise<SavePricingDetailsResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/employer/pricing-details",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getOnlineSignUp(
    data: GetOnlineSignUpData,
  ): CancelablePromise<GetOnlineSignUpResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/online-signup",
      query: {
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveOnlineSignUp(
    data: SaveOnlineSignUpData,
  ): CancelablePromise<SaveOnlineSignUpResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/employer/online-signup",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAccountDetails(
    data: GetAccountDetailsData,
  ): CancelablePromise<GetAccountDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/account-details",
      query: {
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveAccountDetails(
    data: SaveAccountDetailsData,
  ): CancelablePromise<SaveAccountDetailsResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/employer/account-details",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addEmployer(
    data: AddEmployerData,
  ): CancelablePromise<AddEmployerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/employer",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getInvoiceSetting(
    data: GetInvoiceSettingData,
  ): CancelablePromise<GetInvoiceSettingResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/invoice_setting/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.requestBody
   * @param data.employerInvoiceSettingUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateInvoiceSetting1(
    data: UpdateInvoiceSetting1Data,
  ): CancelablePromise<UpdateInvoiceSetting1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/employer/invoice_setting/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        employerInvoiceSettingUuid: data.employerInvoiceSettingUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.status
   * @param data.employerUuid
   * @param data.isCancelEndMembership
   * @param data.planEndDate
   * @param data.planStartDate
   * @param data.cancellationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateEmployerStatus(
    data: UpdateEmployerStatusData,
  ): CancelablePromise<UpdateEmployerStatusResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/employer/status",
      query: {
        status: data.status,
        employerUuid: data.employerUuid,
        isCancelEndMembership: data.isCancelEndMembership,
        planEndDate: data.planEndDate,
        planStartDate: data.planStartDate,
        cancellationUuid: data.cancellationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.isEmployeePatient
   * @param data.patientStatus
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEmployerTotalCount(
    data: GetAllEmployerTotalCountData = {},
  ): CancelablePromise<GetAllEmployerTotalCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/total-count",
      query: {
        employerUuid: data.employerUuid,
        isEmployeePatient: data.isEmployeePatient,
        patientStatus: data.patientStatus,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerMemberShip(
    data: GetEmployerMemberShipData,
  ): CancelablePromise<GetEmployerMemberShipResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/membership/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.planUuid
   * @param data.employerPlanHistoryUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getMembershipDetails(
    data: GetMembershipDetailsData,
  ): CancelablePromise<GetMembershipDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/membership-details/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        employerPlanHistoryUuid: data.employerPlanHistoryUuid,
        planUuid: data.planUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerByUuid(
    data: GetEmployerByUuidData,
  ): CancelablePromise<GetEmployerByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/fetch/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerCustomLogoByUuid(
    data: GetEmployerCustomLogoByUuidData,
  ): CancelablePromise<GetEmployerCustomLogoByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/custom-logo/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerCoveragePlans(
    data: GetEmployerCoveragePlansData,
  ): CancelablePromise<GetEmployerCoveragePlansResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/coverage-plan/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getBasicDetailsByPatientUuid(
    data: GetBasicDetailsByPatientUuidData,
  ): CancelablePromise<GetBasicDetailsByPatientUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/basic-details/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.planName
   * @param data.status
   * @param data.search
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEmployers(
    data: GetAllEmployersData = {},
  ): CancelablePromise<GetAllEmployersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        planName: data.planName,
        status: data.status,
        search: data.search,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static archiveEmployerPlan(
    data: ArchiveEmployerPlanData,
  ): CancelablePromise<ArchiveEmployerPlanResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/employer/plan_change",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class EmployerPageControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateEmployerPage(
    data: UpdateEmployerPageData,
  ): CancelablePromise<UpdateEmployerPageResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/employer-page",
      query: {
        employerUuid: data.employerUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static createEmployerPage(
    data: CreateEmployerPageData,
  ): CancelablePromise<CreateEmployerPageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/employer-page",
      query: {
        employerUuid: data.employerUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerPageUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerPageByUuid(
    data: GetEmployerPageByUuidData,
  ): CancelablePromise<GetEmployerPageByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer-page/{employerPageUuid}",
      path: {
        employerPageUuid: data.employerPageUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerPageUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteEmployerPageByUuid(
    data: DeleteEmployerPageByUuidData,
  ): CancelablePromise<DeleteEmployerPageByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/employer-page/{employerPageUuid}",
      path: {
        employerPageUuid: data.employerPageUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerPageUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static isLinkActive(
    data: IsLinkActiveData,
  ): CancelablePromise<IsLinkActiveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer-page/link-active/{employerPageUuid}",
      path: {
        employerPageUuid: data.employerPageUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.employerOnlineSignUpUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEmployerPages(
    data: GetAllEmployerPagesData = {},
  ): CancelablePromise<GetAllEmployerPagesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer-page/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        employerOnlineSignUpUuid: data.employerOnlineSignUpUuid,
      },
    });
  }
}

export class EmployerDivisionControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateEmployerDivision(
    data: UpdateEmployerDivisionData,
  ): CancelablePromise<UpdateEmployerDivisionResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/employer-division",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createEmployerDivision(
    data: CreateEmployerDivisionData,
  ): CancelablePromise<CreateEmployerDivisionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/employer-division",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerDivisionUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerDivisionByUuid(
    data: GetEmployerDivisionByUuidData,
  ): CancelablePromise<GetEmployerDivisionByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer-division/{employerDivisionUuid}",
      path: {
        employerDivisionUuid: data.employerDivisionUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerDivisionUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteEmployerDivisionByUuid(
    data: DeleteEmployerDivisionByUuidData,
  ): CancelablePromise<DeleteEmployerDivisionByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/employer-division/{employerDivisionUuid}",
      path: {
        employerDivisionUuid: data.employerDivisionUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEmployerDivisions(
    data: GetAllEmployerDivisionsData = {},
  ): CancelablePromise<GetAllEmployerDivisionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer-division/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        employerUuid: data.employerUuid,
      },
    });
  }
}

export class EmployerAdministratorControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateEmployerAdministrator(
    data: UpdateEmployerAdministratorData,
  ): CancelablePromise<UpdateEmployerAdministratorResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/employer-administrator",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createEmployerAdministrator(
    data: CreateEmployerAdministratorData,
  ): CancelablePromise<CreateEmployerAdministratorResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/employer-administrator",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerAdministratorUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerAdministratorByUuid(
    data: GetEmployerAdministratorByUuidData,
  ): CancelablePromise<GetEmployerAdministratorByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer-administrator/{employerAdministratorUuid}",
      path: {
        employerAdministratorUuid: data.employerAdministratorUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerAdministratorUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteEmployerAdministratorByUuid(
    data: DeleteEmployerAdministratorByUuidData,
  ): CancelablePromise<DeleteEmployerAdministratorByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/employer-administrator/{employerAdministratorUuid}",
      path: {
        employerAdministratorUuid: data.employerAdministratorUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEmployerAdministrators(
    data: GetAllEmployerAdministratorsData,
  ): CancelablePromise<GetAllEmployerAdministratorsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/employer-administrator/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        employerUuid: data.employerUuid,
      },
    });
  }
}

export class CreditControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getCreditByUuid(
    data: GetCreditByUuidData,
  ): CancelablePromise<GetCreditByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/credit/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateCredit(
    data: UpdateCreditData,
  ): CancelablePromise<UpdateCreditResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/credit/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteCredit(
    data: DeleteCreditData,
  ): CancelablePromise<DeleteCreditResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/credit/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addCredit(
    data: AddCreditData,
  ): CancelablePromise<AddCreditResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/credit",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getTotalCreditByUuid(
    data: GetTotalCreditByUuidData,
  ): CancelablePromise<GetTotalCreditByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/credit/total_credit/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.expired
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllCredits(
    data: GetAllCreditsData,
  ): CancelablePromise<GetAllCreditsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/credit/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        expired: data.expired,
      },
    });
  }
}

export class CoverageRuleControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateCoverageRule(
    data: UpdateCoverageRuleData,
  ): CancelablePromise<UpdateCoverageRuleResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/coverage-rules",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createCoverageRule(
    data: CreateCoverageRuleData,
  ): CancelablePromise<CreateCoverageRuleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/coverage-rules",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coverageRuleUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getCoverageRuleByUuid(
    data: GetCoverageRuleByUuidData,
  ): CancelablePromise<GetCoverageRuleByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/coverage-rules/{coverageRuleUuid}",
      path: {
        coverageRuleUuid: data.coverageRuleUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coverageRuleUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteCoverageRuleByUuid(
    data: DeleteCoverageRuleByUuidData,
  ): CancelablePromise<DeleteCoverageRuleByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/coverage-rules/{coverageRuleUuid}",
      path: {
        coverageRuleUuid: data.coverageRuleUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllCoverageRule(
    data: GetAllCoverageRuleData = {},
  ): CancelablePromise<GetAllCoverageRuleResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/coverage-rules/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class CoveragePlanControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateCoveragePlan(
    data: UpdateCoveragePlanData,
  ): CancelablePromise<UpdateCoveragePlanResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/coverage-plans",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createCoveragePlan(
    data: CreateCoveragePlanData,
  ): CancelablePromise<CreateCoveragePlanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/coverage-plans",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coveragePlanUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getCoveragePlanByUuid(
    data: GetCoveragePlanByUuidData,
  ): CancelablePromise<GetCoveragePlanByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/coverage-plans/{coveragePlanUuid}",
      path: {
        coveragePlanUuid: data.coveragePlanUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coveragePlanUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteCoveragePlanByUuid(
    data: DeleteCoveragePlanByUuidData,
  ): CancelablePromise<DeleteCoveragePlanByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/coverage-plans/{coveragePlanUuid}",
      path: {
        coveragePlanUuid: data.coveragePlanUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllCoveragePlan(
    data: GetAllCoveragePlanData = {},
  ): CancelablePromise<GetAllCoveragePlanResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/coverage-plans/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coveragePlanEmployerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteCoveragePlanEmployerByUuid(
    data: DeleteCoveragePlanEmployerByUuidData,
  ): CancelablePromise<DeleteCoveragePlanEmployerByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/coverage-plans/employer/{coveragePlanEmployerUuid}",
      path: {
        coveragePlanEmployerUuid: data.coveragePlanEmployerUuid,
      },
    });
  }
}

export class CouponControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateCoupon(
    data: UpdateCouponData,
  ): CancelablePromise<UpdateCouponResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/coupons",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createCoupon(
    data: CreateCouponData,
  ): CancelablePromise<CreateCouponResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/coupons",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.couponUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getCouponByUuid(
    data: GetCouponByUuidData,
  ): CancelablePromise<GetCouponByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/coupons/{couponUuid}",
      path: {
        couponUuid: data.couponUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.couponUuid
   * @param data.archive
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteCouponByUuid(
    data: DeleteCouponByUuidData,
  ): CancelablePromise<DeleteCouponByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/coupons/{couponUuid}",
      path: {
        couponUuid: data.couponUuid,
      },
      query: {
        archive: data.archive,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.activeExpired
   * @param data.providerUuids
   * @param data.redeemableNonRedeemable
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllCoupons(
    data: GetAllCouponsData = {},
  ): CancelablePromise<GetAllCouponsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/coupons/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        activeExpired: data.activeExpired,
        providerUuids: data.providerUuids,
        redeemableNonRedeemable: data.redeemableNonRedeemable,
      },
    });
  }
}

export class ChargeItemControllerService {
  /**
   * @param data The data for the request.
   * @param data.chargeItemUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getChargeItemByUuid(
    data: GetChargeItemByUuidData,
  ): CancelablePromise<GetChargeItemByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/charge_item/{chargeItemUuid}",
      path: {
        chargeItemUuid: data.chargeItemUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.chargeItemUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateChargeItemByUuid(
    data: UpdateChargeItemByUuidData,
  ): CancelablePromise<UpdateChargeItemByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/charge_item/{chargeItemUuid}",
      path: {
        chargeItemUuid: data.chargeItemUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.chargeItemUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteChargeItemByUuid(
    data: DeleteChargeItemByUuidData,
  ): CancelablePromise<DeleteChargeItemByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/charge_item/{chargeItemUuid}",
      path: {
        chargeItemUuid: data.chargeItemUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadCsv(
    data: UploadCsvData = {},
  ): CancelablePromise<UploadCsvResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/charge_item/upload-csv",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePricesFromCsv(
    data: UpdatePricesFromCsvData = {},
  ): CancelablePromise<UpdatePricesFromCsvResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/charge_item/update-price-csv",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveChargeItem(
    data: SaveChargeItemData,
  ): CancelablePromise<SaveChargeItemResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/charge_item/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.chargeItemUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getChargeItemTaxMapping(
    data: GetChargeItemTaxMappingData,
  ): CancelablePromise<GetChargeItemTaxMappingResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/charge_item/tax-mapping",
      query: {
        patientUuid: data.patientUuid,
        chargeItemUuid: data.chargeItemUuid,
      },
    });
  }

  /**
   * @returns binary OK
   * @throws ApiError
   */
  public static downloadPriceUpdateCsvTemplate(): CancelablePromise<DownloadPriceUpdateCsvTemplateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/charge_item/price-update-csv-template",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.search
   * @param data.categoryName
   * @param data.minPrice
   * @param data.maxPrice
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportCsv(
    data: ExportCsvData = {},
  ): CancelablePromise<ExportCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/charge_item/export-csv",
      query: {
        search: data.search,
        categoryName: data.categoryName,
        minPrice: data.minPrice,
        maxPrice: data.maxPrice,
      },
    });
  }

  /**
   * @returns binary OK
   * @throws ApiError
   */
  public static downloadCsvTemplate1(): CancelablePromise<DownloadCsvTemplate1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/charge_item/csv-template",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.chargeCategoryUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getChargeItemsByChargeCategoryUuid(
    data: GetChargeItemsByChargeCategoryUuidData,
  ): CancelablePromise<GetChargeItemsByChargeCategoryUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/charge_item/charge-items/{chargeCategoryUuid}",
      path: {
        chargeCategoryUuid: data.chargeCategoryUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.search
   * @param data.categoryName
   * @param data.minPrice
   * @param data.maxPrice
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static searchAndFilterChargeItems(
    data: SearchAndFilterChargeItemsData = {},
  ): CancelablePromise<SearchAndFilterChargeItemsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/charge_item/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        search: data.search,
        categoryName: data.categoryName,
        minPrice: data.minPrice,
        maxPrice: data.maxPrice,
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteChargeItemsByUuids(
    data: DeleteChargeItemsByUuidsData,
  ): CancelablePromise<DeleteChargeItemsByUuidsResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/charge_item/delete-all",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class ChargeCategoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.chargeCategoryUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getChargeCategoryByUuid(
    data: GetChargeCategoryByUuidData,
  ): CancelablePromise<GetChargeCategoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/charge_category/{chargeCategoryUuid}",
      path: {
        chargeCategoryUuid: data.chargeCategoryUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.chargeCategoryUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateChargeCategoryByUuid(
    data: UpdateChargeCategoryByUuidData,
  ): CancelablePromise<UpdateChargeCategoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/charge_category/{chargeCategoryUuid}",
      path: {
        chargeCategoryUuid: data.chargeCategoryUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.chargeCategoryUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteChargeCategoryByUuid(
    data: DeleteChargeCategoryByUuidData,
  ): CancelablePromise<DeleteChargeCategoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/charge_category/{chargeCategoryUuid}",
      path: {
        chargeCategoryUuid: data.chargeCategoryUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveChargeCategory(
    data: SaveChargeCategoryData,
  ): CancelablePromise<SaveChargeCategoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/charge_category/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coveragePlanUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getChargeCategoryByCoveragePlanUuid(
    data: GetChargeCategoryByCoveragePlanUuidData,
  ): CancelablePromise<GetChargeCategoryByCoveragePlanUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/charge_category/charge-category/{coveragePlanUuid}",
      path: {
        coveragePlanUuid: data.coveragePlanUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.searchString
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllChargeCategories(
    data: GetAllChargeCategoriesData = {},
  ): CancelablePromise<GetAllChargeCategoriesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/charge_category/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        searchString: data.searchString,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class CancellationControllerService {
  /**
   * @param data The data for the request.
   * @param data.cancellationsUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getCancellationByUuid(
    data: GetCancellationByUuidData,
  ): CancelablePromise<GetCancellationByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/cancellation/{cancellationsUuid}",
      path: {
        cancellationsUuid: data.cancellationsUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cancellationsUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateCancellation(
    data: UpdateCancellationData,
  ): CancelablePromise<UpdateCancellationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/cancellation/{cancellationsUuid}",
      path: {
        cancellationsUuid: data.cancellationsUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cancellationsUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteCancellationByUuid(
    data: DeleteCancellationByUuidData,
  ): CancelablePromise<DeleteCancellationByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/cancellation/{cancellationsUuid}",
      path: {
        cancellationsUuid: data.cancellationsUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cancellationsUuid
   * @param data.archive
   * @returns Response OK
   * @throws ApiError
   */
  public static archiveAndUnarchiveCancellationByUuid(
    data: ArchiveAndUnarchiveCancellationByUuidData,
  ): CancelablePromise<ArchiveAndUnarchiveCancellationByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/cancellation/{cancellationsUuid}/archive",
      path: {
        cancellationsUuid: data.cancellationsUuid,
      },
      query: {
        archive: data.archive,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveCancellation(
    data: SaveCancellationData,
  ): CancelablePromise<SaveCancellationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/cancellation/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.description
   * @param data.archive
   * @param data.isCustom
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllCancellations(
    data: GetAllCancellationsData = {},
  ): CancelablePromise<GetAllCancellationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/cancellation/all",
      query: {
        description: data.description,
        archive: data.archive,
        isCustom: data.isCustom,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class BrokerControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateBroker(
    data: UpdateBrokerData,
  ): CancelablePromise<UpdateBrokerResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/brokers",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createBroker(
    data: CreateBrokerData,
  ): CancelablePromise<CreateBrokerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/brokers",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.brokerUuid
   * @param data.active
   * @returns Response OK
   * @throws ApiError
   */
  public static updateBrokerStatus(
    data: UpdateBrokerStatusData,
  ): CancelablePromise<UpdateBrokerStatusResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/brokers/{brokerUuid}/status",
      path: {
        brokerUuid: data.brokerUuid,
      },
      query: {
        active: data.active,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.brokerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getBrokerByUuid(
    data: GetBrokerByUuidData,
  ): CancelablePromise<GetBrokerByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/brokers/{brokerUuid}",
      path: {
        brokerUuid: data.brokerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.brokerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteBrokerByUuid(
    data: DeleteBrokerByUuidData,
  ): CancelablePromise<DeleteBrokerByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/brokers/{brokerUuid}",
      path: {
        brokerUuid: data.brokerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.employerUuids
   * @param data.agentFirmUuids
   * @param data.status
   * @param data.startDate
   * @param data.endDate
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllBrokers(
    data: GetAllBrokersData = {},
  ): CancelablePromise<GetAllBrokersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/brokers/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        employerUuids: data.employerUuids,
        agentFirmUuids: data.agentFirmUuids,
        status: data.status,
        startDate: data.startDate,
        endDate: data.endDate,
      },
    });
  }
}

export class BreakGlassControllerService {
  /**
   * @param data The data for the request.
   * @param data.breakGlassUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static update3(data: Update3Data): CancelablePromise<Update3Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/break-glass/update/{breakGlassUuid}",
      path: {
        breakGlassUuid: data.breakGlassUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static create3(data: Create3Data): CancelablePromise<Create3Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/break-glass/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.breakGlassUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getByUuid3(
    data: GetByUuid3Data,
  ): CancelablePromise<GetByUuid3Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/break-glass/{breakGlassUuid}",
      path: {
        breakGlassUuid: data.breakGlassUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.providerUuid
   * @param data.nurseStaffProviderUuid
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllBreakGlass(
    data: GetAllBreakGlassData = {},
  ): CancelablePromise<GetAllBreakGlassResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/break-glass/all",
      query: {
        patientUuid: data.patientUuid,
        providerUuid: data.providerUuid,
        nurseStaffProviderUuid: data.nurseStaffProviderUuid,
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.breakGlassUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static delete3(data: Delete3Data): CancelablePromise<Delete3Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/break-glass/delete/{breakGlassUuid}",
      path: {
        breakGlassUuid: data.breakGlassUuid,
      },
    });
  }
}

export class AncillaryServiceChargesControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.invoiceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAncillaryServiceCharges(
    data: UpdateAncillaryServiceChargesData,
  ): CancelablePromise<UpdateAncillaryServiceChargesResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/ancillary_service_charges/update",
      query: {
        invoiceUuid: data.invoiceUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.miscellaneousServiceChargeUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getMiscellaneousServiceChargeByUuid(
    data: GetMiscellaneousServiceChargeByUuidData,
  ): CancelablePromise<GetMiscellaneousServiceChargeByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/miscellaneous_service_charge/{miscellaneousServiceChargeUuid}",
      path: {
        miscellaneousServiceChargeUuid: data.miscellaneousServiceChargeUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.miscellaneousServiceChargeUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateMiscellaneousServiceChargeByUuid(
    data: UpdateMiscellaneousServiceChargeByUuidData,
  ): CancelablePromise<UpdateMiscellaneousServiceChargeByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/ancillary_service_charges/miscellaneous_service_charge/{miscellaneousServiceChargeUuid}",
      path: {
        miscellaneousServiceChargeUuid: data.miscellaneousServiceChargeUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.miscellaneousServiceChargeUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteMiscellaneousServiceChargeByUuid(
    data: DeleteMiscellaneousServiceChargeByUuidData,
  ): CancelablePromise<DeleteMiscellaneousServiceChargeByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/ancillary_service_charges/miscellaneous_service_charge/{miscellaneousServiceChargeUuid}",
      path: {
        miscellaneousServiceChargeUuid: data.miscellaneousServiceChargeUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePlanRenewalDatesForActiveRetailPatients(): CancelablePromise<UpdatePlanRenewalDatesForActiveRetailPatientsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/update_plan_renewal_dates",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static syncEmployerInvoice(
    data: SyncEmployerInvoiceData,
  ): CancelablePromise<SyncEmployerInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/sync_employer_invoice/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static scheduledPaymentProcessing(): CancelablePromise<ScheduledPaymentProcessingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/scheduled_payment_processing",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static scheduledPayment(
    data: ScheduledPaymentData,
  ): CancelablePromise<ScheduledPaymentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/scheduled_payment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.patientUuid
   * @param data.invoiceStatus
   * @param data.paymentMethod
   * @param data.paymentMethodReason
   * @returns Response OK
   * @throws ApiError
   */
  public static updateExistingRetailPatientMembershipInvoice(
    data: UpdateExistingRetailPatientMembershipInvoiceData,
  ): CancelablePromise<UpdateExistingRetailPatientMembershipInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/retail_patient_membership_invoice/update",
      query: {
        invoiceUuid: data.invoiceUuid,
        patientUuid: data.patientUuid,
        invoiceStatus: data.invoiceStatus,
        paymentMethod: data.paymentMethod,
        paymentMethodReason: data.paymentMethodReason,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static refundAmount1(
    data: RefundAmount1Data,
  ): CancelablePromise<RefundAmount1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/refund_amount",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static reactiveEmployerMembership(
    data: ReactiveEmployerMembershipData,
  ): CancelablePromise<ReactiveEmployerMembershipResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/reactive-employer-membership",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static processOverdueInvoicesAndGeneratePdfs(): CancelablePromise<ProcessOverdueInvoicesAndGeneratePdfsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/process_overdue_invoices",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveMiscellaneousServiceCharge(
    data: SaveMiscellaneousServiceChargeData,
  ): CancelablePromise<SaveMiscellaneousServiceChargeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/miscellaneous_service_charge/create",
      query: {
        invoiceUuid: data.invoiceUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static makePayment(
    data: MakePaymentData,
  ): CancelablePromise<MakePaymentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/make_payment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.chargeItemUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static linkChargeItemsToPatient(
    data: LinkChargeItemsToPatientData,
  ): CancelablePromise<LinkChargeItemsToPatientResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/link/charge_items/patient/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        chargeItemUuid: data.chargeItemUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static markLabOrderAsDrawn(
    data: MarkLabOrderAsDrawnData,
  ): CancelablePromise<MarkLabOrderAsDrawnResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/lab_orders/{labOrderUuid}/mark_as_drawn",
      path: {
        labOrderUuid: data.labOrderUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static invoiceLabOrderNow(
    data: InvoiceLabOrderNowData,
  ): CancelablePromise<InvoiceLabOrderNowResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/lab_orders/{labOrderUuid}/invoice_now",
      path: {
        labOrderUuid: data.labOrderUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static sendLabInvoicePaymentReminders(): CancelablePromise<SendLabInvoicePaymentRemindersResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/lab_invoice_payment_reminders",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static labInvoiceAutopayProcessing(): CancelablePromise<LabInvoiceAutopayProcessingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/lab_invoice_autopay_processing",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.stripeClientSecret
   * @returns Response OK
   * @throws ApiError
   */
  public static createRetailMembershipInvoice(
    data: CreateRetailMembershipInvoiceData,
  ): CancelablePromise<CreateRetailMembershipInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/invoicing_ahead_of_time/{stripeClientSecret}",
      path: {
        stripeClientSecret: data.stripeClientSecret,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static retailPatientAutopayProcessing(): CancelablePromise<RetailPatientAutopayProcessingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/invoicing_ahead_of_time/retail_patient_autopay_processing",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static generateMonthlyEmployerInvoices(): CancelablePromise<GenerateMonthlyEmployerInvoicesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/generate_monthly_employer_invoices",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static generateMonthlyBrokerFirmInvoices(): CancelablePromise<GenerateMonthlyBrokerFirmInvoicesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/generate_monthly_broker_firm_invoices",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static generateMonthlyAffiliateFirmInvoices(): CancelablePromise<GenerateMonthlyAffiliateFirmInvoicesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/generate_monthly_affiliate_firm_invoices",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static generateLabOrderInvoices(): CancelablePromise<GenerateLabOrderInvoicesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/generate_lab_order_invoices",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.salesTaxProfileUuid
   * @param data.rate
   * @param data.savedBankUuid
   * @param data.savedCardUuid
   * @param data.paymentMethod
   * @param data.paymentMethodReason
   * @param data.userTypes
   * @param data.issueDate
   * @param data.dueDate
   * @param data.invoiceStatus
   * @param data.invoiceUuid
   * @param data.reason
   * @param data.makePayment
   * @param data.applyCredit
   * @param data.partialAmount
   * @param data.sharedCard
   * @returns Response OK
   * @throws ApiError
   */
  public static generateInvoiceOfAncillaryForUser(
    data: GenerateInvoiceOfAncillaryForUserData = {},
  ): CancelablePromise<GenerateInvoiceOfAncillaryForUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/generate_invoice_of_ancillary/user",
      query: {
        userUuid: data.userUuid,
        salesTaxProfileUuid: data.salesTaxProfileUuid,
        rate: data.rate,
        savedBankUuid: data.savedBankUuid,
        savedCardUuid: data.savedCardUuid,
        paymentMethod: data.paymentMethod,
        paymentMethodReason: data.paymentMethodReason,
        userTypes: data.userTypes,
        issueDate: data.issueDate,
        dueDate: data.dueDate,
        invoiceStatus: data.invoiceStatus,
        invoiceUuid: data.invoiceUuid,
        reason: data.reason,
        makePayment: data.makePayment,
        applyCredit: data.applyCredit,
        partialAmount: data.partialAmount,
        sharedCard: data.sharedCard,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.invoiceUuid
   * @param data.invoiceStatus
   * @param data.issueDate
   * @param data.dueDate
   * @param data.savedBankUuid
   * @param data.savedCardUuid
   * @param data.paymentMethod
   * @param data.paymentMethodReason
   * @param data.makePayment
   * @param data.salesTaxProfileUuid
   * @param data.rate
   * @param data.partialAmount
   * @param data.sharedCard
   * @param data.reason
   * @returns Response OK
   * @throws ApiError
   */
  public static generateInvoiceEmployerMembership(
    data: GenerateInvoiceEmployerMembershipData,
  ): CancelablePromise<GenerateInvoiceEmployerMembershipResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/generate_invoice/employer_membership/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        invoiceUuid: data.invoiceUuid,
        invoiceStatus: data.invoiceStatus,
        issueDate: data.issueDate,
        dueDate: data.dueDate,
        savedBankUuid: data.savedBankUuid,
        savedCardUuid: data.savedCardUuid,
        paymentMethod: data.paymentMethod,
        paymentMethodReason: data.paymentMethodReason,
        makePayment: data.makePayment,
        salesTaxProfileUuid: data.salesTaxProfileUuid,
        rate: data.rate,
        partialAmount: data.partialAmount,
        sharedCard: data.sharedCard,
        reason: data.reason,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static employerInvoiceSetting(): CancelablePromise<EmployerInvoiceSettingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/employer_membership/invoice_setting",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static deactivateRetailPatientsWithUnpaidInvoices(): CancelablePromise<DeactivateRetailPatientsWithUnpaidInvoicesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/deactivate_retail_patients_with_unpaid_invoices",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static processEmployerDeactivation(): CancelablePromise<ProcessEmployerDeactivationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/deactivate_employer",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createChargeItemAndInvoice(
    data: CreateChargeItemAndInvoiceData,
  ): CancelablePromise<CreateChargeItemAndInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/create_charge_item_and_invoice_automatic",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveAncillaryServiceCharges(
    data: SaveAncillaryServiceChargesData,
  ): CancelablePromise<SaveAncillaryServiceChargesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static convertPatientMembership(): CancelablePromise<ConvertPatientMembershipResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/convert_patient_membership",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static checkChargeCoverage(
    data: CheckChargeCoverageData,
  ): CancelablePromise<CheckChargeCoverageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/check_charge_coverage",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static changeInvoiceStatus(
    data: ChangeInvoiceStatusData,
  ): CancelablePromise<ChangeInvoiceStatusResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/change_invoice_status",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.affiliateFirmUuid
   * @param data.issueDate
   * @param data.invoiceStatus
   * @param data.paymentMethod
   * @param data.paymentMethodReason
   * @param data.makePayment
   * @param data.dueDate
   * @returns Response OK
   * @throws ApiError
   */
  public static updateExistingAffiliateFirmMembershipInvoice(
    data: UpdateExistingAffiliateFirmMembershipInvoiceData,
  ): CancelablePromise<UpdateExistingAffiliateFirmMembershipInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/affiliate_broker_service_charges/save",
      query: {
        invoiceUuid: data.invoiceUuid,
        affiliateFirmUuid: data.affiliateFirmUuid,
        issueDate: data.issueDate,
        invoiceStatus: data.invoiceStatus,
        paymentMethod: data.paymentMethod,
        paymentMethodReason: data.paymentMethodReason,
        makePayment: data.makePayment,
        dueDate: data.dueDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.agentFirmUuid
   * @param data.issueDate
   * @param data.dueDate
   * @param data.invoiceStatus
   * @param data.paymentMethod
   * @param data.paymentMethodReason
   * @param data.makePayment
   * @returns Response OK
   * @throws ApiError
   */
  public static updateExistingBrokerFirmMembershipInvoice(
    data: UpdateExistingBrokerFirmMembershipInvoiceData,
  ): CancelablePromise<UpdateExistingBrokerFirmMembershipInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/affiliate_broker_service_charges/broker_firm/save",
      query: {
        invoiceUuid: data.invoiceUuid,
        agentFirmUuid: data.agentFirmUuid,
        issueDate: data.issueDate,
        dueDate: data.dueDate,
        invoiceStatus: data.invoiceStatus,
        paymentMethod: data.paymentMethod,
        paymentMethodReason: data.paymentMethodReason,
        makePayment: data.makePayment,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static activatePendingEmployeePatients(): CancelablePromise<ActivatePendingEmployeePatientsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/ancillary_service_charges/activate_pending_employee_patients",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ancillaryServiceChargesUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAncillaryServiceChargesUuid(
    data: GetAncillaryServiceChargesUuidData,
  ): CancelablePromise<GetAncillaryServiceChargesUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/{ancillaryServiceChargesUuid}",
      path: {
        ancillaryServiceChargesUuid: data.ancillaryServiceChargesUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.userTypes
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static transactionDetails(
    data: TransactionDetailsData,
  ): CancelablePromise<TransactionDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/transaction_details",
      query: {
        userUuid: data.userUuid,
        userTypes: data.userTypes,
        startDate: data.startDate,
        endDate: data.endDate,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static invoiceTransactionDetails(
    data: InvoiceTransactionDetailsData,
  ): CancelablePromise<InvoiceTransactionDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/transaction_details/{invoiceUuid}",
      path: {
        invoiceUuid: data.invoiceUuid,
      },
      query: {
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.userTypes
   * @param data.startDate
   * @param data.endDate
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getInvoiceStatement(
    data: GetInvoiceStatementData,
  ): CancelablePromise<GetInvoiceStatementResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/statement/{userUuid}/and/{userTypes}",
      path: {
        userUuid: data.userUuid,
        userTypes: data.userTypes,
      },
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllScheduledPayment(
    data: GetAllScheduledPaymentData,
  ): CancelablePromise<GetAllScheduledPaymentResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/scheduled_payment/{invoiceUuid}",
      path: {
        invoiceUuid: data.invoiceUuid,
      },
      query: {
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static paymentHistory(
    data: PaymentHistoryData,
  ): CancelablePromise<PaymentHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/payment_history/{invoiceUuid}",
      path: {
        invoiceUuid: data.invoiceUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllMiscellaneousServiceCharges(
    data: GetAllMiscellaneousServiceChargesData,
  ): CancelablePromise<GetAllMiscellaneousServiceChargesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/miscellaneous_service_charge/all",
      query: {
        invoiceUuid: data.invoiceUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static generateRetailPatientInvoices(): CancelablePromise<GenerateRetailPatientInvoicesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/invoicing_ahead_of_time/generate_retail_patient_invoices",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getInvoiceStatus(
    data: GetInvoiceStatusData,
  ): CancelablePromise<GetInvoiceStatusResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/invoice_status/{invoiceUuid}",
      path: {
        invoiceUuid: data.invoiceUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static invoiceDetails(
    data: InvoiceDetailsData,
  ): CancelablePromise<InvoiceDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/invoice_details/{invoiceUUid}",
      path: {
        invoiceUUid: data.invoiceUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.search
   * @param data.invoiceUuid
   * @param data.chargeType
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static employerEmployeesDetails(
    data: EmployerEmployeesDetailsData,
  ): CancelablePromise<EmployerEmployeesDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/employer_employees_details/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        search: data.search,
        invoiceUuid: data.invoiceUuid,
        chargeType: data.chargeType,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getChargeItemNamesByInvoice(
    data: GetChargeItemNamesByInvoiceData,
  ): CancelablePromise<GetChargeItemNamesByInvoiceResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/charge_items/names/{invoiceUuid}",
      path: {
        invoiceUuid: data.invoiceUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.rate
   * @param data.patientUuid
   * @param data.applyCredit
   * @returns Response OK
   * @throws ApiError
   */
  public static amountDetails(
    data: AmountDetailsData,
  ): CancelablePromise<AmountDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/amount_details",
      query: {
        rate: data.rate,
        invoiceUuid: data.invoiceUuid,
        patientUuid: data.patientUuid,
        applyCredit: data.applyCredit,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.userUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAncillaryServiceCharges(
    data: GetAllAncillaryServiceChargesData = {},
  ): CancelablePromise<GetAllAncillaryServiceChargesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/all",
      query: {
        invoiceUuid: data.invoiceUuid,
        userUuid: data.userUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateFirmUuid
   * @param data.invoiceUuid
   * @param data.search
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static affiliateFirmEmployeesDetails(
    data: AffiliateFirmEmployeesDetailsData,
  ): CancelablePromise<AffiliateFirmEmployeesDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/affiliate_firm_employees_details/{affiliateFirmUuid}/and/{invoiceUuid}",
      path: {
        affiliateFirmUuid: data.affiliateFirmUuid,
        invoiceUuid: data.invoiceUuid,
      },
      query: {
        search: data.search,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.year
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static employerDetailsMonthWise(
    data: EmployerDetailsMonthWiseData,
  ): CancelablePromise<EmployerDetailsMonthWiseResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/affiliate_broker_service_charges/broker_firm/employer_brokerage_details_month_wise",
      query: {
        employerUuid: data.employerUuid,
        year: data.year,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAffiliateBrokerServiceCharges(
    data: GetAllAffiliateBrokerServiceChargesData = {},
  ): CancelablePromise<GetAllAffiliateBrokerServiceChargesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/affiliate_broker_service_charges/all",
      query: {
        invoiceUuid: data.invoiceUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.search
   * @param data.chargeType
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static affiliateProviderEmployeeDetails(
    data: AffiliateProviderEmployeeDetailsData,
  ): CancelablePromise<AffiliateProviderEmployeeDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/ancillary_service_charges/affiliate_broker_service_charges/affiliate_provider_employee_details/{invoiceUuid}",
      path: {
        invoiceUuid: data.invoiceUuid,
      },
      query: {
        search: data.search,
        chargeType: data.chargeType,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ancillaryServiceChargesByUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAncillaryServiceChargesByUuid(
    data: DeleteAncillaryServiceChargesByUuidData,
  ): CancelablePromise<DeleteAncillaryServiceChargesByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/ancillary_service_charges/{ancillaryServiceChargesByUuid}",
      path: {
        ancillaryServiceChargesByUuid: data.ancillaryServiceChargesByUuid,
      },
    });
  }
}

export class AgentFirmControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAgentFirm(
    data: UpdateAgentFirmData,
  ): CancelablePromise<UpdateAgentFirmResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/agent-firm",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createAgentFirm(
    data: CreateAgentFirmData,
  ): CancelablePromise<CreateAgentFirmResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/agent-firm",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agentFirmUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAgentFirmByUuid(
    data: GetAgentFirmByUuidData,
  ): CancelablePromise<GetAgentFirmByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/agent-firm/{agentFirmUuid}",
      path: {
        agentFirmUuid: data.agentFirmUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agentFirmUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAgentFirmByUuid(
    data: DeleteAgentFirmByUuidData,
  ): CancelablePromise<DeleteAgentFirmByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/agent-firm/{agentFirmUuid}",
      path: {
        agentFirmUuid: data.agentFirmUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agentFirmUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.employerStatus
   * @param data.commissionStatus
   * @param data.brokerUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployersUnderAgentFirm(
    data: GetEmployersUnderAgentFirmData,
  ): CancelablePromise<GetEmployersUnderAgentFirmResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/agent-firm/by-agent-firm/{agentFirmUuid}",
      path: {
        agentFirmUuid: data.agentFirmUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        employerStatus: data.employerStatus,
        commissionStatus: data.commissionStatus,
        brokerUuids: data.brokerUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.search
   * @param data.agentFirmType
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAgentFirms(
    data: GetAllAgentFirmsData = {},
  ): CancelablePromise<GetAllAgentFirmsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/agent-firm/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        search: data.search,
        agentFirmType: data.agentFirmType,
      },
    });
  }
}

export class AgentDealControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAgentDeal(
    data: UpdateAgentDealData,
  ): CancelablePromise<UpdateAgentDealResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/agent-deal",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createAgentDeal(
    data: CreateAgentDealData,
  ): CancelablePromise<CreateAgentDealResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/agent-deal",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agentDealUuid
   * @param data.endDate
   * @returns Response OK
   * @throws ApiError
   */
  public static endAgentDeal(
    data: EndAgentDealData,
  ): CancelablePromise<EndAgentDealResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/agent-deal/{agentDealUuid}/end",
      path: {
        agentDealUuid: data.agentDealUuid,
      },
      query: {
        endDate: data.endDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agentFirmUuid
   * @param data.effectiveDate
   * @param data.cancelEndDeal
   * @param data.agentDealUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static endAllDealsByAgentFirm(
    data: EndAllDealsByAgentFirmData,
  ): CancelablePromise<EndAllDealsByAgentFirmResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/agent-deal/end-all/agent-firm/{agentFirmUuid}",
      path: {
        agentFirmUuid: data.agentFirmUuid,
      },
      query: {
        effectiveDate: data.effectiveDate,
        cancelEndDeal: data.cancelEndDeal,
        agentDealUuids: data.agentDealUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agentDealUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAgentDealByUuid(
    data: GetAgentDealByUuidData,
  ): CancelablePromise<GetAgentDealByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/agent-deal/{agentDealUuid}",
      path: {
        agentDealUuid: data.agentDealUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agentDealUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAgentDealByUuid(
    data: DeleteAgentDealByUuidData,
  ): CancelablePromise<DeleteAgentDealByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/agent-deal/{agentDealUuid}",
      path: {
        agentDealUuid: data.agentDealUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.brokerUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.employerStatus
   * @param data.commissionStatus
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployersUnderBroker(
    data: GetEmployersUnderBrokerData,
  ): CancelablePromise<GetEmployersUnderBrokerResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/agent-deal/by-broker/{brokerUuid}",
      path: {
        brokerUuid: data.brokerUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        employerStatus: data.employerStatus,
        commissionStatus: data.commissionStatus,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agentFirmUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.deals
   * @returns Response OK
   * @throws ApiError
   */
  public static getAgentDealsByAgentFirmUuid(
    data: GetAgentDealsByAgentFirmUuidData,
  ): CancelablePromise<GetAgentDealsByAgentFirmUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/agent-deal/by-agent-firm/{agentFirmUuid}",
      path: {
        agentFirmUuid: data.agentFirmUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        deals: data.deals,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.employerUuid
   * @param data.deals
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAgentDeals(
    data: GetAllAgentDealsData = {},
  ): CancelablePromise<GetAllAgentDealsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/agent-deal/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        employerUuid: data.employerUuid,
        deals: data.deals,
      },
    });
  }
}

export class AffiliateGroupControllerService {
  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAffiliateGropByUuid(
    data: GetAffiliateGropByUuidData,
  ): CancelablePromise<GetAffiliateGropByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/affiliate-group/{affiliateGroupUuid}",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAffiliate(
    data: UpdateAffiliateData,
  ): CancelablePromise<UpdateAffiliateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/affiliate-group/{affiliateGroupUuid}",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAffiliate(
    data: DeleteAffiliateData,
  ): CancelablePromise<DeleteAffiliateResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/affiliate-group/{affiliateGroupUuid}",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @param data.userUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAffiliateUser(
    data: UpdateAffiliateUserData,
  ): CancelablePromise<UpdateAffiliateUserResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/affiliate-group/{affiliateGroupUuid}/user/{userUuid}",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
        userUuid: data.userUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @param data.userUuid
   * @param data.primary
   * @returns Response OK
   * @throws ApiError
   */
  public static markAffiliateUserAsPrimary(
    data: MarkAffiliateUserAsPrimaryData,
  ): CancelablePromise<MarkAffiliateUserAsPrimaryResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/affiliate-group/{affiliateGroupUuid}/user/{userUuid}/primary",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
        userUuid: data.userUuid,
      },
      query: {
        primary: data.primary,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addAffiliate(
    data: AddAffiliateData,
  ): CancelablePromise<AddAffiliateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/affiliate-group",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAffiliateUsersByAffiliateGroupUuid(
    data: GetAffiliateUsersByAffiliateGroupUuidData,
  ): CancelablePromise<GetAffiliateUsersByAffiliateGroupUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/affiliate-group/{affiliateGroupUuid}/user",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addAffiliateUser(
    data: AddAffiliateUserData,
  ): CancelablePromise<AddAffiliateUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/affiliate-group/{affiliateGroupUuid}/user",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static downloadAffiliateDataExcel(
    data: DownloadAffiliateDataExcelData,
  ): CancelablePromise<DownloadAffiliateDataExcelResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/affiliate-group/{affiliateGroupUuid}/download-data",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAffiliateUserByUuid(
    data: GetAffiliateUserByUuidData,
  ): CancelablePromise<GetAffiliateUserByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/affiliate-group/user/{userUuid}",
      path: {
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.searchString
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportCsvForAffiliate(
    data: ExportCsvForAffiliateData = {},
  ): CancelablePromise<ExportCsvForAffiliateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/affiliate-group/export-csv",
      query: {
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAffiliates(
    data: GetAllAffiliatesData = {},
  ): CancelablePromise<GetAllAffiliatesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/affiliate-group/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class AdminUserControllerService {
  /**
   * @param data The data for the request.
   * @param data.adminUserUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAdminUserByUuid(
    data: GetAdminUserByUuidData,
  ): CancelablePromise<GetAdminUserByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/admin_user/{adminUserUuid}",
      path: {
        adminUserUuid: data.adminUserUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.adminUserUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAdminUserByUuid(
    data: UpdateAdminUserByUuidData,
  ): CancelablePromise<UpdateAdminUserByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/admin_user/{adminUserUuid}",
      path: {
        adminUserUuid: data.adminUserUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.adminUserUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAdminUserByUuid(
    data: DeleteAdminUserByUuidData,
  ): CancelablePromise<DeleteAdminUserByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/admin_user/{adminUserUuid}",
      path: {
        adminUserUuid: data.adminUserUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.adminUserUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static activeAdminUserByUuid(
    data: ActiveAdminUserByUuidData,
  ): CancelablePromise<ActiveAdminUserByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/master/v1/admin_user/user_activate/{adminUserUuid}",
      path: {
        adminUserUuid: data.adminUserUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static resetUserMfa(
    data: ResetUserMfaData,
  ): CancelablePromise<ResetUserMfaResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/admin_user/users/{userUuid}/mfa/reset",
      path: {
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.dashBoardId
   * @returns Response OK
   * @throws ApiError
   */
  public static generateGuestToken(
    data: GenerateGuestTokenData,
  ): CancelablePromise<GenerateGuestTokenResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/admin_user/super-set/token",
      query: {
        dashBoardId: data.dashBoardId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.userTypes
   * @returns Response OK
   * @throws ApiError
   */
  public static resendLink(
    data: ResendLinkData,
  ): CancelablePromise<ResendLinkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/admin_user/resend_link/{userUuid}",
      path: {
        userUuid: data.userUuid,
      },
      query: {
        userTypes: data.userTypes,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveAdminUser(
    data: SaveAdminUserData,
  ): CancelablePromise<SaveAdminUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/admin_user/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.dashboardType
   * @returns Response OK
   * @throws ApiError
   */
  public static getSupersetDashBoardId(
    data: GetSupersetDashBoardIdData,
  ): CancelablePromise<GetSupersetDashBoardIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/admin_user/super-set/dashboard",
      query: {
        dashboardType: data.dashboardType,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getUserDetails(
    data: GetUserDetailsData,
  ): CancelablePromise<GetUserDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/admin_user/stats/{userUuid}",
      path: {
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getProfile2(): CancelablePromise<GetProfile2Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/admin_user/profile",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.roleName
   * @param data.notification
   * @param data.archive
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAdminUsers(
    data: GetAllAdminUsersData = {},
  ): CancelablePromise<GetAllAdminUsersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/admin_user/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        roleName: data.roleName,
        notification: data.notification,
        archive: data.archive,
      },
    });
  }
}

export class SupervisingProviderRequestControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendRequests(
    data: SendRequestsData,
  ): CancelablePromise<SendRequestsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/supervising-request/send",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestUuid
   * @param data.rejectionReason
   * @returns Response OK
   * @throws ApiError
   */
  public static deny(data: DenyData): CancelablePromise<DenyResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/supervising-request/{requestUuid}/deny",
      path: {
        requestUuid: data.requestUuid,
      },
      query: {
        rejectionReason: data.rejectionReason,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static approve(data: ApproveData): CancelablePromise<ApproveResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/supervising-request/{requestUuid}/approve",
      path: {
        requestUuid: data.requestUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.status
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getIncomingRequests(
    data: GetIncomingRequestsData = {},
  ): CancelablePromise<GetIncomingRequestsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/supervising-request",
      query: {
        status: data.status,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.nurseStaffProviderUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getApprovedProviders(
    data: GetApprovedProvidersData,
  ): CancelablePromise<GetApprovedProvidersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/supervising-request/approved/{nurseStaffProviderUuid}",
      path: {
        nurseStaffProviderUuid: data.nurseStaffProviderUuid,
      },
    });
  }
}

export class ShareCardControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static shareCard(
    data: ShareCardData,
  ): CancelablePromise<ShareCardResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/share_card/share_with_users",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.userTypes
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getSharedCardsByUser(
    data: GetSharedCardsByUserData,
  ): CancelablePromise<GetSharedCardsByUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/share_card/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        userTypes: data.userTypes,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.savedCardUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getSharedCardCustomers(
    data: GetSharedCardCustomersData,
  ): CancelablePromise<GetSharedCardCustomersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/share_card/customers/{savedCardUuid}",
      path: {
        savedCardUuid: data.savedCardUuid,
      },
      query: {
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.sharedCardUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteShareCard(
    data: DeleteShareCardData,
  ): CancelablePromise<DeleteShareCardResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/share_card/{sharedCardUuid}",
      path: {
        sharedCardUuid: data.sharedCardUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static shareCard1(
    data: ShareCard1Data,
  ): CancelablePromise<ShareCard1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/share_card/share_with_users",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static addMetadata(
    data: AddMetadataData,
  ): CancelablePromise<AddMetadataResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/share_card/add_metadata",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response1 OK
   * @throws ApiError
   */
  public static getSharedCardsByUser1(
    data: GetSharedCardsByUser1Data,
  ): CancelablePromise<GetSharedCardsByUser1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/billing/v1/share_card/{userUuid}",
      path: {
        userUuid: data.userUuid,
      },
      query: {
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class ShareBankControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static shareBank(
    data: ShareBankData,
  ): CancelablePromise<ShareBankResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/share_bank/share_with_users",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.userTypes
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getSharedBanksByUser(
    data: GetSharedBanksByUserData,
  ): CancelablePromise<GetSharedBanksByUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/share_bank/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        userTypes: data.userTypes,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.savedBankAccountUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getSharedBankCustomers(
    data: GetSharedBankCustomersData,
  ): CancelablePromise<GetSharedBankCustomersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/share_bank/customers/{savedBankAccountUuid}",
      path: {
        savedBankAccountUuid: data.savedBankAccountUuid,
      },
      query: {
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.sharedBankAccountUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteSharedBankAccount(
    data: DeleteSharedBankAccountData,
  ): CancelablePromise<DeleteSharedBankAccountResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/share_bank/{sharedBankAccountUuid}",
      path: {
        sharedBankAccountUuid: data.sharedBankAccountUuid,
      },
    });
  }
}

export class ProviderCoverageControllerService {
  /**
   * @param data The data for the request.
   * @param data.direction
   * @param data.status
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getCoverages(
    data: GetCoveragesData = {},
  ): CancelablePromise<GetCoveragesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider_coverage",
      query: {
        direction: data.direction,
        status: data.status,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createRequest(
    data: CreateRequestData,
  ): CancelablePromise<CreateRequestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/provider_coverage",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coverageUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static resyncScriptSure(
    data: ResyncScriptSureData,
  ): CancelablePromise<ResyncScriptSureResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/provider_coverage/{coverageUuid}/script-sure-sync",
      path: {
        coverageUuid: data.coverageUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coverageUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static revoke(data: RevokeData): CancelablePromise<RevokeResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/provider_coverage/{coverageUuid}/revoke",
      path: {
        coverageUuid: data.coverageUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coverageUuid
   * @param data.denialReasonCode
   * @param data.denialReasonNote
   * @returns Response OK
   * @throws ApiError
   */
  public static deny1(data: Deny1Data): CancelablePromise<Deny1Response> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/provider_coverage/{coverageUuid}/deny",
      path: {
        coverageUuid: data.coverageUuid,
      },
      query: {
        denialReasonCode: data.denialReasonCode,
        denialReasonNote: data.denialReasonNote,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coverageUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static approve1(
    data: Approve1Data,
  ): CancelablePromise<Approve1Response> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/provider_coverage/{coverageUuid}/approve",
      path: {
        coverageUuid: data.coverageUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getUrgentMessageAlert(): CancelablePromise<GetUrgentMessageAlertResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider_coverage/urgent-alert",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateUrgentMessageAlert(
    data: UpdateUrgentMessageAlertData,
  ): CancelablePromise<UpdateUrgentMessageAlertResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/provider_coverage/urgent-alert",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static expireEndedCoverages(): CancelablePromise<ExpireEndedCoveragesResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/provider_coverage/expire_ended",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.coverageUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getCoverageByUuid(
    data: GetCoverageByUuidData,
  ): CancelablePromise<GetCoverageByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider_coverage/{coverageUuid}",
      path: {
        coverageUuid: data.coverageUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getActiveCoverage(): CancelablePromise<GetActiveCoverageResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/provider_coverage/active",
    });
  }
}

export class PdfControllerService {
  /**
   * @param data The data for the request.
   * @param data.soapNoteUuid
   * @param data.localDateTime
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadSoapNotePdf(
    data: UploadSoapNotePdfData,
  ): CancelablePromise<UploadSoapNotePdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/upload-soap-note/{soapNoteUuid}",
      path: {
        soapNoteUuid: data.soapNoteUuid,
      },
      query: {
        localDateTime: data.localDateTime,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadSingleLabOrderPdf(
    data: UploadSingleLabOrderPdfData,
  ): CancelablePromise<UploadSingleLabOrderPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/upload-single-lab-order",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.pocUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadPocPdf(
    data: UploadPocPdfData,
  ): CancelablePromise<UploadPocPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/upload-poc-pdf/{pocUuid}",
      path: {
        pocUuid: data.pocUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientInformationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadPatientInformationPdf(
    data: UploadPatientInformationPdfData,
  ): CancelablePromise<UploadPatientInformationPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/upload-patient-information/{patientInformationUuid}",
      path: {
        patientInformationUuid: data.patientInformationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labResultUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadLabResultPdf(
    data: UploadLabResultPdfData,
  ): CancelablePromise<UploadLabResultPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/upload-lab-result/{labResultUuid}",
      path: {
        labResultUuid: data.labResultUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.imagingResultUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadImagingResultPdf(
    data: UploadImagingResultPdfData,
  ): CancelablePromise<UploadImagingResultPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/upload-imaging-result/{imagingResultUuid}",
      path: {
        imagingResultUuid: data.imagingResultUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.handpNoteUuid
   * @param data.localDateTime
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadHandpNotePdf(
    data: UploadHandpNotePdfData,
  ): CancelablePromise<UploadHandpNotePdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/upload-handp-note/{handpNoteUuid}",
      path: {
        handpNoteUuid: data.handpNoteUuid,
      },
      query: {
        localDateTime: data.localDateTime,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.signatureImage
   * @param data.x
   * @param data.y
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static signExistingPdf(
    data: SignExistingPdfData,
  ): CancelablePromise<SignExistingPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/sign-existing",
      query: {
        signatureImage: data.signatureImage,
        x: data.x,
        y: data.y,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.reportName
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static generatePdf(
    data: GeneratePdfData,
  ): CancelablePromise<GeneratePdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate/{reportName}",
      path: {
        reportName: data.reportName,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.appointmentUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateWorkNotePdf(
    data: GenerateWorkNotePdfData,
  ): CancelablePromise<GenerateWorkNotePdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-workNote/{appointmentUuid}",
      path: {
        appointmentUuid: data.appointmentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.userTypes
   * @param data.startDate
   * @param data.endDate
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateExportStatementPdf(
    data: GenerateExportStatementPdfData,
  ): CancelablePromise<GenerateExportStatementPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-statement/{userUuid}/and/{userTypes}",
      path: {
        userUuid: data.userUuid,
        userTypes: data.userTypes,
      },
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static generateSpecimenLabel(
    data: GenerateSpecimenLabelData,
  ): CancelablePromise<GenerateSpecimenLabelResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-specimen-label",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.soapNoteUuid
   * @param data.localDateTime
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateSoapNotePdf(
    data: GenerateSoapNotePdfData,
  ): CancelablePromise<GenerateSoapNotePdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-soap-note/{soapNoteUuid}",
      path: {
        soapNoteUuid: data.soapNoteUuid,
      },
      query: {
        localDateTime: data.localDateTime,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateSingleLabOrderPdf(
    data: GenerateSingleLabOrderPdfData,
  ): CancelablePromise<GenerateSingleLabOrderPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-single-lab-order",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workNoteUuid
   * @returns string OK
   * @throws ApiError
   */
  public static generateReturnLetterPdf(
    data: GenerateReturnLetterPdfData,
  ): CancelablePromise<GenerateReturnLetterPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-return-letter/{workNoteUuid}",
      path: {
        workNoteUuid: data.workNoteUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.referralUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateReferralPdf(
    data: GenerateReferralPdfData,
  ): CancelablePromise<GenerateReferralPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-referral/{referralUuid}",
      path: {
        referralUuid: data.referralUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerUuid
   * @param data.startDate
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateProviderAppointmentsPdf(
    data: GenerateProviderAppointmentsPdfData,
  ): CancelablePromise<GenerateProviderAppointmentsPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-provider-appointments/{providerUuid}",
      path: {
        providerUuid: data.providerUuid,
      },
      query: {
        startDate: data.startDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.pocUuid
   * @returns string OK
   * @throws ApiError
   */
  public static generatePocPdf(
    data: GeneratePocPdfData,
  ): CancelablePromise<GeneratePocPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-poc-pdf/{pocUuid}",
      path: {
        pocUuid: data.pocUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientInformationUuid
   * @returns string OK
   * @throws ApiError
   */
  public static generatePatientInformationPdf(
    data: GeneratePatientInformationPdfData,
  ): CancelablePromise<GeneratePatientInformationPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-patient-information/{patientInformationUuid}",
      path: {
        patientInformationUuid: data.patientInformationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.medicationUuids
   * @param data.status
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static generateMedicationsPdf(
    data: GenerateMedicationsPdfData,
  ): CancelablePromise<GenerateMedicationsPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-medications/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        medicationUuids: data.medicationUuids,
        status: data.status,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateLabResultPdf(
    data: GenerateLabResultPdfData,
  ): CancelablePromise<GenerateLabResultPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-lab-result",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labResultUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateLabResultPdfByUuid(
    data: GenerateLabResultPdfByUuidData,
  ): CancelablePromise<GenerateLabResultPdfByUuidResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-lab-result-by-uuid/{labResultUuid}",
      path: {
        labResultUuid: data.labResultUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateLabOrdersPdf(
    data: GenerateLabOrdersPdfData,
  ): CancelablePromise<GenerateLabOrdersPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-lab-orders/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.inventoryOrderUuid
   * @returns string OK
   * @throws ApiError
   */
  public static generateInventoryOrderPdf(
    data: GenerateInventoryOrderPdfData,
  ): CancelablePromise<GenerateInventoryOrderPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-inventory-order/{inventoryOrderUuid}",
      path: {
        inventoryOrderUuid: data.inventoryOrderUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationInventoryUuid
   * @returns string OK
   * @throws ApiError
   */
  public static generateInventoryDetailPdf(
    data: GenerateInventoryDetailPdfData,
  ): CancelablePromise<GenerateInventoryDetailPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-inventory-detail/{locationInventoryUuid}",
      path: {
        locationInventoryUuid: data.locationInventoryUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateImmunizationsPdf(
    data: GenerateImmunizationsPdfData,
  ): CancelablePromise<GenerateImmunizationsPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-immunizations/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.imagingResultUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateImagingResultPdf(
    data: GenerateImagingResultPdfData,
  ): CancelablePromise<GenerateImagingResultPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-imaging-result/{imagingResultUuid}",
      path: {
        imagingResultUuid: data.imagingResultUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.handpNoteUuid
   * @param data.localDateTime
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateHandpNotePdf(
    data: GenerateHandpNotePdfData,
  ): CancelablePromise<GenerateHandpNotePdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-handp-note/{handpNoteUuid}",
      path: {
        handpNoteUuid: data.handpNoteUuid,
      },
      query: {
        localDateTime: data.localDateTime,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateFacesheetPdf(
    data: GenerateFacesheetPdfData,
  ): CancelablePromise<GenerateFacesheetPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-facesheet/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.status
   * @returns unknown OK
   * @throws ApiError
   */
  public static generateDiagnosisPdf(
    data: GenerateDiagnosisPdfData,
  ): CancelablePromise<GenerateDiagnosisPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-diagnosis/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static generateAuditLogPdf(
    data: GenerateAuditLogPdfData,
  ): CancelablePromise<GenerateAuditLogPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/pdf/generate-audit-log-pdf",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns string OK
   * @throws ApiError
   */
  public static getLabPdfByPatient(
    data: GetLabPdfByPatientData,
  ): CancelablePromise<GetLabPdfByPatientResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/pdf/generate-lab-result-notification/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class AgentPayoutService {
  /**
   * Make payout to agent/broker
   * Creates an ACH payout to the specified bank account for agent commission payments
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static makePayout(
    data: MakePayoutData,
  ): CancelablePromise<MakePayoutResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/payout/make_payout",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Add bank account for agent payouts
   * Creates a Stripe bank account token for agent commission payouts
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addPayoutBankAccount(
    data: AddPayoutBankAccountData,
  ): CancelablePromise<AddPayoutBankAccountResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/payout/bank_account",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Verify agent bank account
   * Verifies bank account ownership using micro-deposit amounts
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static verifyPayoutBankAccount(
    data: VerifyPayoutBankAccountData,
  ): CancelablePromise<VerifyPayoutBankAccountResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/payout/bank_account/verify",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get user payout bank accounts
   * Retrieves all bank accounts configured for user payouts based on user type
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.userTypes
   * @returns Response OK
   * @throws ApiError
   */
  public static getPayoutBankAccounts(
    data: GetPayoutBankAccountsData,
  ): CancelablePromise<GetPayoutBankAccountsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/payout/users/{userUuid}/type/{userTypes}/bank_accounts",
      path: {
        userUuid: data.userUuid,
        userTypes: data.userTypes,
      },
    });
  }
}

export class InventoryOrderControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addToInventory(
    data: AddToInventoryData,
  ): CancelablePromise<AddToInventoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/inventory_order",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static pollShipments(): CancelablePromise<PollShipmentsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/inventory_order/poll_shipments",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static placeOrderOnNorthWind(
    data: PlaceOrderOnNorthWindData = {},
  ): CancelablePromise<PlaceOrderOnNorthWindResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/inventory_order/place_order_northwind",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static transferInventory(
    data: TransferInventoryData,
  ): CancelablePromise<TransferInventoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/inventory_order/location_based_transfer_inventory",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addInventoryQuantity(
    data: AddInventoryQuantityData,
  ): CancelablePromise<AddInventoryQuantityResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/inventory_order/add_inventory_quantity",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateInventory(
    data: UpdateInventoryData,
  ): CancelablePromise<UpdateInventoryResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/inventory_order/update",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.inventoryDetailUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static updateFormulary(
    data: UpdateFormularyData,
  ): CancelablePromise<UpdateFormularyResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/inventory_order/formulary",
      query: {
        inventoryDetailUuids: data.inventoryDetailUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationInventoryUuid
   * @param data.autoShip
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAutoShip(
    data: UpdateAutoShipData,
  ): CancelablePromise<UpdateAutoShipResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/inventory_order/auto_ship",
      query: {
        locationInventoryUuid: data.locationInventoryUuid,
        autoShip: data.autoShip,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllInventory(
    data: GetAllInventoryData = {},
  ): CancelablePromise<GetAllInventoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/inventory_order/location_based_medication",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static locationBasedFormulary(
    data: LocationBasedFormularyData = {},
  ): CancelablePromise<LocationBasedFormularyResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/inventory_order/location_based_formulary",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @returns string OK
   * @throws ApiError
   */
  public static exportLocationBasedInventoryCsv(): CancelablePromise<ExportLocationBasedInventoryCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/inventory_order/export_location_based_inventory_csv",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formulary
   * @returns string OK
   * @throws ApiError
   */
  public static exportInventoryCsv(
    data: ExportInventoryCsvData = {},
  ): CancelablePromise<ExportInventoryCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/inventory_order/export_inventory_csv",
      query: {
        formulary: data.formulary,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.invoiceId
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllShipmentMedicationByInvoiceNumber(
    data: GetAllShipmentMedicationByInvoiceNumberData = {},
  ): CancelablePromise<GetAllShipmentMedicationByInvoiceNumberResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/inventory_order/all_shipment_medication_by_invoice_number",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        invoiceId: data.invoiceId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllShipment(
    data: GetAllShipmentData = {},
  ): CancelablePromise<GetAllShipmentResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/inventory_order/all_shipment",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllOrder(
    data: GetAllOrderData = {},
  ): CancelablePromise<GetAllOrderResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/inventory_order/all_orders",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class GoogleMapsControllerService {
  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadPatientAddressesCsv(
    data: UploadPatientAddressesCsvData,
  ): CancelablePromise<UploadPatientAddressesCsvResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/google_maps/upload_patient_addresses",
      query: {
        employerUuid: data.employerUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.onlyPhp
   * @param data.name
   * @param data.uploadBatchUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static generateShareLink(
    data: GenerateShareLinkData = {},
  ): CancelablePromise<GenerateShareLinkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/google_maps/generate_share_link",
      query: {
        employerUuid: data.employerUuid,
        onlyPhp: data.onlyPhp,
        name: data.name,
        uploadBatchUuid: data.uploadBatchUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteShareLink(
    data: DeleteShareLinkData,
  ): CancelablePromise<DeleteShareLinkResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/google_maps/share_links/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateShareLink(
    data: UpdateShareLinkData,
  ): CancelablePromise<UpdateShareLinkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/google_maps/share_links/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.active
   * @param data.search
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllShareLinks(
    data: GetAllShareLinksData = {},
  ): CancelablePromise<GetAllShareLinksResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/google_maps/share_links",
      query: {
        active: data.active,
        search: data.search,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @returns binary OK
   * @throws ApiError
   */
  public static downloadPatientZipcodeCsvTemplate(): CancelablePromise<DownloadPatientZipcodeCsvTemplateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/google_maps/patient_addresses_csv_template",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.onlyPhp
   * @param data.uploadBatchUuid
   * @param data.shareToken
   * @returns Response OK
   * @throws ApiError
   */
  public static getMapData(
    data: GetMapDataData = {},
  ): CancelablePromise<GetMapDataResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/google_maps/map_data",
      query: {
        employerUuid: data.employerUuid,
        onlyPhp: data.onlyPhp,
        uploadBatchUuid: data.uploadBatchUuid,
        shareToken: data.shareToken,
      },
    });
  }
}

export class FutureBillingControllerService {
  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static regenerateInvoiceWithCurrentRenewalDate(
    data: RegenerateInvoiceWithCurrentRenewalDateData,
  ): CancelablePromise<RegenerateInvoiceWithCurrentRenewalDateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/future_billing/regenerate_invoice/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static regenerateEmployerMembershipInvoice(
    data: RegenerateEmployerMembershipInvoiceData,
  ): CancelablePromise<RegenerateEmployerMembershipInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/future_billing/regenerate_employer_invoice/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
    });
  }
}

export class CsvControllerService {
  /**
   * @param data The data for the request.
   * @param data.force
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadEmployeeUploadTemplate(
    data: UploadEmployeeUploadTemplateData = {},
  ): CancelablePromise<UploadEmployeeUploadTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/csv/upload_template",
      query: {
        force: data.force,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployeeUploadTemplate(): CancelablePromise<GetEmployeeUploadTemplateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/csv/get-template",
    });
  }

  /**
   * @returns binary OK
   * @throws ApiError
   */
  public static downloadExcelTemplate(): CancelablePromise<DownloadExcelTemplateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/csv/excel-template",
    });
  }

  /**
   * @returns binary OK
   * @throws ApiError
   */
  public static downloadCsvTemplate(): CancelablePromise<DownloadCsvTemplateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/csv/download-template",
    });
  }

  /**
   * @returns binary OK
   * @throws ApiError
   */
  public static getCsvTemplateAsFile(): CancelablePromise<GetCsvTemplateAsFileResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/csv/csv-template",
    });
  }
}

export class CartControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static placeOrder(
    data: PlaceOrderData,
  ): CancelablePromise<PlaceOrderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/cart/place_order",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationInventoryUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static addToCart(
    data: AddToCartData,
  ): CancelablePromise<AddToCartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/v1/cart/add_to_cart",
      query: {
        locationInventoryUuid: data.locationInventoryUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cartUuid
   * @param data.quantity
   * @returns Response OK
   * @throws ApiError
   */
  public static updateQuantity(
    data: UpdateQuantityData,
  ): CancelablePromise<UpdateQuantityResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/master/v1/cart/quantity",
      query: {
        cartUuid: data.cartUuid,
        quantity: data.quantity,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllCarts(
    data: GetAllCartsData = {},
  ): CancelablePromise<GetAllCartsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/cart/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteCartByUuid(
    data: DeleteCartByUuidData,
  ): CancelablePromise<DeleteCartByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/master/v1/cart/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }
}

export class MobileAuthControllerService {
  /**
   * Refresh Token
   * Get a new access token using a valid refresh token
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static refresh(data: RefreshData): CancelablePromise<RefreshResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/mobile/auth/refresh",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Confirm MFA Enrollment
   * Confirm the initial TOTP code after scanning the QR, persists the OTP credential in Keycloak, and returns tokens.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static confirmEnrollment(
    data: ConfirmEnrollmentData,
  ): CancelablePromise<ConfirmEnrollmentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/mobile/auth/mfa/enroll/confirm",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Mobile Logout
   * Invalidate the user's refresh token in Keycloak
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static logout(data: LogoutData): CancelablePromise<LogoutResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/mobile/auth/logout",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Mobile Login
   * Authenticate mobile user with username/email and password. Returns tokens, or an MFA challenge, or an enrollment challenge depending on the user's MFA state and enforcement policy.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static login(data: LoginData): CancelablePromise<LoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/mobile/auth/login",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Verify MFA OTP
   * Exchange a valid mfaToken and TOTP code for access & refresh tokens
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static verifyOtp(
    data: VerifyOtpData,
  ): CancelablePromise<VerifyOtpResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/mobile/auth/login/verify-otp",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Forgot Password
   * Emails the user a one-time link to set a new password — the same Keycloak UPDATE_PASSWORD action email the web forgot-password flow sends. Accepts a username or an email address. The response is identical whether or not the account exists, so it cannot be used to enumerate accounts.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static forgotPassword(
    data: ForgotPasswordData,
  ): CancelablePromise<ForgotPasswordResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/master/mobile/auth/forgot-password",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class VideoControllerService {
  /**
   * @param data The data for the request.
   * @param data.room
   * @returns Response OK
   * @throws ApiError
   */
  public static jitsiToken(
    data: JitsiTokenData = {},
  ): CancelablePromise<JitsiTokenResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/video/jitsi-token",
      query: {
        room: data.room,
      },
    });
  }
}

export class SpecialityControllerService {
  /**
   * @param data The data for the request.
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllSpecialities(
    data: GetAllSpecialitiesData = {},
  ): CancelablePromise<GetAllSpecialitiesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/speciality/all",
      query: {
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class PhysicianAccountTypeControllerService {
  /**
   * @param data The data for the request.
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPhysicianAccountTypes(
    data: GetAllPhysicianAccountTypesData = {},
  ): CancelablePromise<GetAllPhysicianAccountTypesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/physician_account_type/all",
      query: {
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class EmailHistoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.page
   * @param data.pageSize
   * @param data.read
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmailHistoryByUser(
    data: GetEmailHistoryByUserData,
  ): CancelablePromise<GetEmailHistoryByUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/email-history/{userId}",
      path: {
        userId: data.userId,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        read: data.read,
      },
    });
  }
}

export class DashboardControllerService {
  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerManagementStats(
    data: GetEmployerManagementStatsData,
  ): CancelablePromise<GetEmployerManagementStatsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/dashboard/employer/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getAffiliateStats(): CancelablePromise<GetAffiliateStatsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/dashboard/affliate",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affliateUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAffiliatePortalStats(
    data: GetAffiliatePortalStatsData,
  ): CancelablePromise<GetAffiliatePortalStatsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/master/v1/dashboard/affliate-portal/{affliateUuid}",
      path: {
        affliateUuid: data.affliateUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.resultUuid
   * @param data.resultType
   * @param data.reviewComment
   * @returns Response OK
   * @throws ApiError
   */
  public static markReviewResult(
    data: MarkReviewResultData,
  ): CancelablePromise<MarkReviewResultResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/dashboard/{resultUuid}/mark-review",
      path: {
        resultUuid: data.resultUuid,
      },
      query: {
        resultType: data.resultType,
        reviewComment: data.reviewComment,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.resolved
   * @param data.categoryUuids
   * @param data.assignedToUuids
   * @param data.assignedByUuids
   * @param data.userUuid
   * @param data.providerUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static getPendingItems(
    data: GetPendingItemsData = {},
  ): CancelablePromise<GetPendingItemsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/dashboard/pending-items",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        resolved: data.resolved,
        categoryUuids: data.categoryUuids,
        assignedToUuids: data.assignedToUuids,
        assignedByUuids: data.assignedByUuids,
        userUuid: data.userUuid,
        providerUuids: data.providerUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPendingFormsCount(
    data: GetPendingFormsCountData,
  ): CancelablePromise<GetPendingFormsCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/dashboard/pending-forms-count",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.patientUuid
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientReports(
    data: GetPatientReportsData = {},
  ): CancelablePromise<GetPatientReportsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/dashboard/patient-reports",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        patientUuid: data.patientUuid,
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientPortalCounts(
    data: GetPatientPortalCountsData,
  ): CancelablePromise<GetPatientPortalCountsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/dashboard/patient-portal-counts",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerUuids
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getMessegeInfo(
    data: GetMessegeInfoData = {},
  ): CancelablePromise<GetMessegeInfoResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/dashboard/message-info",
      query: {
        providerUuids: data.providerUuids,
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.patientUuid
   * @param data.status
   * @param data.locationUuids
   * @param data.providerUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static getLabAndImagingResults(
    data: GetLabAndImagingResultsData = {},
  ): CancelablePromise<GetLabAndImagingResultsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/dashboard/lab-imaging-results",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        patientUuid: data.patientUuid,
        status: data.status,
        locationUuids: data.locationUuids,
        providerUuids: data.providerUuids,
      },
    });
  }
}

export class WorkNoteControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getWorkNoteByUuid(
    data: GetWorkNoteByUuidData,
  ): CancelablePromise<GetWorkNoteByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/work-note/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateWorkNote(
    data: UpdateWorkNoteData,
  ): CancelablePromise<UpdateWorkNoteResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/work-note/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteWorkNoteByUuid(
    data: DeleteWorkNoteByUuidData,
  ): CancelablePromise<DeleteWorkNoteByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/work-note/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addWorkNote(
    data: AddWorkNoteData,
  ): CancelablePromise<AddWorkNoteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/work-note",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllWorkNotes(
    data: GetAllWorkNotesData,
  ): CancelablePromise<GetAllWorkNotesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/work-note/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class VitalControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getVitalByUuid(
    data: GetVitalByUuidData,
  ): CancelablePromise<GetVitalByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/vital/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateVital(
    data: UpdateVitalData,
  ): CancelablePromise<UpdateVitalResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/vital/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteVital(
    data: DeleteVitalData,
  ): CancelablePromise<DeleteVitalResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/vital/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static addVital(
    data: AddVitalData,
  ): CancelablePromise<AddVitalResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/vital",
      query: {
        draft: data.draft,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static recalculateGrowthPercentiles(): CancelablePromise<RecalculateGrowthPercentilesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/vital/recalculate-percentiles",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.startDate
   * @param data.endDate
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllVitals(
    data: GetAllVitalsData,
  ): CancelablePromise<GetAllVitalsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/vital/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        startDate: data.startDate,
        endDate: data.endDate,
        draft: data.draft,
      },
    });
  }
}

export class VaccineControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getVaccineByUuid(
    data: GetVaccineByUuidData,
  ): CancelablePromise<GetVaccineByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/vaccine/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateVaccine(
    data: UpdateVaccineData,
  ): CancelablePromise<UpdateVaccineResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/vaccine/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteVaccineByUuid(
    data: DeleteVaccineByUuidData,
  ): CancelablePromise<DeleteVaccineByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/vaccine/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createVaccine(
    data: CreateVaccineData,
  ): CancelablePromise<CreateVaccineResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/vaccine",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.type
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllVaccines(
    data: GetAllVaccinesData = {},
  ): CancelablePromise<GetAllVaccinesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/vaccine/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        type: data.type,
      },
    });
  }
}

export class TaskControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getTaskByUuid(
    data: GetTaskByUuidData,
  ): CancelablePromise<GetTaskByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/task/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateTask(
    data: UpdateTaskData,
  ): CancelablePromise<UpdateTaskResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/task/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteTask(
    data: DeleteTaskData,
  ): CancelablePromise<DeleteTaskResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/task/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addTask(data: AddTaskData): CancelablePromise<AddTaskResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/task",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.threadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static resolveTasksForThread(
    data: ResolveTasksForThreadData,
  ): CancelablePromise<ResolveTasksForThreadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/task/thread/{threadUuid}/resolve",
      path: {
        threadUuid: data.threadUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static processTaskReminders(): CancelablePromise<ProcessTaskRemindersResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/task/process-reminders",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.threadUuid
   * @returns boolean OK
   * @throws ApiError
   */
  public static hasUnresolvedTaskForThread(
    data: HasUnresolvedTaskForThreadData,
  ): CancelablePromise<HasUnresolvedTaskForThreadResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/task/thread/{threadUuid}/has-unresolved-task",
      path: {
        threadUuid: data.threadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.patientUuids
   * @param data.assignedByUuids
   * @param data.assignedToUuids
   * @param data.categoryUuids
   * @param data.priorities
   * @param data.createdStartDate
   * @param data.createdEndDate
   * @param data.dueStartDate
   * @param data.dueEndDate
   * @param data.flag
   * @param data.resolved
   * @param data.locationUuid
   * @param data.matchAll
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllTasks(
    data: GetAllTasksData = {},
  ): CancelablePromise<GetAllTasksResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/task/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        patientUuids: data.patientUuids,
        assignedByUuids: data.assignedByUuids,
        assignedToUuids: data.assignedToUuids,
        categoryUuids: data.categoryUuids,
        priorities: data.priorities,
        createdStartDate: data.createdStartDate,
        createdEndDate: data.createdEndDate,
        dueStartDate: data.dueStartDate,
        dueEndDate: data.dueEndDate,
        flag: data.flag,
        resolved: data.resolved,
        locationUuid: data.locationUuid,
        matchAll: data.matchAll,
      },
    });
  }
}

export class StatusConfigurationControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateStatusConfiguration(
    data: UpdateStatusConfigurationData,
  ): CancelablePromise<UpdateStatusConfigurationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/status-configuration",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createStatusConfiguration(
    data: CreateStatusConfigurationData,
  ): CancelablePromise<CreateStatusConfigurationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/status-configuration",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.statusConfigurationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getStatusConfigurationByUuid(
    data: GetStatusConfigurationByUuidData,
  ): CancelablePromise<GetStatusConfigurationByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/status-configuration/{statusConfigurationUuid}",
      path: {
        statusConfigurationUuid: data.statusConfigurationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.statusConfigurationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteStatusConfigurationByUuid(
    data: DeleteStatusConfigurationByUuidData,
  ): CancelablePromise<DeleteStatusConfigurationByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/status-configuration/{statusConfigurationUuid}",
      path: {
        statusConfigurationUuid: data.statusConfigurationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllStatusConfigurations(
    data: GetAllStatusConfigurationsData = {},
  ): CancelablePromise<GetAllStatusConfigurationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/status-configuration/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class SocialHistoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getSocialHistoryByUuid(
    data: GetSocialHistoryByUuidData,
  ): CancelablePromise<GetSocialHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/social-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateSocialHistory(
    data: UpdateSocialHistoryData,
  ): CancelablePromise<UpdateSocialHistoryResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/social-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteSocialHistoryByUuid(
    data: DeleteSocialHistoryByUuidData,
  ): CancelablePromise<DeleteSocialHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/social-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static create1(data: Create1Data): CancelablePromise<Create1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/social-history",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllSocialHistory(
    data: GetAllSocialHistoryData,
  ): CancelablePromise<GetAllSocialHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/social-history/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class SoapNoteControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateSoapNote(
    data: UpdateSoapNoteData,
  ): CancelablePromise<UpdateSoapNoteResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/soap-note/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addSoapNote(
    data: AddSoapNoteData,
  ): CancelablePromise<AddSoapNoteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/soap-note",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePreEngagedStatus(
    data: UpdatePreEngagedStatusData,
  ): CancelablePromise<UpdatePreEngagedStatusResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/soap-note/pre-engage/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.soapNoteUuid
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getSoapNoteByUuid(
    data: GetSoapNoteByUuidData,
  ): CancelablePromise<GetSoapNoteByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note/{soapNoteUuid}",
      path: {
        soapNoteUuid: data.soapNoteUuid,
      },
      query: {
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.soapNoteUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteSoapNote(
    data: DeleteSoapNoteData,
  ): CancelablePromise<DeleteSoapNoteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/soap-note/{soapNoteUuid}",
      path: {
        soapNoteUuid: data.soapNoteUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllWorkNotes1(
    data: GetAllWorkNotes1Data,
  ): CancelablePromise<GetAllWorkNotes1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note/work-note",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.signed
   * @returns Response OK
   * @throws ApiError
   */
  public static getSoapNotesByPatientUuid(
    data: GetSoapNotesByPatientUuidData,
  ): CancelablePromise<GetSoapNotesByPatientUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note/patient/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        signed: data.signed,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllInstructions(
    data: GetAllInstructionsData,
  ): CancelablePromise<GetAllInstructionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note/instruction-note",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.appointmentUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getSoapNoteByAppointmentUuid(
    data: GetSoapNoteByAppointmentUuidData,
  ): CancelablePromise<GetSoapNoteByAppointmentUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note/get/{appointmentUuid}",
      path: {
        appointmentUuid: data.appointmentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.appointmentUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getSoapNoteAndHandPnoteByAppointmentUuid(
    data: GetSoapNoteAndHandPnoteByAppointmentUuidData,
  ): CancelablePromise<GetSoapNoteAndHandPnoteByAppointmentUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note/get-work-note/{appointmentUuid}",
      path: {
        appointmentUuid: data.appointmentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.isDraft
   * @param data.noteTypes
   * @returns Response OK
   * @throws ApiError
   */
  public static getVisitNotesByPatientUuid(
    data: GetVisitNotesByPatientUuidData,
  ): CancelablePromise<GetVisitNotesByPatientUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note/get-all-visit-notes",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        isDraft: data.isDraft,
        noteTypes: data.noteTypes,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.noteType
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEncounterDetails(
    data: GetAllEncounterDetailsData,
  ): CancelablePromise<GetAllEncounterDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note/encounter-details",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        noteType: data.noteType,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllCarePlanNotes(
    data: GetAllCarePlanNotesData,
  ): CancelablePromise<GetAllCarePlanNotesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note/care-plan",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.isDraft
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllSoapNotes(
    data: GetAllSoapNotesData,
  ): CancelablePromise<GetAllSoapNotesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        isDraft: data.isDraft,
      },
    });
  }
}

export class SoapNoteTemplateControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getSoapNoteTemplateByUuid(
    data: GetSoapNoteTemplateByUuidData,
  ): CancelablePromise<GetSoapNoteTemplateByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note-template/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @param data.isAdmin
   * @returns Response OK
   * @throws ApiError
   */
  public static updateSoapNoteTemplate(
    data: UpdateSoapNoteTemplateData,
  ): CancelablePromise<UpdateSoapNoteTemplateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/soap-note-template/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        isAdmin: data.isAdmin,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.isAdmin
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteSoapNoteTemplateByUuid(
    data: DeleteSoapNoteTemplateByUuidData,
  ): CancelablePromise<DeleteSoapNoteTemplateByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/soap-note-template/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        isAdmin: data.isAdmin,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addSoapNoteTemplate(
    data: AddSoapNoteTemplateData,
  ): CancelablePromise<AddSoapNoteTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/soap-note-template",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.bookMark
   * @returns Response OK
   * @throws ApiError
   */
  public static updateSoapNoteTemplateBookmark(
    data: UpdateSoapNoteTemplateBookmarkData,
  ): CancelablePromise<UpdateSoapNoteTemplateBookmarkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/soap-note-template/{uuid}/bookmark",
      path: {
        uuid: data.uuid,
      },
      query: {
        bookMark: data.bookMark,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.isPrivate
   * @param data.flag
   * @param data.noteType
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllSoapNoteTemplates(
    data: GetAllSoapNoteTemplatesData = {},
  ): CancelablePromise<GetAllSoapNoteTemplatesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/soap-note-template/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        isPrivate: data.isPrivate,
        flag: data.flag,
        noteType: data.noteType,
        searchString: data.searchString,
      },
    });
  }
}

export class ScreenHistoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getScreenHistoryByUuid(
    data: GetScreenHistoryByUuidData,
  ): CancelablePromise<GetScreenHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/screen/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateScreenHistory(
    data: UpdateScreenHistoryData,
  ): CancelablePromise<UpdateScreenHistoryResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/screen/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteScreenHistoryByUuid(
    data: DeleteScreenHistoryByUuidData,
  ): CancelablePromise<DeleteScreenHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/screen/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static create11(
    data: Create11Data,
  ): CancelablePromise<Create11Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/screen",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllScreenHistory(
    data: GetAllScreenHistoryData,
  ): CancelablePromise<GetAllScreenHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/screen/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class ReviewOfSystemTemplateControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getReviewOfSystemTemplateByUuid(
    data: GetReviewOfSystemTemplateByUuidData,
  ): CancelablePromise<GetReviewOfSystemTemplateByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/review-of-system_template/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @param data.isAdmin
   * @returns Response OK
   * @throws ApiError
   */
  public static updateReviewOfSystemTemplate(
    data: UpdateReviewOfSystemTemplateData,
  ): CancelablePromise<UpdateReviewOfSystemTemplateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/review-of-system_template/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        isAdmin: data.isAdmin,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.isAdmin
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteReviewOfSystemTemplate(
    data: DeleteReviewOfSystemTemplateData,
  ): CancelablePromise<DeleteReviewOfSystemTemplateResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/review-of-system_template/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        isAdmin: data.isAdmin,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addReviewOfSystemTemplate(
    data: AddReviewOfSystemTemplateData,
  ): CancelablePromise<AddReviewOfSystemTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/review-of-system_template",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.bookMark
   * @returns Response OK
   * @throws ApiError
   */
  public static updateRosBookmark(
    data: UpdateRosBookmarkData,
  ): CancelablePromise<UpdateRosBookmarkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/review-of-system_template/{uuid}/bookmark",
      path: {
        uuid: data.uuid,
      },
      query: {
        bookMark: data.bookMark,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.size
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.isPrivate
   * @param data.flag
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllReviewOfSystemTemplates(
    data: GetAllReviewOfSystemTemplatesData = {},
  ): CancelablePromise<GetAllReviewOfSystemTemplatesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/review-of-system_template/all",
      query: {
        page: data.page,
        size: data.size,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        isPrivate: data.isPrivate,
        flag: data.flag,
        searchString: data.searchString,
      },
    });
  }
}

export class ReviewOfSystemControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getReviewOfSystemByUuid(
    data: GetReviewOfSystemByUuidData,
  ): CancelablePromise<GetReviewOfSystemByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/review-of-system/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateReviewOfSystem(
    data: UpdateReviewOfSystemData,
  ): CancelablePromise<UpdateReviewOfSystemResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/review-of-system/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteReviewOfSystem(
    data: DeleteReviewOfSystemData,
  ): CancelablePromise<DeleteReviewOfSystemResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/review-of-system/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addReviewOfSystem(
    data: AddReviewOfSystemData,
  ): CancelablePromise<AddReviewOfSystemResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/review-of-system",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.size
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllReviewOfSystems(
    data: GetAllReviewOfSystemsData,
  ): CancelablePromise<GetAllReviewOfSystemsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/review-of-system/all",
      query: {
        page: data.page,
        size: data.size,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class ReferralControllerService {
  /**
   * @param data The data for the request.
   * @param data.referralByUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateReferralByUuid(
    data: UpdateReferralByUuidData,
  ): CancelablePromise<UpdateReferralByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/referral/update/{referralByUuid}",
      path: {
        referralByUuid: data.referralByUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static saveReferral(
    data: SaveReferralData,
  ): CancelablePromise<SaveReferralResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/referral/create",
      query: {
        draft: data.draft,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.referralByUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getReferralByUuid(
    data: GetReferralByUuidData,
  ): CancelablePromise<GetReferralByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/referral/{referralByUuid}",
      path: {
        referralByUuid: data.referralByUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.referralByUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteReferralByUuid(
    data: DeleteReferralByUuidData,
  ): CancelablePromise<DeleteReferralByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/referral/{referralByUuid}",
      path: {
        referralByUuid: data.referralByUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerUuids
   * @param data.locationUuids
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllReferralsByProviders(
    data: GetAllReferralsByProvidersData = {},
  ): CancelablePromise<GetAllReferralsByProvidersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/referral/get_referrals_by_providers",
      query: {
        providerUuids: data.providerUuids,
        locationUuids: data.locationUuids,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.searchString
   * @param data.fax
   * @param data.phone
   * @param data.email
   * @param data.stat
   * @param data.referralType
   * @param data.referredBy
   * @param data.referredTo
   * @param data.startDate
   * @param data.endDate
   * @param data.providerUuids
   * @param data.locationUuids
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllReferralsForGlobal(
    data: GetAllReferralsForGlobalData = {},
  ): CancelablePromise<GetAllReferralsForGlobalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/referral/get_all_referrals",
      query: {
        searchString: data.searchString,
        fax: data.fax,
        phone: data.phone,
        email: data.email,
        stat: data.stat,
        referralType: data.referralType,
        referredBy: data.referredBy,
        referredTo: data.referredTo,
        startDate: data.startDate,
        endDate: data.endDate,
        providerUuids: data.providerUuids,
        locationUuids: data.locationUuids,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllChartItem(): CancelablePromise<GetAllChartItemResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/referral/get-all-chart-item",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.searchString
   * @param data.fax
   * @param data.phone
   * @param data.email
   * @param data.stat
   * @param data.referralType
   * @param data.referredBy
   * @param data.referredTo
   * @param data.startDate
   * @param data.endDate
   * @param data.draft
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllReferrals(
    data: GetAllReferralsData,
  ): CancelablePromise<GetAllReferralsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/referral/all",
      query: {
        patientUuid: data.patientUuid,
        searchString: data.searchString,
        fax: data.fax,
        phone: data.phone,
        email: data.email,
        stat: data.stat,
        referralType: data.referralType,
        referredBy: data.referredBy,
        referredTo: data.referredTo,
        startDate: data.startDate,
        endDate: data.endDate,
        draft: data.draft,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class ProviderDirectoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.directoryUuid
   * @param data.source
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateProviderDirectory(
    data: UpdateProviderDirectoryData,
  ): CancelablePromise<UpdateProviderDirectoryResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/provider_directory/{directoryUuid}",
      path: {
        directoryUuid: data.directoryUuid,
      },
      query: {
        source: data.source,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadCsv1(
    data: UploadCsv1Data = {},
  ): CancelablePromise<UploadCsv1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/provider_directory/upload-csv",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @returns Response OK
   * @throws ApiError
   */
  public static getNppesImportHistory(
    data: GetNppesImportHistoryData = {},
  ): CancelablePromise<GetNppesImportHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/provider_directory/nppes/import",
      query: {
        limit: data.limit,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static triggerNppesImport(): CancelablePromise<TriggerNppesImportResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/provider_directory/nppes/import",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fileType
   * @param data.fileName
   * @returns Response OK
   * @throws ApiError
   */
  public static triggerNppesFileImport(
    data: TriggerNppesFileImportData,
  ): CancelablePromise<TriggerNppesFileImportResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/provider_directory/nppes/import/{fileType}",
      path: {
        fileType: data.fileType,
      },
      query: {
        fileName: data.fileName,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveProviderDirectory(
    data: SaveProviderDirectoryData,
  ): CancelablePromise<SaveProviderDirectoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/provider_directory/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerDirectoryUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getProviderDirectoryUuid(
    data: GetProviderDirectoryUuidData,
  ): CancelablePromise<GetProviderDirectoryUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/provider_directory/{providerDirectoryUuid}",
      path: {
        providerDirectoryUuid: data.providerDirectoryUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerDirectoryUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteProviderDirectoryByUuid(
    data: DeleteProviderDirectoryByUuidData,
  ): CancelablePromise<DeleteProviderDirectoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/provider_directory/{providerDirectoryUuid}",
      path: {
        providerDirectoryUuid: data.providerDirectoryUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.searchString
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllReferralTypes(
    data: GetAllReferralTypesData = {},
  ): CancelablePromise<GetAllReferralTypesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/provider_directory/referral-types",
      query: {
        searchString: data.searchString,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.referralType
   * @param data.searchString
   * @param data.city
   * @param data.state
   * @returns unknown OK
   * @throws ApiError
   */
  public static providerDirectoryExportCsv(
    data: ProviderDirectoryExportCsvData = {},
  ): CancelablePromise<ProviderDirectoryExportCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/provider_directory/export-csv",
      query: {
        referralType: data.referralType,
        searchString: data.searchString,
        city: data.city,
        state: data.state,
      },
    });
  }

  /**
   * @returns binary OK
   * @throws ApiError
   */
  public static downloadCsvTemplate1(): CancelablePromise<DownloadCsvTemplate1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/provider_directory/csv-template",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.referralType
   * @param data.searchString
   * @param data.city
   * @param data.state
   * @param data.excludeImaging
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllProviderDirectory(
    data: GetAllProviderDirectoryData = {},
  ): CancelablePromise<GetAllProviderDirectoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/provider_directory/all",
      query: {
        referralType: data.referralType,
        searchString: data.searchString,
        city: data.city,
        state: data.state,
        excludeImaging: data.excludeImaging,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class PointsOfCareLabControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePointOfCareLab(
    data: UpdatePointOfCareLabData,
  ): CancelablePromise<UpdatePointOfCareLabResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/point-of-care",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createPointOfCareLab(
    data: CreatePointOfCareLabData,
  ): CancelablePromise<CreatePointOfCareLabResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/point-of-care",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.pointOfCareUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPointOfCareLabByUuid(
    data: GetPointOfCareLabByUuidData,
  ): CancelablePromise<GetPointOfCareLabByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/point-of-care/{pointOfCareUuid}",
      path: {
        pointOfCareUuid: data.pointOfCareUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.pointOfCareUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePointOfCareLabByUuid(
    data: DeletePointOfCareLabByUuidData,
  ): CancelablePromise<DeletePointOfCareLabByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/point-of-care/{pointOfCareUuid}",
      path: {
        pointOfCareUuid: data.pointOfCareUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPointOfCareLab(
    data: GetAllPointOfCareLabData,
  ): CancelablePromise<GetAllPointOfCareLabResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/point-of-care/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class PocLabTestControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPocLabTestById(
    data: GetPocLabTestByIdData,
  ): CancelablePromise<GetPocLabTestByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/poc-lab-test/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePocLabTest(
    data: UpdatePocLabTestData,
  ): CancelablePromise<UpdatePocLabTestResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/poc-lab-test/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePocLabTest(
    data: DeletePocLabTestData,
  ): CancelablePromise<DeletePocLabTestResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/poc-lab-test/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addPocLabTest(
    data: AddPocLabTestData,
  ): CancelablePromise<AddPocLabTestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/poc-lab-test",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.active
   * @param data.createdBy
   * @param data.startDate
   * @param data.endDate
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPocLabTests(
    data: GetAllPocLabTestsData = {},
  ): CancelablePromise<GetAllPocLabTestsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/poc-lab-test/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        active: data.active,
        createdBy: data.createdBy,
        startDate: data.startDate,
        endDate: data.endDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePocTestFields(
    data: DeletePocTestFieldsData,
  ): CancelablePromise<DeletePocTestFieldsResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/poc-lab-test/poc-test-field/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }
}

export class PocLabResultControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPocLabResultById(
    data: GetPocLabResultByIdData,
  ): CancelablePromise<GetPocLabResultByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/poc-lab-result/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePocLabResult(
    data: UpdatePocLabResultData,
  ): CancelablePromise<UpdatePocLabResultResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/poc-lab-result/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePocLabResult(
    data: DeletePocLabResultData,
  ): CancelablePromise<DeletePocLabResultResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/poc-lab-result/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static addPocLabResult(
    data: AddPocLabResultData,
  ): CancelablePromise<AddPocLabResultResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/poc-lab-result",
      query: {
        draft: data.draft,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.patientUuid
   * @param data.draft
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPocLabResults(
    data: GetAllPocLabResultsData = {},
  ): CancelablePromise<GetAllPocLabResultsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/poc-lab-result/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        draft: data.draft,
        status: data.status,
      },
    });
  }
}

export class PhysicalExamTemplateControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPhysicalExamTemplateByUuid(
    data: GetPhysicalExamTemplateByUuidData,
  ): CancelablePromise<GetPhysicalExamTemplateByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/physical-exam_template/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @param data.isAdmin
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePhysicalExamTemplate(
    data: UpdatePhysicalExamTemplateData,
  ): CancelablePromise<UpdatePhysicalExamTemplateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/physical-exam_template/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        isAdmin: data.isAdmin,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.isAdmin
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePhysicalExamTemplateByUuid(
    data: DeletePhysicalExamTemplateByUuidData,
  ): CancelablePromise<DeletePhysicalExamTemplateByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/physical-exam_template/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        isAdmin: data.isAdmin,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addPhysicalExamTemplate(
    data: AddPhysicalExamTemplateData,
  ): CancelablePromise<AddPhysicalExamTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/physical-exam_template",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.bookMark
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePhysicalExamTemplateBookmark(
    data: UpdatePhysicalExamTemplateBookmarkData,
  ): CancelablePromise<UpdatePhysicalExamTemplateBookmarkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/physical-exam_template/{uuid}/bookmark",
      path: {
        uuid: data.uuid,
      },
      query: {
        bookMark: data.bookMark,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.isPrivate
   * @param data.flag
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPhysicalExamTemplates(
    data: GetAllPhysicalExamTemplatesData = {},
  ): CancelablePromise<GetAllPhysicalExamTemplatesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/physical-exam_template/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        isPrivate: data.isPrivate,
        flag: data.flag,
        searchString: data.searchString,
      },
    });
  }
}

export class PhysicalExamControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPhysicalExamByUuid(
    data: GetPhysicalExamByUuidData,
  ): CancelablePromise<GetPhysicalExamByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/physical-exam/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePhysicalExam(
    data: UpdatePhysicalExamData,
  ): CancelablePromise<UpdatePhysicalExamResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/physical-exam/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePhysicalExamByUuid(
    data: DeletePhysicalExamByUuidData,
  ): CancelablePromise<DeletePhysicalExamByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/physical-exam/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addPhysicalExam(
    data: AddPhysicalExamData,
  ): CancelablePromise<AddPhysicalExamResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/physical-exam",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPhysicalExams(
    data: GetAllPhysicalExamsData,
  ): CancelablePromise<GetAllPhysicalExamsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/physical-exam/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class PharmacyControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPharmacyByUuid(
    data: GetPharmacyByUuidData,
  ): CancelablePromise<GetPharmacyByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/pharmacy/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePharmacy(
    data: UpdatePharmacyData,
  ): CancelablePromise<UpdatePharmacyResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/pharmacy/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePharmacy(
    data: DeletePharmacyData,
  ): CancelablePromise<DeletePharmacyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/pharmacy/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addPharmacy(
    data: AddPharmacyData,
  ): CancelablePromise<AddPharmacyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/pharmacy",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPharmacies(
    data: GetAllPharmaciesData = {},
  ): CancelablePromise<GetAllPharmaciesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/pharmacy/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class PatientVaccinationControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientVaccinationByUuid(
    data: GetPatientVaccinationByUuidData,
  ): CancelablePromise<GetPatientVaccinationByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/patient-vaccination/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePatientVaccination(
    data: UpdatePatientVaccinationData,
  ): CancelablePromise<UpdatePatientVaccinationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/patient-vaccination/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePatientVaccination(
    data: DeletePatientVaccinationData,
  ): CancelablePromise<DeletePatientVaccinationResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/patient-vaccination/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static createPatientVaccination(
    data: CreatePatientVaccinationData,
  ): CancelablePromise<CreatePatientVaccinationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/patient-vaccination",
      query: {
        draft: data.draft,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllVaccinationsForPdf(
    data: GetAllVaccinationsForPdfData,
  ): CancelablePromise<GetAllVaccinationsForPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/patient-vaccination/list",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns string OK
   * @throws ApiError
   */
  public static exportPatientVaccinations(
    data: ExportPatientVaccinationsData,
  ): CancelablePromise<ExportPatientVaccinationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/patient-vaccination/export/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.isDraft
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPatientVaccination(
    data: GetAllPatientVaccinationData,
  ): CancelablePromise<GetAllPatientVaccinationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/patient-vaccination/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        isDraft: data.isDraft,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.type
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPatientVaccinationForVaccineTable(
    data: GetAllPatientVaccinationForVaccineTableData,
  ): CancelablePromise<GetAllPatientVaccinationForVaccineTableResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/patient-vaccination/all/vaccine-table",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        type: data.type,
      },
    });
  }
}

export class PatientFlagControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientFlagByUuid(
    data: GetPatientFlagByUuidData,
  ): CancelablePromise<GetPatientFlagByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/patient-flag/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePatientFlag(
    data: UpdatePatientFlagData,
  ): CancelablePromise<UpdatePatientFlagResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/patient-flag/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePatientFlag(
    data: DeletePatientFlagData,
  ): CancelablePromise<DeletePatientFlagResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/patient-flag/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addPatientFlag(
    data: AddPatientFlagData,
  ): CancelablePromise<AddPatientFlagResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/patient-flag",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPatientFlags(
    data: GetAllPatientFlagsData,
  ): CancelablePromise<GetAllPatientFlagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/patient-flag/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class PastSurgicalHistoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPastSurgicalHistoryByUuid(
    data: GetPastSurgicalHistoryByUuidData,
  ): CancelablePromise<GetPastSurgicalHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/past-surgical-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePastSurgicalHistory(
    data: UpdatePastSurgicalHistoryData,
  ): CancelablePromise<UpdatePastSurgicalHistoryResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/past-surgical-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePastSurgicalHistoryByUuid(
    data: DeletePastSurgicalHistoryByUuidData,
  ): CancelablePromise<DeletePastSurgicalHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/past-surgical-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addPastSurgicalHistory(
    data: AddPastSurgicalHistoryData,
  ): CancelablePromise<AddPastSurgicalHistoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/past-surgical-history",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPastSurgicalHistory(
    data: GetAllPastSurgicalHistoryData,
  ): CancelablePromise<GetAllPastSurgicalHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/past-surgical-history/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        draft: data.draft,
      },
    });
  }
}

export class PastMedicalHistoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPastMedicalHistoryByUuid(
    data: GetPastMedicalHistoryByUuidData,
  ): CancelablePromise<GetPastMedicalHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/past-medical-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePastMedicalHistory(
    data: UpdatePastMedicalHistoryData,
  ): CancelablePromise<UpdatePastMedicalHistoryResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/past-medical-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePastMedicalHistoryByUuid(
    data: DeletePastMedicalHistoryByUuidData,
  ): CancelablePromise<DeletePastMedicalHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/past-medical-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static addPastMedicalHistory(
    data: AddPastMedicalHistoryData,
  ): CancelablePromise<AddPastMedicalHistoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/past-medical-history",
      query: {
        draft: data.draft,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPastMedicalHistory(
    data: GetAllPastMedicalHistoryData,
  ): CancelablePromise<GetAllPastMedicalHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/past-medical-history/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        draft: data.draft,
      },
    });
  }
}

export class NoteControllerService {
  /**
   * @param data The data for the request.
   * @param data.noteByUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateNoteByUuid(
    data: UpdateNoteByUuidData,
  ): CancelablePromise<UpdateNoteByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/note/update/{noteByUuid}",
      path: {
        noteByUuid: data.noteByUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.threadUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveThreadToChart(
    data: SaveThreadToChartData,
  ): CancelablePromise<SaveThreadToChartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/note/thread/{threadUuid}/save-to-chart",
      path: {
        threadUuid: data.threadUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveNote(
    data: SaveNoteData,
  ): CancelablePromise<SaveNoteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/note/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.status
   * @param data.noteUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static updateNoteFlag(
    data: UpdateNoteFlagData,
  ): CancelablePromise<UpdateNoteFlagResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/note/status",
      query: {
        status: data.status,
        noteUuid: data.noteUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.noteByUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getNoteByUuid(
    data: GetNoteByUuidData,
  ): CancelablePromise<GetNoteByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/note/{noteByUuid}",
      path: {
        noteByUuid: data.noteByUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.noteByUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteNoteByUuid(
    data: DeleteNoteByUuidData,
  ): CancelablePromise<DeleteNoteByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/note/{noteByUuid}",
      path: {
        noteByUuid: data.noteByUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.threadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getNoteByThreadUuid(
    data: GetNoteByThreadUuidData,
  ): CancelablePromise<GetNoteByThreadUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/note/thread/{threadUuid}",
      path: {
        threadUuid: data.threadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.documentNote
   * @param data.note
   * @param data.createdDate
   * @param data.modifiedDate
   * @param data.createdBy
   * @param data.modifiedBy
   * @param data.isPrivate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllNotes(
    data: GetAllNotesData,
  ): CancelablePromise<GetAllNotesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/note/all",
      query: {
        patientUuid: data.patientUuid,
        documentNote: data.documentNote,
        note: data.note,
        createdDate: data.createdDate,
        modifiedDate: data.modifiedDate,
        createdBy: data.createdBy,
        modifiedBy: data.modifiedBy,
        isPrivate: data.isPrivate,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.flag
   * @param data.patientUuid
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllFlagNotes(
    data: GetAllFlagNotesData = {},
  ): CancelablePromise<GetAllFlagNotesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/note/all-note",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        flag: data.flag,
        patientUuid: data.patientUuid,
        employerUuid: data.employerUuid,
      },
    });
  }
}

export class MedicationControllerService {
  /**
   * @param data The data for the request.
   * @param data.medicationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getMedicationByUuid(
    data: GetMedicationByUuidData,
  ): CancelablePromise<GetMedicationByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/medication/{medicationUuid}",
      path: {
        medicationUuid: data.medicationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.medicationUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateMedicationByUuid(
    data: UpdateMedicationByUuidData,
  ): CancelablePromise<UpdateMedicationByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/medication/{medicationUuid}",
      path: {
        medicationUuid: data.medicationUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.medicationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteMedicationByUuid(
    data: DeleteMedicationByUuidData,
  ): CancelablePromise<DeleteMedicationByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/medication/{medicationUuid}",
      path: {
        medicationUuid: data.medicationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadMedications(
    data: UploadMedicationsData,
  ): CancelablePromise<UploadMedicationsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/medication/upload-medication",
      query: {
        patientUuid: data.patientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static saveMedication(
    data: SaveMedicationData,
  ): CancelablePromise<SaveMedicationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/medication/create",
      query: {
        draft: data.draft,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.medicationStatus
   * @param data.medicationUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllMedicationsForPdf(
    data: GetAllMedicationsForPdfData,
  ): CancelablePromise<GetAllMedicationsForPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/medication/list",
      query: {
        patientUuid: data.patientUuid,
        medicationStatus: data.medicationStatus,
        medicationUuids: data.medicationUuids,
      },
    });
  }

  /**
   * @returns binary OK
   * @throws ApiError
   */
  public static downloadCsvTemplate11(): CancelablePromise<DownloadCsvTemplate11Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/medication/csv-template",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.searchString
   * @param data.medicationStatus
   * @param data.draft
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllMedications(
    data: GetAllMedicationsData,
  ): CancelablePromise<GetAllMedicationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/medication/all",
      query: {
        patientUuid: data.patientUuid,
        searchString: data.searchString,
        medicationStatus: data.medicationStatus,
        draft: data.draft,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class MacroControllerService {
  /**
   * @param data The data for the request.
   * @param data.macroUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getMacroByUuid(
    data: GetMacroByUuidData,
  ): CancelablePromise<GetMacroByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/macro/{macroUuid}",
      path: {
        macroUuid: data.macroUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.macroUuid
   * @param data.requestBody
   * @param data.isAdmin
   * @returns Response OK
   * @throws ApiError
   */
  public static updateMacro(
    data: UpdateMacroData,
  ): CancelablePromise<UpdateMacroResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/macro/{macroUuid}",
      path: {
        macroUuid: data.macroUuid,
      },
      query: {
        isAdmin: data.isAdmin,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.macroUuid
   * @param data.isAdmin
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteMacro(
    data: DeleteMacroData,
  ): CancelablePromise<DeleteMacroResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/macro/{macroUuid}",
      path: {
        macroUuid: data.macroUuid,
      },
      query: {
        isAdmin: data.isAdmin,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addMacro(
    data: AddMacroData,
  ): CancelablePromise<AddMacroResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/macro",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.macroUuid
   * @param data.bookMark
   * @returns Response OK
   * @throws ApiError
   */
  public static updateMacroBookmark(
    data: UpdateMacroBookmarkData,
  ): CancelablePromise<UpdateMacroBookmarkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/macro/{macroUuid}/bookmark",
      path: {
        macroUuid: data.macroUuid,
      },
      query: {
        bookMark: data.bookMark,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.macroText
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getMacroByText(
    data: GetMacroByTextData,
  ): CancelablePromise<GetMacroByTextResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/macro/get-macro-by-text",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        macroText: data.macroText,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.isPrivate
   * @param data.flag
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllMacro(
    data: GetAllMacroData = {},
  ): CancelablePromise<GetAllMacroResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/macro/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        isPrivate: data.isPrivate,
        flag: data.flag,
      },
    });
  }
}

export class LocationControllerService {
  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns Response OK
   * @throws ApiError
   */
  public static updateLocation(
    data: UpdateLocationData = {},
  ): CancelablePromise<UpdateLocationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/location",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns Response OK
   * @throws ApiError
   */
  public static addLocation(
    data: AddLocationData = {},
  ): CancelablePromise<AddLocationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/location",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getLocationByUuid(
    data: GetLocationByUuidData,
  ): CancelablePromise<GetLocationByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/location/{locationUuid}",
      path: {
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteLocationByUuid(
    data: DeleteLocationByUuidData,
  ): CancelablePromise<DeleteLocationByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/location/{locationUuid}",
      path: {
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationGroupUuids
   * @param data.onlineSignUp
   * @param data.state
   * @returns Response OK
   * @throws ApiError
   */
  public static exportLocationsToCsv(
    data: ExportLocationsToCsvData = {},
  ): CancelablePromise<ExportLocationsToCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/location/locations/export-csv",
      query: {
        locationGroupUuids: data.locationGroupUuids,
        onlineSignUp: data.onlineSignUp,
        state: data.state,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLocationList(): CancelablePromise<GetAllLocationListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/location/list",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.status
   * @param data.providerUuid
   * @param data.adminUserUuid
   * @param data.nurseStaffUuid
   * @param data.onlineSignUp
   * @param data.locationGroupUuids
   * @param data.state
   * @param data.affiliateGroupUuids
   * @param data.isAffiliate
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLocation(
    data: GetAllLocationData = {},
  ): CancelablePromise<GetAllLocationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/location/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        status: data.status,
        providerUuid: data.providerUuid,
        adminUserUuid: data.adminUserUuid,
        nurseStaffUuid: data.nurseStaffUuid,
        onlineSignUp: data.onlineSignUp,
        locationGroupUuids: data.locationGroupUuids,
        state: data.state,
        affiliateGroupUuids: data.affiliateGroupUuids,
        isAffiliate: data.isAffiliate,
      },
    });
  }
}

export class LocationShareableSettingControllerService {
  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @param data.sharableUuid
   * @param data.enabled
   * @returns Response OK
   * @throws ApiError
   */
  public static updateSingleToggle(
    data: UpdateSingleToggleData,
  ): CancelablePromise<UpdateSingleToggleResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/location-sharable-item-settings/{locationUuid}/item/{sharableUuid}",
      path: {
        locationUuid: data.locationUuid,
        sharableUuid: data.sharableUuid,
      },
      query: {
        enabled: data.enabled,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllSettingsByLocation(
    data: GetAllSettingsByLocationData,
  ): CancelablePromise<GetAllSettingsByLocationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/location-sharable-item-settings/{locationUuid}",
      path: {
        locationUuid: data.locationUuid,
      },
    });
  }
}

export class LocationGroupControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateLocationGroup(
    data: UpdateLocationGroupData,
  ): CancelablePromise<UpdateLocationGroupResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/location-group",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addLocationGroup(
    data: AddLocationGroupData,
  ): CancelablePromise<AddLocationGroupResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/location-group",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationGroupUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getLocationGroupByUuid(
    data: GetLocationGroupByUuidData,
  ): CancelablePromise<GetLocationGroupByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/location-group/{locationGroupUuid}",
      path: {
        locationGroupUuid: data.locationGroupUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationGroupUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteLocationGroupByUuid(
    data: DeleteLocationGroupByUuidData,
  ): CancelablePromise<DeleteLocationGroupByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/location-group/{locationGroupUuid}",
      path: {
        locationGroupUuid: data.locationGroupUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLocationGroup(
    data: GetAllLocationGroupData = {},
  ): CancelablePromise<GetAllLocationGroupResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/location-group/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        status: data.status,
      },
    });
  }
}

export class LocationAvailabilityControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getLocationAvailabilityByUuid(
    data: GetLocationAvailabilityByUuidData,
  ): CancelablePromise<GetLocationAvailabilityByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/location-availability/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateLocationAvailability(
    data: UpdateLocationAvailabilityData,
  ): CancelablePromise<UpdateLocationAvailabilityResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/location-availability/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteLocationAvailabilityByUuid(
    data: DeleteLocationAvailabilityByUuidData,
  ): CancelablePromise<DeleteLocationAvailabilityByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/location-availability/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static create21(
    data: Create21Data,
  ): CancelablePromise<Create21Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/location-availability",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLocationAvailability(
    data: GetAllLocationAvailabilityData = {},
  ): CancelablePromise<GetAllLocationAvailabilityResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/location-availability/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class PatientLinkPharmacyControllerService {
  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.pharmacyUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static setDefaultPharmacy(
    data: SetDefaultPharmacyData,
  ): CancelablePromise<SetDefaultPharmacyResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/link-pharmacy/set-default",
      query: {
        patientUuid: data.patientUuid,
        pharmacyUuid: data.pharmacyUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static linkPharmacy(
    data: LinkPharmacyData,
  ): CancelablePromise<LinkPharmacyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/link-pharmacy/link",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPharmaciesForPatient(
    data: GetAllPharmaciesForPatientData,
  ): CancelablePromise<GetAllPharmaciesForPatientResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/link-pharmacy/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deletePharmacyForPatientByUuid(
    data: DeletePharmacyForPatientByUuidData,
  ): CancelablePromise<DeletePharmacyForPatientByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/link-pharmacy/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }
}

export class LabTestControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateLabTest(
    data: UpdateLabTestData,
  ): CancelablePromise<UpdateLabTestResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/lab-test",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createLabTest(
    data: CreateLabTestData,
  ): CancelablePromise<CreateLabTestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/lab-test",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labTestUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getLabTestByUuid(
    data: GetLabTestByUuidData,
  ): CancelablePromise<GetLabTestByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-test/{labTestUuid}",
      path: {
        labTestUuid: data.labTestUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labTestUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteLabTestByUuid(
    data: DeleteLabTestByUuidData,
  ): CancelablePromise<DeleteLabTestByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/lab-test/{labTestUuid}",
      path: {
        labTestUuid: data.labTestUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLabTest(
    data: GetAllLabTestData = {},
  ): CancelablePromise<GetAllLabTestResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-test/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class LabResultControllerService {
  /**
   * @param data The data for the request.
   * @param data.labResultUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static approveLabResult(
    data: ApproveLabResultData,
  ): CancelablePromise<ApproveLabResultResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/lab-result/{labResultUuid}/approve",
      path: {
        labResultUuid: data.labResultUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static proccesResult(): CancelablePromise<ProccesResultResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/lab-result/process-result",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.orderUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLabResultsByOrderUuid(
    data: GetAllLabResultsByOrderUuidData,
  ): CancelablePromise<GetAllLabResultsByOrderUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-result/order/{orderUuid}",
      path: {
        orderUuid: data.orderUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.orderUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addLabResultByOrderUuid(
    data: AddLabResultByOrderUuidData,
  ): CancelablePromise<AddLabResultByOrderUuidResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/lab-result/order/{orderUuid}",
      path: {
        orderUuid: data.orderUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addLabResult(
    data: AddLabResultData,
  ): CancelablePromise<AddLabResultResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/lab-result/addLabResult",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.search
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLabResultsByPatientUuid(
    data: GetAllLabResultsByPatientUuidData,
  ): CancelablePromise<GetAllLabResultsByPatientUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-result/patient/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        search: data.search,
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.status
   * @param data.providerUuids
   * @param data.locationUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLabResults(
    data: GetAllLabResultsData = {},
  ): CancelablePromise<GetAllLabResultsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-result/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        status: data.status,
        providerUuids: data.providerUuids,
        locationUuids: data.locationUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labResultUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static archiveLabResult(
    data: ArchiveLabResultData,
  ): CancelablePromise<ArchiveLabResultResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/lab-result/{labResultUuid}",
      path: {
        labResultUuid: data.labResultUuid,
      },
    });
  }
}

export class LabOrderControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateLabOrder(
    data: UpdateLabOrderData,
  ): CancelablePromise<UpdateLabOrderResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/lab-order",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static createLabOrder(
    data: CreateLabOrderData,
  ): CancelablePromise<CreateLabOrderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/lab-order",
      query: {
        draft: data.draft,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static calculatePrice(
    data: CalculatePriceData,
  ): CancelablePromise<CalculatePriceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/lab-order/calculate-price",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getLabOrderByUuid(
    data: GetLabOrderByUuidData,
  ): CancelablePromise<GetLabOrderByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-order/{labOrderUuid}",
      path: {
        labOrderUuid: data.labOrderUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteLabOrderByUuid(
    data: DeleteLabOrderByUuidData,
  ): CancelablePromise<DeleteLabOrderByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/lab-order/{labOrderUuid}",
      path: {
        labOrderUuid: data.labOrderUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static markAsComplete(
    data: MarkAsCompleteData,
  ): CancelablePromise<MarkAsCompleteResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/lab-order/{labOrderUuid}",
      path: {
        labOrderUuid: data.labOrderUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderUuid
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static archiveLabOrderByUuid(
    data: ArchiveLabOrderByUuidData,
  ): CancelablePromise<ArchiveLabOrderByUuidResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/lab-order/{labOrderUuid}/archive",
      path: {
        labOrderUuid: data.labOrderUuid,
      },
      query: {
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderUuid
   * @returns string OK
   * @throws ApiError
   */
  public static getSpecimenLabel(
    data: GetSpecimenLabelData,
  ): CancelablePromise<GetSpecimenLabelResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-order/{labOrderUuid}/specimen-label",
      path: {
        labOrderUuid: data.labOrderUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderUuid
   * @param data.limit
   * @returns Response OK
   * @throws ApiError
   */
  public static getLabOrderHistory(
    data: GetLabOrderHistoryData,
  ): CancelablePromise<GetLabOrderHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-order/{labOrderUuid}/history",
      path: {
        labOrderUuid: data.labOrderUuid,
      },
      query: {
        limit: data.limit,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.isTrible
   * @param data.searchString
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getTestCodesWithOrderSets(
    data: GetTestCodesWithOrderSetsData,
  ): CancelablePromise<GetTestCodesWithOrderSetsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-order/test-codes-with-ordersets",
      query: {
        isTrible: data.isTrible,
        searchString: data.searchString,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLabOrdersForPdf1(
    data: GetAllLabOrdersForPdf1Data,
  ): CancelablePromise<GetAllLabOrdersForPdf1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-order/list",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.patientUuid
   * @param data.locationUuids
   * @param data.providerUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllDraftLabAndImagingOrders(
    data: GetAllDraftLabAndImagingOrdersData = {},
  ): CancelablePromise<GetAllDraftLabAndImagingOrdersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-order/drafts",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        locationUuids: data.locationUuids,
        providerUuids: data.providerUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.patientUuid
   * @param data.archive
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLabOrder(
    data: GetAllLabOrderData = {},
  ): CancelablePromise<GetAllLabOrderResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-order/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        patientUuid: data.patientUuid,
        archive: data.archive,
        draft: data.draft,
      },
    });
  }
}

export class LabOrderSetControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateLabOrderSet(
    data: UpdateLabOrderSetData,
  ): CancelablePromise<UpdateLabOrderSetResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/lab-order-set",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createLabOrderSet(
    data: CreateLabOrderSetData,
  ): CancelablePromise<CreateLabOrderSetResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/lab-order-set",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderSetUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getLabOrderSetByUuid(
    data: GetLabOrderSetByUuidData,
  ): CancelablePromise<GetLabOrderSetByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-order-set/{labOrderSetUuid}",
      path: {
        labOrderSetUuid: data.labOrderSetUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderSetUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteLabOrderSetByUuid(
    data: DeleteLabOrderSetByUuidData,
  ): CancelablePromise<DeleteLabOrderSetByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/lab-order-set/{labOrderSetUuid}",
      path: {
        labOrderSetUuid: data.labOrderSetUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLabOrderSet(
    data: GetAllLabOrderSetData = {},
  ): CancelablePromise<GetAllLabOrderSetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-order-set/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getGlobalLabOrderSet(
    data: GetGlobalLabOrderSetData = {},
  ): CancelablePromise<GetGlobalLabOrderSetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/lab-order-set/all-global",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class InvoiceControllerService {
  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getInvoiceByUuid(
    data: GetInvoiceByUuidData,
  ): CancelablePromise<GetInvoiceByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/invoice/{invoiceUuid}",
      path: {
        invoiceUuid: data.invoiceUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateInvoiceByUuid(
    data: UpdateInvoiceByUuidData,
  ): CancelablePromise<UpdateInvoiceByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/invoice/{invoiceUuid}",
      path: {
        invoiceUuid: data.invoiceUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteInvoiceByUuid(
    data: DeleteInvoiceByUuidData,
  ): CancelablePromise<DeleteInvoiceByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/invoice/{invoiceUuid}",
      path: {
        invoiceUuid: data.invoiceUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveInvoiceStatement(
    data: SaveInvoiceStatementData,
  ): CancelablePromise<SaveInvoiceStatementResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/invoice/create_invoice_statement",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveInvoice(
    data: SaveInvoiceData,
  ): CancelablePromise<SaveInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/invoice/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getInvoiceStatement1(
    data: GetInvoiceStatement1Data,
  ): CancelablePromise<GetInvoiceStatement1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/invoice/statement/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.employerUuidForBrokerInvoice
   * @param data.userTypes
   * @param data.startDate
   * @param data.endDate
   * @param data.invoiceUuid
   * @param data.invoiceUuids
   * @param data.invoiceChargeType
   * @param data.invoiceStatus
   * @param data.brokerFirmUuids
   * @param data.searchString
   * @returns string OK
   * @throws ApiError
   */
  public static exportInvoicesToCsv(
    data: ExportInvoicesToCsvData = {},
  ): CancelablePromise<ExportInvoicesToCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/invoice/export/csv",
      query: {
        userUuid: data.userUuid,
        employerUuidForBrokerInvoice: data.employerUuidForBrokerInvoice,
        userTypes: data.userTypes,
        startDate: data.startDate,
        endDate: data.endDate,
        invoiceUuid: data.invoiceUuid,
        invoiceUuids: data.invoiceUuids,
        invoiceChargeType: data.invoiceChargeType,
        invoiceStatus: data.invoiceStatus,
        brokerFirmUuids: data.brokerFirmUuids,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userTypes
   * @param data.userUuid
   * @param data.employerUuidForBrokerInvoice
   * @param data.startDate
   * @param data.endDate
   * @param data.invoiceUuid
   * @param data.invoiceChargeType
   * @param data.invoiceStatus
   * @param data.brokerFirmUuids
   * @param data.searchString
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllInvoices(
    data: GetAllInvoicesData,
  ): CancelablePromise<GetAllInvoicesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/invoice/all",
      query: {
        userUuid: data.userUuid,
        employerUuidForBrokerInvoice: data.employerUuidForBrokerInvoice,
        userTypes: data.userTypes,
        startDate: data.startDate,
        endDate: data.endDate,
        invoiceUuid: data.invoiceUuid,
        invoiceChargeType: data.invoiceChargeType,
        invoiceStatus: data.invoiceStatus,
        brokerFirmUuids: data.brokerFirmUuids,
        searchString: data.searchString,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class InsuranceControllerService {
  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateInsurance(
    data: UpdateInsuranceData,
  ): CancelablePromise<UpdateInsuranceResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/insurance",
      query: {
        patientUuid: data.patientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createInsurance(
    data: CreateInsuranceData,
  ): CancelablePromise<CreateInsuranceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/insurance",
      query: {
        patientUuid: data.patientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPatientInsuranceWithDependents(
    data: GetAllPatientInsuranceWithDependentsData,
  ): CancelablePromise<GetAllPatientInsuranceWithDependentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/insurance/{patientUuid}/all",
      path: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.insuranceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getInsuranceByUuid(
    data: GetInsuranceByUuidData,
  ): CancelablePromise<GetInsuranceByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/insurance/{insuranceUuid}",
      path: {
        insuranceUuid: data.insuranceUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.insuranceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteInsuranceByUuid(
    data: DeleteInsuranceByUuidData,
  ): CancelablePromise<DeleteInsuranceByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/insurance/{insuranceUuid}",
      path: {
        insuranceUuid: data.insuranceUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.active
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPatientInsurance(
    data: GetAllPatientInsuranceData,
  ): CancelablePromise<GetAllPatientInsuranceResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/insurance/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        patientUuid: data.patientUuid,
        active: data.active,
      },
    });
  }
}

export class ImagingResultControllerService {
  /**
   * @param data The data for the request.
   * @param data.imagingResultByUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getImagingResultByUuid(
    data: GetImagingResultByUuidData,
  ): CancelablePromise<GetImagingResultByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/imaging_result/{imagingResultByUuid}",
      path: {
        imagingResultByUuid: data.imagingResultByUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.imagingResultByUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateImagingResult(
    data: UpdateImagingResultData,
  ): CancelablePromise<UpdateImagingResultResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/imaging_result/{imagingResultByUuid}",
      path: {
        imagingResultByUuid: data.imagingResultByUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.imagingResultByUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteImagingResultByUuid(
    data: DeleteImagingResultByUuidData,
  ): CancelablePromise<DeleteImagingResultByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/imaging_result/{imagingResultByUuid}",
      path: {
        imagingResultByUuid: data.imagingResultByUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveImagingResult(
    data: SaveImagingResultData,
  ): CancelablePromise<SaveImagingResultResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/imaging_result/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static exportCsv1(
    data: ExportCsv1Data,
  ): CancelablePromise<ExportCsv1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/imaging_result/results/export-csv",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.searchString
   * @param data.status
   * @param data.providerUuids
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllImagingResults(
    data: GetAllImagingResultsData,
  ): CancelablePromise<GetAllImagingResultsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/imaging_result/all",
      query: {
        patientUuid: data.patientUuid,
        searchString: data.searchString,
        status: data.status,
        providerUuids: data.providerUuids,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class ImagingOrderControllerService {
  /**
   * @param data The data for the request.
   * @param data.imagingOrderByUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getImagingOrderByUuid(
    data: GetImagingOrderByUuidData,
  ): CancelablePromise<GetImagingOrderByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/imaging_order/{imagingOrderByUuid}",
      path: {
        imagingOrderByUuid: data.imagingOrderByUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.imagingOrderByUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateImagingOrder(
    data: UpdateImagingOrderData,
  ): CancelablePromise<UpdateImagingOrderResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/imaging_order/{imagingOrderByUuid}",
      path: {
        imagingOrderByUuid: data.imagingOrderByUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.imagingOrderByUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteImagingOrderByUuid(
    data: DeleteImagingOrderByUuidData,
  ): CancelablePromise<DeleteImagingOrderByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/imaging_order/{imagingOrderByUuid}",
      path: {
        imagingOrderByUuid: data.imagingOrderByUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveImagingOrder(
    data: SaveImagingOrderData,
  ): CancelablePromise<SaveImagingOrderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/imaging_order/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllImagingOrder(
    data: GetAllImagingOrderData,
  ): CancelablePromise<GetAllImagingOrderResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/imaging_order/all",
      query: {
        patientUuid: data.patientUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class IcdCodeControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getIcdCodeByUuid(
    data: GetIcdCodeByUuidData,
  ): CancelablePromise<GetIcdCodeByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/icd-code/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateIcdCode(
    data: UpdateIcdCodeData,
  ): CancelablePromise<UpdateIcdCodeResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/icd-code/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteIcdCodeByUuid(
    data: DeleteIcdCodeByUuidData,
  ): CancelablePromise<DeleteIcdCodeByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/icd-code/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createIcdCode(
    data: CreateIcdCodeData,
  ): CancelablePromise<CreateIcdCodeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/icd-code",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static searchExternalIcdCodes(
    data: SearchExternalIcdCodesData = {},
  ): CancelablePromise<SearchExternalIcdCodesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/icd-code/search",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllIcdCodes(
    data: GetAllIcdCodesData = {},
  ): CancelablePromise<GetAllIcdCodesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/icd-code/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class HAndPNoteControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getHandPnoteByUuid(
    data: GetHandPnoteByUuidData,
  ): CancelablePromise<GetHandPnoteByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/hp-notes/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateHandPnote(
    data: UpdateHandPnoteData,
  ): CancelablePromise<UpdateHandPnoteResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/hp-notes/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteHandPnote(
    data: DeleteHandPnoteData,
  ): CancelablePromise<DeleteHandPnoteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/hp-notes/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addHandPnote(
    data: AddHandPnoteData,
  ): CancelablePromise<AddHandPnoteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/hp-notes",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.startDateTime
   * @param data.endDateTime
   * @param data.patientUuids
   * @param data.providerUuids
   * @param data.locationUuids
   * @param data.appointmentModes
   * @param data.appointmentTypeUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static getUnsignedNotesByUser(
    data: GetUnsignedNotesByUserData,
  ): CancelablePromise<GetUnsignedNotesByUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/hp-notes/unsigned-notes",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        userUuid: data.userUuid,
        searchString: data.searchString,
        startDateTime: data.startDateTime,
        endDateTime: data.endDateTime,
        patientUuids: data.patientUuids,
        providerUuids: data.providerUuids,
        locationUuids: data.locationUuids,
        appointmentModes: data.appointmentModes,
        appointmentTypeUuids: data.appointmentTypeUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getHandPnotesByPatientUuid(
    data: GetHandPnotesByPatientUuidData,
  ): CancelablePromise<GetHandPnotesByPatientUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/hp-notes/patient/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.appointmentUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getHandPnoteByAppointmentUuid(
    data: GetHandPnoteByAppointmentUuidData,
  ): CancelablePromise<GetHandPnoteByAppointmentUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/hp-notes/get/{appointmentUuid}",
      path: {
        appointmentUuid: data.appointmentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.patientUuids
   * @param data.providerUuids
   * @param data.locationUuids
   * @param data.appointmentModes
   * @param data.appointmentTypeUuids
   * @param data.signed
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEncountersWithoutDateFilter(
    data: GetAllEncountersWithoutDateFilterData = {},
  ): CancelablePromise<GetAllEncountersWithoutDateFilterResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/hp-notes/encounters/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        patientUuids: data.patientUuids,
        providerUuids: data.providerUuids,
        locationUuids: data.locationUuids,
        appointmentModes: data.appointmentModes,
        appointmentTypeUuids: data.appointmentTypeUuids,
        signed: data.signed,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.isDraft
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllHandPnotes(
    data: GetAllHandPnotesData,
  ): CancelablePromise<GetAllHandPnotesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/hp-notes/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        isDraft: data.isDraft,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.startDateTime
   * @param data.endDateTime
   * @param data.patientUuids
   * @param data.providerUuids
   * @param data.locationUuids
   * @param data.appointmentModes
   * @param data.appointmentTypeUuids
   * @param data.signed
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEncounter(
    data: GetAllEncounterData = {},
  ): CancelablePromise<GetAllEncounterResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/hp-notes/all-encounter",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        startDateTime: data.startDateTime,
        endDateTime: data.endDateTime,
        patientUuids: data.patientUuids,
        providerUuids: data.providerUuids,
        locationUuids: data.locationUuids,
        appointmentModes: data.appointmentModes,
        appointmentTypeUuids: data.appointmentTypeUuids,
        signed: data.signed,
      },
    });
  }
}

export class HabitsControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getHabitsByUuid(
    data: GetHabitsByUuidData,
  ): CancelablePromise<GetHabitsByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/habits/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateHabits(
    data: UpdateHabitsData,
  ): CancelablePromise<UpdateHabitsResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/habits/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteHabitsByUuid(
    data: DeleteHabitsByUuidData,
  ): CancelablePromise<DeleteHabitsByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/habits/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static create31(
    data: Create31Data,
  ): CancelablePromise<Create31Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/habits",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllHabits(
    data: GetAllHabitsData,
  ): CancelablePromise<GetAllHabitsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/habits/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class GlobalHolidayControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getGlobalHolidayByUuid(
    data: GetGlobalHolidayByUuidData,
  ): CancelablePromise<GetGlobalHolidayByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/global-holiday/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateGlobalHoliday(
    data: UpdateGlobalHolidayData,
  ): CancelablePromise<UpdateGlobalHolidayResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/global-holiday/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteGlobalHolidayByUuid(
    data: DeleteGlobalHolidayByUuidData,
  ): CancelablePromise<DeleteGlobalHolidayByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/global-holiday/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addGlobalHoliday(
    data: AddGlobalHolidayData,
  ): CancelablePromise<AddGlobalHolidayResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/global-holiday",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.active
   * @returns Response OK
   * @throws ApiError
   */
  public static toggleGlobalHoliday(
    data: ToggleGlobalHolidayData,
  ): CancelablePromise<ToggleGlobalHolidayResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/global-holiday/{uuid}/toggle",
      path: {
        uuid: data.uuid,
      },
      query: {
        active: data.active,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getHolidaysForLocation(
    data: GetHolidaysForLocationData,
  ): CancelablePromise<GetHolidaysForLocationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/global-holiday/location/{locationUuid}",
      path: {
        locationUuid: data.locationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.year
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllGlobalHolidays(
    data: GetAllGlobalHolidaysData = {},
  ): CancelablePromise<GetAllGlobalHolidaysResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/global-holiday/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        year: data.year,
        searchString: data.searchString,
      },
    });
  }
}

export class FormTemplateControllerService {
  /**
   * @param data The data for the request.
   * @param data.formTemplateUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getFormTemplateByUuid(
    data: GetFormTemplateByUuidData,
  ): CancelablePromise<GetFormTemplateByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/form-templates/{formTemplateUuid}",
      path: {
        formTemplateUuid: data.formTemplateUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formTemplateUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateFormTemplate(
    data: UpdateFormTemplateData,
  ): CancelablePromise<UpdateFormTemplateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/form-templates/{formTemplateUuid}",
      path: {
        formTemplateUuid: data.formTemplateUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formTemplateUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteFormTemplate(
    data: DeleteFormTemplateData,
  ): CancelablePromise<DeleteFormTemplateResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/form-templates/{formTemplateUuid}",
      path: {
        formTemplateUuid: data.formTemplateUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formTemplateUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static setFormAsDefault(
    data: SetFormAsDefaultData,
  ): CancelablePromise<SetFormAsDefaultResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/form-templates/{formTemplateUuid}/set-default",
      path: {
        formTemplateUuid: data.formTemplateUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formTemplateUuid
   * @param data.formData
   * @returns Response OK
   * @throws ApiError
   */
  public static updateFormTemplateWithPdf(
    data: UpdateFormTemplateWithPdfData,
  ): CancelablePromise<UpdateFormTemplateWithPdfResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/form-templates/{formTemplateUuid}/multipart",
      path: {
        formTemplateUuid: data.formTemplateUuid,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.searchString
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.startDate
   * @param data.endDate
   * @param data.formBuilderType
   * @param data.createdBy
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllFormTemplates(
    data: GetAllFormTemplatesData = {},
  ): CancelablePromise<GetAllFormTemplatesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/form-templates",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        searchString: data.searchString,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        startDate: data.startDate,
        endDate: data.endDate,
        formBuilderType: data.formBuilderType,
        createdBy: data.createdBy,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createFormTemplate(
    data: CreateFormTemplateData,
  ): CancelablePromise<CreateFormTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/form-templates",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formTemplateUuid
   * @param data.newName
   * @returns Response OK
   * @throws ApiError
   */
  public static duplicateFormTemplate(
    data: DuplicateFormTemplateData,
  ): CancelablePromise<DuplicateFormTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/form-templates/{formTemplateUuid}/duplicate",
      path: {
        formTemplateUuid: data.formTemplateUuid,
      },
      query: {
        newName: data.newName,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns Response OK
   * @throws ApiError
   */
  public static createFormTemplateWithPdf(
    data: CreateFormTemplateWithPdfData = {},
  ): CancelablePromise<CreateFormTemplateWithPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/form-templates/multipart",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formTemplateUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getFormJson(
    data: GetFormJsonData,
  ): CancelablePromise<GetFormJsonResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/form-templates/{formTemplateUuid}/json",
      path: {
        formTemplateUuid: data.formTemplateUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formTemplateUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static checkIfFormDefaultExists(
    data: CheckIfFormDefaultExistsData,
  ): CancelablePromise<CheckIfFormDefaultExistsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/form-templates/{formTemplateUuid}/check-default",
      path: {
        formTemplateUuid: data.formTemplateUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formBuilderType
   * @returns Response OK
   * @throws ApiError
   */
  public static getFormTemplateContentByType(
    data: GetFormTemplateContentByTypeData,
  ): CancelablePromise<GetFormTemplateContentByTypeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/form-templates/content-formBuilderType",
      query: {
        formBuilderType: data.formBuilderType,
      },
    });
  }
}

export class FdbMedicationsControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getFdbMedicationByUuid(
    data: GetFdbMedicationByUuidData,
  ): CancelablePromise<GetFdbMedicationByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/fdb-medications/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateFdbMedication(
    data: UpdateFdbMedicationData,
  ): CancelablePromise<UpdateFdbMedicationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/fdb-medications/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteFdbMedicationByUuid(
    data: DeleteFdbMedicationByUuidData,
  ): CancelablePromise<DeleteFdbMedicationByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/fdb-medications/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static create4(data: Create4Data): CancelablePromise<Create4Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/fdb-medications",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.search
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllFdbMedications(
    data: GetAllFdbMedicationsData = {},
  ): CancelablePromise<GetAllFdbMedicationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/fdb-medications/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        search: data.search,
      },
    });
  }
}

export class FamilyHistoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getFamilyHistoryByUuid(
    data: GetFamilyHistoryByUuidData,
  ): CancelablePromise<GetFamilyHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/family-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateFamilyHistory(
    data: UpdateFamilyHistoryData,
  ): CancelablePromise<UpdateFamilyHistoryResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/family-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteFamilyHistoryByUuid(
    data: DeleteFamilyHistoryByUuidData,
  ): CancelablePromise<DeleteFamilyHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/family-history/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static addFamilyHistory(
    data: AddFamilyHistoryData,
  ): CancelablePromise<AddFamilyHistoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/family-history",
      query: {
        draft: data.draft,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllFamilyHistory(
    data: GetAllFamilyHistoryData,
  ): CancelablePromise<GetAllFamilyHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/family-history/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        draft: data.draft,
      },
    });
  }
}

export class EducationalMaterialControllerService {
  /**
   * @param data The data for the request.
   * @param data.educationalMaterialUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getEducationalMaterialByUuid(
    data: GetEducationalMaterialByUuidData,
  ): CancelablePromise<GetEducationalMaterialByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/educational-material/{educationalMaterialUuid}",
      path: {
        educationalMaterialUuid: data.educationalMaterialUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.educationalMaterialUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateEducationalMaterial(
    data: UpdateEducationalMaterialData,
  ): CancelablePromise<UpdateEducationalMaterialResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/educational-material/{educationalMaterialUuid}",
      path: {
        educationalMaterialUuid: data.educationalMaterialUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.educationalMaterialUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteEducationalMaterial(
    data: DeleteEducationalMaterialData,
  ): CancelablePromise<DeleteEducationalMaterialResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/educational-material/{educationalMaterialUuid}",
      path: {
        educationalMaterialUuid: data.educationalMaterialUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createEducationalMaterial(
    data: CreateEducationalMaterialData,
  ): CancelablePromise<CreateEducationalMaterialResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/educational-material",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.educationalMaterialUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static setPatientsForMaterial(
    data: SetPatientsForMaterialData,
  ): CancelablePromise<SetPatientsForMaterialResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/educational-material/{educationalMaterialUuid}/patients",
      path: {
        educationalMaterialUuid: data.educationalMaterialUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.educationalMaterialUuid
   * @param data.patientUuid
   * @param data.bookMark
   * @returns Response OK
   * @throws ApiError
   */
  public static updatePatientMaterialBookmark(
    data: UpdatePatientMaterialBookmarkData,
  ): CancelablePromise<UpdatePatientMaterialBookmarkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/educational-material/{educationalMaterialUuid}/patient/{patientUuid}/bookmark",
      path: {
        educationalMaterialUuid: data.educationalMaterialUuid,
        patientUuid: data.patientUuid,
      },
      query: {
        bookMark: data.bookMark,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.educationalMaterialUuid
   * @param data.bookMark
   * @returns Response OK
   * @throws ApiError
   */
  public static updateBookmark(
    data: UpdateBookmarkData,
  ): CancelablePromise<UpdateBookmarkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/educational-material/{educationalMaterialUuid}/bookmark",
      path: {
        educationalMaterialUuid: data.educationalMaterialUuid,
      },
      query: {
        bookMark: data.bookMark,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.startDate
   * @param data.endDate
   * @param data.fileTypes
   * @param data.patientUuid
   * @param data.createdByList
   * @param data.isGlobal
   * @param data.includeAssignments
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEducationalMaterials(
    data: GetAllEducationalMaterialsData = {},
  ): CancelablePromise<GetAllEducationalMaterialsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/educational-material/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        startDate: data.startDate,
        endDate: data.endDate,
        fileTypes: data.fileTypes,
        patientUuid: data.patientUuid,
        createdByList: data.createdByList,
        isGlobal: data.isGlobal,
        includeAssignments: data.includeAssignments,
      },
    });
  }
}

export class DrugIntoleranceControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateDrugIntolerance(
    data: UpdateDrugIntoleranceData,
  ): CancelablePromise<UpdateDrugIntoleranceResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/drug-intolerance/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addDrugIntolerance(
    data: AddDrugIntoleranceData,
  ): CancelablePromise<AddDrugIntoleranceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/drug-intolerance",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.drugIntoleranceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getDrugIntoleranceByUuid(
    data: GetDrugIntoleranceByUuidData,
  ): CancelablePromise<GetDrugIntoleranceByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/drug-intolerance/{drugIntoleranceUuid}",
      path: {
        drugIntoleranceUuid: data.drugIntoleranceUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.drugIntoleranceUuid
   * @param data.archive
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteDrugIntoleranceByUuid(
    data: DeleteDrugIntoleranceByUuidData,
  ): CancelablePromise<DeleteDrugIntoleranceByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/drug-intolerance/{drugIntoleranceUuid}",
      path: {
        drugIntoleranceUuid: data.drugIntoleranceUuid,
      },
      query: {
        archive: data.archive,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllDrugIntolerancesForPdf(
    data: GetAllDrugIntolerancesForPdfData,
  ): CancelablePromise<GetAllDrugIntolerancesForPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/drug-intolerance/list",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllDrugIntolerances(
    data: GetAllDrugIntolerancesData,
  ): CancelablePromise<GetAllDrugIntolerancesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/drug-intolerance/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class DocumentTypeControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateDocumentType(
    data: UpdateDocumentTypeData,
  ): CancelablePromise<UpdateDocumentTypeResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/document_type/update",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveDocumentType(
    data: SaveDocumentTypeData,
  ): CancelablePromise<SaveDocumentTypeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/document_type/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.documentTypeUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getDocumentTypeByUuid(
    data: GetDocumentTypeByUuidData,
  ): CancelablePromise<GetDocumentTypeByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/document_type/{documentTypeUuid}",
      path: {
        documentTypeUuid: data.documentTypeUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.documentTypeUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteDocumentTypeByUuid(
    data: DeleteDocumentTypeByUuidData,
  ): CancelablePromise<DeleteDocumentTypeByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/document_type/{documentTypeUuid}",
      path: {
        documentTypeUuid: data.documentTypeUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.documentType
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllDocumentTypes(
    data: GetAllDocumentTypesData = {},
  ): CancelablePromise<GetAllDocumentTypesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/document_type/all",
      query: {
        documentType: data.documentType,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class DiagnosisControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getDiagnosisByUuid(
    data: GetDiagnosisByUuidData,
  ): CancelablePromise<GetDiagnosisByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/diagnosis/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateDiagnosis(
    data: UpdateDiagnosisData,
  ): CancelablePromise<UpdateDiagnosisResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/diagnosis/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteDiagnosis(
    data: DeleteDiagnosisData,
  ): CancelablePromise<DeleteDiagnosisResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/diagnosis/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addDiagnosis(
    data: AddDiagnosisData,
  ): CancelablePromise<AddDiagnosisResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/diagnosis",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static resolvedDiagnosis(
    data: ResolvedDiagnosisData,
  ): CancelablePromise<ResolvedDiagnosisResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/diagnosis/resolved-diagnosis/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllDiagnosisForPdf(
    data: GetAllDiagnosisForPdfData,
  ): CancelablePromise<GetAllDiagnosisForPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/diagnosis/list",
      query: {
        patientUuid: data.patientUuid,
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.type
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllDiagnoses(
    data: GetAllDiagnosesData,
  ): CancelablePromise<GetAllDiagnosesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/diagnosis/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        type: data.type,
        status: data.status,
        patientUuid: data.patientUuid,
      },
    });
  }
}

export class CptCodeControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateIcdCode1(
    data: UpdateIcdCode1Data,
  ): CancelablePromise<UpdateIcdCode1Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/cpt-code",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addCptCode(
    data: AddCptCodeData,
  ): CancelablePromise<AddCptCodeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/cpt-code",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cptCodeUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getIcdCodeByUuid1(
    data: GetIcdCodeByUuid1Data,
  ): CancelablePromise<GetIcdCodeByUuid1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/cpt-code/{cptCodeUuid}",
      path: {
        cptCodeUuid: data.cptCodeUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cptCodeUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteIcdCodeByUuid1(
    data: DeleteIcdCodeByUuid1Data,
  ): CancelablePromise<DeleteIcdCodeByUuid1Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/cpt-code/{cptCodeUuid}",
      path: {
        cptCodeUuid: data.cptCodeUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllIcdCodes1(
    data: GetAllIcdCodes1Data = {},
  ): CancelablePromise<GetAllIcdCodes1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/cpt-code/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        searchString: data.searchString,
      },
    });
  }
}

export class CommentControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getMessageByUuid(
    data: GetMessageByUuidData,
  ): CancelablePromise<GetMessageByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/comment/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateMessage(
    data: UpdateMessageData,
  ): CancelablePromise<UpdateMessageResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/comment/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteMessage(
    data: DeleteMessageData,
  ): CancelablePromise<DeleteMessageResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/comment/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addMessage(
    data: AddMessageData,
  ): CancelablePromise<AddMessageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/comment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAssignableUsersForTask(
    data: GetAssignableUsersForTaskData,
  ): CancelablePromise<GetAssignableUsersForTaskResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/comment/assignable-users/{taskUuid}",
      path: {
        taskUuid: data.taskUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.taskUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllMessages(
    data: GetAllMessagesData = {},
  ): CancelablePromise<GetAllMessagesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/comment/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        taskUuid: data.taskUuid,
      },
    });
  }
}

export class CarePlanControllerService {
  /**
   * @param data The data for the request.
   * @param data.carePlanUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getCarePlanByUuid(
    data: GetCarePlanByUuidData,
  ): CancelablePromise<GetCarePlanByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/care_plan/{carePlanUuid}",
      path: {
        carePlanUuid: data.carePlanUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.carePlanUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateCarePlanByUuid(
    data: UpdateCarePlanByUuidData,
  ): CancelablePromise<UpdateCarePlanByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/care_plan/{carePlanUuid}",
      path: {
        carePlanUuid: data.carePlanUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.carePlanUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteCarePlan(
    data: DeleteCarePlanData,
  ): CancelablePromise<DeleteCarePlanResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/care_plan/{carePlanUuid}",
      path: {
        carePlanUuid: data.carePlanUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveCarePlan(
    data: SaveCarePlanData,
  ): CancelablePromise<SaveCarePlanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/care_plan/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.page
   * @param data.size
   * @returns Response OK
   * @throws ApiError
   */
  public static getCarePlans(
    data: GetCarePlansData = {},
  ): CancelablePromise<GetCarePlansResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/care_plan/care-plans",
      query: {
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        page: data.page,
        size: data.size,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.name
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.page
   * @param data.size
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllCarePlans(
    data: GetAllCarePlansData = {},
  ): CancelablePromise<GetAllCarePlansResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/care_plan/all",
      query: {
        name: data.name,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        page: data.page,
        size: data.size,
      },
    });
  }
}

export class AvailabilityControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAvailability(
    data: UpdateAvailabilityData,
  ): CancelablePromise<UpdateAvailabilityResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/availability",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addAvailability(
    data: AddAvailabilityData,
  ): CancelablePromise<AddAvailabilityResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/availability",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.availabilityDate
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createAvailabilityForDate(
    data: CreateAvailabilityForDateData = {},
  ): CancelablePromise<CreateAvailabilityForDateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/availability/date",
      query: {
        availabilityDate: data.availabilityDate,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerUuid
   * @param data.locationUuid
   * @param data.blockDate
   * @returns Response OK
   * @throws ApiError
   */
  public static getBlockDaysForProviders(
    data: GetBlockDaysForProvidersData = {},
  ): CancelablePromise<GetBlockDaysForProvidersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/availability/block-days",
      query: {
        providerUuid: data.providerUuid,
        locationUuid: data.locationUuid,
        blockDate: data.blockDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.occurrenceDateTime
   * @returns Response OK
   * @throws ApiError
   */
  public static createBlockSlot(
    data: CreateBlockSlotData,
  ): CancelablePromise<CreateBlockSlotResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/availability/block-days",
      query: {
        occurrenceDateTime: data.occurrenceDateTime,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.providerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAvailabilityByProviderUuid(
    data: GetAvailabilityByProviderUuidData,
  ): CancelablePromise<GetAvailabilityByProviderUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/availability/{providerUuid}",
      path: {
        providerUuid: data.providerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.startDateTime
   * @param data.endDateTime
   * @param data.providerUuid
   * @param data.locationUuid
   * @param data.duration
   * @param data.coBook
   * @param data.dayOfWeek
   * @param data.appointmentMode
   * @returns Response OK
   * @throws ApiError
   */
  public static getAvailabilitySlots(
    data: GetAvailabilitySlotsData,
  ): CancelablePromise<GetAvailabilitySlotsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/availability/slots",
      query: {
        providerUuid: data.providerUuid,
        locationUuid: data.locationUuid,
        duration: data.duration,
        startDateTime: data.startDateTime,
        endDateTime: data.endDateTime,
        coBook: data.coBook,
        dayOfWeek: data.dayOfWeek,
        appointmentMode: data.appointmentMode,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.startDateTime
   * @param data.endDateTime
   * @param data.providerUuid
   * @param data.locationUuid
   * @param data.blockDayUuid
   * @param data.recurringBlockDayUuid
   * @param data.appointmentMode
   * @returns Response OK
   * @throws ApiError
   */
  public static getAvailabilitySlotForCalendar(
    data: GetAvailabilitySlotForCalendarData = {},
  ): CancelablePromise<GetAvailabilitySlotForCalendarResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/availability/calendar",
      query: {
        startDateTime: data.startDateTime,
        endDateTime: data.endDateTime,
        providerUuid: data.providerUuid,
        locationUuid: data.locationUuid,
        blockDayUuid: data.blockDayUuid,
        recurringBlockDayUuid: data.recurringBlockDayUuid,
        appointmentMode: data.appointmentMode,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAvailability(
    data: GetAllAvailabilityData = {},
  ): CancelablePromise<GetAllAvailabilityResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/availability/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.availabilityUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAvailabilityByUuid(
    data: DeleteAvailabilityByUuidData,
  ): CancelablePromise<DeleteAvailabilityByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/availability/{availabilityUuid}",
      path: {
        availabilityUuid: data.availabilityUuid,
      },
    });
  }
}

export class AppointmentControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAppointment(
    data: UpdateAppointmentData,
  ): CancelablePromise<UpdateAppointmentResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/appointment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createAppointment(
    data: CreateAppointmentData,
  ): CancelablePromise<CreateAppointmentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/appointment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.masterAppointmentUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static cancelAppointmentByUuid(
    data: CancelAppointmentByUuidData,
  ): CancelablePromise<CancelAppointmentByUuidResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/appointment/cancel-appointment/{masterAppointmentUuid}",
      path: {
        masterAppointmentUuid: data.masterAppointmentUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.appointmentUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static submitVideoConsent(
    data: SubmitVideoConsentData,
  ): CancelablePromise<SubmitVideoConsentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/appointment/{appointmentUuid}/submit-video-consent",
      path: {
        appointmentUuid: data.appointmentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.appointmentUuid
   * @param data.appointmentStartDateTime
   * @returns Response OK
   * @throws ApiError
   */
  public static confirmAppointmentFromSms(
    data: ConfirmAppointmentFromSmsData,
  ): CancelablePromise<ConfirmAppointmentFromSmsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/appointment/confirm-sms",
      query: {
        appointmentUuid: data.appointmentUuid,
        appointmentStartDateTime: data.appointmentStartDateTime,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static generateCalendarSyncUrl(): CancelablePromise<GenerateCalendarSyncUrlResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/appointment/calendar-sync",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.appointmentUuid
   * @param data.appointmentStartDateTime
   * @param data.statusConfigurationUuid
   * @param data.appointmentRoom
   * @param data.description
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAppointmentStatus(
    data: UpdateAppointmentStatusData,
  ): CancelablePromise<UpdateAppointmentStatusResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/appointment/status",
      query: {
        appointmentUuid: data.appointmentUuid,
        appointmentStartDateTime: data.appointmentStartDateTime,
        statusConfigurationUuid: data.statusConfigurationUuid,
        appointmentRoom: data.appointmentRoom,
        description: data.description,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.appointmentUuid
   * @param data.occurrenceDate
   * @returns Response OK
   * @throws ApiError
   */
  public static getAppointmentByUuid(
    data: GetAppointmentByUuidData,
  ): CancelablePromise<GetAppointmentByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/appointment/{appointmentUuid}",
      path: {
        appointmentUuid: data.appointmentUuid,
      },
      query: {
        occurrenceDate: data.occurrenceDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.visitType
   * @param data.patientUuid
   * @param data.confidential
   * @returns Response OK
   * @throws ApiError
   */
  public static getAppointmentVisitDetails(
    data: GetAppointmentVisitDetailsData = {},
  ): CancelablePromise<GetAppointmentVisitDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/appointment/visit-details",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        visitType: data.visitType,
        patientUuid: data.patientUuid,
        confidential: data.confidential,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getVideoConsentForm(): CancelablePromise<GetVideoConsentFormResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/appointment/video-consent-form",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAppointmentForDashBoard(
    data: GetAppointmentForDashBoardData,
  ): CancelablePromise<GetAppointmentForDashBoardResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/appointment/dashboard",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.token
   * @returns string OK
   * @throws ApiError
   */
  public static getProviderCalendarIcs(
    data: GetProviderCalendarIcsData,
  ): CancelablePromise<GetProviderCalendarIcsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/appointment/calendar-sync/{token}",
      path: {
        token: data.token,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.startDateTime
   * @param data.endDateTime
   * @param data.patientUuids
   * @param data.providerUuids
   * @param data.locationUuids
   * @param data.appointmentModes
   * @param data.appointmentTypeUuids
   * @param data.statusConfigurationUuids
   * @param data.calendar
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAppointments(
    data: GetAllAppointmentsData = {},
  ): CancelablePromise<GetAllAppointmentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/appointment/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        startDateTime: data.startDateTime,
        endDateTime: data.endDateTime,
        patientUuids: data.patientUuids,
        providerUuids: data.providerUuids,
        locationUuids: data.locationUuids,
        appointmentModes: data.appointmentModes,
        appointmentTypeUuids: data.appointmentTypeUuids,
        statusConfigurationUuids: data.statusConfigurationUuids,
        calendar: data.calendar,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.masterAppointmentUuid
   * @param data.cancellation
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAppointmentByUuid(
    data: DeleteAppointmentByUuidData,
  ): CancelablePromise<DeleteAppointmentByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/appointment/{masterAppointmentUuid}",
      path: {
        masterAppointmentUuid: data.masterAppointmentUuid,
      },
      query: {
        cancellation: data.cancellation,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class AppointmentTypeControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAppointmentType(
    data: UpdateAppointmentTypeData,
  ): CancelablePromise<UpdateAppointmentTypeResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/appointment-type",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createAppointmentType(
    data: CreateAppointmentTypeData,
  ): CancelablePromise<CreateAppointmentTypeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/appointment-type",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.appointmentTypeUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAppointmentTypeByUuid(
    data: GetAppointmentTypeByUuidData,
  ): CancelablePromise<GetAppointmentTypeByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/appointment-type/{appointmentTypeUuid}",
      path: {
        appointmentTypeUuid: data.appointmentTypeUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.appointmentTypeUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAppointmentTypeByUuid(
    data: DeleteAppointmentTypeByUuidData,
  ): CancelablePromise<DeleteAppointmentTypeByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/appointment-type/{appointmentTypeUuid}",
      path: {
        appointmentTypeUuid: data.appointmentTypeUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.appointmentMode
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAppointmentType(
    data: GetAllAppointmentTypeData = {},
  ): CancelablePromise<GetAllAppointmentTypeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/appointment-type/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        appointmentMode: data.appointmentMode,
      },
    });
  }
}

export class AnnotableImageControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAnnotableImage(
    data: GetAnnotableImageData,
  ): CancelablePromise<GetAnnotableImageResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/annotable-image/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAnnotableImage(
    data: UpdateAnnotableImageData,
  ): CancelablePromise<UpdateAnnotableImageResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/annotable-image/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAnnotableImage(
    data: DeleteAnnotableImageData,
  ): CancelablePromise<DeleteAnnotableImageResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/annotable-image/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addAnnotableImage(
    data: AddAnnotableImageData,
  ): CancelablePromise<AddAnnotableImageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/annotable-image",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.size
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAnnotableImages(
    data: GetAllAnnotableImagesData,
  ): CancelablePromise<GetAllAnnotableImagesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/annotable-image/all",
      query: {
        patientUuid: data.patientUuid,
        page: data.page,
        size: data.size,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class AnnotableImageTemplateControllerService {
  /**
   * @param data The data for the request.
   * @param data.anotableImageTemplateUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAnnotableImageTemplateByUuid(
    data: GetAnnotableImageTemplateByUuidData,
  ): CancelablePromise<GetAnnotableImageTemplateByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/annotable-image-template/{anotableImageTemplateUuid}",
      path: {
        anotableImageTemplateUuid: data.anotableImageTemplateUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.anotableImageTemplateUuid
   * @param data.requestBody
   * @param data.isAdmin
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAnnotableImageTemplate(
    data: UpdateAnnotableImageTemplateData,
  ): CancelablePromise<UpdateAnnotableImageTemplateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/annotable-image-template/{anotableImageTemplateUuid}",
      path: {
        anotableImageTemplateUuid: data.anotableImageTemplateUuid,
      },
      query: {
        isAdmin: data.isAdmin,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.anotableImageTemplateUuid
   * @param data.isAdmin
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAnnotableImageTemplate(
    data: DeleteAnnotableImageTemplateData,
  ): CancelablePromise<DeleteAnnotableImageTemplateResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/annotable-image-template/{anotableImageTemplateUuid}",
      path: {
        anotableImageTemplateUuid: data.anotableImageTemplateUuid,
      },
      query: {
        isAdmin: data.isAdmin,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addAnnotableImageTemplate(
    data: AddAnnotableImageTemplateData,
  ): CancelablePromise<AddAnnotableImageTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/annotable-image-template",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.anotableImageTemplateUuid
   * @param data.bookMark
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAnnotableImageTemplateBookmark(
    data: UpdateAnnotableImageTemplateBookmarkData,
  ): CancelablePromise<UpdateAnnotableImageTemplateBookmarkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/annotable-image-template/{anotableImageTemplateUuid}/bookmark",
      path: {
        anotableImageTemplateUuid: data.anotableImageTemplateUuid,
      },
      query: {
        bookMark: data.bookMark,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.isPrivate
   * @param data.flag
   * @param data.searchString
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAnnotableImageTemplate(
    data: GetAllAnnotableImageTemplateData = {},
  ): CancelablePromise<GetAllAnnotableImageTemplateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/annotable-image-template/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        isPrivate: data.isPrivate,
        flag: data.flag,
        searchString: data.searchString,
      },
    });
  }
}

export class AnnotableImagePinControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAnnotableImagePinByUuid(
    data: GetAnnotableImagePinByUuidData,
  ): CancelablePromise<GetAnnotableImagePinByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/annotable-image-pins/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAnnotableImagePin(
    data: UpdateAnnotableImagePinData,
  ): CancelablePromise<UpdateAnnotableImagePinResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/annotable-image-pins/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAnnotableImagePin(
    data: DeleteAnnotableImagePinData,
  ): CancelablePromise<DeleteAnnotableImagePinResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/annotable-image-pins/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addAnnotableImagePin(
    data: AddAnnotableImagePinData,
  ): CancelablePromise<AddAnnotableImagePinResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/annotable-image-pins",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.size
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAnnotableImagePins(
    data: GetAllAnnotableImagePinsData = {},
  ): CancelablePromise<GetAllAnnotableImagePinsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/annotable-image-pins/all",
      query: {
        page: data.page,
        size: data.size,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class AllergyControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllergyByUuid(
    data: GetAllergyByUuidData,
  ): CancelablePromise<GetAllergyByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/allergy/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateAllergy1(
    data: UpdateAllergy1Data,
  ): CancelablePromise<UpdateAllergy1Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/ehr/v1/allergy/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.archive
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAllergyByUuId(
    data: DeleteAllergyByUuIdData,
  ): CancelablePromise<DeleteAllergyByUuIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/allergy/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        archive: data.archive,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static addAllergy(
    data: AddAllergyData,
  ): CancelablePromise<AddAllergyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/allergy",
      query: {
        draft: data.draft,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAllergiesForPdf(
    data: GetAllAllergiesForPdfData,
  ): CancelablePromise<GetAllAllergiesForPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/allergy/list",
      query: {
        patientUuid: data.patientUuid,
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.filter
   * @param data.searchString
   * @param data.draft
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAllergies(
    data: GetAllAllergiesData,
  ): CancelablePromise<GetAllAllergiesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/allergy/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        patientUuid: data.patientUuid,
        filter: data.filter,
        searchString: data.searchString,
        draft: data.draft,
      },
    });
  }
}

export class QuestionnaireControllerService {
  /**
   * @param data The data for the request.
   * @param data.questionnaireUuid
   * @param data.patientUuid
   * @param data.formData
   * @returns Response OK
   * @throws ApiError
   */
  public static submitQuestionnaireMultipart(
    data: SubmitQuestionnaireMultipartData,
  ): CancelablePromise<SubmitQuestionnaireMultipartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/questionnaires/{questionnaireUuid}/submit/{patientUuid}/multipart",
      path: {
        questionnaireUuid: data.questionnaireUuid,
        patientUuid: data.patientUuid,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.questionnaireUuid
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendQuestionnaireReminder(
    data: SendQuestionnaireReminderData,
  ): CancelablePromise<SendQuestionnaireReminderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/questionnaires/{questionnaireUuid}/send-reminder/{patientUuid}",
      path: {
        questionnaireUuid: data.questionnaireUuid,
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.questionnaireUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendQuestionnaireFax1(
    data: SendQuestionnaireFax1Data,
  ): CancelablePromise<SendQuestionnaireFax1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/questionnaires/{questionnaireUuid}/send-fax",
      path: {
        questionnaireUuid: data.questionnaireUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadPdf(
    data: UploadPdfData,
  ): CancelablePromise<UploadPdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/questionnaires/upload-form-pdf",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.questionnaireUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static markAsReviewed(
    data: MarkAsReviewedData,
  ): CancelablePromise<MarkAsReviewedResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/questionnaires/{questionnaireUuid}/mark-reviewed",
      path: {
        questionnaireUuid: data.questionnaireUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.questionnaireUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getQuestionnairePdfUrls(
    data: GetQuestionnairePdfUrlsData,
  ): CancelablePromise<GetQuestionnairePdfUrlsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/questionnaires/{questionnaireUuid}/pdf-urls",
      path: {
        questionnaireUuid: data.questionnaireUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.questionnaireUuid
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getQuestionnaireTableMappings(
    data: GetQuestionnaireTableMappingsData,
  ): CancelablePromise<GetQuestionnaireTableMappingsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/questionnaires/{questionnaireUuid}/mappings/{patientUuid}",
      path: {
        questionnaireUuid: data.questionnaireUuid,
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.questionnaireUuid
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getQuestionnaireContentForPatient(
    data: GetQuestionnaireContentForPatientData,
  ): CancelablePromise<GetQuestionnaireContentForPatientResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/questionnaires/{questionnaireUuid}/content/{patientUuid}",
      path: {
        questionnaireUuid: data.questionnaireUuid,
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.submitted
   * @param data.formBuilderType
   * @param data.isPdfFormSubmission
   * @param data.appointmentUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.startDate
   * @param data.endDate
   * @returns Response OK
   * @throws ApiError
   */
  public static getQuestionnairesForPatientPortal(
    data: GetQuestionnairesForPatientPortalData,
  ): CancelablePromise<GetQuestionnairesForPatientPortalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/questionnaires/patient-portal/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        submitted: data.submitted,
        formBuilderType: data.formBuilderType,
        isPdfFormSubmission: data.isPdfFormSubmission,
        appointmentUuid: data.appointmentUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        startDate: data.startDate,
        endDate: data.endDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.questionnaireUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteQuestionnaire(
    data: DeleteQuestionnaireData,
  ): CancelablePromise<DeleteQuestionnaireResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/questionnaires/{questionnaireUuid}",
      path: {
        questionnaireUuid: data.questionnaireUuid,
      },
    });
  }
}

export class QuestResultPushControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static receiveQuestResult(
    data: ReceiveQuestResultData,
  ): CancelablePromise<ReceiveQuestResultResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/quest/results/receive",
      body: data.requestBody,
      mediaType: "text/plain",
    });
  }
}

export class QuestControllerService {
  /**
   * @param data The data for the request.
   * @param data.orderUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getOrderDocument(
    data: GetOrderDocumentData,
  ): CancelablePromise<GetOrderDocumentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/quest/get-order-document/{orderUuid}",
      path: {
        orderUuid: data.orderUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.search
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllCptCodes(
    data: GetAllCptCodesData = {},
  ): CancelablePromise<GetAllCptCodesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/quest/cpt-codes",
      query: {
        search: data.search,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.testCode
   * @returns Response OK
   * @throws ApiError
   */
  public static getAoeQuestions(
    data: GetAoeQuestionsData,
  ): CancelablePromise<GetAoeQuestionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/quest/aoe-questions/{testCode}",
      path: {
        testCode: data.testCode,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.search
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllCodes(
    data: GetAllCodesData = {},
  ): CancelablePromise<GetAllCodesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/quest/all",
      query: {
        search: data.search,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class Hl7ControllerService {
  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static updateCompadium(): CancelablePromise<UpdateCompadiumResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/hl7/update-compadium",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendOrder(
    data: SendOrderData,
  ): CancelablePromise<SendOrderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/hl7/trible/order",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static submitToQuest(
    data: SubmitToQuestData,
  ): CancelablePromise<SubmitToQuestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/hl7/submit-to-quest",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static testOrderQuest(
    data: TestOrderQuestData,
  ): CancelablePromise<TestOrderQuestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/hl7/quest-order",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.orderNumber
   * @param data.startDate
   * @param data.endDate
   * @returns Response OK
   * @throws ApiError
   */
  public static getResults(
    data: GetResultsData = {},
  ): CancelablePromise<GetResultsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/hl7/getResult",
      query: {
        orderNumber: data.orderNumber,
        startDate: data.startDate,
        endDate: data.endDate,
      },
    });
  }
}

export class PatientFormControllerService {
  /**
   * @param data The data for the request.
   * @param data.formUuid
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFormToPatient(
    data: SendFormToPatientData,
  ): CancelablePromise<SendFormToPatientResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/forms/patient/send/{formUuid}/{patientUuid}",
      path: {
        formUuid: data.formUuid,
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendMultipleFormsToPatient(
    data: SendMultipleFormsToPatientData,
  ): CancelablePromise<SendMultipleFormsToPatientResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/forms/patient/send-multiple/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFormToBulkPatients(
    data: SendFormToBulkPatientsData,
  ): CancelablePromise<SendFormToBulkPatientsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/forms/patient/send-bulk/{formUuid}",
      path: {
        formUuid: data.formUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DocumentControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.referenceType
   * @param data.documentKey
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadDocument(
    data: UploadDocumentData = {},
  ): CancelablePromise<UploadDocumentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/document/upload",
      query: {
        uuid: data.uuid,
        referenceType: data.referenceType,
        documentKey: data.documentKey,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveDocument(
    data: SaveDocumentData,
  ): CancelablePromise<SaveDocumentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/document/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.documentUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static unshareDocumentWithPatient(
    data: UnshareDocumentWithPatientData,
  ): CancelablePromise<UnshareDocumentWithPatientResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/document/{documentUuid}/unshare",
      path: {
        documentUuid: data.documentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.documentUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static shareDocumentWithPatient(
    data: ShareDocumentWithPatientData,
  ): CancelablePromise<ShareDocumentWithPatientResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/document/{documentUuid}/share",
      path: {
        documentUuid: data.documentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.documentUuid
   * @param data.status
   * @returns Response OK
   * @throws ApiError
   */
  public static updateReviewRequired(
    data: UpdateReviewRequiredData,
  ): CancelablePromise<UpdateReviewRequiredResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/document/{documentUuid}/review-required",
      path: {
        documentUuid: data.documentUuid,
      },
      query: {
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.documentUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static expireDocument(
    data: ExpireDocumentData,
  ): CancelablePromise<ExpireDocumentResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/ehr/v1/document/{documentUuid}/expire",
      path: {
        documentUuid: data.documentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.documentUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getDocumentByUuid(
    data: GetDocumentByUuidData,
  ): CancelablePromise<GetDocumentByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/document/{documentUuid}",
      path: {
        documentUuid: data.documentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.documentUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteDocumentByUuid(
    data: DeleteDocumentByUuidData,
  ): CancelablePromise<DeleteDocumentByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/document/{documentUuid}",
      path: {
        documentUuid: data.documentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.fileName
   * @param data.documentType
   * @param data.startDate
   * @param data.endDate
   * @param data.shared
   * @param data.includeArchived
   * @param data.reviewRequired
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllDocuments1(
    data: GetAllDocuments1Data,
  ): CancelablePromise<GetAllDocuments1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/document/all",
      query: {
        patientUuid: data.patientUuid,
        fileName: data.fileName,
        documentType: data.documentType,
        startDate: data.startDate,
        endDate: data.endDate,
        shared: data.shared,
        includeArchived: data.includeArchived,
        reviewRequired: data.reviewRequired,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class ContactDirectoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static saveContactDirectory(
    data: SaveContactDirectoryData,
  ): CancelablePromise<SaveContactDirectoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/contact_directory/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.contactDirectoryUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getContactDirectoryUuid(
    data: GetContactDirectoryUuidData,
  ): CancelablePromise<GetContactDirectoryUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/contact_directory/{contactDirectoryUuid}",
      path: {
        contactDirectoryUuid: data.contactDirectoryUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.contactDirectoryUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteContactDirectoryByUuid(
    data: DeleteContactDirectoryByUuidData,
  ): CancelablePromise<DeleteContactDirectoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/contact_directory/{contactDirectoryUuid}",
      path: {
        contactDirectoryUuid: data.contactDirectoryUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.referralType
   * @param data.searchString
   * @param data.city
   * @param data.state
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllContactDirectory(
    data: GetAllContactDirectoryData = {},
  ): CancelablePromise<GetAllContactDirectoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/contact_directory/all",
      query: {
        referralType: data.referralType,
        searchString: data.searchString,
        city: data.city,
        state: data.state,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class AwsControllerService {
  /**
   * @param data The data for the request.
   * @param data.referenceType
   * @param data.userUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadImageAsMultipart(
    data: UploadImageAsMultipartData,
  ): CancelablePromise<UploadImageAsMultipartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/aws/upload/image/multipart",
      query: {
        referenceType: data.referenceType,
        userUuid: data.userUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.referenceType
   * @param data.base64
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadImageAsBase64(
    data: UploadImageAsBase64Data,
  ): CancelablePromise<UploadImageAsBase64Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/aws/upload/image/base64",
      query: {
        userUuid: data.userUuid,
        referenceType: data.referenceType,
        base64: data.base64,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.referenceType
   * @param data.userUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadDocumentAsMultipart(
    data: UploadDocumentAsMultipartData,
  ): CancelablePromise<UploadDocumentAsMultipartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/aws/upload/document/multipart",
      query: {
        referenceType: data.referenceType,
        userUuid: data.userUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.base64
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadDocumentAsBase64(
    data: UploadDocumentAsBase64Data,
  ): CancelablePromise<UploadDocumentAsBase64Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/aws/upload/document/base64",
      query: {
        base64: data.base64,
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.key
   * @returns Response OK
   * @throws ApiError
   */
  public static getFile(data: GetFileData): CancelablePromise<GetFileResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/aws/auth/pre-signed-url",
      query: {
        key: data.key,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.key
   * @returns Response OK
   * @throws ApiError
   */
  public static getFile1(
    data: GetFile1Data,
  ): CancelablePromise<GetFile1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/aws/pre-signed-url",
      query: {
        key: data.key,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.key
   * @returns Response OK
   * @throws ApiError
   */
  public static getDownloadUrl(
    data: GetDownloadUrlData,
  ): CancelablePromise<GetDownloadUrlResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/aws/auth/download-url",
      query: {
        key: data.key,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.key
   * @returns Response OK
   * @throws ApiError
   */
  public static getDownloadUrl1(
    data: GetDownloadUrl1Data,
  ): CancelablePromise<GetDownloadUrl1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/aws/download-url",
      query: {
        key: data.key,
      },
    });
  }
}

export class AgreementControllerService {
  /**
   * @param data The data for the request.
   * @param data.agreementUuid
   * @param data.affiliateGroupUuid
   * @param data.formData
   * @returns Response OK
   * @throws ApiError
   */
  public static submitAgreementMultipart(
    data: SubmitAgreementMultipartData,
  ): CancelablePromise<SubmitAgreementMultipartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/agreements/{agreementUuid}/submit/{affiliateGroupUuid}/multipart",
      path: {
        agreementUuid: data.agreementUuid,
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @param data.formTemplateUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static createAffiliateAgreement(
    data: CreateAffiliateAgreementData,
  ): CancelablePromise<CreateAffiliateAgreementResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/agreements/affiliate-group/{affiliateGroupUuid}",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
      query: {
        formTemplateUuid: data.formTemplateUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @param data.formTemplateUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static createMultipleAffiliateAgreements(
    data: CreateMultipleAffiliateAgreementsData,
  ): CancelablePromise<CreateMultipleAffiliateAgreementsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/ehr/v1/agreements/affiliate-group/{affiliateGroupUuid}/bulk",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
      query: {
        formTemplateUuids: data.formTemplateUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agreementUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAgreementByUuid(
    data: GetAgreementByUuidData,
  ): CancelablePromise<GetAgreementByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/agreements/{agreementUuid}",
      path: {
        agreementUuid: data.agreementUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agreementUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteAgreement(
    data: DeleteAgreementData,
  ): CancelablePromise<DeleteAgreementResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/ehr/v1/agreements/{agreementUuid}",
      path: {
        agreementUuid: data.agreementUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agreementUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAgreementPdfUrls(
    data: GetAgreementPdfUrlsData,
  ): CancelablePromise<GetAgreementPdfUrlsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/agreements/{agreementUuid}/pdf-urls",
      path: {
        agreementUuid: data.agreementUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.agreementUuid
   * @param data.affiliateGroupUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAgreementContentForAffiliateGroup(
    data: GetAgreementContentForAffiliateGroupData,
  ): CancelablePromise<GetAgreementContentForAffiliateGroupResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/agreements/{agreementUuid}/content/{affiliateGroupUuid}",
      path: {
        agreementUuid: data.agreementUuid,
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.signed
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAgreementsForPortal(
    data: GetAgreementsForPortalData,
  ): CancelablePromise<GetAgreementsForPortalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/agreements/portal/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        signed: data.signed,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAgreementsForFirms(
    data: GetAllAgreementsForFirmsData = {},
  ): CancelablePromise<GetAllAgreementsForFirmsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/agreements/firms",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.affiliateGroupUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getPendingAgreementForLogin(
    data: GetPendingAgreementForLoginData,
  ): CancelablePromise<GetPendingAgreementForLoginResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/agreements/affiliate-group/{affiliateGroupUuid}/pending-agreement",
      path: {
        affiliateGroupUuid: data.affiliateGroupUuid,
      },
    });
  }
}

export class TribleLabControllerService {
  /**
   * @param data The data for the request.
   * @param data.pageable
   * @param data.search
   * @returns PageTribleTestCodesDto OK
   * @throws ApiError
   */
  public static getAllTribleTestCodes(
    data: GetAllTribleTestCodesData,
  ): CancelablePromise<GetAllTribleTestCodesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/trible",
      query: {
        search: data.search,
        pageable: data.pageable,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.isApprove
   * @returns Response OK
   * @throws ApiError
   */
  public static getByPatientUuid(
    data: GetByPatientUuidData,
  ): CancelablePromise<GetByPatientUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/trible/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        isApprove: data.isApprove,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllLabOrdersForPdf(
    data: GetAllLabOrdersForPdfData,
  ): CancelablePromise<GetAllLabOrdersForPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/trible/list",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @returns Response OK
   * @throws ApiError
   */
  public static getAll1(
    data: GetAll1Data = {},
  ): CancelablePromise<GetAll1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/trible/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
      },
    });
  }
}

export class TaskCategoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllTaskCategories(
    data: GetAllTaskCategoriesData = {},
  ): CancelablePromise<GetAllTaskCategoriesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/task-category/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
      },
    });
  }
}

export class ProcedureCodeControllerService {
  /**
   * @param data The data for the request.
   * @param data.code
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getProcedureCodes(
    data: GetProcedureCodesData = {},
  ): CancelablePromise<GetProcedureCodesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/procedure_code/all",
      query: {
        code: data.code,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class PlaceholderControllerService {
  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllPlaceholders(): CancelablePromise<GetAllPlaceholdersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/placeholders",
    });
  }
}

export class OrderStudyControllerService {
  /**
   * @param data The data for the request.
   * @param data.studyName
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllDocuments(
    data: GetAllDocumentsData = {},
  ): CancelablePromise<GetAllDocumentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/order_study/all",
      query: {
        studyName: data.studyName,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class GrowthChartControllerService {
  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.chartType
   * @param data.standard
   * @param data.combined
   * @param data.gestationalAgeWeeks
   * @returns Response OK
   * @throws ApiError
   */
  public static getGrowthChart(
    data: GetGrowthChartData,
  ): CancelablePromise<GetGrowthChartResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/growth-chart",
      query: {
        patientUuid: data.patientUuid,
        chartType: data.chartType,
        standard: data.standard,
        combined: data.combined,
        gestationalAgeWeeks: data.gestationalAgeWeeks,
      },
    });
  }
}

export class DynamicMappingControllerService {
  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getAvailableFields(): CancelablePromise<GetAvailableFieldsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/dynamic-mapping/available-fields",
    });
  }
}

export class AuditHistoryControllerService {
  /**
   * @param data The data for the request.
   * @param data.entityName
   * @param data.auditUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAuditHistoryByUuid(
    data: GetAuditHistoryByUuidData,
  ): CancelablePromise<GetAuditHistoryByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/{entityName}/{auditUuid}",
      path: {
        entityName: data.entityName,
        auditUuid: data.auditUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getUserAuditLogs(
    data: GetUserAuditLogsData,
  ): CancelablePromise<GetUserAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/user_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        userUuid: data.userUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ticketUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getTicketAuditLogs(
    data: GetTicketAuditLogsData,
  ): CancelablePromise<GetTicketAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/ticket_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        ticketUuid: data.ticketUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.flag
   * @param data.pageable
   * @returns PageGenericAuditLogResponse OK
   * @throws ApiError
   */
  public static getTaskAuditLogs(
    data: GetTaskAuditLogsData,
  ): CancelablePromise<GetTaskAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/tasks/{userUuid}",
      path: {
        userUuid: data.userUuid,
      },
      query: {
        flag: data.flag,
        pageable: data.pageable,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.soapNoteUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getSoapNoteAuditLogs(
    data: GetSoapNoteAuditLogsData,
  ): CancelablePromise<GetSoapNoteAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/soap_note_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        soapNoteUuid: data.soapNoteUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientModuleAccessAuditLogs(
    data: GetPatientModuleAccessAuditLogsData,
  ): CancelablePromise<GetPatientModuleAccessAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/patient_module_access_audit_logs",
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
        patientUuid: data.patientUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.username
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getInventoryAuditLogs(
    data: GetInventoryAuditLogsData = {},
  ): CancelablePromise<GetInventoryAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/inventory_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        username: data.username,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.hAndPnoteUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getHandPnoteAuditLogs(
    data: GetHandPnoteAuditLogsData,
  ): CancelablePromise<GetHandPnoteAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/h_and_p_note_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        hAndPNoteUuid: data.hAndPnoteUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.flag
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportTaskAuditLogsCsv(
    data: ExportTaskAuditLogsCsvData,
  ): CancelablePromise<ExportTaskAuditLogsCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/export-task-csv/{userUuid}",
      path: {
        userUuid: data.userUuid,
      },
      query: {
        flag: data.flag,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @param data.actions
   * @param data.roleTypes
   * @param data.roles
   * @param data.username
   * @returns string OK
   * @throws ApiError
   */
  public static exportAuditLogsPdf(
    data: ExportAuditLogsPdfData = {},
  ): CancelablePromise<ExportAuditLogsPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/export-pdf",
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
        actions: data.actions,
        roleTypes: data.roleTypes,
        roles: data.roles,
        username: data.username,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.username
   * @returns string OK
   * @throws ApiError
   */
  public static exportInventoryAuditLogsPdf(
    data: ExportInventoryAuditLogsPdfData = {},
  ): CancelablePromise<ExportInventoryAuditLogsPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/export-inventory-pdf",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        username: data.username,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.username
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportInventoryAuditLogsCsv(
    data: ExportInventoryAuditLogsCsvData = {},
  ): CancelablePromise<ExportInventoryAuditLogsCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/export-inventory-csv",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        username: data.username,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportEmployerAuditLogsCsv(
    data: ExportEmployerAuditLogsCsvData,
  ): CancelablePromise<ExportEmployerAuditLogsCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/export-employer-csv",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employeeUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportEmployeeAuditLogsCsv(
    data: ExportEmployeeAuditLogsCsvData,
  ): CancelablePromise<ExportEmployeeAuditLogsCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/export-employee-csv",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        employeeUuid: data.employeeUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.patientUuid
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportAuditLogsCsv(
    data: ExportAuditLogsCsvData = {},
  ): CancelablePromise<ExportAuditLogsCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/export-csv",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @param data.actions
   * @param data.roleTypes
   * @param data.roles
   * @param data.username
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportAuditLogsCsv1(
    data: ExportAuditLogsCsv1Data = {},
  ): CancelablePromise<ExportAuditLogsCsv1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/export-csv-admin",
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
        actions: data.actions,
        roleTypes: data.roleTypes,
        roles: data.roles,
        username: data.username,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @param data.actions
   * @param data.roleTypes
   * @param data.roles
   * @param data.username
   * @returns unknown OK
   * @throws ApiError
   */
  public static exportAdminAuditLogsCsv(
    data: ExportAdminAuditLogsCsvData = {},
  ): CancelablePromise<ExportAdminAuditLogsCsvResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/export-admin-csv",
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
        actions: data.actions,
        roleTypes: data.roleTypes,
        roles: data.roles,
        username: data.username,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getTicketRelatedAuditLogs(
    data: GetTicketRelatedAuditLogsData,
  ): CancelablePromise<GetTicketRelatedAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/employer_tms_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        employerUuid: data.employerUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerAuditLogs(
    data: GetEmployerAuditLogsData,
  ): CancelablePromise<GetEmployerAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/employer_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        employerUuid: data.employerUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerAdministratorUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerAdministratorAuditLogs(
    data: GetEmployerAdministratorAuditLogsData,
  ): CancelablePromise<GetEmployerAdministratorAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/employer_administrator_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        employerAdministratorUuid: data.employerAdministratorUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employeeUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployeeAuditLogs(
    data: GetEmployeeAuditLogsData,
  ): CancelablePromise<GetEmployeeAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/employee_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        employeeUuid: data.employeeUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.providerUuid
   * @param data.clinicUserUuid
   * @param data.patientUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getBreakGlassAuditLogs(
    data: GetBreakGlassAuditLogsData,
  ): CancelablePromise<GetBreakGlassAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/break_glass_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        locationUuid: data.locationUuid,
        providerUuid: data.providerUuid,
        clinicUserUuid: data.clinicUserUuid,
        patientUuid: data.patientUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @returns string OK
   * @throws ApiError
   */
  public static getAllAuditEntities(): CancelablePromise<GetAllAuditEntitiesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/audit_entities",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllTicketAuditLogs(
    data: GetAllTicketAuditLogsData = {},
  ): CancelablePromise<GetAllTicketAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/all_ticket_audit_logs",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.entityNames
   * @param data.startDate
   * @param data.endDate
   * @param data.patientUuid
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllAuditHistory(
    data: GetAllAuditHistoryData = {},
  ): CancelablePromise<GetAllAuditHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/all",
      query: {
        entityNames: data.entityNames,
        startDate: data.startDate,
        endDate: data.endDate,
        patientUuid: data.patientUuid,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @param data.actions
   * @param data.roleTypes
   * @param data.roles
   * @param data.username
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAdminAuditLogs(
    data: GetAdminAuditLogsData = {},
  ): CancelablePromise<GetAdminAuditLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/ehr/v1/audit_history/admin_audit_logs",
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
        actions: data.actions,
        roleTypes: data.roleTypes,
        roles: data.roles,
        username: data.username,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class NotificationControllerService {
  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.notificationUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static markAsRead(
    data: MarkAsReadData,
  ): CancelablePromise<MarkAsReadResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/notification/v1/notifications/mark-read",
      query: {
        notificationUuid: data.notificationUuid,
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.isRead
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllNotifications(
    data: GetAllNotificationsData,
  ): CancelablePromise<GetAllNotificationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/notifications",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        userUuid: data.userUuid,
        isRead: data.isRead,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static createNotification(
    data: CreateNotificationData,
  ): CancelablePromise<CreateNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notifications",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getNotification(
    data: GetNotificationData,
  ): CancelablePromise<GetNotificationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/notifications/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteNotification(
    data: DeleteNotificationData,
  ): CancelablePromise<DeleteNotificationResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/notification/v1/notifications/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getNotificationCountByUserUuid(
    data: GetNotificationCountByUserUuidData,
  ): CancelablePromise<GetNotificationCountByUserUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/notifications/count/{userUuid}",
      path: {
        userUuid: data.userUuid,
      },
    });
  }
}

export class NotificationPreferenceControllerService {
  /**
   * @param data The data for the request.
   * @param data.notificationPreferenceUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateNotificationPreference(
    data: UpdateNotificationPreferenceData,
  ): CancelablePromise<UpdateNotificationPreferenceResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/notification/v1/notification_preference/{notificationPreferenceUuid}",
      path: {
        notificationPreferenceUuid: data.notificationPreferenceUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static addNotificationPreference(
    data: AddNotificationPreferenceData,
  ): CancelablePromise<AddNotificationPreferenceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_preference",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllNotificationPreference(): CancelablePromise<GetAllNotificationPreferenceResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/notification_preference/all",
    });
  }
}

export class EmployerManagementNotificationSettingControllerService {
  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.notificationSettingUuid
   * @param data.enabled
   * @returns Response OK
   * @throws ApiError
   */
  public static updateSingleToggle1(
    data: UpdateSingleToggle1Data,
  ): CancelablePromise<UpdateSingleToggle1Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/notification/v1/employer_management_notification_setting/{employerUuid}/setting/{notificationSettingUuid}",
      path: {
        employerUuid: data.employerUuid,
        notificationSettingUuid: data.notificationSettingUuid,
      },
      query: {
        enabled: data.enabled,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.active
   * @param data.structure
   * @param data.fileName
   * @param data.objectRequestCategory
   * @param data.employerManagementNotificationSettingUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadEmailStructureAndTemplateToS32(
    data: UploadEmailStructureAndTemplateToS32Data,
  ): CancelablePromise<UploadEmailStructureAndTemplateToS32Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/employer_management_notification_setting/upload/structure_and_template",
      query: {
        active: data.active,
        structure: data.structure,
        fileName: data.fileName,
        objectRequestCategory: data.objectRequestCategory,
        employerManagementNotificationSettingUuid:
          data.employerManagementNotificationSettingUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerManagementNotificationSettingUuid
   * @param data.active
   * @returns Response OK
   * @throws ApiError
   */
  public static updateStatus(
    data: UpdateStatusData,
  ): CancelablePromise<UpdateStatusResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/employer_management_notification_setting/status/{employerManagementNotificationSettingUuid}",
      path: {
        employerManagementNotificationSettingUuid:
          data.employerManagementNotificationSettingUuid,
      },
      query: {
        active: data.active,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerManagementNotificationSettingyUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getEmployerManagementNotificationSettingyUuid(
    data: GetEmployerManagementNotificationSettingyUuidData,
  ): CancelablePromise<GetEmployerManagementNotificationSettingyUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/employer_management_notification_setting/{employerManagementNotificationSettingyUuid}",
      path: {
        employerManagementNotificationSettingyUuid:
          data.employerManagementNotificationSettingyUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllSettingsByEmployer(
    data: GetAllSettingsByEmployerData,
  ): CancelablePromise<GetAllSettingsByEmployerResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/employer_management_notification_setting/employer-notifications/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.category
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEmployerManagementNotificationSettings(
    data: GetAllEmployerManagementNotificationSettingsData = {},
  ): CancelablePromise<GetAllEmployerManagementNotificationSettingsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/employer_management_notification_setting/all",
      query: {
        category: data.category,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class PushNotificationControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFcmNotification(
    data: SendFcmNotificationData,
  ): CancelablePromise<SendFcmNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/push-notification/send-fcm-notification",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFcmBulkNotification(
    data: SendFcmBulkNotificationData,
  ): CancelablePromise<SendFcmBulkNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/push-notification/send-fcm-bulk-notification",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class NotificationSettingControllerService {
  /**
   * @param data The data for the request.
   * @param data.notificationSettingUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getNotificationSettingyUuid(
    data: GetNotificationSettingyUuidData,
  ): CancelablePromise<GetNotificationSettingyUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/notification_setting/{notificationSettingUuid}",
      path: {
        notificationSettingUuid: data.notificationSettingUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.notificationSettingUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static updateCustomNotification(
    data: UpdateCustomNotificationData,
  ): CancelablePromise<UpdateCustomNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/{notificationSettingUuid}",
      path: {
        notificationSettingUuid: data.notificationSettingUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForSetPassword(
    data: SendEmailForSetPasswordData,
  ): CancelablePromise<SendEmailForSetPasswordResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/user_onboarding",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fileName
   * @param data.objectRequestCategory
   * @param data.referenceType
   * @param data.notificationSettingUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadEmailTemplateToS3(
    data: UploadEmailTemplateToS3Data,
  ): CancelablePromise<UploadEmailTemplateToS3Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/upload/template",
      query: {
        fileName: data.fileName,
        objectRequestCategory: data.objectRequestCategory,
        referenceType: data.referenceType,
        notificationSettingUuid: data.notificationSettingUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.active
   * @param data.structure
   * @param data.fileName
   * @param data.objectRequestCategory
   * @param data.notificationSettingUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadEmailStructureAndTemplateToS3(
    data: UploadEmailStructureAndTemplateToS3Data,
  ): CancelablePromise<UploadEmailStructureAndTemplateToS3Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/upload/structure_and_template",
      query: {
        active: data.active,
        structure: data.structure,
        fileName: data.fileName,
        objectRequestCategory: data.objectRequestCategory,
        notificationSettingUuid: data.notificationSettingUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailFor(
    data: SendEmailForData,
  ): CancelablePromise<SendEmailForResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/trigger/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForAddPaymentToPatient(
    data: SendEmailForAddPaymentToPatientData,
  ): CancelablePromise<SendEmailForAddPaymentToPatientResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/trigger/send-mail-patient-payment-info",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendAddressChangeMailToPhp(
    data: SendAddressChangeMailToPhpData,
  ): CancelablePromise<SendAddressChangeMailToPhpResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/trigger/invoiceToPhp",
      query: {
        invoiceUuid: data.invoiceUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForProviderSignup(
    data: SendEmailForProviderSignupData,
  ): CancelablePromise<SendEmailForProviderSignupResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/sign-up-invitation",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendAppointmentJoinNotificationToPatient(
    data: SendAppointmentJoinNotificationToPatientData,
  ): CancelablePromise<SendAppointmentJoinNotificationToPatientResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/send-notification-patient",
      query: {
        labOrderUuid: data.labOrderUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.labOrderUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendLabResultToPatient(
    data: SendLabResultToPatientData,
  ): CancelablePromise<SendLabResultToPatientResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/send-lab-results",
      query: {
        labOrderUuid: data.labOrderUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static sendRetailEnrollmentNotification(): CancelablePromise<SendRetailEnrollmentNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/retail-enrollment",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendRefundEmail(
    data: SendRefundEmailData,
  ): CancelablePromise<SendRefundEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/refund",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForPatientBirthday(): CancelablePromise<SendEmailForPatientBirthdayResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/patient_birthday",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendUpcomingInvoiceNotification(
    data: SendUpcomingInvoiceNotificationData,
  ): CancelablePromise<SendUpcomingInvoiceNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/patient/upcoming-invoice",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendPatientNotificationEmail(
    data: SendPatientNotificationEmailData,
  ): CancelablePromise<SendPatientNotificationEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/patient-notification",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendPatientEnrollmentRequestNotification(
    data: SendPatientEnrollmentRequestNotificationData,
  ): CancelablePromise<SendPatientEnrollmentRequestNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/patient-enrollment-request",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendMultipleFormsEmail(
    data: SendMultipleFormsEmailData,
  ): CancelablePromise<SendMultipleFormsEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/multiple-forms",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.amount
   * @param data.transactionId
   * @returns Response OK
   * @throws ApiError
   */
  public static sendMembershipPaidEmail(
    data: SendMembershipPaidEmailData,
  ): CancelablePromise<SendMembershipPaidEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/membership-paid",
      query: {
        patientUuid: data.patientUuid,
        amount: data.amount,
        transactionId: data.transactionId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendMembershipCreatedEmail(
    data: SendMembershipCreatedEmailData,
  ): CancelablePromise<SendMembershipCreatedEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/membership-created",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendLabResultReadyNotification(
    data: SendLabResultReadyNotificationData,
  ): CancelablePromise<SendLabResultReadyNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/lab-result-ready",
      query: {
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForInvoiceNotificationAutopayDisabled(): CancelablePromise<SendEmailForInvoiceNotificationAutopayDisabledResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/invoice_notification_autopay_disabled",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForInvoiceNotificationAutopay(): CancelablePromise<SendEmailForInvoiceNotificationAutopayResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/invoice_notification_autopay",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.invoiceUuid
   * @param data.patientUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForInvoice(
    data: SendEmailForInvoiceData,
  ): CancelablePromise<SendEmailForInvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/invoice",
      query: {
        invoiceUuid: data.invoiceUuid,
        patientUuid: data.patientUuid,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailsForInvoiceNotification(): CancelablePromise<SendEmailsForInvoiceNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/invoice-notification",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFailedPaymentSummaryToAdmin(): CancelablePromise<SendFailedPaymentSummaryToAdminResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/failed-payment-report",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendUpcomingInvoiceNotificationToEmployer(
    data: SendUpcomingInvoiceNotificationToEmployerData,
  ): CancelablePromise<SendUpcomingInvoiceNotificationToEmployerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/employer/upcoming-invoice",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendPatientPaidNotificationToEmployer(
    data: SendPatientPaidNotificationToEmployerData,
  ): CancelablePromise<SendPatientPaidNotificationToEmployerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/employer/payment-received",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendInvoiceIssuedNotificationToEmployer(
    data: SendInvoiceIssuedNotificationToEmployerData,
  ): CancelablePromise<SendInvoiceIssuedNotificationToEmployerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/employer/invoice-issued",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendCreatedInvoiceNotificationToEmployer(
    data: SendCreatedInvoiceNotificationToEmployerData,
  ): CancelablePromise<SendCreatedInvoiceNotificationToEmployerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/employer/created-invoice",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendAutopayProcessedNotificationToEmployer(
    data: SendAutopayProcessedNotificationToEmployerData,
  ): CancelablePromise<SendAutopayProcessedNotificationToEmployerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/employer/autopay-processed",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmployerInvoiceCreationReminderNotification(): CancelablePromise<SendEmployerInvoiceCreationReminderNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/employer-invoice-creation-reminder",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForChargePaid(
    data: SendEmailForChargePaidData,
  ): CancelablePromise<SendEmailForChargePaidResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/charge_paid",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForCardExpiringSoon(): CancelablePromise<SendEmailForCardExpiringSoonResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/card_expiring_soon",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendCardSharedEmail(
    data: SendCardSharedEmailData,
  ): CancelablePromise<SendCardSharedEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/card-shared",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForRemovalOfCard(
    data: SendEmailForRemovalOfCardData,
  ): CancelablePromise<SendEmailForRemovalOfCardResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/card-remove",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendCardReceivedEmail(
    data: SendCardReceivedEmailData,
  ): CancelablePromise<SendCardReceivedEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/card-received",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendCallInvitationNotification(
    data: SendCallInvitationNotificationData,
  ): CancelablePromise<SendCallInvitationNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/call-invitation",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.brokerName
   * @returns Response OK
   * @throws ApiError
   */
  public static sendSignBroker(
    data: SendSignBrokerData,
  ): CancelablePromise<SendSignBrokerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/broker-sign",
      query: {
        brokerName: data.brokerName,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendEmailForRemovalOfBank(
    data: SendEmailForRemovalOfBankData,
  ): CancelablePromise<SendEmailForRemovalOfBankResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/bank-remove",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendAppointmentEmail(
    data: SendAppointmentEmailData,
  ): CancelablePromise<SendAppointmentEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/appointment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendAgentFirmAgreementCreatedEmail(
    data: SendAgentFirmAgreementCreatedEmailData,
  ): CancelablePromise<SendAgentFirmAgreementCreatedEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/agent-firm-agreement-created",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendAffiliateAgreementCreatedEmail(
    data: SendAffiliateAgreementCreatedEmailData,
  ): CancelablePromise<SendAffiliateAgreementCreatedEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/notification_setting/affiliate-agreement-created",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.key
   * @returns Response OK
   * @throws ApiError
   */
  public static getFile1(
    data: GetFile1Data,
  ): CancelablePromise<GetFile1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/notification_setting/pre-signed-url",
      query: {
        key: data.key,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.key
   * @returns Response OK
   * @throws ApiError
   */
  public static getFile11(
    data: GetFile11Data,
  ): CancelablePromise<GetFile11Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/notification_setting/auth/pre-signed-url",
      query: {
        key: data.key,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.category
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllNotificationSettings(
    data: GetAllNotificationSettingsData = {},
  ): CancelablePromise<GetAllNotificationSettingsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/notification_setting/all",
      query: {
        category: data.category,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class SnsWebHookControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static handleSnsNotification(
    data: HandleSnsNotificationData,
  ): CancelablePromise<HandleSnsNotificationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/events/email",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class EmployerNotificationSettingControllerService {
  /**
   * @param data The data for the request.
   * @param data.active
   * @param data.structure
   * @param data.fileName
   * @param data.objectRequestCategory
   * @param data.notificationSettingUuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static uploadEmailStructureAndTemplateToS31(
    data: UploadEmailStructureAndTemplateToS31Data,
  ): CancelablePromise<UploadEmailStructureAndTemplateToS31Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/employer_notification_setting/upload/structure_and_template",
      query: {
        active: data.active,
        structure: data.structure,
        fileName: data.fileName,
        objectRequestCategory: data.objectRequestCategory,
        notificationSettingUuid: data.notificationSettingUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerNotificationSettingUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static employerNotificationSettingUuid(
    data: EmployerNotificationSettingUuidData,
  ): CancelablePromise<EmployerNotificationSettingUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/employer_notification_setting/{employerNotificationSettingUuid}",
      path: {
        employerNotificationSettingUuid: data.employerNotificationSettingUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.category
   * @param data.page Zero-based page index (0..N)
   * @param data.size The size of the page to be returned
   * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns Response OK
   * @throws ApiError
   */
  public static getAllEmployerNotificationSettings(
    data: GetAllEmployerNotificationSettingsData = {},
  ): CancelablePromise<GetAllEmployerNotificationSettingsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notification/v1/employer_notification_setting/all",
      query: {
        category: data.category,
        page: data.page,
        size: data.size,
        sort: data.sort,
      },
    });
  }
}

export class EmailControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendReferralEmail(
    data: SendReferralEmailData,
  ): CancelablePromise<SendReferralEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/email/send-referral",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendReferralEmailWithLink(
    data: SendReferralEmailWithLinkData,
  ): CancelablePromise<SendReferralEmailWithLinkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/email/send-referral-with-link",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static sendProviderReassignmentEmails(
    data: SendProviderReassignmentEmailsData,
  ): CancelablePromise<SendProviderReassignmentEmailsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/email/send-provider-reassignment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendFormTemplate(
    data: SendFormTemplateData,
  ): CancelablePromise<SendFormTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/email/send-form-template",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendBulkEmail(
    data: SendBulkEmailData,
  ): CancelablePromise<SendBulkEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/email/send-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.toEmail
   * @param data.title
   * @returns Response OK
   * @throws ApiError
   */
  public static sendInvitationEmail(
    data: SendInvitationEmailData,
  ): CancelablePromise<SendInvitationEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notification/v1/email/invite/{userUuid}",
      query: {
        toEmail: data.toEmail,
        title: data.title,
      },
    });
  }
}

export class StripControllerService {
  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @returns Response1 OK
   * @throws ApiError
   */
  public static getSubscription1(
    data: GetSubscription1Data,
  ): CancelablePromise<GetSubscription1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/billing/v1/strip/subscription/{subscriptionId}",
      path: {
        subscriptionId: data.subscriptionId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @param data.priceId
   * @param data.promotionCode
   * @returns Response1 OK
   * @throws ApiError
   */
  public static updateSubscription1(
    data: UpdateSubscription1Data,
  ): CancelablePromise<UpdateSubscription1Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/billing/v1/strip/subscription/{subscriptionId}",
      path: {
        subscriptionId: data.subscriptionId,
      },
      query: {
        priceId: data.priceId,
        promotionCode: data.promotionCode,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @returns Response1 OK
   * @throws ApiError
   */
  public static cancelSubscription1(
    data: CancelSubscription1Data,
  ): CancelablePromise<CancelSubscription1Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/billing/v1/strip/subscription/{subscriptionId}",
      path: {
        subscriptionId: data.subscriptionId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @param data.newPriceId
   * @returns Response1 OK
   * @throws ApiError
   */
  public static changePlan1(
    data: ChangePlan1Data,
  ): CancelablePromise<ChangePlan1Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/billing/v1/strip/subscription/{subscriptionId}/change-plan",
      path: {
        subscriptionId: data.subscriptionId,
      },
      query: {
        newPriceId: data.newPriceId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @param data.newPriceId
   * @param data.prorate
   * @returns Response1 OK
   * @throws ApiError
   */
  public static changePlanWithProration1(
    data: ChangePlanWithProration1Data,
  ): CancelablePromise<ChangePlanWithProration1Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/billing/v1/strip/subscription/{subscriptionId}/change-plan-advanced",
      path: {
        subscriptionId: data.subscriptionId,
      },
      query: {
        newPriceId: data.newPriceId,
        prorate: data.prorate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.promotionalCodeId
   * @param data.active
   * @returns Response1 OK
   * @throws ApiError
   */
  public static updatePromotionalCoupon1(
    data: UpdatePromotionalCoupon1Data,
  ): CancelablePromise<UpdatePromotionalCoupon1Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/billing/v1/strip/promotional-code",
      query: {
        promotionalCodeId: data.promotionalCodeId,
        active: data.active,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createPromotionalCoupon1(
    data: CreatePromotionalCoupon1Data,
  ): CancelablePromise<CreatePromotionalCoupon1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/promotional-code",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns string OK
   * @throws ApiError
   */
  public static handleStripeWebhook1(): CancelablePromise<HandleStripeWebhook1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/webhook",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createSubscription1(
    data: CreateSubscription1Data,
  ): CancelablePromise<CreateSubscription1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/subscription",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createSubscriptionWithPayment1(
    data: CreateSubscriptionWithPayment1Data,
  ): CancelablePromise<CreateSubscriptionWithPayment1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/subscription/with-payment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.customerId
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createSetupIntent1(
    data: CreateSetupIntent1Data,
  ): CancelablePromise<CreateSetupIntent1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/setup_intent",
      query: {
        customerId: data.customerId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createSetupIntentWithCustomer1(
    data: CreateSetupIntentWithCustomer1Data,
  ): CancelablePromise<CreateSetupIntentWithCustomer1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/setup_intent/with-customer",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.customerId
   * @param data.paymentMethodId
   * @returns Response1 OK
   * @throws ApiError
   */
  public static setDefaultPaymentMethod1(
    data: SetDefaultPaymentMethod1Data,
  ): CancelablePromise<SetDefaultPaymentMethod1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/set-default-payment-method",
      query: {
        customerId: data.customerId,
        paymentMethodId: data.paymentMethodId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static saveCardToCustomerWithCharging1(
    data: SaveCardToCustomerWithCharging1Data,
  ): CancelablePromise<SaveCardToCustomerWithCharging1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/save_card_charging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static saveCardToCustomer1(
    data: SaveCardToCustomer1Data,
  ): CancelablePromise<SaveCardToCustomer1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/save_card",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createProduct1(
    data: CreateProduct1Data,
  ): CancelablePromise<CreateProduct1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/product",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.productId
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createPriceForProduct1(
    data: CreatePriceForProduct1Data,
  ): CancelablePromise<CreatePriceForProduct1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/product/{productId}/price",
      path: {
        productId: data.productId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createProductAndPrice1(
    data: CreateProductAndPrice1Data,
  ): CancelablePromise<CreateProductAndPrice1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/product-price",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createPaymentIntent1(
    data: CreatePaymentIntent1Data,
  ): CancelablePromise<CreatePaymentIntent1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/create_customer_payment",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createCustomer1(
    data: CreateCustomer1Data,
  ): CancelablePromise<CreateCustomer1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/create_customer",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response1 OK
   * @throws ApiError
   */
  public static createCoupon1(
    data: CreateCoupon1Data,
  ): CancelablePromise<CreateCoupon1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/billing/v1/strip/coupon",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response1 OK
   * @throws ApiError
   */
  public static getStripeConfig1(): CancelablePromise<GetStripeConfig1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/billing/v1/strip/config",
    });
  }
}

export class TicketControllerService {
  /**
   * @param data The data for the request.
   * @param data.ticketUuid
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTicket(
    data: UpdateTicketData,
  ): CancelablePromise<UpdateTicketResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/ticket/{ticketUuid}",
      path: {
        ticketUuid: data.ticketUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ticketUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static deleteTicket(
    data: DeleteTicketData,
  ): CancelablePromise<DeleteTicketResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/ticket/{ticketUuid}",
      path: {
        ticketUuid: data.ticketUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ticketUuid
   * @param data.newPriority
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTicketPriority(
    data: UpdateTicketPriorityData,
  ): CancelablePromise<UpdateTicketPriorityResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/ticket/{ticketUuid}/priority",
      path: {
        ticketUuid: data.ticketUuid,
      },
      query: {
        newPriority: data.newPriority,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ticketUuid
   * @param data.status
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTicketStatus(
    data: UpdateTicketStatusData,
  ): CancelablePromise<UpdateTicketStatusResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/ticket/status/{ticketUuid}",
      path: {
        ticketUuid: data.ticketUuid,
      },
      query: {
        status: data.status,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static createTicket(
    data: CreateTicketData,
  ): CancelablePromise<CreateTicketResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/ticket/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ticketUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getTicketByUuid(
    data: GetTicketByUuidData,
  ): CancelablePromise<GetTicketByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket/{ticketUuid}/get",
      path: {
        ticketUuid: data.ticketUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.status
   * @param data.searchString
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.priority
   * @param data.ticketType
   * @param data.createdByUuids
   * @param data.requestedByUuids
   * @param data.employerUuids
   * @param data.assignToUuids
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getTicketsByEmployerUuid(
    data: GetTicketsByEmployerUuidData,
  ): CancelablePromise<GetTicketsByEmployerUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket/{employerUuid}/employer",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        status: data.status,
        searchString: data.searchString,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        priority: data.priority,
        ticketType: data.ticketType,
        createdByUuids: data.createdByUuids,
        requestedByUuids: data.requestedByUuids,
        employerUuids: data.employerUuids,
        assignToUuids: data.assignToUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.requestedByUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getTotalTicketsCountByUuid(
    data: GetTotalTicketsCountByUuidData = {},
  ): CancelablePromise<GetTotalTicketsCountByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket/total",
      query: {
        employerUuid: data.employerUuid,
        requestedByUuid: data.requestedByUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.requestedByUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getTicketCountsByStatusByUuid(
    data: GetTicketCountsByStatusByUuidData = {},
  ): CancelablePromise<GetTicketCountsByStatusByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket/status-counts",
      query: {
        employerUuid: data.employerUuid,
        requestedByUuid: data.requestedByUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getEmployerInfo(
    data: GetEmployerInfoData,
  ): CancelablePromise<GetEmployerInfoResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket/getEmployerInfo/{employerUuid}",
      path: {
        employerUuid: data.employerUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.search
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getEmployerStats(
    data: GetEmployerStatsData = {},
  ): CancelablePromise<GetEmployerStatsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket/employer-status",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        search: data.search,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.creatorUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getCreatorTicketStats(
    data: GetCreatorTicketStatsData,
  ): CancelablePromise<GetCreatorTicketStatsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket/creator/{creatorUuid}/stats",
      path: {
        creatorUuid: data.creatorUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerAdminUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getTicketCounts(
    data: GetTicketCountsData = {},
  ): CancelablePromise<GetTicketCountsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket/counts",
      query: {
        employerAdminUuid: data.employerAdminUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ticketUuids
   * @param data.createdByUuids
   * @param data.requestedByUuids
   * @param data.assignToUuids
   * @param data.employerUuids
   * @param data.priority
   * @param data.ticketType
   * @param data.status
   * @param data.excludeClosed
   * @param data.requestedStartDate
   * @param data.endDate
   * @param data.searchString
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllTicketsWithFilters(
    data: GetAllTicketsWithFiltersData = {},
  ): CancelablePromise<GetAllTicketsWithFiltersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket/all",
      query: {
        ticketUuids: data.ticketUuids,
        createdByUuids: data.createdByUuids,
        requestedByUuids: data.requestedByUuids,
        assignToUuids: data.assignToUuids,
        employerUuids: data.employerUuids,
        priority: data.priority,
        ticketType: data.ticketType,
        status: data.status,
        excludeClosed: data.excludeClosed,
        requestedStartDate: data.requestedStartDate,
        endDate: data.endDate,
        searchString: data.searchString,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.search
   * @param data.employerUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAdminTicketStatus(
    data: GetAdminTicketStatusData = {},
  ): CancelablePromise<GetAdminTicketStatusResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket/admin-status",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        search: data.search,
        employerUuid: data.employerUuid,
      },
    });
  }
}

export class TicketTaskControllerService {
  /**
   * @param data The data for the request.
   * @param data.taskUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getTicketTaskByUuid(
    data: GetTicketTaskByUuidData,
  ): CancelablePromise<GetTicketTaskByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-task/{taskUuid}",
      path: {
        taskUuid: data.taskUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskUuid
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTicketTask(
    data: UpdateTicketTaskData,
  ): CancelablePromise<UpdateTicketTaskResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/ticket-task/{taskUuid}",
      path: {
        taskUuid: data.taskUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static deleteTicketTask(
    data: DeleteTicketTaskData,
  ): CancelablePromise<DeleteTicketTaskResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/ticket-task/{taskUuid}",
      path: {
        taskUuid: data.taskUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskUuid
   * @param data.newStatus
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTicketTaskStatus(
    data: UpdateTicketTaskStatusData,
  ): CancelablePromise<UpdateTicketTaskStatusResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/ticket-task/{taskUuid}/status",
      path: {
        taskUuid: data.taskUuid,
      },
      query: {
        newStatus: data.newStatus,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskUuid
   * @param data.newPriority
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTicketTaskPriority(
    data: UpdateTicketTaskPriorityData,
  ): CancelablePromise<UpdateTicketTaskPriorityResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/ticket-task/{taskUuid}/priority",
      path: {
        taskUuid: data.taskUuid,
      },
      query: {
        newPriority: data.newPriority,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskUuid
   * @param data.assigneeUuids
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTicketTaskAssignee(
    data: UpdateTicketTaskAssigneeData,
  ): CancelablePromise<UpdateTicketTaskAssigneeResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/ticket-task/{taskUuid}/assignee",
      path: {
        taskUuid: data.taskUuid,
      },
      query: {
        assigneeUuids: data.assigneeUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static createTicketTask(
    data: CreateTicketTaskData,
  ): CancelablePromise<CreateTicketTaskResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/ticket-task/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.status
   * @param data.priority
   * @param data.assignToUuids
   * @param data.createdByUuids
   * @param data.startDate
   * @param data.endDate
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllTasksByEmployer(
    data: GetAllTasksByEmployerData,
  ): CancelablePromise<GetAllTasksByEmployerResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-task/employer/{employerUuid}/tasks",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        status: data.status,
        priority: data.priority,
        assignToUuids: data.assignToUuids,
        createdByUuids: data.createdByUuids,
        startDate: data.startDate,
        endDate: data.endDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ticketUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.priority
   * @param data.assignToUuids
   * @param data.createdByUuids
   * @param data.startDate
   * @param data.endDate
   * @param data.status
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllTasksByTicketUuid(
    data: GetAllTasksByTicketUuidData = {},
  ): CancelablePromise<GetAllTasksByTicketUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-task/all-tasks",
      query: {
        ticketUuid: data.ticketUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        priority: data.priority,
        assignToUuids: data.assignToUuids,
        createdByUuids: data.createdByUuids,
        startDate: data.startDate,
        endDate: data.endDate,
        status: data.status,
        searchString: data.searchString,
      },
    });
  }
}

export class TicketNotesControllerService {
  /**
   * @param data The data for the request.
   * @param data.notesUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getTicketNotesByUuid(
    data: GetTicketNotesByUuidData,
  ): CancelablePromise<GetTicketNotesByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-notes/{notesUuid}",
      path: {
        notesUuid: data.notesUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.notesUuid
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTicketNotes(
    data: UpdateTicketNotesData,
  ): CancelablePromise<UpdateTicketNotesResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/ticket-notes/{notesUuid}",
      path: {
        notesUuid: data.notesUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.notesUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static deleteTicketNotes(
    data: DeleteTicketNotesData,
  ): CancelablePromise<DeleteTicketNotesResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/ticket-notes/{notesUuid}",
      path: {
        notesUuid: data.notesUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static createTicketNotes(
    data: CreateTicketNotesData,
  ): CancelablePromise<CreateTicketNotesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/ticket-notes/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.createdByUuids
   * @param data.searchString
   * @param data.startDate
   * @param data.endDate
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllNotesByEmployer(
    data: GetAllNotesByEmployerData,
  ): CancelablePromise<GetAllNotesByEmployerResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-notes/employer/{employerUuid}/notes",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        createdByUuids: data.createdByUuids,
        searchString: data.searchString,
        startDate: data.startDate,
        endDate: data.endDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ticketUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllTicketNotes(
    data: GetAllTicketNotesData,
  ): CancelablePromise<GetAllTicketNotesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-notes/all-notes",
      query: {
        ticketUuid: data.ticketUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
      },
    });
  }
}

export class TicketAttachmentControllerService {
  /**
   * @param data The data for the request.
   * @param data.attachmentUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAttachmentByUuid(
    data: GetAttachmentByUuidData,
  ): CancelablePromise<GetAttachmentByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-attachment/{attachmentUuid}",
      path: {
        attachmentUuid: data.attachmentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.attachmentUuid
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateAttachment(
    data: UpdateAttachmentData,
  ): CancelablePromise<UpdateAttachmentResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/ticket-attachment/{attachmentUuid}",
      path: {
        attachmentUuid: data.attachmentUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.attachmentUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static deleteAttachment(
    data: DeleteAttachmentData,
  ): CancelablePromise<DeleteAttachmentResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/ticket-attachment/{attachmentUuid}",
      path: {
        attachmentUuid: data.attachmentUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static addAttachment(
    data: AddAttachmentData,
  ): CancelablePromise<AddAttachmentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/ticket-attachment/add",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.employerUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.startDate
   * @param data.endDate
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllAttachmentsByEmployer(
    data: GetAllAttachmentsByEmployerData,
  ): CancelablePromise<GetAllAttachmentsByEmployerResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-attachment/employer/{employerUuid}/attachments",
      path: {
        employerUuid: data.employerUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        startDate: data.startDate,
        endDate: data.endDate,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ticketUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllAttachmentsByTicketUuid(
    data: GetAllAttachmentsByTicketUuidData,
  ): CancelablePromise<GetAllAttachmentsByTicketUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-attachment/all-attachment",
      query: {
        ticketUuid: data.ticketUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class CrmTemplateControllerService {
  /**
   * @param data The data for the request.
   * @param data.templateUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getTemplate(
    data: GetTemplateData,
  ): CancelablePromise<GetTemplateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-templates/{templateUuid}",
      path: {
        templateUuid: data.templateUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.templateUuid
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTemplate(
    data: UpdateTemplateData,
  ): CancelablePromise<UpdateTemplateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/crm-templates/{templateUuid}",
      path: {
        templateUuid: data.templateUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.templateUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static deleteTemplate(
    data: DeleteTemplateData,
  ): CancelablePromise<DeleteTemplateResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/crm-templates/{templateUuid}",
      path: {
        templateUuid: data.templateUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static addTemplate(
    data: AddTemplateData,
  ): CancelablePromise<AddTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/crm-templates/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllTemplates(
    data: GetAllTemplatesData = {},
  ): CancelablePromise<GetAllTemplatesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-templates/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @param data.templateCategory
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllTemplates1(
    data: GetAllTemplates1Data = {},
  ): CancelablePromise<GetAllTemplates1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-templates/all-templatesByCategory",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
        templateCategory: data.templateCategory,
      },
    });
  }
}

export class CrmTaskControllerService {
  /**
   * @param data The data for the request.
   * @param data.taskUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getTaskByUuid1(
    data: GetTaskByUuid1Data,
  ): CancelablePromise<GetTaskByUuid1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-tasks/{taskUuid}",
      path: {
        taskUuid: data.taskUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskUuid
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateCrmTask(
    data: UpdateCrmTaskData,
  ): CancelablePromise<UpdateCrmTaskResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/crm-tasks/{taskUuid}",
      path: {
        taskUuid: data.taskUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static deleteCrmTask(
    data: DeleteCrmTaskData,
  ): CancelablePromise<DeleteCrmTaskResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/crm-tasks/{taskUuid}",
      path: {
        taskUuid: data.taskUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskPriority
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTaskPriority(
    data: UpdateTaskPriorityData,
  ): CancelablePromise<UpdateTaskPriorityResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/crm-tasks/priority/{taskUuid}",
      query: {
        taskPriority: data.taskPriority,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static createTask(
    data: CreateTaskData,
  ): CancelablePromise<CreateTaskResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/crm-tasks/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.contactUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.priority
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllTasksByContactUuid(
    data: GetAllTasksByContactUuidData,
  ): CancelablePromise<GetAllTasksByContactUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-tasks/contact/{contactUuid}",
      path: {
        contactUuid: data.contactUuid,
      },
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        priority: data.priority,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.priority
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllTasks1(
    data: GetAllTasks1Data = {},
  ): CancelablePromise<GetAllTasks1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-tasks/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        priority: data.priority,
        searchString: data.searchString,
      },
    });
  }
}

export class TaskLogControllerService {
  /**
   * @param data The data for the request.
   * @param data.taskLogUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getTaskLogByUuid(
    data: GetTaskLogByUuidData,
  ): CancelablePromise<GetTaskLogByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-taskLog/{taskLogUuid}",
      path: {
        taskLogUuid: data.taskLogUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskLogUuid
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateTaskLog(
    data: UpdateTaskLogData,
  ): CancelablePromise<UpdateTaskLogResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/crm-taskLog/{taskLogUuid}",
      path: {
        taskLogUuid: data.taskLogUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.taskLogUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static deleteTaskLog(
    data: DeleteTaskLogData,
  ): CancelablePromise<DeleteTaskLogResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/crm-taskLog/{taskLogUuid}",
      path: {
        taskLogUuid: data.taskLogUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static createTaskLog(
    data: CreateTaskLogData,
  ): CancelablePromise<CreateTaskLogResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/crm-taskLog/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.leadUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllTaskLogs(
    data: GetAllTaskLogsData,
  ): CancelablePromise<GetAllTaskLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-taskLog/all_taskLog",
      query: {
        leadUuid: data.leadUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class CrmNewsletterControllerService {
  /**
   * @param data The data for the request.
   * @param data.newsletterUuid
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateNewsletter(
    data: UpdateNewsletterData,
  ): CancelablePromise<UpdateNewsletterResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/crm-newsletter/{newsletterUuid}",
      path: {
        newsletterUuid: data.newsletterUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.newsletterUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static deleteNewsletter(
    data: DeleteNewsletterData,
  ): CancelablePromise<DeleteNewsletterResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/crm-newsletter/{newsletterUuid}",
      path: {
        newsletterUuid: data.newsletterUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static createNewsletter(
    data: CreateNewsletterData,
  ): CancelablePromise<CreateNewsletterResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/crm-newsletter/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getNewsletterByUuid(): CancelablePromise<GetNewsletterByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-newsletter/newsletterUuid",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllNewsletter(
    data: GetAllNewsletterData = {},
  ): CancelablePromise<GetAllNewsletterResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-newsletter/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class CrmCampaignControllerService {
  /**
   * @param data The data for the request.
   * @param data.campaignUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getCampaignByUuid(
    data: GetCampaignByUuidData,
  ): CancelablePromise<GetCampaignByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-campaign/{campaignUuid}",
      path: {
        campaignUuid: data.campaignUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.campaignUuid
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateCampaign(
    data: UpdateCampaignData,
  ): CancelablePromise<UpdateCampaignResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/crm-campaign/{campaignUuid}",
      path: {
        campaignUuid: data.campaignUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response2 OK
   * @throws ApiError
   */
  public static deleteCampaign(): CancelablePromise<DeleteCampaignResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/crm-campaign/{campaignUuid}",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static createCampaign(
    data: CreateCampaignData,
  ): CancelablePromise<CreateCampaignResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/crm-campaign/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllCampaign(
    data: GetAllCampaignData = {},
  ): CancelablePromise<GetAllCampaignResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-campaign/all",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class CallLogsControllerService {
  /**
   * @param data The data for the request.
   * @param data.callLogUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getCallLogByUuid(
    data: GetCallLogByUuidData,
  ): CancelablePromise<GetCallLogByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-callLog/{callLogUuid}",
      path: {
        callLogUuid: data.callLogUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callLogUuid
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static updateCallLog(
    data: UpdateCallLogData,
  ): CancelablePromise<UpdateCallLogResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/crm/v1/crm-callLog/{callLogUuid}",
      path: {
        callLogUuid: data.callLogUuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callLogUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static deleteCallLog(
    data: DeleteCallLogData,
  ): CancelablePromise<DeleteCallLogResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/crm-callLog/{callLogUuid}",
      path: {
        callLogUuid: data.callLogUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static createCallLog(
    data: CreateCallLogData,
  ): CancelablePromise<CreateCallLogResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/crm-callLog/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.leadUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllCallLogs(
    data: GetAllCallLogsData,
  ): CancelablePromise<GetAllCallLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/crm-callLog/all_callLog",
      query: {
        leadUuid: data.leadUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class TicketMergeControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static mergeTicket(
    data: MergeTicketData,
  ): CancelablePromise<MergeTicketResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/ticket-merge/merge",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getMergedTicket(
    data: GetMergedTicketData,
  ): CancelablePromise<GetMergedTicketResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-merge/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllMergedTickets(
    data: GetAllMergedTicketsData = {},
  ): CancelablePromise<GetAllMergedTicketsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-merge/all-merged",
      query: {
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class TicketLinkedControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static linkTicket(
    data: LinkTicketData,
  ): CancelablePromise<LinkTicketResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/ticket-linked/link",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.linkedUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getLinkedTicketByUuid(
    data: GetLinkedTicketByUuidData,
  ): CancelablePromise<GetLinkedTicketByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-linked/{linkedUuid}",
      path: {
        linkedUuid: data.linkedUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.mainTicketUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllLinkedTickets(
    data: GetAllLinkedTicketsData,
  ): CancelablePromise<GetAllLinkedTicketsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-linked/all",
      query: {
        mainTicketUuid: data.mainTicketUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.mainTicketUuid
   * @param data.linkedTicketUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static unlinkTicket(
    data: UnlinkTicketData,
  ): CancelablePromise<UnlinkTicketResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/crm/v1/ticket-linked/{mainTicketUuid}/unlink/{linkedTicketUuid}",
      path: {
        mainTicketUuid: data.mainTicketUuid,
        linkedTicketUuid: data.linkedTicketUuid,
      },
    });
  }
}

export class TicketConversationControllerService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response2 OK
   * @throws ApiError
   */
  public static createConversation(
    data: CreateConversationData,
  ): CancelablePromise<CreateConversationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/crm/v1/ticket-conversation/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.conversationUuid
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getConversationByUuid(
    data: GetConversationByUuidData,
  ): CancelablePromise<GetConversationByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-conversation/{conversationUuid}",
      path: {
        conversationUuid: data.conversationUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.ticketUuid
   * @param data.page
   * @param data.pageSize
   * @param data.sortBy
   * @param data.sortDirection
   * @param data.searchString
   * @returns Response2 OK
   * @throws ApiError
   */
  public static getAllConversationsByTicketUuid(
    data: GetAllConversationsByTicketUuidData,
  ): CancelablePromise<GetAllConversationsByTicketUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/crm/v1/ticket-conversation/all-conversation",
      query: {
        ticketUuid: data.ticketUuid,
        page: data.page,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection,
        searchString: data.searchString,
      },
    });
  }
}

export class MessageControllerService {
  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static markMessageUrgent(
    data: MarkMessageUrgentData,
  ): CancelablePromise<MarkMessageUrgentResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/communication/v1/messages/{uuid}/urgent",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static markMessageReadByUser(
    data: MarkMessageReadByUserData,
  ): CancelablePromise<MarkMessageReadByUserResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/communication/v1/messages/{uuid}/read-by-user",
      path: {
        uuid: data.uuid,
      },
      query: {
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static cancelScheduledMessage(
    data: CancelScheduledMessageData,
  ): CancelablePromise<CancelScheduledMessageResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/communication/v1/messages/{uuid}/cancel",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.threadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static markAllMessagesReadInThread(
    data: MarkAllMessagesReadInThreadData,
  ): CancelablePromise<MarkAllMessagesReadInThreadResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/communication/v1/messages/thread/{threadUuid}/mark-all-read",
      path: {
        threadUuid: data.threadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.threadUuid
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static markAllMessagesReadInThreadForUser(
    data: MarkAllMessagesReadInThreadForUserData,
  ): CancelablePromise<MarkAllMessagesReadInThreadForUserResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/communication/v1/messages/thread/{threadUuid}/mark-all-read-for-user",
      path: {
        threadUuid: data.threadUuid,
      },
      query: {
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static rescheduleMessage(
    data: RescheduleMessageData,
  ): CancelablePromise<RescheduleMessageResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/communication/v1/messages/scheduled/{uuid}/reschedule",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static editScheduledMessage(
    data: EditScheduledMessageData,
  ): CancelablePromise<EditScheduledMessageResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/communication/v1/messages/scheduled/{uuid}/edit",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static removeMessageUrgent(
    data: RemoveMessageUrgentData,
  ): CancelablePromise<RemoveMessageUrgentResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/communication/v1/messages/remove-urgent/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendMessage(
    data: SendMessageData,
  ): CancelablePromise<SendMessageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/messages",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static sendScheduledMessageNow(
    data: SendScheduledMessageNowData,
  ): CancelablePromise<SendScheduledMessageNowResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/messages/scheduled/{uuid}/send-now",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static removeAttacment(
    data: RemoveAttacmentData,
  ): CancelablePromise<RemoveAttacmentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/messages/attachment/remove",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getUnreadMessageCountByUserUuid(
    data: GetUnreadMessageCountByUserUuidData,
  ): CancelablePromise<GetUnreadMessageCountByUserUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/user/{userUuid}/unread-count",
      path: {
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userUuid
   * @param data.search
   * @param data.locationUuid
   * @param data.providerUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static getMessageSummariesByUserUuid(
    data: GetMessageSummariesByUserUuidData,
  ): CancelablePromise<GetMessageSummariesByUserUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/user/{userUuid}/summary",
      path: {
        userUuid: data.userUuid,
      },
      query: {
        search: data.search,
        locationUuid: data.locationUuid,
        providerUuids: data.providerUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.size
   * @param data.locationUuid
   * @param data.providerUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static getUrgentUnreadMessagesForUser(
    data: GetUrgentUnreadMessagesForUserData = {},
  ): CancelablePromise<GetUrgentUnreadMessagesForUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/user/urgent-unread",
      query: {
        page: data.page,
        size: data.size,
        locationUuid: data.locationUuid,
        providerUuids: data.providerUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.locationUuid
   * @param data.providerUuids
   * @returns Response OK
   * @throws ApiError
   */
  public static getUrgentUnreadMessageCountForUser(
    data: GetUrgentUnreadMessageCountForUserData = {},
  ): CancelablePromise<GetUrgentUnreadMessageCountForUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/user/urgent-unread/count",
      query: {
        locationUuid: data.locationUuid,
        providerUuids: data.providerUuids,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page
   * @param data.size
   * @returns Response OK
   * @throws ApiError
   */
  public static getUnreadMessagesForUser(
    data: GetUnreadMessagesForUserData = {},
  ): CancelablePromise<GetUnreadMessagesForUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/user/unread-messages",
      query: {
        page: data.page,
        size: data.size,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static getUnreadMessageCountForUser(): CancelablePromise<GetUnreadMessageCountForUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/user/unread-message/count",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.threadUuid
   * @param data.page
   * @param data.size
   * @param data.filter
   * @param data.search
   * @returns Response OK
   * @throws ApiError
   */
  public static listMessages(
    data: ListMessagesData,
  ): CancelablePromise<ListMessagesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/thread/{threadUuid}",
      path: {
        threadUuid: data.threadUuid,
      },
      query: {
        page: data.page,
        size: data.size,
        filter: data.filter,
        search: data.search,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.threadUuid
   * @param data.page
   * @param data.size
   * @returns Response OK
   * @throws ApiError
   */
  public static getScheduledMessages(
    data: GetScheduledMessagesData,
  ): CancelablePromise<GetScheduledMessagesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/thread/{threadUuid}/scheduled",
      path: {
        threadUuid: data.threadUuid,
      },
      query: {
        page: data.page,
        size: data.size,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.threadUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static countUnread(
    data: CountUnreadData,
  ): CancelablePromise<CountUnreadResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/thread/{threadUuid}/count-unread",
      path: {
        threadUuid: data.threadUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.threadUuid
   * @param data.userUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static countUnreadForUser(
    data: CountUnreadForUserData,
  ): CancelablePromise<CountUnreadForUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/thread/{threadUuid}/count-unread-for-user",
      path: {
        threadUuid: data.threadUuid,
      },
      query: {
        userUuid: data.userUuid,
      },
    });
  }

  /**
   * Search messages
   * Search messages by content, including attachments
   * @param data The data for the request.
   * @param data.query Search query for message content
   * @param data.includeAttachments Include attachments in search
   * @param data.threadUuid Thread UUID to search within (optional)
   * @param data.page Page number (0-based)
   * @param data.size Page size
   * @returns Response Messages found successfully
   * @throws ApiError
   */
  public static searchMessages(
    data: SearchMessagesData,
  ): CancelablePromise<SearchMessagesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/search",
      query: {
        query: data.query,
        includeAttachments: data.includeAttachments,
        threadUuid: data.threadUuid,
        page: data.page,
        size: data.size,
      },
      errors: {
        401: "User not authenticated",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.patientUuid
   * @param data.search
   * @returns Response OK
   * @throws ApiError
   */
  public static getPatientDependentsMessageSummary(
    data: GetPatientDependentsMessageSummaryData,
  ): CancelablePromise<GetPatientDependentsMessageSummaryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/messages/patient/{patientUuid}/dependents/summary",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        search: data.search,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteMessageByUuid(
    data: DeleteMessageByUuidData,
  ): CancelablePromise<DeleteMessageByUuidResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/communication/v1/messages/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns Response OK
   * @throws ApiError
   */
  public static deleteScheduledMessage(
    data: DeleteScheduledMessageData,
  ): CancelablePromise<DeleteScheduledMessageResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/communication/v1/messages/scheduled/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }
}

export class VideoCallControllerService {
  /**
   * @param data The data for the request.
   * @param data.callUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static endCall(data: EndCallData): CancelablePromise<EndCallResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/video-call/{callUuid}/end",
      path: {
        callUuid: data.callUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static declineCall(
    data: DeclineCallData,
  ): CancelablePromise<DeclineCallResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/video-call/{callUuid}/decline",
      path: {
        callUuid: data.callUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static cancelCall(
    data: CancelCallData,
  ): CancelablePromise<CancelCallResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/video-call/{callUuid}/cancel",
      path: {
        callUuid: data.callUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static acceptCall(
    data: AcceptCallData,
  ): CancelablePromise<AcceptCallResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/video-call/{callUuid}/accept",
      path: {
        callUuid: data.callUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static startCall(
    data: StartCallData,
  ): CancelablePromise<StartCallResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/video-call/start",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getCall(data: GetCallData): CancelablePromise<GetCallResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/video-call/{callUuid}",
      path: {
        callUuid: data.callUuid,
      },
    });
  }
}

export class TwilioVoiceWebhookControllerService {
  /**
   * @param data The data for the request.
   * @param data.callRef
   * @param data.formData
   * @returns string OK
   * @throws ApiError
   */
  public static outboundDial(
    data: OutboundDialData = {},
  ): CancelablePromise<OutboundDialResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/voice/twiml/outbound",
      query: {
        callRef: data.callRef,
      },
      formData: data.formData,
      mediaType: "application/x-www-form-urlencoded",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns string OK
   * @throws ApiError
   */
  public static inboundCall(
    data: InboundCallData = {},
  ): CancelablePromise<InboundCallResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/voice/twiml/inbound",
      formData: data.formData,
      mediaType: "application/x-www-form-urlencoded",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callRef
   * @param data.menu
   * @param data.attempt
   * @param data.formData
   * @returns string OK
   * @throws ApiError
   */
  public static dialAction(
    data: DialActionData = {},
  ): CancelablePromise<DialActionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/voice/twiml/dial-action",
      query: {
        callRef: data.callRef,
        menu: data.menu,
        attempt: data.attempt,
      },
      formData: data.formData,
      mediaType: "application/x-www-form-urlencoded",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns string OK
   * @throws ApiError
   */
  public static appDial(
    data: AppDialData = {},
  ): CancelablePromise<AppDialResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/voice/twiml/app",
      formData: data.formData,
      mediaType: "application/x-www-form-urlencoded",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callRef
   * @param data.voicemail
   * @param data.urgent
   * @param data.silent
   * @param data.formData
   * @returns unknown OK
   * @throws ApiError
   */
  public static recordings(
    data: RecordingsData = {},
  ): CancelablePromise<RecordingsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/voice/recordings",
      query: {
        callRef: data.callRef,
        voicemail: data.voicemail,
        urgent: data.urgent,
        silent: data.silent,
      },
      formData: data.formData,
      mediaType: "application/x-www-form-urlencoded",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callRef
   * @param data.formData
   * @returns unknown OK
   * @throws ApiError
   */
  public static events(
    data: EventsData = {},
  ): CancelablePromise<EventsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/voice/events",
      query: {
        callRef: data.callRef,
      },
      formData: data.formData,
      mediaType: "application/x-www-form-urlencoded",
    });
  }
}

export class TwilioVoiceControllerService {
  /**
   * @param data The data for the request.
   * @param data.platform
   * @returns Response OK
   * @throws ApiError
   */
  public static issueToken(
    data: IssueTokenData = {},
  ): CancelablePromise<IssueTokenResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/voice/token",
      query: {
        platform: data.platform,
      },
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static unregister(): CancelablePromise<UnregisterResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/communication/v1/twilio/voice/token",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.direction
   * @param data.fromUserUuid
   * @param data.toUserUuid
   * @param data.patientUuid
   * @param data.providerUuid
   * @param data.phoneNumber
   * @param data.from
   * @param data.to
   * @param data.page
   * @param data.size
   * @returns Response OK
   * @throws ApiError
   */
  public static callLog(
    data: CallLogData = {},
  ): CancelablePromise<CallLogResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/twilio/voice/calls",
      query: {
        direction: data.direction,
        fromUserUuid: data.fromUserUuid,
        toUserUuid: data.toUserUuid,
        patientUuid: data.patientUuid,
        providerUuid: data.providerUuid,
        phoneNumber: data.phoneNumber,
        from: data.from,
        to: data.to,
        page: data.page,
        size: data.size,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static placeCall(
    data: PlaceCallData,
  ): CancelablePromise<PlaceCallResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/voice/calls",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static hangUp(): CancelablePromise<HangUpResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/voice/calls/hangup",
    });
  }

  /**
   * @returns Response OK
   * @throws ApiError
   */
  public static status(): CancelablePromise<StatusResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/twilio/voice/status",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callUuid
   * @returns Response OK
   * @throws ApiError
   */
  public static getCall1(
    data: GetCall1Data,
  ): CancelablePromise<GetCall1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/twilio/voice/calls/{callUuid}",
      path: {
        callUuid: data.callUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callUuid
   * @returns binary OK
   * @throws ApiError
   */
  public static readTranscript(
    data: ReadTranscriptData,
  ): CancelablePromise<ReadTranscriptResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/twilio/voice/calls/{callUuid}/transcript",
      path: {
        callUuid: data.callUuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.callUuid
   * @param data.range
   * @returns binary OK
   * @throws ApiError
   */
  public static playRecording(
    data: PlayRecordingData,
  ): CancelablePromise<PlayRecordingResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/twilio/voice/calls/{callUuid}/recording",
      path: {
        callUuid: data.callUuid,
      },
      headers: {
        Range: data.range,
      },
    });
  }
}

export class TwilioControllerService {
  /**
   * Twilio inbound SMS webhook
   * Configured in the Twilio console as the 'A MESSAGE COMES IN' webhook. Confirms an appointment when the patient replies with the token from the reminder SMS. Twilio posts form-encoded parameters and expects TwiML back.
   * @param data The data for the request.
   * @param data.from
   * @param data.body
   * @returns string OK
   * @throws ApiError
   */
  public static inboundSms(
    data: InboundSmsData = {},
  ): CancelablePromise<InboundSmsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/sms/inbound",
      query: {
        From: data.from,
        Body: data.body,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendSms(data: SendSmsData): CancelablePromise<SendSmsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/send_sms",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response OK
   * @throws ApiError
   */
  public static sendGenericSms(
    data: SendGenericSmsData,
  ): CancelablePromise<SendGenericSmsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/twilio/send_generic_sms",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Generate Twilio access token
   * Generates a new access token for Twilio Conversations
   * @returns Response Token generated successfully
   * @throws ApiError
   */
  public static generateAccessToken(): CancelablePromise<GenerateAccessTokenResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/twilio/token",
      errors: {
        401: "User not authenticated",
        500: "Internal server error",
      },
    });
  }

  /**
   * Get Twilio service status
   * Returns the current status and configuration information of the Twilio service
   * @returns Response Service status retrieved successfully
   * @throws ApiError
   */
  public static getServiceStatus(): CancelablePromise<GetServiceStatusResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/twilio/status",
      errors: {
        401: "User not authenticated",
      },
    });
  }

  /**
   * Check Twilio connection health
   * Tests the connection to Twilio API and validates credentials
   * @returns string Twilio connection is healthy
   * @throws ApiError
   */
  public static checkHealth(): CancelablePromise<CheckHealthResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/twilio/health",
      errors: {
        500: "Twilio connection failed",
      },
    });
  }
}

export class ThreadControllerService {
  /**
   * Create a new communication thread
   * Creates a new thread with a Twilio conversation for patient communication
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response Thread created successfully
   * @throws ApiError
   */
  public static createThread(
    data: CreateThreadData,
  ): CancelablePromise<CreateThreadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/thread",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Invalid request data",
        401: "User not authenticated",
      },
    });
  }

  /**
   * Resume resolved thread
   * Reopens a resolved thread by changing its status back to OPEN
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @returns Response Thread resumed successfully
   * @throws ApiError
   */
  public static resumeThread(
    data: ResumeThreadData,
  ): CancelablePromise<ResumeThreadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/thread/{threadUuid}/resume",
      path: {
        threadUuid: data.threadUuid,
      },
      errors: {
        400: "Thread is not resolved",
        401: "User not authenticated",
        404: "Thread not found",
      },
    });
  }

  /**
   * Broadcast thread list update for a thread
   * Pushes the thread_list_updated socket event to all thread participants. Used by other services (e.g. ehr-service task resolution) after changing thread state outside this service.
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @returns Response Broadcast triggered successfully
   * @throws ApiError
   */
  public static broadcastThreadListUpdate(
    data: BroadcastThreadListUpdateData,
  ): CancelablePromise<BroadcastThreadListUpdateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/thread/{threadUuid}/broadcast-thread-list",
      path: {
        threadUuid: data.threadUuid,
      },
      errors: {
        404: "Thread not found",
      },
    });
  }

  /**
   * Broadcast message summaries for a thread
   * Pushes the message_summary_updated socket event to all thread participants. Used by other services (e.g. ehr-service task resolution) after changing thread state outside this service.
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @returns Response Broadcast triggered successfully
   * @throws ApiError
   */
  public static broadcastThreadSummaries(
    data: BroadcastThreadSummariesData,
  ): CancelablePromise<BroadcastThreadSummariesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/thread/{threadUuid}/broadcast-summary",
      path: {
        threadUuid: data.threadUuid,
      },
    });
  }

  /**
   * Route thread to a user
   * Adds the given user as a participant of the thread
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @param data.userUuid User UUID to add to the thread
   * @returns Response Thread routed successfully
   * @throws ApiError
   */
  public static routeThread(
    data: RouteThreadData,
  ): CancelablePromise<RouteThreadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/thread/routing",
      query: {
        threadUuid: data.threadUuid,
        userUuid: data.userUuid,
      },
      errors: {
        400: "User not found",
        401: "User not authenticated",
        404: "Thread not found",
      },
    });
  }

  /**
   * Create open thread
   * Records whether a user currently has the given thread open
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response Open thread created successfully
   * @throws ApiError
   */
  public static createOpenThread(
    data: CreateOpenThreadData,
  ): CancelablePromise<CreateOpenThreadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/thread/open",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "User not found",
        401: "User not authenticated",
        404: "Thread not found",
      },
    });
  }

  /**
   * Mark thread as urgent
   * Marks a thread as urgent or removes urgent status
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @param data.urgent Mark as urgent (true) or remove urgent status (false)
   * @returns Response Thread urgency updated successfully
   * @throws ApiError
   */
  public static markThreadUrgent(
    data: MarkThreadUrgentData,
  ): CancelablePromise<MarkThreadUrgentResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/communication/v1/thread/{threadUuid}/urgent",
      path: {
        threadUuid: data.threadUuid,
      },
      query: {
        urgent: data.urgent,
      },
      errors: {
        401: "User not authenticated",
        404: "Thread not found",
      },
    });
  }

  /**
   * Update thread status
   * Updates the status of a thread (e.g., OPEN, CLOSED, RESOLVED)
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @param data.status New thread status
   * @returns Response Thread status updated successfully
   * @throws ApiError
   */
  public static updateThreadStatus(
    data: UpdateThreadStatusData,
  ): CancelablePromise<UpdateThreadStatusResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/communication/v1/thread/{threadUuid}/status",
      path: {
        threadUuid: data.threadUuid,
      },
      query: {
        status: data.status,
      },
      errors: {
        401: "User not authenticated",
        404: "Thread not found",
      },
    });
  }

  /**
   * Update open thread
   * Updates the open flag of an open thread record
   * @param data The data for the request.
   * @param data.uuid Open thread UUID
   * @param data.open Open flag
   * @returns Response Open thread updated successfully
   * @throws ApiError
   */
  public static updateOpenThread(
    data: UpdateOpenThreadData,
  ): CancelablePromise<UpdateOpenThreadResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/communication/v1/thread/open/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        open: data.open,
      },
      errors: {
        401: "User not authenticated",
        404: "Open thread not found",
      },
    });
  }

  /**
   * Get thread by ID
   * Retrieves a specific thread by its UUID
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @returns Response Thread retrieved successfully
   * @throws ApiError
   */
  public static getThreadById(
    data: GetThreadByIdData,
  ): CancelablePromise<GetThreadByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/thread/{threadUuid}",
      path: {
        threadUuid: data.threadUuid,
      },
      errors: {
        401: "User not authenticated",
        404: "Thread not found",
      },
    });
  }

  /**
   * Get users who have a thread open
   * Retrieves the uuid and username of every user whose open flag is true for the thread
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @returns Response Open thread users retrieved successfully
   * @throws ApiError
   */
  public static getOpenThreadUsers(
    data: GetOpenThreadUsersData,
  ): CancelablePromise<GetOpenThreadUsersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/thread/{threadUuid}/open",
      path: {
        threadUuid: data.threadUuid,
      },
      errors: {
        401: "User not authenticated",
      },
    });
  }

  /**
   * Search threads
   * Search threads by subject and categories
   * @param data The data for the request.
   * @param data.subject Search query for thread subject
   * @param data.categories Categories to filter by
   * @param data.patientUuid Patient UUID to filter by (optional)
   * @param data.urgentOnly Include urgent threads only
   * @param data.page Page number (0-based)
   * @param data.size Page size
   * @returns Response Threads found successfully
   * @throws ApiError
   */
  public static searchThreads(
    data: SearchThreadsData = {},
  ): CancelablePromise<SearchThreadsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/thread/search",
      query: {
        subject: data.subject,
        categories: data.categories,
        patientUuid: data.patientUuid,
        urgentOnly: data.urgentOnly,
        page: data.page,
        size: data.size,
      },
      errors: {
        401: "User not authenticated",
      },
    });
  }

  /**
   * Get threads by patient
   * Retrieves all threads for a specific patient
   * @param data The data for the request.
   * @param data.patientUuid Patient UUID
   * @param data.page Page number (0-based)
   * @param data.size Page size
   * @returns Response Threads retrieved successfully
   * @throws ApiError
   */
  public static getThreadsByPatient(
    data: GetThreadsByPatientData,
  ): CancelablePromise<GetThreadsByPatientResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/thread/patient/{patientUuid}",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        page: data.page,
        size: data.size,
      },
      errors: {
        401: "User not authenticated",
      },
    });
  }

  /**
   * Get optimized threads list for patient
   * Retrieves threads list with filters, unread counts, and last message info
   * @param data The data for the request.
   * @param data.patientUuid Patient UUID
   * @param data.filter Filter: ALL, INBOX, SENT, RESOLVED, URGENT
   * @param data.search Search by subject name
   * @param data.excludeResolved Exclude resolved threads from results
   * @param data.userUuid Only threads where both the patient and this user are participants
   * @param data.page Page number (0-based)
   * @param data.size Page size
   * @returns Response Threads list retrieved successfully
   * @throws ApiError
   */
  public static getThreadsList(
    data: GetThreadsListData,
  ): CancelablePromise<GetThreadsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/thread/patient/{patientUuid}/list",
      path: {
        patientUuid: data.patientUuid,
      },
      query: {
        filter: data.filter,
        search: data.search,
        excludeResolved: data.excludeResolved,
        userUuid: data.userUuid,
        page: data.page,
        size: data.size,
      },
      errors: {
        401: "User not authenticated",
      },
    });
  }

  /**
   * Get threads for current user
   * Retrieves all threads where the current user is a participant
   * @param data The data for the request.
   * @param data.page Page number (0-based)
   * @param data.size Page size
   * @param data.providerUuids
   * @returns Response Threads retrieved successfully
   * @throws ApiError
   */
  public static getMyThreads(
    data: GetMyThreadsData = {},
  ): CancelablePromise<GetMyThreadsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/thread/my-threads",
      query: {
        page: data.page,
        size: data.size,
        providerUuids: data.providerUuids,
      },
      errors: {
        401: "User not authenticated",
      },
    });
  }

  /**
   * Get thread categories
   * Retrieves list of available thread categories
   * @returns Response Categories retrieved successfully
   * @throws ApiError
   */
  public static getThreadCategories(): CancelablePromise<GetThreadCategoriesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/thread/categories",
    });
  }
}

export class RealtimeControllerService {
  /**
   * Broadcast a real-time event
   * Pushes the realtime_event socket event to the rooms derived from the event's routing keys. Called by other services (e.g. ehr-service) after a create/update/delete.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Response Broadcast triggered successfully
   * @throws ApiError
   */
  public static broadcast(
    data: BroadcastData,
  ): CancelablePromise<BroadcastResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/realtime/broadcast",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class BookmarkControllerService {
  /**
   * Bookmark a thread
   * Adds a thread to user's bookmarks
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @returns Response Thread bookmarked successfully
   * @throws ApiError
   */
  public static bookmarkThread(
    data: BookmarkThreadData,
  ): CancelablePromise<BookmarkThreadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/bookmarks/threads/{threadUuid}",
      path: {
        threadUuid: data.threadUuid,
      },
      errors: {
        400: "Thread already bookmarked",
        404: "Thread not found",
      },
    });
  }

  /**
   * Unbookmark a thread
   * Removes a thread from user's bookmarks
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @returns Response Thread unbookmarked successfully
   * @throws ApiError
   */
  public static unbookmarkThread(
    data: UnbookmarkThreadData,
  ): CancelablePromise<UnbookmarkThreadResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/communication/v1/bookmarks/threads/{threadUuid}",
      path: {
        threadUuid: data.threadUuid,
      },
      errors: {
        404: "Thread not found",
      },
    });
  }

  /**
   * Bookmark a message
   * Adds a message to user's bookmarks
   * @param data The data for the request.
   * @param data.messageUuid Message UUID
   * @returns Response Message bookmarked successfully
   * @throws ApiError
   */
  public static bookmarkMessage(
    data: BookmarkMessageData,
  ): CancelablePromise<BookmarkMessageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/communication/v1/bookmarks/messages/{messageUuid}",
      path: {
        messageUuid: data.messageUuid,
      },
      errors: {
        400: "Message already bookmarked",
        404: "Message not found",
      },
    });
  }

  /**
   * Unbookmark a message
   * Removes a message from user's bookmarks
   * @param data The data for the request.
   * @param data.messageUuid Message UUID
   * @returns Response Message unbookmarked successfully
   * @throws ApiError
   */
  public static unbookmarkMessage(
    data: UnbookmarkMessageData,
  ): CancelablePromise<UnbookmarkMessageResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/communication/v1/bookmarks/messages/{messageUuid}",
      path: {
        messageUuid: data.messageUuid,
      },
      errors: {
        404: "Message not found",
      },
    });
  }

  /**
   * Get bookmarked threads
   * Retrieves paginated list of user's bookmarked threads. For non-patient users, patientUuid is required.
   * @param data The data for the request.
   * @param data.page Page number (0-based)
   * @param data.size Page size
   * @param data.patientUuid Patient UUID (required for non-patient users)
   * @returns Response Bookmarked threads retrieved successfully
   * @throws ApiError
   */
  public static getBookmarkedThreads(
    data: GetBookmarkedThreadsData = {},
  ): CancelablePromise<GetBookmarkedThreadsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/bookmarks/threads",
      query: {
        page: data.page,
        size: data.size,
        patientUuid: data.patientUuid,
      },
      errors: {
        400: "patientUuid is required for non-patient users",
      },
    });
  }

  /**
   * Get bookmarked messages
   * Retrieves paginated list of user's bookmarked messages grouped by category and date. For non-patient users, patientUuid is required.
   * @param data The data for the request.
   * @param data.page Page number (0-based)
   * @param data.size Page size
   * @param data.patientUuid Patient UUID (required for non-patient users)
   * @returns Response Bookmarked messages retrieved successfully
   * @throws ApiError
   */
  public static getBookmarkedMessages(
    data: GetBookmarkedMessagesData = {},
  ): CancelablePromise<GetBookmarkedMessagesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/bookmarks/messages",
      query: {
        page: data.page,
        size: data.size,
        patientUuid: data.patientUuid,
      },
      errors: {
        400: "patientUuid is required for non-patient users",
      },
    });
  }

  /**
   * Get message position in thread
   * Returns the position (1-based index) of a message within a thread, ordered by creation time (newest first)
   * @param data The data for the request.
   * @param data.messageUuid Message UUID
   * @param data.threadUuid Thread UUID
   * @returns Response Message position retrieved successfully
   * @throws ApiError
   */
  public static getMessagePositionInThread(
    data: GetMessagePositionInThreadData,
  ): CancelablePromise<GetMessagePositionInThreadResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/bookmarks/messages/{messageUuid}/position/thread/{threadUuid}",
      path: {
        messageUuid: data.messageUuid,
        threadUuid: data.threadUuid,
      },
      errors: {
        404: "Thread or message not found",
      },
    });
  }

  /**
   * Get bookmarked messages by thread
   * Retrieves paginated list of user's bookmarked messages for a specific thread. For non-patient users, patientUuid is required.
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @param data.page Page number (0-based)
   * @param data.size Page size
   * @param data.patientUuid Patient UUID (required for non-patient users)
   * @returns Response Bookmarked messages retrieved successfully
   * @throws ApiError
   */
  public static getBookmarkedMessagesByThread(
    data: GetBookmarkedMessagesByThreadData,
  ): CancelablePromise<GetBookmarkedMessagesByThreadResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/communication/v1/bookmarks/messages/thread/{threadUuid}",
      path: {
        threadUuid: data.threadUuid,
      },
      query: {
        page: data.page,
        size: data.size,
        patientUuid: data.patientUuid,
      },
      errors: {
        400: "patientUuid is required for non-patient users",
        403: "Access denied - thread does not belong to specified patient",
      },
    });
  }

  /**
   * Unbookmark all messages in a thread
   * Removes all message bookmarks for the specified thread for the current user. For non-patient users, patientUuid is required.
   * @param data The data for the request.
   * @param data.threadUuid Thread UUID
   * @param data.patientUuid Patient UUID (required for non-patient users)
   * @returns Response Messages unbookmarked successfully
   * @throws ApiError
   */
  public static unbookmarkMessagesByThread(
    data: UnbookmarkMessagesByThreadData,
  ): CancelablePromise<UnbookmarkMessagesByThreadResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/communication/v1/bookmarks/messages/thread/{threadUuid}",
      path: {
        threadUuid: data.threadUuid,
      },
      query: {
        patientUuid: data.patientUuid,
      },
      errors: {
        400: "patientUuid is required for non-patient users",
        403: "Access denied for the specified patient",
        404: "Thread not found",
      },
    });
  }
}
